var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined")
    return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});
var __commonJS = (cb, mod) => function __require2() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/crypto-js/core.js
var require_core = __commonJS({
  "node_modules/crypto-js/core.js"(exports, module) {
    "use strict";
    (function(root, factory) {
      if (typeof exports === "object") {
        module.exports = exports = factory();
      } else if (typeof define === "function" && define.amd) {
        define([], factory);
      } else {
        root.CryptoJS = factory();
      }
    })(exports, function() {
      var CryptoJS2 = CryptoJS2 || function(Math2, undefined2) {
        var crypto;
        if (typeof window !== "undefined" && window.crypto) {
          crypto = window.crypto;
        }
        if (typeof self !== "undefined" && self.crypto) {
          crypto = self.crypto;
        }
        if (typeof globalThis !== "undefined" && globalThis.crypto) {
          crypto = globalThis.crypto;
        }
        if (!crypto && typeof window !== "undefined" && window.msCrypto) {
          crypto = window.msCrypto;
        }
        if (!crypto && typeof global !== "undefined" && global.crypto) {
          crypto = global.crypto;
        }
        if (!crypto && typeof __require === "function") {
          try {
            crypto = __require("crypto");
          } catch (err) {
          }
        }
        var cryptoSecureRandomInt = function() {
          if (crypto) {
            if (typeof crypto.getRandomValues === "function") {
              try {
                return crypto.getRandomValues(new Uint32Array(1))[0];
              } catch (err) {
              }
            }
            if (typeof crypto.randomBytes === "function") {
              try {
                return crypto.randomBytes(4).readInt32LE();
              } catch (err) {
              }
            }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        };
        var create = Object.create || function() {
          function F() {
          }
          return function(obj) {
            var subtype;
            F.prototype = obj;
            subtype = new F();
            F.prototype = null;
            return subtype;
          };
        }();
        var C = {};
        var C_lib = C.lib = {};
        var Base = C_lib.Base = function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(overrides) {
              var subtype = create(this);
              if (overrides) {
                subtype.mixIn(overrides);
              }
              if (!subtype.hasOwnProperty("init") || this.init === subtype.init) {
                subtype.init = function() {
                  subtype.$super.init.apply(this, arguments);
                };
              }
              subtype.init.prototype = subtype;
              subtype.$super = this;
              return subtype;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var instance = this.extend();
              instance.init.apply(instance, arguments);
              return instance;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(properties) {
              for (var propertyName in properties) {
                if (properties.hasOwnProperty(propertyName)) {
                  this[propertyName] = properties[propertyName];
                }
              }
              if (properties.hasOwnProperty("toString")) {
                this.toString = properties.toString;
              }
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }();
        var WordArray = C_lib.WordArray = Base.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(words, sigBytes) {
            words = this.words = words || [];
            if (sigBytes != undefined2) {
              this.sigBytes = sigBytes;
            } else {
              this.sigBytes = words.length * 4;
            }
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(encoder) {
            return (encoder || Hex).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(wordArray) {
            var thisWords = this.words;
            var thatWords = wordArray.words;
            var thisSigBytes = this.sigBytes;
            var thatSigBytes = wordArray.sigBytes;
            this.clamp();
            if (thisSigBytes % 4) {
              for (var i = 0; i < thatSigBytes; i++) {
                var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
              }
            } else {
              for (var j = 0; j < thatSigBytes; j += 4) {
                thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
              }
            }
            this.sigBytes += thatSigBytes;
            return this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var words = this.words;
            var sigBytes = this.sigBytes;
            words[sigBytes >>> 2] &= 4294967295 << 32 - sigBytes % 4 * 8;
            words.length = Math2.ceil(sigBytes / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var clone = Base.clone.call(this);
            clone.words = this.words.slice(0);
            return clone;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(nBytes) {
            var words = [];
            for (var i = 0; i < nBytes; i += 4) {
              words.push(cryptoSecureRandomInt());
            }
            return new WordArray.init(words, nBytes);
          }
        });
        var C_enc = C.enc = {};
        var Hex = C_enc.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(wordArray) {
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;
            var hexChars = [];
            for (var i = 0; i < sigBytes; i++) {
              var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
              hexChars.push((bite >>> 4).toString(16));
              hexChars.push((bite & 15).toString(16));
            }
            return hexChars.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(hexStr) {
            var hexStrLength = hexStr.length;
            var words = [];
            for (var i = 0; i < hexStrLength; i += 2) {
              words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
            }
            return new WordArray.init(words, hexStrLength / 2);
          }
        };
        var Latin1 = C_enc.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(wordArray) {
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;
            var latin1Chars = [];
            for (var i = 0; i < sigBytes; i++) {
              var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
              latin1Chars.push(String.fromCharCode(bite));
            }
            return latin1Chars.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(latin1Str) {
            var latin1StrLength = latin1Str.length;
            var words = [];
            for (var i = 0; i < latin1StrLength; i++) {
              words[i >>> 2] |= (latin1Str.charCodeAt(i) & 255) << 24 - i % 4 * 8;
            }
            return new WordArray.init(words, latin1StrLength);
          }
        };
        var Utf8 = C_enc.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(wordArray) {
            try {
              return decodeURIComponent(escape(Latin1.stringify(wordArray)));
            } catch (e) {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(utf8Str) {
            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
          }
        };
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new WordArray.init();
            this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(data) {
            if (typeof data == "string") {
              data = Utf8.parse(data);
            }
            this._data.concat(data);
            this._nDataBytes += data.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(doFlush) {
            var processedWords;
            var data = this._data;
            var dataWords = data.words;
            var dataSigBytes = data.sigBytes;
            var blockSize = this.blockSize;
            var blockSizeBytes = blockSize * 4;
            var nBlocksReady = dataSigBytes / blockSizeBytes;
            if (doFlush) {
              nBlocksReady = Math2.ceil(nBlocksReady);
            } else {
              nBlocksReady = Math2.max((nBlocksReady | 0) - this._minBufferSize, 0);
            }
            var nWordsReady = nBlocksReady * blockSize;
            var nBytesReady = Math2.min(nWordsReady * 4, dataSigBytes);
            if (nWordsReady) {
              for (var offset = 0; offset < nWordsReady; offset += blockSize) {
                this._doProcessBlock(dataWords, offset);
              }
              processedWords = dataWords.splice(0, nWordsReady);
              data.sigBytes -= nBytesReady;
            }
            return new WordArray.init(processedWords, nBytesReady);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var clone = Base.clone.call(this);
            clone._data = this._data.clone();
            return clone;
          },
          _minBufferSize: 0
        });
        var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
          /**
           * Configuration options.
           */
          cfg: Base.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(cfg) {
            this.cfg = this.cfg.extend(cfg);
            this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            BufferedBlockAlgorithm.reset.call(this);
            this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(messageUpdate) {
            this._append(messageUpdate);
            this._process();
            return this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(messageUpdate) {
            if (messageUpdate) {
              this._append(messageUpdate);
            }
            var hash = this._doFinalize();
            return hash;
          },
          blockSize: 512 / 32,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(hasher) {
            return function(message, cfg) {
              return new hasher.init(cfg).finalize(message);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(hasher) {
            return function(message, key) {
              return new C_algo.HMAC.init(hasher, key).finalize(message);
            };
          }
        });
        var C_algo = C.algo = {};
        return C;
      }(Math);
      return CryptoJS2;
    });
  }
});

// node_modules/crypto-js/x64-core.js
var require_x64_core = __commonJS({
  "node_modules/crypto-js/x64-core.js"(exports, module) {
    "use strict";
    (function(root, factory) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function(undefined2) {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        var C_x64 = C.x64 = {};
        var X64Word = C_x64.Word = Base.extend({
          /**
           * Initializes a newly created 64-bit word.
           *
           * @param {number} high The high 32 bits.
           * @param {number} low The low 32 bits.
           *
           * @example
           *
           *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
           */
          init: function(high, low) {
            this.high = high;
            this.low = low;
          }
          /**
           * Bitwise NOTs this word.
           *
           * @return {X64Word} A new x64-Word object after negating.
           *
           * @example
           *
           *     var negated = x64Word.not();
           */
          // not: function () {
          // var high = ~this.high;
          // var low = ~this.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ANDs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to AND with this word.
           *
           * @return {X64Word} A new x64-Word object after ANDing.
           *
           * @example
           *
           *     var anded = x64Word.and(anotherX64Word);
           */
          // and: function (word) {
          // var high = this.high & word.high;
          // var low = this.low & word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to OR with this word.
           *
           * @return {X64Word} A new x64-Word object after ORing.
           *
           * @example
           *
           *     var ored = x64Word.or(anotherX64Word);
           */
          // or: function (word) {
          // var high = this.high | word.high;
          // var low = this.low | word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise XORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to XOR with this word.
           *
           * @return {X64Word} A new x64-Word object after XORing.
           *
           * @example
           *
           *     var xored = x64Word.xor(anotherX64Word);
           */
          // xor: function (word) {
          // var high = this.high ^ word.high;
          // var low = this.low ^ word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the left.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftL(25);
           */
          // shiftL: function (n) {
          // if (n < 32) {
          // var high = (this.high << n) | (this.low >>> (32 - n));
          // var low = this.low << n;
          // } else {
          // var high = this.low << (n - 32);
          // var low = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the right.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftR(7);
           */
          // shiftR: function (n) {
          // if (n < 32) {
          // var low = (this.low >>> n) | (this.high << (32 - n));
          // var high = this.high >>> n;
          // } else {
          // var low = this.high >>> (n - 32);
          // var high = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Rotates this word n bits to the left.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotL(25);
           */
          // rotL: function (n) {
          // return this.shiftL(n).or(this.shiftR(64 - n));
          // },
          /**
           * Rotates this word n bits to the right.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotR(7);
           */
          // rotR: function (n) {
          // return this.shiftR(n).or(this.shiftL(64 - n));
          // },
          /**
           * Adds this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to add with this word.
           *
           * @return {X64Word} A new x64-Word object after adding.
           *
           * @example
           *
           *     var added = x64Word.add(anotherX64Word);
           */
          // add: function (word) {
          // var low = (this.low + word.low) | 0;
          // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
          // var high = (this.high + word.high + carry) | 0;
          // return X64Word.create(high, low);
          // }
        });
        var X64WordArray = C_x64.WordArray = Base.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.x64.WordArray.create();
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ]);
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ], 10);
           */
          init: function(words, sigBytes) {
            words = this.words = words || [];
            if (sigBytes != undefined2) {
              this.sigBytes = sigBytes;
            } else {
              this.sigBytes = words.length * 8;
            }
          },
          /**
           * Converts this 64-bit word array to a 32-bit word array.
           *
           * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
           *
           * @example
           *
           *     var x32WordArray = x64WordArray.toX32();
           */
          toX32: function() {
            var x64Words = this.words;
            var x64WordsLength = x64Words.length;
            var x32Words = [];
            for (var i = 0; i < x64WordsLength; i++) {
              var x64Word = x64Words[i];
              x32Words.push(x64Word.high);
              x32Words.push(x64Word.low);
            }
            return X32WordArray.create(x32Words, this.sigBytes);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {X64WordArray} The clone.
           *
           * @example
           *
           *     var clone = x64WordArray.clone();
           */
          clone: function() {
            var clone = Base.clone.call(this);
            var words = clone.words = this.words.slice(0);
            var wordsLength = words.length;
            for (var i = 0; i < wordsLength; i++) {
              words[i] = words[i].clone();
            }
            return clone;
          }
        });
      })();
      return CryptoJS2;
    });
  }
});

// node_modules/crypto-js/lib-typedarrays.js
var require_lib_typedarrays = __commonJS({
  "node_modules/crypto-js/lib-typedarrays.js"(exports, module) {
    "use strict";
    (function(root, factory) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        if (typeof ArrayBuffer != "function") {
          return;
        }
        var C = CryptoJS2;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var superInit = WordArray.init;
        var subInit = WordArray.init = function(typedArray) {
          if (typedArray instanceof ArrayBuffer) {
            typedArray = new Uint8Array(typedArray);
          }
          if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) {
            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
          }
          if (typedArray instanceof Uint8Array) {
            var typedArrayByteLength = typedArray.byteLength;
            var words = [];
            for (var i = 0; i < typedArrayByteLength; i++) {
              words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
            }
            superInit.call(this, words, typedArrayByteLength);
          } else {
            superInit.apply(this, arguments);
          }
        };
        subInit.prototype = WordArray;
      })();
      return CryptoJS2.lib.WordArray;
    });
  }
});

// node_modules/crypto-js/enc-utf16.js
var require_enc_utf16 = __commonJS({
  "node_modules/crypto-js/enc-utf16.js"(exports, module) {
    "use strict";
    (function(root, factory) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
          /**
           * Converts a word array to a UTF-16 BE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 BE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
           */
          stringify: function(wordArray) {
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;
            var utf16Chars = [];
            for (var i = 0; i < sigBytes; i += 2) {
              var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 65535;
              utf16Chars.push(String.fromCharCode(codePoint));
            }
            return utf16Chars.join("");
          },
          /**
           * Converts a UTF-16 BE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 BE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
           */
          parse: function(utf16Str) {
            var utf16StrLength = utf16Str.length;
            var words = [];
            for (var i = 0; i < utf16StrLength; i++) {
              words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
            }
            return WordArray.create(words, utf16StrLength * 2);
          }
        };
        C_enc.Utf16LE = {
          /**
           * Converts a word array to a UTF-16 LE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 LE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
           */
          stringify: function(wordArray) {
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;
            var utf16Chars = [];
            for (var i = 0; i < sigBytes; i += 2) {
              var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 65535);
              utf16Chars.push(String.fromCharCode(codePoint));
            }
            return utf16Chars.join("");
          },
          /**
           * Converts a UTF-16 LE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 LE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
           */
          parse: function(utf16Str) {
            var utf16StrLength = utf16Str.length;
            var words = [];
            for (var i = 0; i < utf16StrLength; i++) {
              words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
            }
            return WordArray.create(words, utf16StrLength * 2);
          }
        };
        function swapEndian(word) {
          return word << 8 & 4278255360 | word >>> 8 & 16711935;
        }
      })();
      return CryptoJS2.enc.Utf16;
    });
  }
});

// node_modules/crypto-js/enc-base64.js
var require_enc_base64 = __commonJS({
  "node_modules/crypto-js/enc-base64.js"(exports, module) {
    "use strict";
    (function(root, factory) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        var Base64 = C_enc.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(wordArray) {
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;
            var map = this._map;
            wordArray.clamp();
            var base64Chars = [];
            for (var i = 0; i < sigBytes; i += 3) {
              var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
              var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 255;
              var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 255;
              var triplet = byte1 << 16 | byte2 << 8 | byte3;
              for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
                base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 63));
              }
            }
            var paddingChar = map.charAt(64);
            if (paddingChar) {
              while (base64Chars.length % 4) {
                base64Chars.push(paddingChar);
              }
            }
            return base64Chars.join("");
          },
          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(base64Str) {
            var base64StrLength = base64Str.length;
            var map = this._map;
            var reverseMap = this._reverseMap;
            if (!reverseMap) {
              reverseMap = this._reverseMap = [];
              for (var j = 0; j < map.length; j++) {
                reverseMap[map.charCodeAt(j)] = j;
              }
            }
            var paddingChar = map.charAt(64);
            if (paddingChar) {
              var paddingIndex = base64Str.indexOf(paddingChar);
              if (paddingIndex !== -1) {
                base64StrLength = paddingIndex;
              }
            }
            return parseLoop(base64Str, base64StrLength, reverseMap);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
          var words = [];
          var nBytes = 0;
          for (var i = 0; i < base64StrLength; i++) {
            if (i % 4) {
              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
              var bitsCombined = bits1 | bits2;
              words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
              nBytes++;
            }
          }
          return WordArray.create(words, nBytes);
        }
      })();
      return CryptoJS2.enc.Base64;
    });
  }
});

// node_modules/crypto-js/enc-base64url.js
var require_enc_base64url = __commonJS({
  "node_modules/crypto-js/enc-base64url.js"(exports, module) {
    "use strict";
    (function(root, factory) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        var Base64url = C_enc.Base64url = {
          /**
           * Converts a word array to a Base64url string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {string} The Base64url string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
           */
          stringify: function(wordArray, urlSafe) {
            if (urlSafe === void 0) {
              urlSafe = true;
            }
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;
            var map = urlSafe ? this._safe_map : this._map;
            wordArray.clamp();
            var base64Chars = [];
            for (var i = 0; i < sigBytes; i += 3) {
              var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
              var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 255;
              var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 255;
              var triplet = byte1 << 16 | byte2 << 8 | byte3;
              for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
                base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 63));
              }
            }
            var paddingChar = map.charAt(64);
            if (paddingChar) {
              while (base64Chars.length % 4) {
                base64Chars.push(paddingChar);
              }
            }
            return base64Chars.join("");
          },
          /**
           * Converts a Base64url string to a word array.
           *
           * @param {string} base64Str The Base64url string.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
           */
          parse: function(base64Str, urlSafe) {
            if (urlSafe === void 0) {
              urlSafe = true;
            }
            var base64StrLength = base64Str.length;
            var map = urlSafe ? this._safe_map : this._map;
            var reverseMap = this._reverseMap;
            if (!reverseMap) {
              reverseMap = this._reverseMap = [];
              for (var j = 0; j < map.length; j++) {
                reverseMap[map.charCodeAt(j)] = j;
              }
            }
            var paddingChar = map.charAt(64);
            if (paddingChar) {
              var paddingIndex = base64Str.indexOf(paddingChar);
              if (paddingIndex !== -1) {
                base64StrLength = paddingIndex;
              }
            }
            return parseLoop(base64Str, base64StrLength, reverseMap);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
          _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
          var words = [];
          var nBytes = 0;
          for (var i = 0; i < base64StrLength; i++) {
            if (i % 4) {
              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
              var bitsCombined = bits1 | bits2;
              words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
              nBytes++;
            }
          }
          return WordArray.create(words, nBytes);
        }
      })();
      return CryptoJS2.enc.Base64url;
    });
  }
});

// node_modules/crypto-js/md5.js
var require_md5 = __commonJS({
  "node_modules/crypto-js/md5.js"(exports, module) {
    "use strict";
    (function(root, factory) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function(Math2) {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        var T = [];
        (function() {
          for (var i = 0; i < 64; i++) {
            T[i] = Math2.abs(Math2.sin(i + 1)) * 4294967296 | 0;
          }
        })();
        var MD5 = C_algo.MD5 = Hasher.extend({
          _doReset: function() {
            this._hash = new WordArray.init([
              1732584193,
              4023233417,
              2562383102,
              271733878
            ]);
          },
          _doProcessBlock: function(M, offset) {
            for (var i = 0; i < 16; i++) {
              var offset_i = offset + i;
              var M_offset_i = M[offset_i];
              M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 16711935 | (M_offset_i << 24 | M_offset_i >>> 8) & 4278255360;
            }
            var H = this._hash.words;
            var M_offset_0 = M[offset + 0];
            var M_offset_1 = M[offset + 1];
            var M_offset_2 = M[offset + 2];
            var M_offset_3 = M[offset + 3];
            var M_offset_4 = M[offset + 4];
            var M_offset_5 = M[offset + 5];
            var M_offset_6 = M[offset + 6];
            var M_offset_7 = M[offset + 7];
            var M_offset_8 = M[offset + 8];
            var M_offset_9 = M[offset + 9];
            var M_offset_10 = M[offset + 10];
            var M_offset_11 = M[offset + 11];
            var M_offset_12 = M[offset + 12];
            var M_offset_13 = M[offset + 13];
            var M_offset_14 = M[offset + 14];
            var M_offset_15 = M[offset + 15];
            var a = H[0];
            var b = H[1];
            var c = H[2];
            var d = H[3];
            a = FF(a, b, c, d, M_offset_0, 7, T[0]);
            d = FF(d, a, b, c, M_offset_1, 12, T[1]);
            c = FF(c, d, a, b, M_offset_2, 17, T[2]);
            b = FF(b, c, d, a, M_offset_3, 22, T[3]);
            a = FF(a, b, c, d, M_offset_4, 7, T[4]);
            d = FF(d, a, b, c, M_offset_5, 12, T[5]);
            c = FF(c, d, a, b, M_offset_6, 17, T[6]);
            b = FF(b, c, d, a, M_offset_7, 22, T[7]);
            a = FF(a, b, c, d, M_offset_8, 7, T[8]);
            d = FF(d, a, b, c, M_offset_9, 12, T[9]);
            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
            a = FF(a, b, c, d, M_offset_12, 7, T[12]);
            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
            b = FF(b, c, d, a, M_offset_15, 22, T[15]);
            a = GG(a, b, c, d, M_offset_1, 5, T[16]);
            d = GG(d, a, b, c, M_offset_6, 9, T[17]);
            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
            b = GG(b, c, d, a, M_offset_0, 20, T[19]);
            a = GG(a, b, c, d, M_offset_5, 5, T[20]);
            d = GG(d, a, b, c, M_offset_10, 9, T[21]);
            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
            b = GG(b, c, d, a, M_offset_4, 20, T[23]);
            a = GG(a, b, c, d, M_offset_9, 5, T[24]);
            d = GG(d, a, b, c, M_offset_14, 9, T[25]);
            c = GG(c, d, a, b, M_offset_3, 14, T[26]);
            b = GG(b, c, d, a, M_offset_8, 20, T[27]);
            a = GG(a, b, c, d, M_offset_13, 5, T[28]);
            d = GG(d, a, b, c, M_offset_2, 9, T[29]);
            c = GG(c, d, a, b, M_offset_7, 14, T[30]);
            b = GG(b, c, d, a, M_offset_12, 20, T[31]);
            a = HH(a, b, c, d, M_offset_5, 4, T[32]);
            d = HH(d, a, b, c, M_offset_8, 11, T[33]);
            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
            a = HH(a, b, c, d, M_offset_1, 4, T[36]);
            d = HH(d, a, b, c, M_offset_4, 11, T[37]);
            c = HH(c, d, a, b, M_offset_7, 16, T[38]);
            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
            a = HH(a, b, c, d, M_offset_13, 4, T[40]);
            d = HH(d, a, b, c, M_offset_0, 11, T[41]);
            c = HH(c, d, a, b, M_offset_3, 16, T[42]);
            b = HH(b, c, d, a, M_offset_6, 23, T[43]);
            a = HH(a, b, c, d, M_offset_9, 4, T[44]);
            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
            b = HH(b, c, d, a, M_offset_2, 23, T[47]);
            a = II(a, b, c, d, M_offset_0, 6, T[48]);
            d = II(d, a, b, c, M_offset_7, 10, T[49]);
            c = II(c, d, a, b, M_offset_14, 15, T[50]);
            b = II(b, c, d, a, M_offset_5, 21, T[51]);
            a = II(a, b, c, d, M_offset_12, 6, T[52]);
            d = II(d, a, b, c, M_offset_3, 10, T[53]);
            c = II(c, d, a, b, M_offset_10, 15, T[54]);
            b = II(b, c, d, a, M_offset_1, 21, T[55]);
            a = II(a, b, c, d, M_offset_8, 6, T[56]);
            d = II(d, a, b, c, M_offset_15, 10, T[57]);
            c = II(c, d, a, b, M_offset_6, 15, T[58]);
            b = II(b, c, d, a, M_offset_13, 21, T[59]);
            a = II(a, b, c, d, M_offset_4, 6, T[60]);
            d = II(d, a, b, c, M_offset_11, 10, T[61]);
            c = II(c, d, a, b, M_offset_2, 15, T[62]);
            b = II(b, c, d, a, M_offset_9, 21, T[63]);
            H[0] = H[0] + a | 0;
            H[1] = H[1] + b | 0;
            H[2] = H[2] + c | 0;
            H[3] = H[3] + d | 0;
          },
          _doFinalize: function() {
            var data = this._data;
            var dataWords = data.words;
            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;
            dataWords[nBitsLeft >>> 5] |= 128 << 24 - nBitsLeft % 32;
            var nBitsTotalH = Math2.floor(nBitsTotal / 4294967296);
            var nBitsTotalL = nBitsTotal;
            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 16711935 | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 4278255360;
            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 16711935 | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 4278255360;
            data.sigBytes = (dataWords.length + 1) * 4;
            this._process();
            var hash = this._hash;
            var H = hash.words;
            for (var i = 0; i < 4; i++) {
              var H_i = H[i];
              H[i] = (H_i << 8 | H_i >>> 24) & 16711935 | (H_i << 24 | H_i >>> 8) & 4278255360;
            }
            return hash;
          },
          clone: function() {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();
            return clone;
          }
        });
        function FF(a, b, c, d, x, s, t) {
          var n = a + (b & c | ~b & d) + x + t;
          return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
          var n = a + (b & d | c & ~d) + x + t;
          return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
          var n = a + (b ^ c ^ d) + x + t;
          return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
          var n = a + (c ^ (b | ~d)) + x + t;
          return (n << s | n >>> 32 - s) + b;
        }
        C.MD5 = Hasher._createHelper(MD5);
        C.HmacMD5 = Hasher._createHmacHelper(MD5);
      })(Math);
      return CryptoJS2.MD5;
    });
  }
});

// node_modules/crypto-js/sha1.js
var require_sha1 = __commonJS({
  "node_modules/crypto-js/sha1.js"(exports, module) {
    "use strict";
    (function(root, factory) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        var W = [];
        var SHA1 = C_algo.SHA1 = Hasher.extend({
          _doReset: function() {
            this._hash = new WordArray.init([
              1732584193,
              4023233417,
              2562383102,
              271733878,
              3285377520
            ]);
          },
          _doProcessBlock: function(M, offset) {
            var H = this._hash.words;
            var a = H[0];
            var b = H[1];
            var c = H[2];
            var d = H[3];
            var e = H[4];
            for (var i = 0; i < 80; i++) {
              if (i < 16) {
                W[i] = M[offset + i] | 0;
              } else {
                var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                W[i] = n << 1 | n >>> 31;
              }
              var t = (a << 5 | a >>> 27) + e + W[i];
              if (i < 20) {
                t += (b & c | ~b & d) + 1518500249;
              } else if (i < 40) {
                t += (b ^ c ^ d) + 1859775393;
              } else if (i < 60) {
                t += (b & c | b & d | c & d) - 1894007588;
              } else {
                t += (b ^ c ^ d) - 899497514;
              }
              e = d;
              d = c;
              c = b << 30 | b >>> 2;
              b = a;
              a = t;
            }
            H[0] = H[0] + a | 0;
            H[1] = H[1] + b | 0;
            H[2] = H[2] + c | 0;
            H[3] = H[3] + d | 0;
            H[4] = H[4] + e | 0;
          },
          _doFinalize: function() {
            var data = this._data;
            var dataWords = data.words;
            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;
            dataWords[nBitsLeft >>> 5] |= 128 << 24 - nBitsLeft % 32;
            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 4294967296);
            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
            data.sigBytes = dataWords.length * 4;
            this._process();
            return this._hash;
          },
          clone: function() {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();
            return clone;
          }
        });
        C.SHA1 = Hasher._createHelper(SHA1);
        C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
      })();
      return CryptoJS2.SHA1;
    });
  }
});

// node_modules/crypto-js/sha256.js
var require_sha256 = __commonJS({
  "node_modules/crypto-js/sha256.js"(exports, module) {
    "use strict";
    (function(root, factory) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function(Math2) {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        var H = [];
        var K = [];
        (function() {
          function isPrime(n2) {
            var sqrtN = Math2.sqrt(n2);
            for (var factor = 2; factor <= sqrtN; factor++) {
              if (!(n2 % factor)) {
                return false;
              }
            }
            return true;
          }
          function getFractionalBits(n2) {
            return (n2 - (n2 | 0)) * 4294967296 | 0;
          }
          var n = 2;
          var nPrime = 0;
          while (nPrime < 64) {
            if (isPrime(n)) {
              if (nPrime < 8) {
                H[nPrime] = getFractionalBits(Math2.pow(n, 1 / 2));
              }
              K[nPrime] = getFractionalBits(Math2.pow(n, 1 / 3));
              nPrime++;
            }
            n++;
          }
        })();
        var W = [];
        var SHA256 = C_algo.SHA256 = Hasher.extend({
          _doReset: function() {
            this._hash = new WordArray.init(H.slice(0));
          },
          _doProcessBlock: function(M, offset) {
            var H2 = this._hash.words;
            var a = H2[0];
            var b = H2[1];
            var c = H2[2];
            var d = H2[3];
            var e = H2[4];
            var f = H2[5];
            var g = H2[6];
            var h = H2[7];
            for (var i = 0; i < 64; i++) {
              if (i < 16) {
                W[i] = M[offset + i] | 0;
              } else {
                var gamma0x = W[i - 15];
                var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                var gamma1x = W[i - 2];
                var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
              }
              var ch = e & f ^ ~e & g;
              var maj = a & b ^ a & c ^ b & c;
              var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
              var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
              var t1 = h + sigma1 + ch + K[i] + W[i];
              var t2 = sigma0 + maj;
              h = g;
              g = f;
              f = e;
              e = d + t1 | 0;
              d = c;
              c = b;
              b = a;
              a = t1 + t2 | 0;
            }
            H2[0] = H2[0] + a | 0;
            H2[1] = H2[1] + b | 0;
            H2[2] = H2[2] + c | 0;
            H2[3] = H2[3] + d | 0;
            H2[4] = H2[4] + e | 0;
            H2[5] = H2[5] + f | 0;
            H2[6] = H2[6] + g | 0;
            H2[7] = H2[7] + h | 0;
          },
          _doFinalize: function() {
            var data = this._data;
            var dataWords = data.words;
            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;
            dataWords[nBitsLeft >>> 5] |= 128 << 24 - nBitsLeft % 32;
            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math2.floor(nBitsTotal / 4294967296);
            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
            data.sigBytes = dataWords.length * 4;
            this._process();
            return this._hash;
          },
          clone: function() {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();
            return clone;
          }
        });
        C.SHA256 = Hasher._createHelper(SHA256);
        C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
      })(Math);
      return CryptoJS2.SHA256;
    });
  }
});

// node_modules/crypto-js/sha224.js
var require_sha224 = __commonJS({
  "node_modules/crypto-js/sha224.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_sha256());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./sha256"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        var SHA224 = C_algo.SHA224 = SHA256.extend({
          _doReset: function() {
            this._hash = new WordArray.init([
              3238371032,
              914150663,
              812702999,
              4144912697,
              4290775857,
              1750603025,
              1694076839,
              3204075428
            ]);
          },
          _doFinalize: function() {
            var hash = SHA256._doFinalize.call(this);
            hash.sigBytes -= 4;
            return hash;
          }
        });
        C.SHA224 = SHA256._createHelper(SHA224);
        C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
      })();
      return CryptoJS2.SHA224;
    });
  }
});

// node_modules/crypto-js/sha512.js
var require_sha512 = __commonJS({
  "node_modules/crypto-js/sha512.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_x64_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./x64-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
          return X64Word.create.apply(X64Word, arguments);
        }
        var K = [
          X64Word_create(1116352408, 3609767458),
          X64Word_create(1899447441, 602891725),
          X64Word_create(3049323471, 3964484399),
          X64Word_create(3921009573, 2173295548),
          X64Word_create(961987163, 4081628472),
          X64Word_create(1508970993, 3053834265),
          X64Word_create(2453635748, 2937671579),
          X64Word_create(2870763221, 3664609560),
          X64Word_create(3624381080, 2734883394),
          X64Word_create(310598401, 1164996542),
          X64Word_create(607225278, 1323610764),
          X64Word_create(1426881987, 3590304994),
          X64Word_create(1925078388, 4068182383),
          X64Word_create(2162078206, 991336113),
          X64Word_create(2614888103, 633803317),
          X64Word_create(3248222580, 3479774868),
          X64Word_create(3835390401, 2666613458),
          X64Word_create(4022224774, 944711139),
          X64Word_create(264347078, 2341262773),
          X64Word_create(604807628, 2007800933),
          X64Word_create(770255983, 1495990901),
          X64Word_create(1249150122, 1856431235),
          X64Word_create(1555081692, 3175218132),
          X64Word_create(1996064986, 2198950837),
          X64Word_create(2554220882, 3999719339),
          X64Word_create(2821834349, 766784016),
          X64Word_create(2952996808, 2566594879),
          X64Word_create(3210313671, 3203337956),
          X64Word_create(3336571891, 1034457026),
          X64Word_create(3584528711, 2466948901),
          X64Word_create(113926993, 3758326383),
          X64Word_create(338241895, 168717936),
          X64Word_create(666307205, 1188179964),
          X64Word_create(773529912, 1546045734),
          X64Word_create(1294757372, 1522805485),
          X64Word_create(1396182291, 2643833823),
          X64Word_create(1695183700, 2343527390),
          X64Word_create(1986661051, 1014477480),
          X64Word_create(2177026350, 1206759142),
          X64Word_create(2456956037, 344077627),
          X64Word_create(2730485921, 1290863460),
          X64Word_create(2820302411, 3158454273),
          X64Word_create(3259730800, 3505952657),
          X64Word_create(3345764771, 106217008),
          X64Word_create(3516065817, 3606008344),
          X64Word_create(3600352804, 1432725776),
          X64Word_create(4094571909, 1467031594),
          X64Word_create(275423344, 851169720),
          X64Word_create(430227734, 3100823752),
          X64Word_create(506948616, 1363258195),
          X64Word_create(659060556, 3750685593),
          X64Word_create(883997877, 3785050280),
          X64Word_create(958139571, 3318307427),
          X64Word_create(1322822218, 3812723403),
          X64Word_create(1537002063, 2003034995),
          X64Word_create(1747873779, 3602036899),
          X64Word_create(1955562222, 1575990012),
          X64Word_create(2024104815, 1125592928),
          X64Word_create(2227730452, 2716904306),
          X64Word_create(2361852424, 442776044),
          X64Word_create(2428436474, 593698344),
          X64Word_create(2756734187, 3733110249),
          X64Word_create(3204031479, 2999351573),
          X64Word_create(3329325298, 3815920427),
          X64Word_create(3391569614, 3928383900),
          X64Word_create(3515267271, 566280711),
          X64Word_create(3940187606, 3454069534),
          X64Word_create(4118630271, 4000239992),
          X64Word_create(116418474, 1914138554),
          X64Word_create(174292421, 2731055270),
          X64Word_create(289380356, 3203993006),
          X64Word_create(460393269, 320620315),
          X64Word_create(685471733, 587496836),
          X64Word_create(852142971, 1086792851),
          X64Word_create(1017036298, 365543100),
          X64Word_create(1126000580, 2618297676),
          X64Word_create(1288033470, 3409855158),
          X64Word_create(1501505948, 4234509866),
          X64Word_create(1607167915, 987167468),
          X64Word_create(1816402316, 1246189591)
        ];
        var W = [];
        (function() {
          for (var i = 0; i < 80; i++) {
            W[i] = X64Word_create();
          }
        })();
        var SHA512 = C_algo.SHA512 = Hasher.extend({
          _doReset: function() {
            this._hash = new X64WordArray.init([
              new X64Word.init(1779033703, 4089235720),
              new X64Word.init(3144134277, 2227873595),
              new X64Word.init(1013904242, 4271175723),
              new X64Word.init(2773480762, 1595750129),
              new X64Word.init(1359893119, 2917565137),
              new X64Word.init(2600822924, 725511199),
              new X64Word.init(528734635, 4215389547),
              new X64Word.init(1541459225, 327033209)
            ]);
          },
          _doProcessBlock: function(M, offset) {
            var H = this._hash.words;
            var H0 = H[0];
            var H1 = H[1];
            var H2 = H[2];
            var H3 = H[3];
            var H4 = H[4];
            var H5 = H[5];
            var H6 = H[6];
            var H7 = H[7];
            var H0h = H0.high;
            var H0l = H0.low;
            var H1h = H1.high;
            var H1l = H1.low;
            var H2h = H2.high;
            var H2l = H2.low;
            var H3h = H3.high;
            var H3l = H3.low;
            var H4h = H4.high;
            var H4l = H4.low;
            var H5h = H5.high;
            var H5l = H5.low;
            var H6h = H6.high;
            var H6l = H6.low;
            var H7h = H7.high;
            var H7l = H7.low;
            var ah = H0h;
            var al = H0l;
            var bh = H1h;
            var bl = H1l;
            var ch = H2h;
            var cl = H2l;
            var dh = H3h;
            var dl = H3l;
            var eh = H4h;
            var el = H4l;
            var fh = H5h;
            var fl = H5l;
            var gh = H6h;
            var gl = H6l;
            var hh = H7h;
            var hl = H7l;
            for (var i = 0; i < 80; i++) {
              var Wil;
              var Wih;
              var Wi = W[i];
              if (i < 16) {
                Wih = Wi.high = M[offset + i * 2] | 0;
                Wil = Wi.low = M[offset + i * 2 + 1] | 0;
              } else {
                var gamma0x = W[i - 15];
                var gamma0xh = gamma0x.high;
                var gamma0xl = gamma0x.low;
                var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                var gamma1x = W[i - 2];
                var gamma1xh = gamma1x.high;
                var gamma1xl = gamma1x.low;
                var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                var Wi7 = W[i - 7];
                var Wi7h = Wi7.high;
                var Wi7l = Wi7.low;
                var Wi16 = W[i - 16];
                var Wi16h = Wi16.high;
                var Wi16l = Wi16.low;
                Wil = gamma0l + Wi7l;
                Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                Wil = Wil + gamma1l;
                Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                Wil = Wil + Wi16l;
                Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                Wi.high = Wih;
                Wi.low = Wil;
              }
              var chh = eh & fh ^ ~eh & gh;
              var chl = el & fl ^ ~el & gl;
              var majh = ah & bh ^ ah & ch ^ bh & ch;
              var majl = al & bl ^ al & cl ^ bl & cl;
              var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
              var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
              var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
              var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
              var Ki = K[i];
              var Kih = Ki.high;
              var Kil = Ki.low;
              var t1l = hl + sigma1l;
              var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
              var t1l = t1l + chl;
              var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
              var t1l = t1l + Kil;
              var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
              var t1l = t1l + Wil;
              var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
              var t2l = sigma0l + majl;
              var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
              hh = gh;
              hl = gl;
              gh = fh;
              gl = fl;
              fh = eh;
              fl = el;
              el = dl + t1l | 0;
              eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
              dh = ch;
              dl = cl;
              ch = bh;
              cl = bl;
              bh = ah;
              bl = al;
              al = t1l + t2l | 0;
              ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
            }
            H0l = H0.low = H0l + al;
            H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
            H1l = H1.low = H1l + bl;
            H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
            H2l = H2.low = H2l + cl;
            H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
            H3l = H3.low = H3l + dl;
            H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
            H4l = H4.low = H4l + el;
            H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
            H5l = H5.low = H5l + fl;
            H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
            H6l = H6.low = H6l + gl;
            H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
            H7l = H7.low = H7l + hl;
            H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
          },
          _doFinalize: function() {
            var data = this._data;
            var dataWords = data.words;
            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;
            dataWords[nBitsLeft >>> 5] |= 128 << 24 - nBitsLeft % 32;
            dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 4294967296);
            dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
            data.sigBytes = dataWords.length * 4;
            this._process();
            var hash = this._hash.toX32();
            return hash;
          },
          clone: function() {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();
            return clone;
          },
          blockSize: 1024 / 32
        });
        C.SHA512 = Hasher._createHelper(SHA512);
        C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
      })();
      return CryptoJS2.SHA512;
    });
  }
});

// node_modules/crypto-js/sha384.js
var require_sha384 = __commonJS({
  "node_modules/crypto-js/sha384.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_x64_core(), require_sha512());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./x64-core", "./sha512"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        var SHA384 = C_algo.SHA384 = SHA512.extend({
          _doReset: function() {
            this._hash = new X64WordArray.init([
              new X64Word.init(3418070365, 3238371032),
              new X64Word.init(1654270250, 914150663),
              new X64Word.init(2438529370, 812702999),
              new X64Word.init(355462360, 4144912697),
              new X64Word.init(1731405415, 4290775857),
              new X64Word.init(2394180231, 1750603025),
              new X64Word.init(3675008525, 1694076839),
              new X64Word.init(1203062813, 3204075428)
            ]);
          },
          _doFinalize: function() {
            var hash = SHA512._doFinalize.call(this);
            hash.sigBytes -= 16;
            return hash;
          }
        });
        C.SHA384 = SHA512._createHelper(SHA384);
        C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
      })();
      return CryptoJS2.SHA384;
    });
  }
});

// node_modules/crypto-js/sha3.js
var require_sha3 = __commonJS({
  "node_modules/crypto-js/sha3.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_x64_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./x64-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function(Math2) {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        (function() {
          var x = 1, y = 0;
          for (var t = 0; t < 24; t++) {
            RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
            var newX = y % 5;
            var newY = (2 * x + 3 * y) % 5;
            x = newX;
            y = newY;
          }
          for (var x = 0; x < 5; x++) {
            for (var y = 0; y < 5; y++) {
              PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            }
          }
          var LFSR = 1;
          for (var i = 0; i < 24; i++) {
            var roundConstantMsw = 0;
            var roundConstantLsw = 0;
            for (var j = 0; j < 7; j++) {
              if (LFSR & 1) {
                var bitPosition = (1 << j) - 1;
                if (bitPosition < 32) {
                  roundConstantLsw ^= 1 << bitPosition;
                } else {
                  roundConstantMsw ^= 1 << bitPosition - 32;
                }
              }
              if (LFSR & 128) {
                LFSR = LFSR << 1 ^ 113;
              } else {
                LFSR <<= 1;
              }
            }
            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
          }
        })();
        var T = [];
        (function() {
          for (var i = 0; i < 25; i++) {
            T[i] = X64Word.create();
          }
        })();
        var SHA3 = C_algo.SHA3 = Hasher.extend({
          /**
           * Configuration options.
           *
           * @property {number} outputLength
           *   The desired number of bits in the output hash.
           *   Only values permitted are: 224, 256, 384, 512.
           *   Default: 512
           */
          cfg: Hasher.cfg.extend({
            outputLength: 512
          }),
          _doReset: function() {
            var state = this._state = [];
            for (var i = 0; i < 25; i++) {
              state[i] = new X64Word.init();
            }
            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
          },
          _doProcessBlock: function(M, offset) {
            var state = this._state;
            var nBlockSizeLanes = this.blockSize / 2;
            for (var i = 0; i < nBlockSizeLanes; i++) {
              var M2i = M[offset + 2 * i];
              var M2i1 = M[offset + 2 * i + 1];
              M2i = (M2i << 8 | M2i >>> 24) & 16711935 | (M2i << 24 | M2i >>> 8) & 4278255360;
              M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 16711935 | (M2i1 << 24 | M2i1 >>> 8) & 4278255360;
              var lane = state[i];
              lane.high ^= M2i1;
              lane.low ^= M2i;
            }
            for (var round = 0; round < 24; round++) {
              for (var x = 0; x < 5; x++) {
                var tMsw = 0, tLsw = 0;
                for (var y = 0; y < 5; y++) {
                  var lane = state[x + 5 * y];
                  tMsw ^= lane.high;
                  tLsw ^= lane.low;
                }
                var Tx = T[x];
                Tx.high = tMsw;
                Tx.low = tLsw;
              }
              for (var x = 0; x < 5; x++) {
                var Tx4 = T[(x + 4) % 5];
                var Tx1 = T[(x + 1) % 5];
                var Tx1Msw = Tx1.high;
                var Tx1Lsw = Tx1.low;
                var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                for (var y = 0; y < 5; y++) {
                  var lane = state[x + 5 * y];
                  lane.high ^= tMsw;
                  lane.low ^= tLsw;
                }
              }
              for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
                var tMsw;
                var tLsw;
                var lane = state[laneIndex];
                var laneMsw = lane.high;
                var laneLsw = lane.low;
                var rhoOffset = RHO_OFFSETS[laneIndex];
                if (rhoOffset < 32) {
                  tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                  tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                } else {
                  tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                  tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                }
                var TPiLane = T[PI_INDEXES[laneIndex]];
                TPiLane.high = tMsw;
                TPiLane.low = tLsw;
              }
              var T0 = T[0];
              var state0 = state[0];
              T0.high = state0.high;
              T0.low = state0.low;
              for (var x = 0; x < 5; x++) {
                for (var y = 0; y < 5; y++) {
                  var laneIndex = x + 5 * y;
                  var lane = state[laneIndex];
                  var TLane = T[laneIndex];
                  var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                  var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                  lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                  lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                }
              }
              var lane = state[0];
              var roundConstant = ROUND_CONSTANTS[round];
              lane.high ^= roundConstant.high;
              lane.low ^= roundConstant.low;
            }
          },
          _doFinalize: function() {
            var data = this._data;
            var dataWords = data.words;
            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;
            var blockSizeBits = this.blockSize * 32;
            dataWords[nBitsLeft >>> 5] |= 1 << 24 - nBitsLeft % 32;
            dataWords[(Math2.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 128;
            data.sigBytes = dataWords.length * 4;
            this._process();
            var state = this._state;
            var outputLengthBytes = this.cfg.outputLength / 8;
            var outputLengthLanes = outputLengthBytes / 8;
            var hashWords = [];
            for (var i = 0; i < outputLengthLanes; i++) {
              var lane = state[i];
              var laneMsw = lane.high;
              var laneLsw = lane.low;
              laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 16711935 | (laneMsw << 24 | laneMsw >>> 8) & 4278255360;
              laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 16711935 | (laneLsw << 24 | laneLsw >>> 8) & 4278255360;
              hashWords.push(laneLsw);
              hashWords.push(laneMsw);
            }
            return new WordArray.init(hashWords, outputLengthBytes);
          },
          clone: function() {
            var clone = Hasher.clone.call(this);
            var state = clone._state = this._state.slice(0);
            for (var i = 0; i < 25; i++) {
              state[i] = state[i].clone();
            }
            return clone;
          }
        });
        C.SHA3 = Hasher._createHelper(SHA3);
        C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
      })(Math);
      return CryptoJS2.SHA3;
    });
  }
});

// node_modules/crypto-js/ripemd160.js
var require_ripemd160 = __commonJS({
  "node_modules/crypto-js/ripemd160.js"(exports, module) {
    "use strict";
    (function(root, factory) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function(Math2) {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        var _zl = WordArray.create([
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          7,
          4,
          13,
          1,
          10,
          6,
          15,
          3,
          12,
          0,
          9,
          5,
          2,
          14,
          11,
          8,
          3,
          10,
          14,
          4,
          9,
          15,
          8,
          1,
          2,
          7,
          0,
          6,
          13,
          11,
          5,
          12,
          1,
          9,
          11,
          10,
          0,
          8,
          12,
          4,
          13,
          3,
          7,
          15,
          14,
          5,
          6,
          2,
          4,
          0,
          5,
          9,
          7,
          12,
          2,
          10,
          14,
          1,
          3,
          8,
          11,
          6,
          15,
          13
        ]);
        var _zr = WordArray.create([
          5,
          14,
          7,
          0,
          9,
          2,
          11,
          4,
          13,
          6,
          15,
          8,
          1,
          10,
          3,
          12,
          6,
          11,
          3,
          7,
          0,
          13,
          5,
          10,
          14,
          15,
          8,
          12,
          4,
          9,
          1,
          2,
          15,
          5,
          1,
          3,
          7,
          14,
          6,
          9,
          11,
          8,
          12,
          2,
          10,
          0,
          4,
          13,
          8,
          6,
          4,
          1,
          3,
          11,
          15,
          0,
          5,
          12,
          2,
          13,
          9,
          7,
          10,
          14,
          12,
          15,
          10,
          4,
          1,
          5,
          8,
          7,
          6,
          2,
          13,
          14,
          0,
          3,
          9,
          11
        ]);
        var _sl = WordArray.create([
          11,
          14,
          15,
          12,
          5,
          8,
          7,
          9,
          11,
          13,
          14,
          15,
          6,
          7,
          9,
          8,
          7,
          6,
          8,
          13,
          11,
          9,
          7,
          15,
          7,
          12,
          15,
          9,
          11,
          7,
          13,
          12,
          11,
          13,
          6,
          7,
          14,
          9,
          13,
          15,
          14,
          8,
          13,
          6,
          5,
          12,
          7,
          5,
          11,
          12,
          14,
          15,
          14,
          15,
          9,
          8,
          9,
          14,
          5,
          6,
          8,
          6,
          5,
          12,
          9,
          15,
          5,
          11,
          6,
          8,
          13,
          12,
          5,
          12,
          13,
          14,
          11,
          8,
          5,
          6
        ]);
        var _sr = WordArray.create([
          8,
          9,
          9,
          11,
          13,
          15,
          15,
          5,
          7,
          7,
          8,
          11,
          14,
          14,
          12,
          6,
          9,
          13,
          15,
          7,
          12,
          8,
          9,
          11,
          7,
          7,
          12,
          7,
          6,
          15,
          13,
          11,
          9,
          7,
          15,
          11,
          8,
          6,
          6,
          14,
          12,
          13,
          5,
          14,
          13,
          13,
          7,
          5,
          15,
          5,
          8,
          11,
          14,
          14,
          6,
          14,
          6,
          9,
          12,
          9,
          12,
          5,
          15,
          8,
          8,
          5,
          12,
          9,
          12,
          5,
          14,
          6,
          8,
          13,
          6,
          5,
          15,
          13,
          11,
          11
        ]);
        var _hl = WordArray.create([0, 1518500249, 1859775393, 2400959708, 2840853838]);
        var _hr = WordArray.create([1352829926, 1548603684, 1836072691, 2053994217, 0]);
        var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
          _doReset: function() {
            this._hash = WordArray.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
          },
          _doProcessBlock: function(M, offset) {
            for (var i = 0; i < 16; i++) {
              var offset_i = offset + i;
              var M_offset_i = M[offset_i];
              M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 16711935 | (M_offset_i << 24 | M_offset_i >>> 8) & 4278255360;
            }
            var H = this._hash.words;
            var hl = _hl.words;
            var hr = _hr.words;
            var zl = _zl.words;
            var zr = _zr.words;
            var sl = _sl.words;
            var sr = _sr.words;
            var al, bl, cl, dl, el;
            var ar, br, cr, dr, er;
            ar = al = H[0];
            br = bl = H[1];
            cr = cl = H[2];
            dr = dl = H[3];
            er = el = H[4];
            var t;
            for (var i = 0; i < 80; i += 1) {
              t = al + M[offset + zl[i]] | 0;
              if (i < 16) {
                t += f1(bl, cl, dl) + hl[0];
              } else if (i < 32) {
                t += f2(bl, cl, dl) + hl[1];
              } else if (i < 48) {
                t += f3(bl, cl, dl) + hl[2];
              } else if (i < 64) {
                t += f4(bl, cl, dl) + hl[3];
              } else {
                t += f5(bl, cl, dl) + hl[4];
              }
              t = t | 0;
              t = rotl(t, sl[i]);
              t = t + el | 0;
              al = el;
              el = dl;
              dl = rotl(cl, 10);
              cl = bl;
              bl = t;
              t = ar + M[offset + zr[i]] | 0;
              if (i < 16) {
                t += f5(br, cr, dr) + hr[0];
              } else if (i < 32) {
                t += f4(br, cr, dr) + hr[1];
              } else if (i < 48) {
                t += f3(br, cr, dr) + hr[2];
              } else if (i < 64) {
                t += f2(br, cr, dr) + hr[3];
              } else {
                t += f1(br, cr, dr) + hr[4];
              }
              t = t | 0;
              t = rotl(t, sr[i]);
              t = t + er | 0;
              ar = er;
              er = dr;
              dr = rotl(cr, 10);
              cr = br;
              br = t;
            }
            t = H[1] + cl + dr | 0;
            H[1] = H[2] + dl + er | 0;
            H[2] = H[3] + el + ar | 0;
            H[3] = H[4] + al + br | 0;
            H[4] = H[0] + bl + cr | 0;
            H[0] = t;
          },
          _doFinalize: function() {
            var data = this._data;
            var dataWords = data.words;
            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;
            dataWords[nBitsLeft >>> 5] |= 128 << 24 - nBitsLeft % 32;
            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 16711935 | (nBitsTotal << 24 | nBitsTotal >>> 8) & 4278255360;
            data.sigBytes = (dataWords.length + 1) * 4;
            this._process();
            var hash = this._hash;
            var H = hash.words;
            for (var i = 0; i < 5; i++) {
              var H_i = H[i];
              H[i] = (H_i << 8 | H_i >>> 24) & 16711935 | (H_i << 24 | H_i >>> 8) & 4278255360;
            }
            return hash;
          },
          clone: function() {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();
            return clone;
          }
        });
        function f1(x, y, z) {
          return x ^ y ^ z;
        }
        function f2(x, y, z) {
          return x & y | ~x & z;
        }
        function f3(x, y, z) {
          return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
          return x & z | y & ~z;
        }
        function f5(x, y, z) {
          return x ^ (y | ~z);
        }
        function rotl(x, n) {
          return x << n | x >>> 32 - n;
        }
        C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
      })(Math);
      return CryptoJS2.RIPEMD160;
    });
  }
});

// node_modules/crypto-js/hmac.js
var require_hmac = __commonJS({
  "node_modules/crypto-js/hmac.js"(exports, module) {
    "use strict";
    (function(root, factory) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        var HMAC = C_algo.HMAC = Base.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function(hasher, key) {
            hasher = this._hasher = new hasher.init();
            if (typeof key == "string") {
              key = Utf8.parse(key);
            }
            var hasherBlockSize = hasher.blockSize;
            var hasherBlockSizeBytes = hasherBlockSize * 4;
            if (key.sigBytes > hasherBlockSizeBytes) {
              key = hasher.finalize(key);
            }
            key.clamp();
            var oKey = this._oKey = key.clone();
            var iKey = this._iKey = key.clone();
            var oKeyWords = oKey.words;
            var iKeyWords = iKey.words;
            for (var i = 0; i < hasherBlockSize; i++) {
              oKeyWords[i] ^= 1549556828;
              iKeyWords[i] ^= 909522486;
            }
            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
            this.reset();
          },
          /**
           * Resets this HMAC to its initial state.
           *
           * @example
           *
           *     hmacHasher.reset();
           */
          reset: function() {
            var hasher = this._hasher;
            hasher.reset();
            hasher.update(this._iKey);
          },
          /**
           * Updates this HMAC with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {HMAC} This HMAC instance.
           *
           * @example
           *
           *     hmacHasher.update('message');
           *     hmacHasher.update(wordArray);
           */
          update: function(messageUpdate) {
            this._hasher.update(messageUpdate);
            return this;
          },
          /**
           * Finalizes the HMAC computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The HMAC.
           *
           * @example
           *
           *     var hmac = hmacHasher.finalize();
           *     var hmac = hmacHasher.finalize('message');
           *     var hmac = hmacHasher.finalize(wordArray);
           */
          finalize: function(messageUpdate) {
            var hasher = this._hasher;
            var innerHash = hasher.finalize(messageUpdate);
            hasher.reset();
            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
            return hmac;
          }
        });
      })();
    });
  }
});

// node_modules/crypto-js/pbkdf2.js
var require_pbkdf2 = __commonJS({
  "node_modules/crypto-js/pbkdf2.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_sha256(), require_hmac());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./sha256", "./hmac"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        var HMAC = C_algo.HMAC;
        var PBKDF2 = C_algo.PBKDF2 = Base.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hasher to use. Default: SHA256
           * @property {number} iterations The number of iterations to perform. Default: 250000
           */
          cfg: Base.extend({
            keySize: 128 / 32,
            hasher: SHA256,
            iterations: 25e4
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.PBKDF2.create();
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
           */
          init: function(cfg) {
            this.cfg = this.cfg.extend(cfg);
          },
          /**
           * Computes the Password-Based Key Derivation Function 2.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(password, salt) {
            var cfg = this.cfg;
            var hmac = HMAC.create(cfg.hasher, password);
            var derivedKey = WordArray.create();
            var blockIndex = WordArray.create([1]);
            var derivedKeyWords = derivedKey.words;
            var blockIndexWords = blockIndex.words;
            var keySize = cfg.keySize;
            var iterations = cfg.iterations;
            while (derivedKeyWords.length < keySize) {
              var block = hmac.update(salt).finalize(blockIndex);
              hmac.reset();
              var blockWords = block.words;
              var blockWordsLength = blockWords.length;
              var intermediate = block;
              for (var i = 1; i < iterations; i++) {
                intermediate = hmac.finalize(intermediate);
                hmac.reset();
                var intermediateWords = intermediate.words;
                for (var j = 0; j < blockWordsLength; j++) {
                  blockWords[j] ^= intermediateWords[j];
                }
              }
              derivedKey.concat(block);
              blockIndexWords[0]++;
            }
            derivedKey.sigBytes = keySize * 4;
            return derivedKey;
          }
        });
        C.PBKDF2 = function(password, salt, cfg) {
          return PBKDF2.create(cfg).compute(password, salt);
        };
      })();
      return CryptoJS2.PBKDF2;
    });
  }
});

// node_modules/crypto-js/evpkdf.js
var require_evpkdf = __commonJS({
  "node_modules/crypto-js/evpkdf.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_sha1(), require_hmac());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./sha1", "./hmac"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        var EvpKDF = C_algo.EvpKDF = Base.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hash algorithm to use. Default: MD5
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: Base.extend({
            keySize: 128 / 32,
            hasher: MD5,
            iterations: 1
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.EvpKDF.create();
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
           */
          init: function(cfg) {
            this.cfg = this.cfg.extend(cfg);
          },
          /**
           * Derives a key from a password.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(password, salt) {
            var block;
            var cfg = this.cfg;
            var hasher = cfg.hasher.create();
            var derivedKey = WordArray.create();
            var derivedKeyWords = derivedKey.words;
            var keySize = cfg.keySize;
            var iterations = cfg.iterations;
            while (derivedKeyWords.length < keySize) {
              if (block) {
                hasher.update(block);
              }
              block = hasher.update(password).finalize(salt);
              hasher.reset();
              for (var i = 1; i < iterations; i++) {
                block = hasher.finalize(block);
                hasher.reset();
              }
              derivedKey.concat(block);
            }
            derivedKey.sigBytes = keySize * 4;
            return derivedKey;
          }
        });
        C.EvpKDF = function(password, salt, cfg) {
          return EvpKDF.create(cfg).compute(password, salt);
        };
      })();
      return CryptoJS2.EvpKDF;
    });
  }
});

// node_modules/crypto-js/cipher-core.js
var require_cipher_core = __commonJS({
  "node_modules/crypto-js/cipher-core.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_evpkdf());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./evpkdf"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      CryptoJS2.lib.Cipher || function(undefined2) {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
          /**
           * Configuration options.
           *
           * @property {WordArray} iv The IV to use for this operation.
           */
          cfg: Base.extend(),
          /**
           * Creates this cipher in encryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
           */
          createEncryptor: function(key, cfg) {
            return this.create(this._ENC_XFORM_MODE, key, cfg);
          },
          /**
           * Creates this cipher in decryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
           */
          createDecryptor: function(key, cfg) {
            return this.create(this._DEC_XFORM_MODE, key, cfg);
          },
          /**
           * Initializes a newly created cipher.
           *
           * @param {number} xformMode Either the encryption or decryption transormation mode constant.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
           */
          init: function(xformMode, key, cfg) {
            this.cfg = this.cfg.extend(cfg);
            this._xformMode = xformMode;
            this._key = key;
            this.reset();
          },
          /**
           * Resets this cipher to its initial state.
           *
           * @example
           *
           *     cipher.reset();
           */
          reset: function() {
            BufferedBlockAlgorithm.reset.call(this);
            this._doReset();
          },
          /**
           * Adds data to be encrypted or decrypted.
           *
           * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
           *
           * @return {WordArray} The data after processing.
           *
           * @example
           *
           *     var encrypted = cipher.process('data');
           *     var encrypted = cipher.process(wordArray);
           */
          process: function(dataUpdate) {
            this._append(dataUpdate);
            return this._process();
          },
          /**
           * Finalizes the encryption or decryption process.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
           *
           * @return {WordArray} The data after final processing.
           *
           * @example
           *
           *     var encrypted = cipher.finalize();
           *     var encrypted = cipher.finalize('data');
           *     var encrypted = cipher.finalize(wordArray);
           */
          finalize: function(dataUpdate) {
            if (dataUpdate) {
              this._append(dataUpdate);
            }
            var finalProcessedData = this._doFinalize();
            return finalProcessedData;
          },
          keySize: 128 / 32,
          ivSize: 128 / 32,
          _ENC_XFORM_MODE: 1,
          _DEC_XFORM_MODE: 2,
          /**
           * Creates shortcut functions to a cipher's object interface.
           *
           * @param {Cipher} cipher The cipher to create a helper for.
           *
           * @return {Object} An object with encrypt and decrypt shortcut functions.
           *
           * @static
           *
           * @example
           *
           *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
           */
          _createHelper: function() {
            function selectCipherStrategy(key) {
              if (typeof key == "string") {
                return PasswordBasedCipher;
              } else {
                return SerializableCipher;
              }
            }
            return function(cipher) {
              return {
                encrypt: function(message, key, cfg) {
                  return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                },
                decrypt: function(ciphertext, key, cfg) {
                  return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                }
              };
            };
          }()
        });
        var StreamCipher = C_lib.StreamCipher = Cipher.extend({
          _doFinalize: function() {
            var finalProcessedBlocks = this._process(true);
            return finalProcessedBlocks;
          },
          blockSize: 1
        });
        var C_mode = C.mode = {};
        var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
          /**
           * Creates this mode for encryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
           */
          createEncryptor: function(cipher, iv) {
            return this.Encryptor.create(cipher, iv);
          },
          /**
           * Creates this mode for decryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
           */
          createDecryptor: function(cipher, iv) {
            return this.Decryptor.create(cipher, iv);
          },
          /**
           * Initializes a newly created mode.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
           */
          init: function(cipher, iv) {
            this._cipher = cipher;
            this._iv = iv;
          }
        });
        var CBC = C_mode.CBC = function() {
          var CBC2 = BlockCipherMode.extend();
          CBC2.Encryptor = CBC2.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(words, offset) {
              var cipher = this._cipher;
              var blockSize = cipher.blockSize;
              xorBlock.call(this, words, offset, blockSize);
              cipher.encryptBlock(words, offset);
              this._prevBlock = words.slice(offset, offset + blockSize);
            }
          });
          CBC2.Decryptor = CBC2.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(words, offset) {
              var cipher = this._cipher;
              var blockSize = cipher.blockSize;
              var thisBlock = words.slice(offset, offset + blockSize);
              cipher.decryptBlock(words, offset);
              xorBlock.call(this, words, offset, blockSize);
              this._prevBlock = thisBlock;
            }
          });
          function xorBlock(words, offset, blockSize) {
            var block;
            var iv = this._iv;
            if (iv) {
              block = iv;
              this._iv = undefined2;
            } else {
              block = this._prevBlock;
            }
            for (var i = 0; i < blockSize; i++) {
              words[offset + i] ^= block[i];
            }
          }
          return CBC2;
        }();
        var C_pad = C.pad = {};
        var Pkcs7 = C_pad.Pkcs7 = {
          /**
           * Pads data using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to pad.
           * @param {number} blockSize The multiple that the data should be padded to.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
           */
          pad: function(data, blockSize) {
            var blockSizeBytes = blockSize * 4;
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
            var paddingWords = [];
            for (var i = 0; i < nPaddingBytes; i += 4) {
              paddingWords.push(paddingWord);
            }
            var padding = WordArray.create(paddingWords, nPaddingBytes);
            data.concat(padding);
          },
          /**
           * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to unpad.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.unpad(wordArray);
           */
          unpad: function(data) {
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 255;
            data.sigBytes -= nPaddingBytes;
          }
        };
        var BlockCipher = C_lib.BlockCipher = Cipher.extend({
          /**
           * Configuration options.
           *
           * @property {Mode} mode The block mode to use. Default: CBC
           * @property {Padding} padding The padding strategy to use. Default: Pkcs7
           */
          cfg: Cipher.cfg.extend({
            mode: CBC,
            padding: Pkcs7
          }),
          reset: function() {
            var modeCreator;
            Cipher.reset.call(this);
            var cfg = this.cfg;
            var iv = cfg.iv;
            var mode = cfg.mode;
            if (this._xformMode == this._ENC_XFORM_MODE) {
              modeCreator = mode.createEncryptor;
            } else {
              modeCreator = mode.createDecryptor;
              this._minBufferSize = 1;
            }
            if (this._mode && this._mode.__creator == modeCreator) {
              this._mode.init(this, iv && iv.words);
            } else {
              this._mode = modeCreator.call(mode, this, iv && iv.words);
              this._mode.__creator = modeCreator;
            }
          },
          _doProcessBlock: function(words, offset) {
            this._mode.processBlock(words, offset);
          },
          _doFinalize: function() {
            var finalProcessedBlocks;
            var padding = this.cfg.padding;
            if (this._xformMode == this._ENC_XFORM_MODE) {
              padding.pad(this._data, this.blockSize);
              finalProcessedBlocks = this._process(true);
            } else {
              finalProcessedBlocks = this._process(true);
              padding.unpad(finalProcessedBlocks);
            }
            return finalProcessedBlocks;
          },
          blockSize: 128 / 32
        });
        var CipherParams = C_lib.CipherParams = Base.extend({
          /**
           * Initializes a newly created cipher params object.
           *
           * @param {Object} cipherParams An object with any of the possible cipher parameters.
           *
           * @example
           *
           *     var cipherParams = CryptoJS.lib.CipherParams.create({
           *         ciphertext: ciphertextWordArray,
           *         key: keyWordArray,
           *         iv: ivWordArray,
           *         salt: saltWordArray,
           *         algorithm: CryptoJS.algo.AES,
           *         mode: CryptoJS.mode.CBC,
           *         padding: CryptoJS.pad.PKCS7,
           *         blockSize: 4,
           *         formatter: CryptoJS.format.OpenSSL
           *     });
           */
          init: function(cipherParams) {
            this.mixIn(cipherParams);
          },
          /**
           * Converts this cipher params object to a string.
           *
           * @param {Format} formatter (Optional) The formatting strategy to use.
           *
           * @return {string} The stringified cipher params.
           *
           * @throws Error If neither the formatter nor the default formatter is set.
           *
           * @example
           *
           *     var string = cipherParams + '';
           *     var string = cipherParams.toString();
           *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
           */
          toString: function(formatter) {
            return (formatter || this.formatter).stringify(this);
          }
        });
        var C_format = C.format = {};
        var OpenSSLFormatter = C_format.OpenSSL = {
          /**
           * Converts a cipher params object to an OpenSSL-compatible string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The OpenSSL-compatible string.
           *
           * @static
           *
           * @example
           *
           *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
           */
          stringify: function(cipherParams) {
            var wordArray;
            var ciphertext = cipherParams.ciphertext;
            var salt = cipherParams.salt;
            if (salt) {
              wordArray = WordArray.create([1398893684, 1701076831]).concat(salt).concat(ciphertext);
            } else {
              wordArray = ciphertext;
            }
            return wordArray.toString(Base64);
          },
          /**
           * Converts an OpenSSL-compatible string to a cipher params object.
           *
           * @param {string} openSSLStr The OpenSSL-compatible string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
           */
          parse: function(openSSLStr) {
            var salt;
            var ciphertext = Base64.parse(openSSLStr);
            var ciphertextWords = ciphertext.words;
            if (ciphertextWords[0] == 1398893684 && ciphertextWords[1] == 1701076831) {
              salt = WordArray.create(ciphertextWords.slice(2, 4));
              ciphertextWords.splice(0, 4);
              ciphertext.sigBytes -= 16;
            }
            return CipherParams.create({ ciphertext, salt });
          }
        };
        var SerializableCipher = C_lib.SerializableCipher = Base.extend({
          /**
           * Configuration options.
           *
           * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
           */
          cfg: Base.extend({
            format: OpenSSLFormatter
          }),
          /**
           * Encrypts a message.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(cipher, message, key, cfg) {
            cfg = this.cfg.extend(cfg);
            var encryptor = cipher.createEncryptor(key, cfg);
            var ciphertext = encryptor.finalize(message);
            var cipherCfg = encryptor.cfg;
            return CipherParams.create({
              ciphertext,
              key,
              iv: cipherCfg.iv,
              algorithm: cipher,
              mode: cipherCfg.mode,
              padding: cipherCfg.padding,
              blockSize: cipher.blockSize,
              formatter: cfg.format
            });
          },
          /**
           * Decrypts serialized ciphertext.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(cipher, ciphertext, key, cfg) {
            cfg = this.cfg.extend(cfg);
            ciphertext = this._parse(ciphertext, cfg.format);
            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
            return plaintext;
          },
          /**
           * Converts serialized ciphertext to CipherParams,
           * else assumed CipherParams already and returns ciphertext unchanged.
           *
           * @param {CipherParams|string} ciphertext The ciphertext.
           * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
           *
           * @return {CipherParams} The unserialized ciphertext.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
           */
          _parse: function(ciphertext, format) {
            if (typeof ciphertext == "string") {
              return format.parse(ciphertext, this);
            } else {
              return ciphertext;
            }
          }
        });
        var C_kdf = C.kdf = {};
        var OpenSSLKdf = C_kdf.OpenSSL = {
          /**
           * Derives a key and IV from a password.
           *
           * @param {string} password The password to derive from.
           * @param {number} keySize The size in words of the key to generate.
           * @param {number} ivSize The size in words of the IV to generate.
           * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
           *
           * @return {CipherParams} A cipher params object with the key, IV, and salt.
           *
           * @static
           *
           * @example
           *
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
           */
          execute: function(password, keySize, ivSize, salt, hasher) {
            if (!salt) {
              salt = WordArray.random(64 / 8);
            }
            if (!hasher) {
              var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);
            } else {
              var key = EvpKDF.create({ keySize: keySize + ivSize, hasher }).compute(password, salt);
            }
            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
            key.sigBytes = keySize * 4;
            return CipherParams.create({ key, iv, salt });
          }
        };
        var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
          /**
           * Configuration options.
           *
           * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
           */
          cfg: SerializableCipher.cfg.extend({
            kdf: OpenSSLKdf
          }),
          /**
           * Encrypts a message using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(cipher, message, password, cfg) {
            cfg = this.cfg.extend(cfg);
            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
            cfg.iv = derivedParams.iv;
            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
            ciphertext.mixIn(derivedParams);
            return ciphertext;
          },
          /**
           * Decrypts serialized ciphertext using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(cipher, ciphertext, password, cfg) {
            cfg = this.cfg.extend(cfg);
            ciphertext = this._parse(ciphertext, cfg.format);
            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
            cfg.iv = derivedParams.iv;
            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
            return plaintext;
          }
        });
      }();
    });
  }
});

// node_modules/crypto-js/mode-cfb.js
var require_mode_cfb = __commonJS({
  "node_modules/crypto-js/mode-cfb.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      CryptoJS2.mode.CFB = function() {
        var CFB = CryptoJS2.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
          processBlock: function(words, offset) {
            var cipher = this._cipher;
            var blockSize = cipher.blockSize;
            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
            this._prevBlock = words.slice(offset, offset + blockSize);
          }
        });
        CFB.Decryptor = CFB.extend({
          processBlock: function(words, offset) {
            var cipher = this._cipher;
            var blockSize = cipher.blockSize;
            var thisBlock = words.slice(offset, offset + blockSize);
            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
            this._prevBlock = thisBlock;
          }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
          var keystream;
          var iv = this._iv;
          if (iv) {
            keystream = iv.slice(0);
            this._iv = void 0;
          } else {
            keystream = this._prevBlock;
          }
          cipher.encryptBlock(keystream, 0);
          for (var i = 0; i < blockSize; i++) {
            words[offset + i] ^= keystream[i];
          }
        }
        return CFB;
      }();
      return CryptoJS2.mode.CFB;
    });
  }
});

// node_modules/crypto-js/mode-ctr.js
var require_mode_ctr = __commonJS({
  "node_modules/crypto-js/mode-ctr.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      CryptoJS2.mode.CTR = function() {
        var CTR = CryptoJS2.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
          processBlock: function(words, offset) {
            var cipher = this._cipher;
            var blockSize = cipher.blockSize;
            var iv = this._iv;
            var counter = this._counter;
            if (iv) {
              counter = this._counter = iv.slice(0);
              this._iv = void 0;
            }
            var keystream = counter.slice(0);
            cipher.encryptBlock(keystream, 0);
            counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
            for (var i = 0; i < blockSize; i++) {
              words[offset + i] ^= keystream[i];
            }
          }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
      }();
      return CryptoJS2.mode.CTR;
    });
  }
});

// node_modules/crypto-js/mode-ctr-gladman.js
var require_mode_ctr_gladman = __commonJS({
  "node_modules/crypto-js/mode-ctr-gladman.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      CryptoJS2.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS2.lib.BlockCipherMode.extend();
        function incWord(word) {
          if ((word >> 24 & 255) === 255) {
            var b1 = word >> 16 & 255;
            var b2 = word >> 8 & 255;
            var b3 = word & 255;
            if (b1 === 255) {
              b1 = 0;
              if (b2 === 255) {
                b2 = 0;
                if (b3 === 255) {
                  b3 = 0;
                } else {
                  ++b3;
                }
              } else {
                ++b2;
              }
            } else {
              ++b1;
            }
            word = 0;
            word += b1 << 16;
            word += b2 << 8;
            word += b3;
          } else {
            word += 1 << 24;
          }
          return word;
        }
        function incCounter(counter) {
          if ((counter[0] = incWord(counter[0])) === 0) {
            counter[1] = incWord(counter[1]);
          }
          return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
          processBlock: function(words, offset) {
            var cipher = this._cipher;
            var blockSize = cipher.blockSize;
            var iv = this._iv;
            var counter = this._counter;
            if (iv) {
              counter = this._counter = iv.slice(0);
              this._iv = void 0;
            }
            incCounter(counter);
            var keystream = counter.slice(0);
            cipher.encryptBlock(keystream, 0);
            for (var i = 0; i < blockSize; i++) {
              words[offset + i] ^= keystream[i];
            }
          }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
      }();
      return CryptoJS2.mode.CTRGladman;
    });
  }
});

// node_modules/crypto-js/mode-ofb.js
var require_mode_ofb = __commonJS({
  "node_modules/crypto-js/mode-ofb.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      CryptoJS2.mode.OFB = function() {
        var OFB = CryptoJS2.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
          processBlock: function(words, offset) {
            var cipher = this._cipher;
            var blockSize = cipher.blockSize;
            var iv = this._iv;
            var keystream = this._keystream;
            if (iv) {
              keystream = this._keystream = iv.slice(0);
              this._iv = void 0;
            }
            cipher.encryptBlock(keystream, 0);
            for (var i = 0; i < blockSize; i++) {
              words[offset + i] ^= keystream[i];
            }
          }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
      }();
      return CryptoJS2.mode.OFB;
    });
  }
});

// node_modules/crypto-js/mode-ecb.js
var require_mode_ecb = __commonJS({
  "node_modules/crypto-js/mode-ecb.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      CryptoJS2.mode.ECB = function() {
        var ECB = CryptoJS2.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
          processBlock: function(words, offset) {
            this._cipher.encryptBlock(words, offset);
          }
        });
        ECB.Decryptor = ECB.extend({
          processBlock: function(words, offset) {
            this._cipher.decryptBlock(words, offset);
          }
        });
        return ECB;
      }();
      return CryptoJS2.mode.ECB;
    });
  }
});

// node_modules/crypto-js/pad-ansix923.js
var require_pad_ansix923 = __commonJS({
  "node_modules/crypto-js/pad-ansix923.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      CryptoJS2.pad.AnsiX923 = {
        pad: function(data, blockSize) {
          var dataSigBytes = data.sigBytes;
          var blockSizeBytes = blockSize * 4;
          var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
          var lastBytePos = dataSigBytes + nPaddingBytes - 1;
          data.clamp();
          data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
          data.sigBytes += nPaddingBytes;
        },
        unpad: function(data) {
          var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 255;
          data.sigBytes -= nPaddingBytes;
        }
      };
      return CryptoJS2.pad.Ansix923;
    });
  }
});

// node_modules/crypto-js/pad-iso10126.js
var require_pad_iso10126 = __commonJS({
  "node_modules/crypto-js/pad-iso10126.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      CryptoJS2.pad.Iso10126 = {
        pad: function(data, blockSize) {
          var blockSizeBytes = blockSize * 4;
          var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
          data.concat(CryptoJS2.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS2.lib.WordArray.create([nPaddingBytes << 24], 1));
        },
        unpad: function(data) {
          var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 255;
          data.sigBytes -= nPaddingBytes;
        }
      };
      return CryptoJS2.pad.Iso10126;
    });
  }
});

// node_modules/crypto-js/pad-iso97971.js
var require_pad_iso97971 = __commonJS({
  "node_modules/crypto-js/pad-iso97971.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      CryptoJS2.pad.Iso97971 = {
        pad: function(data, blockSize) {
          data.concat(CryptoJS2.lib.WordArray.create([2147483648], 1));
          CryptoJS2.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function(data) {
          CryptoJS2.pad.ZeroPadding.unpad(data);
          data.sigBytes--;
        }
      };
      return CryptoJS2.pad.Iso97971;
    });
  }
});

// node_modules/crypto-js/pad-zeropadding.js
var require_pad_zeropadding = __commonJS({
  "node_modules/crypto-js/pad-zeropadding.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      CryptoJS2.pad.ZeroPadding = {
        pad: function(data, blockSize) {
          var blockSizeBytes = blockSize * 4;
          data.clamp();
          data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function(data) {
          var dataWords = data.words;
          var i = data.sigBytes - 1;
          for (var i = data.sigBytes - 1; i >= 0; i--) {
            if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 255) {
              data.sigBytes = i + 1;
              break;
            }
          }
        }
      };
      return CryptoJS2.pad.ZeroPadding;
    });
  }
});

// node_modules/crypto-js/pad-nopadding.js
var require_pad_nopadding = __commonJS({
  "node_modules/crypto-js/pad-nopadding.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      CryptoJS2.pad.NoPadding = {
        pad: function() {
        },
        unpad: function() {
        }
      };
      return CryptoJS2.pad.NoPadding;
    });
  }
});

// node_modules/crypto-js/format-hex.js
var require_format_hex = __commonJS({
  "node_modules/crypto-js/format-hex.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function(undefined2) {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
          /**
           * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The hexadecimally encoded string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
           */
          stringify: function(cipherParams) {
            return cipherParams.ciphertext.toString(Hex);
          },
          /**
           * Converts a hexadecimally encoded ciphertext string to a cipher params object.
           *
           * @param {string} input The hexadecimally encoded string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
           */
          parse: function(input) {
            var ciphertext = Hex.parse(input);
            return CipherParams.create({ ciphertext });
          }
        };
      })();
      return CryptoJS2.format.Hex;
    });
  }
});

// node_modules/crypto-js/aes.js
var require_aes = __commonJS({
  "node_modules/crypto-js/aes.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_enc_base64(), require_md5(), require_evpkdf(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        (function() {
          var d = [];
          for (var i = 0; i < 256; i++) {
            if (i < 128) {
              d[i] = i << 1;
            } else {
              d[i] = i << 1 ^ 283;
            }
          }
          var x = 0;
          var xi = 0;
          for (var i = 0; i < 256; i++) {
            var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
            sx = sx >>> 8 ^ sx & 255 ^ 99;
            SBOX[x] = sx;
            INV_SBOX[sx] = x;
            var x2 = d[x];
            var x4 = d[x2];
            var x8 = d[x4];
            var t = d[sx] * 257 ^ sx * 16843008;
            SUB_MIX_0[x] = t << 24 | t >>> 8;
            SUB_MIX_1[x] = t << 16 | t >>> 16;
            SUB_MIX_2[x] = t << 8 | t >>> 24;
            SUB_MIX_3[x] = t;
            var t = x8 * 16843009 ^ x4 * 65537 ^ x2 * 257 ^ x * 16843008;
            INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
            INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
            INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
            INV_SUB_MIX_3[sx] = t;
            if (!x) {
              x = xi = 1;
            } else {
              x = x2 ^ d[d[d[x8 ^ x2]]];
              xi ^= d[d[xi]];
            }
          }
        })();
        var RCON = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54];
        var AES = C_algo.AES = BlockCipher.extend({
          _doReset: function() {
            var t;
            if (this._nRounds && this._keyPriorReset === this._key) {
              return;
            }
            var key = this._keyPriorReset = this._key;
            var keyWords = key.words;
            var keySize = key.sigBytes / 4;
            var nRounds = this._nRounds = keySize + 6;
            var ksRows = (nRounds + 1) * 4;
            var keySchedule = this._keySchedule = [];
            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
              if (ksRow < keySize) {
                keySchedule[ksRow] = keyWords[ksRow];
              } else {
                t = keySchedule[ksRow - 1];
                if (!(ksRow % keySize)) {
                  t = t << 8 | t >>> 24;
                  t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 255] << 16 | SBOX[t >>> 8 & 255] << 8 | SBOX[t & 255];
                  t ^= RCON[ksRow / keySize | 0] << 24;
                } else if (keySize > 6 && ksRow % keySize == 4) {
                  t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 255] << 16 | SBOX[t >>> 8 & 255] << 8 | SBOX[t & 255];
                }
                keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
              }
            }
            var invKeySchedule = this._invKeySchedule = [];
            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
              var ksRow = ksRows - invKsRow;
              if (invKsRow % 4) {
                var t = keySchedule[ksRow];
              } else {
                var t = keySchedule[ksRow - 4];
              }
              if (invKsRow < 4 || ksRow <= 4) {
                invKeySchedule[invKsRow] = t;
              } else {
                invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 255]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 255]] ^ INV_SUB_MIX_3[SBOX[t & 255]];
              }
            }
          },
          encryptBlock: function(M, offset) {
            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
          },
          decryptBlock: function(M, offset) {
            var t = M[offset + 1];
            M[offset + 1] = M[offset + 3];
            M[offset + 3] = t;
            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
            var t = M[offset + 1];
            M[offset + 1] = M[offset + 3];
            M[offset + 3] = t;
          },
          _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_02, SUB_MIX_12, SUB_MIX_22, SUB_MIX_32, SBOX2) {
            var nRounds = this._nRounds;
            var s0 = M[offset] ^ keySchedule[0];
            var s1 = M[offset + 1] ^ keySchedule[1];
            var s2 = M[offset + 2] ^ keySchedule[2];
            var s3 = M[offset + 3] ^ keySchedule[3];
            var ksRow = 4;
            for (var round = 1; round < nRounds; round++) {
              var t0 = SUB_MIX_02[s0 >>> 24] ^ SUB_MIX_12[s1 >>> 16 & 255] ^ SUB_MIX_22[s2 >>> 8 & 255] ^ SUB_MIX_32[s3 & 255] ^ keySchedule[ksRow++];
              var t1 = SUB_MIX_02[s1 >>> 24] ^ SUB_MIX_12[s2 >>> 16 & 255] ^ SUB_MIX_22[s3 >>> 8 & 255] ^ SUB_MIX_32[s0 & 255] ^ keySchedule[ksRow++];
              var t2 = SUB_MIX_02[s2 >>> 24] ^ SUB_MIX_12[s3 >>> 16 & 255] ^ SUB_MIX_22[s0 >>> 8 & 255] ^ SUB_MIX_32[s1 & 255] ^ keySchedule[ksRow++];
              var t3 = SUB_MIX_02[s3 >>> 24] ^ SUB_MIX_12[s0 >>> 16 & 255] ^ SUB_MIX_22[s1 >>> 8 & 255] ^ SUB_MIX_32[s2 & 255] ^ keySchedule[ksRow++];
              s0 = t0;
              s1 = t1;
              s2 = t2;
              s3 = t3;
            }
            var t0 = (SBOX2[s0 >>> 24] << 24 | SBOX2[s1 >>> 16 & 255] << 16 | SBOX2[s2 >>> 8 & 255] << 8 | SBOX2[s3 & 255]) ^ keySchedule[ksRow++];
            var t1 = (SBOX2[s1 >>> 24] << 24 | SBOX2[s2 >>> 16 & 255] << 16 | SBOX2[s3 >>> 8 & 255] << 8 | SBOX2[s0 & 255]) ^ keySchedule[ksRow++];
            var t2 = (SBOX2[s2 >>> 24] << 24 | SBOX2[s3 >>> 16 & 255] << 16 | SBOX2[s0 >>> 8 & 255] << 8 | SBOX2[s1 & 255]) ^ keySchedule[ksRow++];
            var t3 = (SBOX2[s3 >>> 24] << 24 | SBOX2[s0 >>> 16 & 255] << 16 | SBOX2[s1 >>> 8 & 255] << 8 | SBOX2[s2 & 255]) ^ keySchedule[ksRow++];
            M[offset] = t0;
            M[offset + 1] = t1;
            M[offset + 2] = t2;
            M[offset + 3] = t3;
          },
          keySize: 256 / 32
        });
        C.AES = BlockCipher._createHelper(AES);
      })();
      return CryptoJS2.AES;
    });
  }
});

// node_modules/crypto-js/tripledes.js
var require_tripledes = __commonJS({
  "node_modules/crypto-js/tripledes.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_enc_base64(), require_md5(), require_evpkdf(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        var PC1 = [
          57,
          49,
          41,
          33,
          25,
          17,
          9,
          1,
          58,
          50,
          42,
          34,
          26,
          18,
          10,
          2,
          59,
          51,
          43,
          35,
          27,
          19,
          11,
          3,
          60,
          52,
          44,
          36,
          63,
          55,
          47,
          39,
          31,
          23,
          15,
          7,
          62,
          54,
          46,
          38,
          30,
          22,
          14,
          6,
          61,
          53,
          45,
          37,
          29,
          21,
          13,
          5,
          28,
          20,
          12,
          4
        ];
        var PC2 = [
          14,
          17,
          11,
          24,
          1,
          5,
          3,
          28,
          15,
          6,
          21,
          10,
          23,
          19,
          12,
          4,
          26,
          8,
          16,
          7,
          27,
          20,
          13,
          2,
          41,
          52,
          31,
          37,
          47,
          55,
          30,
          40,
          51,
          45,
          33,
          48,
          44,
          49,
          39,
          56,
          34,
          53,
          46,
          42,
          50,
          36,
          29,
          32
        ];
        var BIT_SHIFTS = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];
        var SBOX_P = [
          {
            0: 8421888,
            268435456: 32768,
            536870912: 8421378,
            805306368: 2,
            1073741824: 512,
            1342177280: 8421890,
            1610612736: 8389122,
            1879048192: 8388608,
            2147483648: 514,
            2415919104: 8389120,
            2684354560: 33280,
            2952790016: 8421376,
            3221225472: 32770,
            3489660928: 8388610,
            3758096384: 0,
            4026531840: 33282,
            134217728: 0,
            402653184: 8421890,
            671088640: 33282,
            939524096: 32768,
            1207959552: 8421888,
            1476395008: 512,
            1744830464: 8421378,
            2013265920: 2,
            2281701376: 8389120,
            2550136832: 33280,
            2818572288: 8421376,
            3087007744: 8389122,
            3355443200: 8388610,
            3623878656: 32770,
            3892314112: 514,
            4160749568: 8388608,
            1: 32768,
            268435457: 2,
            536870913: 8421888,
            805306369: 8388608,
            1073741825: 8421378,
            1342177281: 33280,
            1610612737: 512,
            1879048193: 8389122,
            2147483649: 8421890,
            2415919105: 8421376,
            2684354561: 8388610,
            2952790017: 33282,
            3221225473: 514,
            3489660929: 8389120,
            3758096385: 32770,
            4026531841: 0,
            134217729: 8421890,
            402653185: 8421376,
            671088641: 8388608,
            939524097: 512,
            1207959553: 32768,
            1476395009: 8388610,
            1744830465: 2,
            2013265921: 33282,
            2281701377: 32770,
            2550136833: 8389122,
            2818572289: 514,
            3087007745: 8421888,
            3355443201: 8389120,
            3623878657: 0,
            3892314113: 33280,
            4160749569: 8421378
          },
          {
            0: 1074282512,
            16777216: 16384,
            33554432: 524288,
            50331648: 1074266128,
            67108864: 1073741840,
            83886080: 1074282496,
            100663296: 1073758208,
            117440512: 16,
            134217728: 540672,
            150994944: 1073758224,
            167772160: 1073741824,
            184549376: 540688,
            201326592: 524304,
            218103808: 0,
            234881024: 16400,
            251658240: 1074266112,
            8388608: 1073758208,
            25165824: 540688,
            41943040: 16,
            58720256: 1073758224,
            75497472: 1074282512,
            92274688: 1073741824,
            109051904: 524288,
            125829120: 1074266128,
            142606336: 524304,
            159383552: 0,
            176160768: 16384,
            192937984: 1074266112,
            209715200: 1073741840,
            226492416: 540672,
            243269632: 1074282496,
            260046848: 16400,
            268435456: 0,
            285212672: 1074266128,
            301989888: 1073758224,
            318767104: 1074282496,
            335544320: 1074266112,
            352321536: 16,
            369098752: 540688,
            385875968: 16384,
            402653184: 16400,
            419430400: 524288,
            436207616: 524304,
            452984832: 1073741840,
            469762048: 540672,
            486539264: 1073758208,
            503316480: 1073741824,
            520093696: 1074282512,
            276824064: 540688,
            293601280: 524288,
            310378496: 1074266112,
            327155712: 16384,
            343932928: 1073758208,
            360710144: 1074282512,
            377487360: 16,
            394264576: 1073741824,
            411041792: 1074282496,
            427819008: 1073741840,
            444596224: 1073758224,
            461373440: 524304,
            478150656: 0,
            494927872: 16400,
            511705088: 1074266128,
            528482304: 540672
          },
          {
            0: 260,
            1048576: 0,
            2097152: 67109120,
            3145728: 65796,
            4194304: 65540,
            5242880: 67108868,
            6291456: 67174660,
            7340032: 67174400,
            8388608: 67108864,
            9437184: 67174656,
            10485760: 65792,
            11534336: 67174404,
            12582912: 67109124,
            13631488: 65536,
            14680064: 4,
            15728640: 256,
            524288: 67174656,
            1572864: 67174404,
            2621440: 0,
            3670016: 67109120,
            4718592: 67108868,
            5767168: 65536,
            6815744: 65540,
            7864320: 260,
            8912896: 4,
            9961472: 256,
            11010048: 67174400,
            12058624: 65796,
            13107200: 65792,
            14155776: 67109124,
            15204352: 67174660,
            16252928: 67108864,
            16777216: 67174656,
            17825792: 65540,
            18874368: 65536,
            19922944: 67109120,
            20971520: 256,
            22020096: 67174660,
            23068672: 67108868,
            24117248: 0,
            25165824: 67109124,
            26214400: 67108864,
            27262976: 4,
            28311552: 65792,
            29360128: 67174400,
            30408704: 260,
            31457280: 65796,
            32505856: 67174404,
            17301504: 67108864,
            18350080: 260,
            19398656: 67174656,
            20447232: 0,
            21495808: 65540,
            22544384: 67109120,
            23592960: 256,
            24641536: 67174404,
            25690112: 65536,
            26738688: 67174660,
            27787264: 65796,
            28835840: 67108868,
            29884416: 67109124,
            30932992: 67174400,
            31981568: 4,
            33030144: 65792
          },
          {
            0: 2151682048,
            65536: 2147487808,
            131072: 4198464,
            196608: 2151677952,
            262144: 0,
            327680: 4198400,
            393216: 2147483712,
            458752: 4194368,
            524288: 2147483648,
            589824: 4194304,
            655360: 64,
            720896: 2147487744,
            786432: 2151678016,
            851968: 4160,
            917504: 4096,
            983040: 2151682112,
            32768: 2147487808,
            98304: 64,
            163840: 2151678016,
            229376: 2147487744,
            294912: 4198400,
            360448: 2151682112,
            425984: 0,
            491520: 2151677952,
            557056: 4096,
            622592: 2151682048,
            688128: 4194304,
            753664: 4160,
            819200: 2147483648,
            884736: 4194368,
            950272: 4198464,
            1015808: 2147483712,
            1048576: 4194368,
            1114112: 4198400,
            1179648: 2147483712,
            1245184: 0,
            1310720: 4160,
            1376256: 2151678016,
            1441792: 2151682048,
            1507328: 2147487808,
            1572864: 2151682112,
            1638400: 2147483648,
            1703936: 2151677952,
            1769472: 4198464,
            1835008: 2147487744,
            1900544: 4194304,
            1966080: 64,
            2031616: 4096,
            1081344: 2151677952,
            1146880: 2151682112,
            1212416: 0,
            1277952: 4198400,
            1343488: 4194368,
            1409024: 2147483648,
            1474560: 2147487808,
            1540096: 64,
            1605632: 2147483712,
            1671168: 4096,
            1736704: 2147487744,
            1802240: 2151678016,
            1867776: 4160,
            1933312: 2151682048,
            1998848: 4194304,
            2064384: 4198464
          },
          {
            0: 128,
            4096: 17039360,
            8192: 262144,
            12288: 536870912,
            16384: 537133184,
            20480: 16777344,
            24576: 553648256,
            28672: 262272,
            32768: 16777216,
            36864: 537133056,
            40960: 536871040,
            45056: 553910400,
            49152: 553910272,
            53248: 0,
            57344: 17039488,
            61440: 553648128,
            2048: 17039488,
            6144: 553648256,
            10240: 128,
            14336: 17039360,
            18432: 262144,
            22528: 537133184,
            26624: 553910272,
            30720: 536870912,
            34816: 537133056,
            38912: 0,
            43008: 553910400,
            47104: 16777344,
            51200: 536871040,
            55296: 553648128,
            59392: 16777216,
            63488: 262272,
            65536: 262144,
            69632: 128,
            73728: 536870912,
            77824: 553648256,
            81920: 16777344,
            86016: 553910272,
            90112: 537133184,
            94208: 16777216,
            98304: 553910400,
            102400: 553648128,
            106496: 17039360,
            110592: 537133056,
            114688: 262272,
            118784: 536871040,
            122880: 0,
            126976: 17039488,
            67584: 553648256,
            71680: 16777216,
            75776: 17039360,
            79872: 537133184,
            83968: 536870912,
            88064: 17039488,
            92160: 128,
            96256: 553910272,
            100352: 262272,
            104448: 553910400,
            108544: 0,
            112640: 553648128,
            116736: 16777344,
            120832: 262144,
            124928: 537133056,
            129024: 536871040
          },
          {
            0: 268435464,
            256: 8192,
            512: 270532608,
            768: 270540808,
            1024: 268443648,
            1280: 2097152,
            1536: 2097160,
            1792: 268435456,
            2048: 0,
            2304: 268443656,
            2560: 2105344,
            2816: 8,
            3072: 270532616,
            3328: 2105352,
            3584: 8200,
            3840: 270540800,
            128: 270532608,
            384: 270540808,
            640: 8,
            896: 2097152,
            1152: 2105352,
            1408: 268435464,
            1664: 268443648,
            1920: 8200,
            2176: 2097160,
            2432: 8192,
            2688: 268443656,
            2944: 270532616,
            3200: 0,
            3456: 270540800,
            3712: 2105344,
            3968: 268435456,
            4096: 268443648,
            4352: 270532616,
            4608: 270540808,
            4864: 8200,
            5120: 2097152,
            5376: 268435456,
            5632: 268435464,
            5888: 2105344,
            6144: 2105352,
            6400: 0,
            6656: 8,
            6912: 270532608,
            7168: 8192,
            7424: 268443656,
            7680: 270540800,
            7936: 2097160,
            4224: 8,
            4480: 2105344,
            4736: 2097152,
            4992: 268435464,
            5248: 268443648,
            5504: 8200,
            5760: 270540808,
            6016: 270532608,
            6272: 270540800,
            6528: 270532616,
            6784: 8192,
            7040: 2105352,
            7296: 2097160,
            7552: 0,
            7808: 268435456,
            8064: 268443656
          },
          {
            0: 1048576,
            16: 33555457,
            32: 1024,
            48: 1049601,
            64: 34604033,
            80: 0,
            96: 1,
            112: 34603009,
            128: 33555456,
            144: 1048577,
            160: 33554433,
            176: 34604032,
            192: 34603008,
            208: 1025,
            224: 1049600,
            240: 33554432,
            8: 34603009,
            24: 0,
            40: 33555457,
            56: 34604032,
            72: 1048576,
            88: 33554433,
            104: 33554432,
            120: 1025,
            136: 1049601,
            152: 33555456,
            168: 34603008,
            184: 1048577,
            200: 1024,
            216: 34604033,
            232: 1,
            248: 1049600,
            256: 33554432,
            272: 1048576,
            288: 33555457,
            304: 34603009,
            320: 1048577,
            336: 33555456,
            352: 34604032,
            368: 1049601,
            384: 1025,
            400: 34604033,
            416: 1049600,
            432: 1,
            448: 0,
            464: 34603008,
            480: 33554433,
            496: 1024,
            264: 1049600,
            280: 33555457,
            296: 34603009,
            312: 1,
            328: 33554432,
            344: 1048576,
            360: 1025,
            376: 34604032,
            392: 33554433,
            408: 34603008,
            424: 0,
            440: 34604033,
            456: 1049601,
            472: 1024,
            488: 33555456,
            504: 1048577
          },
          {
            0: 134219808,
            1: 131072,
            2: 134217728,
            3: 32,
            4: 131104,
            5: 134350880,
            6: 134350848,
            7: 2048,
            8: 134348800,
            9: 134219776,
            10: 133120,
            11: 134348832,
            12: 2080,
            13: 0,
            14: 134217760,
            15: 133152,
            2147483648: 2048,
            2147483649: 134350880,
            2147483650: 134219808,
            2147483651: 134217728,
            2147483652: 134348800,
            2147483653: 133120,
            2147483654: 133152,
            2147483655: 32,
            2147483656: 134217760,
            2147483657: 2080,
            2147483658: 131104,
            2147483659: 134350848,
            2147483660: 0,
            2147483661: 134348832,
            2147483662: 134219776,
            2147483663: 131072,
            16: 133152,
            17: 134350848,
            18: 32,
            19: 2048,
            20: 134219776,
            21: 134217760,
            22: 134348832,
            23: 131072,
            24: 0,
            25: 131104,
            26: 134348800,
            27: 134219808,
            28: 134350880,
            29: 133120,
            30: 2080,
            31: 134217728,
            2147483664: 131072,
            2147483665: 2048,
            2147483666: 134348832,
            2147483667: 133152,
            2147483668: 32,
            2147483669: 134348800,
            2147483670: 134217728,
            2147483671: 134219808,
            2147483672: 134350880,
            2147483673: 134217760,
            2147483674: 134219776,
            2147483675: 0,
            2147483676: 133120,
            2147483677: 2080,
            2147483678: 131104,
            2147483679: 134350848
          }
        ];
        var SBOX_MASK = [
          4160749569,
          528482304,
          33030144,
          2064384,
          129024,
          8064,
          504,
          2147483679
        ];
        var DES = C_algo.DES = BlockCipher.extend({
          _doReset: function() {
            var key = this._key;
            var keyWords = key.words;
            var keyBits = [];
            for (var i = 0; i < 56; i++) {
              var keyBitPos = PC1[i] - 1;
              keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
            }
            var subKeys = this._subKeys = [];
            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
              var subKey = subKeys[nSubKey] = [];
              var bitShift = BIT_SHIFTS[nSubKey];
              for (var i = 0; i < 24; i++) {
                subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
              }
              subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
              for (var i = 1; i < 7; i++) {
                subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
              }
              subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
            }
            var invSubKeys = this._invSubKeys = [];
            for (var i = 0; i < 16; i++) {
              invSubKeys[i] = subKeys[15 - i];
            }
          },
          encryptBlock: function(M, offset) {
            this._doCryptBlock(M, offset, this._subKeys);
          },
          decryptBlock: function(M, offset) {
            this._doCryptBlock(M, offset, this._invSubKeys);
          },
          _doCryptBlock: function(M, offset, subKeys) {
            this._lBlock = M[offset];
            this._rBlock = M[offset + 1];
            exchangeLR.call(this, 4, 252645135);
            exchangeLR.call(this, 16, 65535);
            exchangeRL.call(this, 2, 858993459);
            exchangeRL.call(this, 8, 16711935);
            exchangeLR.call(this, 1, 1431655765);
            for (var round = 0; round < 16; round++) {
              var subKey = subKeys[round];
              var lBlock = this._lBlock;
              var rBlock = this._rBlock;
              var f = 0;
              for (var i = 0; i < 8; i++) {
                f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
              }
              this._lBlock = rBlock;
              this._rBlock = lBlock ^ f;
            }
            var t = this._lBlock;
            this._lBlock = this._rBlock;
            this._rBlock = t;
            exchangeLR.call(this, 1, 1431655765);
            exchangeRL.call(this, 8, 16711935);
            exchangeRL.call(this, 2, 858993459);
            exchangeLR.call(this, 16, 65535);
            exchangeLR.call(this, 4, 252645135);
            M[offset] = this._lBlock;
            M[offset + 1] = this._rBlock;
          },
          keySize: 64 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        function exchangeLR(offset, mask) {
          var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
          this._rBlock ^= t;
          this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
          var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
          this._lBlock ^= t;
          this._rBlock ^= t << offset;
        }
        C.DES = BlockCipher._createHelper(DES);
        var TripleDES = C_algo.TripleDES = BlockCipher.extend({
          _doReset: function() {
            var key = this._key;
            var keyWords = key.words;
            if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) {
              throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
            }
            var key1 = keyWords.slice(0, 2);
            var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
            var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
            this._des1 = DES.createEncryptor(WordArray.create(key1));
            this._des2 = DES.createEncryptor(WordArray.create(key2));
            this._des3 = DES.createEncryptor(WordArray.create(key3));
          },
          encryptBlock: function(M, offset) {
            this._des1.encryptBlock(M, offset);
            this._des2.decryptBlock(M, offset);
            this._des3.encryptBlock(M, offset);
          },
          decryptBlock: function(M, offset) {
            this._des3.decryptBlock(M, offset);
            this._des2.encryptBlock(M, offset);
            this._des1.decryptBlock(M, offset);
          },
          keySize: 192 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        C.TripleDES = BlockCipher._createHelper(TripleDES);
      })();
      return CryptoJS2.TripleDES;
    });
  }
});

// node_modules/crypto-js/rc4.js
var require_rc4 = __commonJS({
  "node_modules/crypto-js/rc4.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_enc_base64(), require_md5(), require_evpkdf(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        var RC4 = C_algo.RC4 = StreamCipher.extend({
          _doReset: function() {
            var key = this._key;
            var keyWords = key.words;
            var keySigBytes = key.sigBytes;
            var S = this._S = [];
            for (var i = 0; i < 256; i++) {
              S[i] = i;
            }
            for (var i = 0, j = 0; i < 256; i++) {
              var keyByteIndex = i % keySigBytes;
              var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 255;
              j = (j + S[i] + keyByte) % 256;
              var t = S[i];
              S[i] = S[j];
              S[j] = t;
            }
            this._i = this._j = 0;
          },
          _doProcessBlock: function(M, offset) {
            M[offset] ^= generateKeystreamWord.call(this);
          },
          keySize: 256 / 32,
          ivSize: 0
        });
        function generateKeystreamWord() {
          var S = this._S;
          var i = this._i;
          var j = this._j;
          var keystreamWord = 0;
          for (var n = 0; n < 4; n++) {
            i = (i + 1) % 256;
            j = (j + S[i]) % 256;
            var t = S[i];
            S[i] = S[j];
            S[j] = t;
            keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
          }
          this._i = i;
          this._j = j;
          return keystreamWord;
        }
        C.RC4 = StreamCipher._createHelper(RC4);
        var RC4Drop = C_algo.RC4Drop = RC4.extend({
          /**
           * Configuration options.
           *
           * @property {number} drop The number of keystream words to drop. Default 192
           */
          cfg: RC4.cfg.extend({
            drop: 192
          }),
          _doReset: function() {
            RC4._doReset.call(this);
            for (var i = this.cfg.drop; i > 0; i--) {
              generateKeystreamWord.call(this);
            }
          }
        });
        C.RC4Drop = StreamCipher._createHelper(RC4Drop);
      })();
      return CryptoJS2.RC4;
    });
  }
});

// node_modules/crypto-js/rabbit.js
var require_rabbit = __commonJS({
  "node_modules/crypto-js/rabbit.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_enc_base64(), require_md5(), require_evpkdf(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        var S = [];
        var C_ = [];
        var G = [];
        var Rabbit = C_algo.Rabbit = StreamCipher.extend({
          _doReset: function() {
            var K = this._key.words;
            var iv = this.cfg.iv;
            for (var i = 0; i < 4; i++) {
              K[i] = (K[i] << 8 | K[i] >>> 24) & 16711935 | (K[i] << 24 | K[i] >>> 8) & 4278255360;
            }
            var X = this._X = [
              K[0],
              K[3] << 16 | K[2] >>> 16,
              K[1],
              K[0] << 16 | K[3] >>> 16,
              K[2],
              K[1] << 16 | K[0] >>> 16,
              K[3],
              K[2] << 16 | K[1] >>> 16
            ];
            var C2 = this._C = [
              K[2] << 16 | K[2] >>> 16,
              K[0] & 4294901760 | K[1] & 65535,
              K[3] << 16 | K[3] >>> 16,
              K[1] & 4294901760 | K[2] & 65535,
              K[0] << 16 | K[0] >>> 16,
              K[2] & 4294901760 | K[3] & 65535,
              K[1] << 16 | K[1] >>> 16,
              K[3] & 4294901760 | K[0] & 65535
            ];
            this._b = 0;
            for (var i = 0; i < 4; i++) {
              nextState.call(this);
            }
            for (var i = 0; i < 8; i++) {
              C2[i] ^= X[i + 4 & 7];
            }
            if (iv) {
              var IV = iv.words;
              var IV_0 = IV[0];
              var IV_1 = IV[1];
              var i0 = (IV_0 << 8 | IV_0 >>> 24) & 16711935 | (IV_0 << 24 | IV_0 >>> 8) & 4278255360;
              var i2 = (IV_1 << 8 | IV_1 >>> 24) & 16711935 | (IV_1 << 24 | IV_1 >>> 8) & 4278255360;
              var i1 = i0 >>> 16 | i2 & 4294901760;
              var i3 = i2 << 16 | i0 & 65535;
              C2[0] ^= i0;
              C2[1] ^= i1;
              C2[2] ^= i2;
              C2[3] ^= i3;
              C2[4] ^= i0;
              C2[5] ^= i1;
              C2[6] ^= i2;
              C2[7] ^= i3;
              for (var i = 0; i < 4; i++) {
                nextState.call(this);
              }
            }
          },
          _doProcessBlock: function(M, offset) {
            var X = this._X;
            nextState.call(this);
            S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
            S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
            S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
            S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
            for (var i = 0; i < 4; i++) {
              S[i] = (S[i] << 8 | S[i] >>> 24) & 16711935 | (S[i] << 24 | S[i] >>> 8) & 4278255360;
              M[offset + i] ^= S[i];
            }
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function nextState() {
          var X = this._X;
          var C2 = this._C;
          for (var i = 0; i < 8; i++) {
            C_[i] = C2[i];
          }
          C2[0] = C2[0] + 1295307597 + this._b | 0;
          C2[1] = C2[1] + 3545052371 + (C2[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
          C2[2] = C2[2] + 886263092 + (C2[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
          C2[3] = C2[3] + 1295307597 + (C2[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
          C2[4] = C2[4] + 3545052371 + (C2[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
          C2[5] = C2[5] + 886263092 + (C2[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
          C2[6] = C2[6] + 1295307597 + (C2[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
          C2[7] = C2[7] + 3545052371 + (C2[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
          this._b = C2[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
          for (var i = 0; i < 8; i++) {
            var gx = X[i] + C2[i];
            var ga = gx & 65535;
            var gb = gx >>> 16;
            var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
            var gl = ((gx & 4294901760) * gx | 0) + ((gx & 65535) * gx | 0);
            G[i] = gh ^ gl;
          }
          X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
          X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
          X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
          X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
          X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
          X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
          X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
          X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        C.Rabbit = StreamCipher._createHelper(Rabbit);
      })();
      return CryptoJS2.Rabbit;
    });
  }
});

// node_modules/crypto-js/rabbit-legacy.js
var require_rabbit_legacy = __commonJS({
  "node_modules/crypto-js/rabbit-legacy.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_enc_base64(), require_md5(), require_evpkdf(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        var S = [];
        var C_ = [];
        var G = [];
        var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
          _doReset: function() {
            var K = this._key.words;
            var iv = this.cfg.iv;
            var X = this._X = [
              K[0],
              K[3] << 16 | K[2] >>> 16,
              K[1],
              K[0] << 16 | K[3] >>> 16,
              K[2],
              K[1] << 16 | K[0] >>> 16,
              K[3],
              K[2] << 16 | K[1] >>> 16
            ];
            var C2 = this._C = [
              K[2] << 16 | K[2] >>> 16,
              K[0] & 4294901760 | K[1] & 65535,
              K[3] << 16 | K[3] >>> 16,
              K[1] & 4294901760 | K[2] & 65535,
              K[0] << 16 | K[0] >>> 16,
              K[2] & 4294901760 | K[3] & 65535,
              K[1] << 16 | K[1] >>> 16,
              K[3] & 4294901760 | K[0] & 65535
            ];
            this._b = 0;
            for (var i = 0; i < 4; i++) {
              nextState.call(this);
            }
            for (var i = 0; i < 8; i++) {
              C2[i] ^= X[i + 4 & 7];
            }
            if (iv) {
              var IV = iv.words;
              var IV_0 = IV[0];
              var IV_1 = IV[1];
              var i0 = (IV_0 << 8 | IV_0 >>> 24) & 16711935 | (IV_0 << 24 | IV_0 >>> 8) & 4278255360;
              var i2 = (IV_1 << 8 | IV_1 >>> 24) & 16711935 | (IV_1 << 24 | IV_1 >>> 8) & 4278255360;
              var i1 = i0 >>> 16 | i2 & 4294901760;
              var i3 = i2 << 16 | i0 & 65535;
              C2[0] ^= i0;
              C2[1] ^= i1;
              C2[2] ^= i2;
              C2[3] ^= i3;
              C2[4] ^= i0;
              C2[5] ^= i1;
              C2[6] ^= i2;
              C2[7] ^= i3;
              for (var i = 0; i < 4; i++) {
                nextState.call(this);
              }
            }
          },
          _doProcessBlock: function(M, offset) {
            var X = this._X;
            nextState.call(this);
            S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
            S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
            S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
            S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
            for (var i = 0; i < 4; i++) {
              S[i] = (S[i] << 8 | S[i] >>> 24) & 16711935 | (S[i] << 24 | S[i] >>> 8) & 4278255360;
              M[offset + i] ^= S[i];
            }
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function nextState() {
          var X = this._X;
          var C2 = this._C;
          for (var i = 0; i < 8; i++) {
            C_[i] = C2[i];
          }
          C2[0] = C2[0] + 1295307597 + this._b | 0;
          C2[1] = C2[1] + 3545052371 + (C2[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
          C2[2] = C2[2] + 886263092 + (C2[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
          C2[3] = C2[3] + 1295307597 + (C2[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
          C2[4] = C2[4] + 3545052371 + (C2[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
          C2[5] = C2[5] + 886263092 + (C2[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
          C2[6] = C2[6] + 1295307597 + (C2[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
          C2[7] = C2[7] + 3545052371 + (C2[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
          this._b = C2[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
          for (var i = 0; i < 8; i++) {
            var gx = X[i] + C2[i];
            var ga = gx & 65535;
            var gb = gx >>> 16;
            var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
            var gl = ((gx & 4294901760) * gx | 0) + ((gx & 65535) * gx | 0);
            G[i] = gh ^ gl;
          }
          X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
          X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
          X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
          X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
          X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
          X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
          X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
          X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
      })();
      return CryptoJS2.RabbitLegacy;
    });
  }
});

// node_modules/crypto-js/blowfish.js
var require_blowfish = __commonJS({
  "node_modules/crypto-js/blowfish.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_enc_base64(), require_md5(), require_evpkdf(), require_cipher_core());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
      } else {
        factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      (function() {
        var C = CryptoJS2;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        const N = 16;
        const ORIG_P = [
          608135816,
          2242054355,
          320440878,
          57701188,
          2752067618,
          698298832,
          137296536,
          3964562569,
          1160258022,
          953160567,
          3193202383,
          887688300,
          3232508343,
          3380367581,
          1065670069,
          3041331479,
          2450970073,
          2306472731
        ];
        const ORIG_S = [
          [
            3509652390,
            2564797868,
            805139163,
            3491422135,
            3101798381,
            1780907670,
            3128725573,
            4046225305,
            614570311,
            3012652279,
            134345442,
            2240740374,
            1667834072,
            1901547113,
            2757295779,
            4103290238,
            227898511,
            1921955416,
            1904987480,
            2182433518,
            2069144605,
            3260701109,
            2620446009,
            720527379,
            3318853667,
            677414384,
            3393288472,
            3101374703,
            2390351024,
            1614419982,
            1822297739,
            2954791486,
            3608508353,
            3174124327,
            2024746970,
            1432378464,
            3864339955,
            2857741204,
            1464375394,
            1676153920,
            1439316330,
            715854006,
            3033291828,
            289532110,
            2706671279,
            2087905683,
            3018724369,
            1668267050,
            732546397,
            1947742710,
            3462151702,
            2609353502,
            2950085171,
            1814351708,
            2050118529,
            680887927,
            999245976,
            1800124847,
            3300911131,
            1713906067,
            1641548236,
            4213287313,
            1216130144,
            1575780402,
            4018429277,
            3917837745,
            3693486850,
            3949271944,
            596196993,
            3549867205,
            258830323,
            2213823033,
            772490370,
            2760122372,
            1774776394,
            2652871518,
            566650946,
            4142492826,
            1728879713,
            2882767088,
            1783734482,
            3629395816,
            2517608232,
            2874225571,
            1861159788,
            326777828,
            3124490320,
            2130389656,
            2716951837,
            967770486,
            1724537150,
            2185432712,
            2364442137,
            1164943284,
            2105845187,
            998989502,
            3765401048,
            2244026483,
            1075463327,
            1455516326,
            1322494562,
            910128902,
            469688178,
            1117454909,
            936433444,
            3490320968,
            3675253459,
            1240580251,
            122909385,
            2157517691,
            634681816,
            4142456567,
            3825094682,
            3061402683,
            2540495037,
            79693498,
            3249098678,
            1084186820,
            1583128258,
            426386531,
            1761308591,
            1047286709,
            322548459,
            995290223,
            1845252383,
            2603652396,
            3431023940,
            2942221577,
            3202600964,
            3727903485,
            1712269319,
            422464435,
            3234572375,
            1170764815,
            3523960633,
            3117677531,
            1434042557,
            442511882,
            3600875718,
            1076654713,
            1738483198,
            4213154764,
            2393238008,
            3677496056,
            1014306527,
            4251020053,
            793779912,
            2902807211,
            842905082,
            4246964064,
            1395751752,
            1040244610,
            2656851899,
            3396308128,
            445077038,
            3742853595,
            3577915638,
            679411651,
            2892444358,
            2354009459,
            1767581616,
            3150600392,
            3791627101,
            3102740896,
            284835224,
            4246832056,
            1258075500,
            768725851,
            2589189241,
            3069724005,
            3532540348,
            1274779536,
            3789419226,
            2764799539,
            1660621633,
            3471099624,
            4011903706,
            913787905,
            3497959166,
            737222580,
            2514213453,
            2928710040,
            3937242737,
            1804850592,
            3499020752,
            2949064160,
            2386320175,
            2390070455,
            2415321851,
            4061277028,
            2290661394,
            2416832540,
            1336762016,
            1754252060,
            3520065937,
            3014181293,
            791618072,
            3188594551,
            3933548030,
            2332172193,
            3852520463,
            3043980520,
            413987798,
            3465142937,
            3030929376,
            4245938359,
            2093235073,
            3534596313,
            375366246,
            2157278981,
            2479649556,
            555357303,
            3870105701,
            2008414854,
            3344188149,
            4221384143,
            3956125452,
            2067696032,
            3594591187,
            2921233993,
            2428461,
            544322398,
            577241275,
            1471733935,
            610547355,
            4027169054,
            1432588573,
            1507829418,
            2025931657,
            3646575487,
            545086370,
            48609733,
            2200306550,
            1653985193,
            298326376,
            1316178497,
            3007786442,
            2064951626,
            458293330,
            2589141269,
            3591329599,
            3164325604,
            727753846,
            2179363840,
            146436021,
            1461446943,
            4069977195,
            705550613,
            3059967265,
            3887724982,
            4281599278,
            3313849956,
            1404054877,
            2845806497,
            146425753,
            1854211946
          ],
          [
            1266315497,
            3048417604,
            3681880366,
            3289982499,
            290971e4,
            1235738493,
            2632868024,
            2414719590,
            3970600049,
            1771706367,
            1449415276,
            3266420449,
            422970021,
            1963543593,
            2690192192,
            3826793022,
            1062508698,
            1531092325,
            1804592342,
            2583117782,
            2714934279,
            4024971509,
            1294809318,
            4028980673,
            1289560198,
            2221992742,
            1669523910,
            35572830,
            157838143,
            1052438473,
            1016535060,
            1802137761,
            1753167236,
            1386275462,
            3080475397,
            2857371447,
            1040679964,
            2145300060,
            2390574316,
            1461121720,
            2956646967,
            4031777805,
            4028374788,
            33600511,
            2920084762,
            1018524850,
            629373528,
            3691585981,
            3515945977,
            2091462646,
            2486323059,
            586499841,
            988145025,
            935516892,
            3367335476,
            2599673255,
            2839830854,
            265290510,
            3972581182,
            2759138881,
            3795373465,
            1005194799,
            847297441,
            406762289,
            1314163512,
            1332590856,
            1866599683,
            4127851711,
            750260880,
            613907577,
            1450815602,
            3165620655,
            3734664991,
            3650291728,
            3012275730,
            3704569646,
            1427272223,
            778793252,
            1343938022,
            2676280711,
            2052605720,
            1946737175,
            3164576444,
            3914038668,
            3967478842,
            3682934266,
            1661551462,
            3294938066,
            4011595847,
            840292616,
            3712170807,
            616741398,
            312560963,
            711312465,
            1351876610,
            322626781,
            1910503582,
            271666773,
            2175563734,
            1594956187,
            70604529,
            3617834859,
            1007753275,
            1495573769,
            4069517037,
            2549218298,
            2663038764,
            504708206,
            2263041392,
            3941167025,
            2249088522,
            1514023603,
            1998579484,
            1312622330,
            694541497,
            2582060303,
            2151582166,
            1382467621,
            776784248,
            2618340202,
            3323268794,
            2497899128,
            2784771155,
            503983604,
            4076293799,
            907881277,
            423175695,
            432175456,
            1378068232,
            4145222326,
            3954048622,
            3938656102,
            3820766613,
            2793130115,
            2977904593,
            26017576,
            3274890735,
            3194772133,
            1700274565,
            1756076034,
            4006520079,
            3677328699,
            720338349,
            1533947780,
            354530856,
            688349552,
            3973924725,
            1637815568,
            332179504,
            3949051286,
            53804574,
            2852348879,
            3044236432,
            1282449977,
            3583942155,
            3416972820,
            4006381244,
            1617046695,
            2628476075,
            3002303598,
            1686838959,
            431878346,
            2686675385,
            1700445008,
            1080580658,
            1009431731,
            832498133,
            3223435511,
            2605976345,
            2271191193,
            2516031870,
            1648197032,
            4164389018,
            2548247927,
            300782431,
            375919233,
            238389289,
            3353747414,
            2531188641,
            2019080857,
            1475708069,
            455242339,
            2609103871,
            448939670,
            3451063019,
            1395535956,
            2413381860,
            1841049896,
            1491858159,
            885456874,
            4264095073,
            4001119347,
            1565136089,
            3898914787,
            1108368660,
            540939232,
            1173283510,
            2745871338,
            3681308437,
            4207628240,
            3343053890,
            4016749493,
            1699691293,
            1103962373,
            3625875870,
            2256883143,
            3830138730,
            1031889488,
            3479347698,
            1535977030,
            4236805024,
            3251091107,
            2132092099,
            1774941330,
            1199868427,
            1452454533,
            157007616,
            2904115357,
            342012276,
            595725824,
            1480756522,
            206960106,
            497939518,
            591360097,
            863170706,
            2375253569,
            3596610801,
            1814182875,
            2094937945,
            3421402208,
            1082520231,
            3463918190,
            2785509508,
            435703966,
            3908032597,
            1641649973,
            2842273706,
            3305899714,
            1510255612,
            2148256476,
            2655287854,
            3276092548,
            4258621189,
            236887753,
            3681803219,
            274041037,
            1734335097,
            3815195456,
            3317970021,
            1899903192,
            1026095262,
            4050517792,
            356393447,
            2410691914,
            3873677099,
            3682840055
          ],
          [
            3913112168,
            2491498743,
            4132185628,
            2489919796,
            1091903735,
            1979897079,
            3170134830,
            3567386728,
            3557303409,
            857797738,
            1136121015,
            1342202287,
            507115054,
            2535736646,
            337727348,
            3213592640,
            1301675037,
            2528481711,
            1895095763,
            1721773893,
            3216771564,
            62756741,
            2142006736,
            835421444,
            2531993523,
            1442658625,
            3659876326,
            2882144922,
            676362277,
            1392781812,
            170690266,
            3921047035,
            1759253602,
            3611846912,
            1745797284,
            664899054,
            1329594018,
            3901205900,
            3045908486,
            2062866102,
            2865634940,
            3543621612,
            3464012697,
            1080764994,
            553557557,
            3656615353,
            3996768171,
            991055499,
            499776247,
            1265440854,
            648242737,
            3940784050,
            980351604,
            3713745714,
            1749149687,
            3396870395,
            4211799374,
            3640570775,
            1161844396,
            3125318951,
            1431517754,
            545492359,
            4268468663,
            3499529547,
            1437099964,
            2702547544,
            3433638243,
            2581715763,
            2787789398,
            1060185593,
            1593081372,
            2418618748,
            4260947970,
            69676912,
            2159744348,
            86519011,
            2512459080,
            3838209314,
            1220612927,
            3339683548,
            133810670,
            1090789135,
            1078426020,
            1569222167,
            845107691,
            3583754449,
            4072456591,
            1091646820,
            628848692,
            1613405280,
            3757631651,
            526609435,
            236106946,
            48312990,
            2942717905,
            3402727701,
            1797494240,
            859738849,
            992217954,
            4005476642,
            2243076622,
            3870952857,
            3732016268,
            765654824,
            3490871365,
            2511836413,
            1685915746,
            3888969200,
            1414112111,
            2273134842,
            3281911079,
            4080962846,
            172450625,
            2569994100,
            980381355,
            4109958455,
            2819808352,
            2716589560,
            2568741196,
            3681446669,
            3329971472,
            1835478071,
            660984891,
            3704678404,
            4045999559,
            3422617507,
            3040415634,
            1762651403,
            1719377915,
            3470491036,
            2693910283,
            3642056355,
            3138596744,
            1364962596,
            2073328063,
            1983633131,
            926494387,
            3423689081,
            2150032023,
            4096667949,
            1749200295,
            3328846651,
            309677260,
            2016342300,
            1779581495,
            3079819751,
            111262694,
            1274766160,
            443224088,
            298511866,
            1025883608,
            3806446537,
            1145181785,
            168956806,
            3641502830,
            3584813610,
            1689216846,
            3666258015,
            3200248200,
            1692713982,
            2646376535,
            4042768518,
            1618508792,
            1610833997,
            3523052358,
            4130873264,
            2001055236,
            3610705100,
            2202168115,
            4028541809,
            2961195399,
            1006657119,
            2006996926,
            3186142756,
            1430667929,
            3210227297,
            1314452623,
            4074634658,
            4101304120,
            2273951170,
            1399257539,
            3367210612,
            3027628629,
            1190975929,
            2062231137,
            2333990788,
            2221543033,
            2438960610,
            1181637006,
            548689776,
            2362791313,
            3372408396,
            3104550113,
            3145860560,
            296247880,
            1970579870,
            3078560182,
            3769228297,
            1714227617,
            3291629107,
            3898220290,
            166772364,
            1251581989,
            493813264,
            448347421,
            195405023,
            2709975567,
            677966185,
            3703036547,
            1463355134,
            2715995803,
            1338867538,
            1343315457,
            2802222074,
            2684532164,
            233230375,
            2599980071,
            2000651841,
            3277868038,
            1638401717,
            4028070440,
            3237316320,
            6314154,
            819756386,
            300326615,
            590932579,
            1405279636,
            3267499572,
            3150704214,
            2428286686,
            3959192993,
            3461946742,
            1862657033,
            1266418056,
            963775037,
            2089974820,
            2263052895,
            1917689273,
            448879540,
            3550394620,
            3981727096,
            150775221,
            3627908307,
            1303187396,
            508620638,
            2975983352,
            2726630617,
            1817252668,
            1876281319,
            1457606340,
            908771278,
            3720792119,
            3617206836,
            2455994898,
            1729034894,
            1080033504
          ],
          [
            976866871,
            3556439503,
            2881648439,
            1522871579,
            1555064734,
            1336096578,
            3548522304,
            2579274686,
            3574697629,
            3205460757,
            3593280638,
            3338716283,
            3079412587,
            564236357,
            2993598910,
            1781952180,
            1464380207,
            3163844217,
            3332601554,
            1699332808,
            1393555694,
            1183702653,
            3581086237,
            1288719814,
            691649499,
            2847557200,
            2895455976,
            3193889540,
            2717570544,
            1781354906,
            1676643554,
            2592534050,
            3230253752,
            1126444790,
            2770207658,
            2633158820,
            2210423226,
            2615765581,
            2414155088,
            3127139286,
            673620729,
            2805611233,
            1269405062,
            4015350505,
            3341807571,
            4149409754,
            1057255273,
            2012875353,
            2162469141,
            2276492801,
            2601117357,
            993977747,
            3918593370,
            2654263191,
            753973209,
            36408145,
            2530585658,
            25011837,
            3520020182,
            2088578344,
            530523599,
            2918365339,
            1524020338,
            1518925132,
            3760827505,
            3759777254,
            1202760957,
            3985898139,
            3906192525,
            674977740,
            4174734889,
            2031300136,
            2019492241,
            3983892565,
            4153806404,
            3822280332,
            352677332,
            2297720250,
            60907813,
            90501309,
            3286998549,
            1016092578,
            2535922412,
            2839152426,
            457141659,
            509813237,
            4120667899,
            652014361,
            1966332200,
            2975202805,
            55981186,
            2327461051,
            676427537,
            3255491064,
            2882294119,
            3433927263,
            1307055953,
            942726286,
            933058658,
            2468411793,
            3933900994,
            4215176142,
            1361170020,
            2001714738,
            2830558078,
            3274259782,
            1222529897,
            1679025792,
            2729314320,
            3714953764,
            1770335741,
            151462246,
            3013232138,
            1682292957,
            1483529935,
            471910574,
            1539241949,
            458788160,
            3436315007,
            1807016891,
            3718408830,
            978976581,
            1043663428,
            3165965781,
            1927990952,
            4200891579,
            2372276910,
            3208408903,
            3533431907,
            1412390302,
            2931980059,
            4132332400,
            1947078029,
            3881505623,
            4168226417,
            2941484381,
            1077988104,
            1320477388,
            886195818,
            18198404,
            3786409e3,
            2509781533,
            112762804,
            3463356488,
            1866414978,
            891333506,
            18488651,
            661792760,
            1628790961,
            3885187036,
            3141171499,
            876946877,
            2693282273,
            1372485963,
            791857591,
            2686433993,
            3759982718,
            3167212022,
            3472953795,
            2716379847,
            445679433,
            3561995674,
            3504004811,
            3574258232,
            54117162,
            3331405415,
            2381918588,
            3769707343,
            4154350007,
            1140177722,
            4074052095,
            668550556,
            3214352940,
            367459370,
            261225585,
            2610173221,
            4209349473,
            3468074219,
            3265815641,
            314222801,
            3066103646,
            3808782860,
            282218597,
            3406013506,
            3773591054,
            379116347,
            1285071038,
            846784868,
            2669647154,
            3771962079,
            3550491691,
            2305946142,
            453669953,
            1268987020,
            3317592352,
            3279303384,
            3744833421,
            2610507566,
            3859509063,
            266596637,
            3847019092,
            517658769,
            3462560207,
            3443424879,
            370717030,
            4247526661,
            2224018117,
            4143653529,
            4112773975,
            2788324899,
            2477274417,
            1456262402,
            2901442914,
            1517677493,
            1846949527,
            2295493580,
            3734397586,
            2176403920,
            1280348187,
            1908823572,
            3871786941,
            846861322,
            1172426758,
            3287448474,
            3383383037,
            1655181056,
            3139813346,
            901632758,
            1897031941,
            2986607138,
            3066810236,
            3447102507,
            1393639104,
            373351379,
            950779232,
            625454576,
            3124240540,
            4148612726,
            2007998917,
            544563296,
            2244738638,
            2330496472,
            2058025392,
            1291430526,
            424198748,
            50039436,
            29584100,
            3605783033,
            2429876329,
            2791104160,
            1057563949,
            3255363231,
            3075367218,
            3463963227,
            1469046755,
            985887462
          ]
        ];
        var BLOWFISH_CTX = {
          pbox: [],
          sbox: []
        };
        function F(ctx, x) {
          let a = x >> 24 & 255;
          let b = x >> 16 & 255;
          let c = x >> 8 & 255;
          let d = x & 255;
          let y = ctx.sbox[0][a] + ctx.sbox[1][b];
          y = y ^ ctx.sbox[2][c];
          y = y + ctx.sbox[3][d];
          return y;
        }
        function BlowFish_Encrypt(ctx, left, right) {
          let Xl = left;
          let Xr = right;
          let temp;
          for (let i = 0; i < N; ++i) {
            Xl = Xl ^ ctx.pbox[i];
            Xr = F(ctx, Xl) ^ Xr;
            temp = Xl;
            Xl = Xr;
            Xr = temp;
          }
          temp = Xl;
          Xl = Xr;
          Xr = temp;
          Xr = Xr ^ ctx.pbox[N];
          Xl = Xl ^ ctx.pbox[N + 1];
          return { left: Xl, right: Xr };
        }
        function BlowFish_Decrypt(ctx, left, right) {
          let Xl = left;
          let Xr = right;
          let temp;
          for (let i = N + 1; i > 1; --i) {
            Xl = Xl ^ ctx.pbox[i];
            Xr = F(ctx, Xl) ^ Xr;
            temp = Xl;
            Xl = Xr;
            Xr = temp;
          }
          temp = Xl;
          Xl = Xr;
          Xr = temp;
          Xr = Xr ^ ctx.pbox[1];
          Xl = Xl ^ ctx.pbox[0];
          return { left: Xl, right: Xr };
        }
        function BlowFishInit(ctx, key, keysize) {
          for (let Row = 0; Row < 4; Row++) {
            ctx.sbox[Row] = [];
            for (let Col = 0; Col < 256; Col++) {
              ctx.sbox[Row][Col] = ORIG_S[Row][Col];
            }
          }
          let keyIndex = 0;
          for (let index = 0; index < N + 2; index++) {
            ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
            keyIndex++;
            if (keyIndex >= keysize) {
              keyIndex = 0;
            }
          }
          let Data1 = 0;
          let Data2 = 0;
          let res = 0;
          for (let i = 0; i < N + 2; i += 2) {
            res = BlowFish_Encrypt(ctx, Data1, Data2);
            Data1 = res.left;
            Data2 = res.right;
            ctx.pbox[i] = Data1;
            ctx.pbox[i + 1] = Data2;
          }
          for (let i = 0; i < 4; i++) {
            for (let j = 0; j < 256; j += 2) {
              res = BlowFish_Encrypt(ctx, Data1, Data2);
              Data1 = res.left;
              Data2 = res.right;
              ctx.sbox[i][j] = Data1;
              ctx.sbox[i][j + 1] = Data2;
            }
          }
          return true;
        }
        var Blowfish = C_algo.Blowfish = BlockCipher.extend({
          _doReset: function() {
            if (this._keyPriorReset === this._key) {
              return;
            }
            var key = this._keyPriorReset = this._key;
            var keyWords = key.words;
            var keySize = key.sigBytes / 4;
            BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
          },
          encryptBlock: function(M, offset) {
            var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
            M[offset] = res.left;
            M[offset + 1] = res.right;
          },
          decryptBlock: function(M, offset) {
            var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
            M[offset] = res.left;
            M[offset + 1] = res.right;
          },
          blockSize: 64 / 32,
          keySize: 128 / 32,
          ivSize: 64 / 32
        });
        C.Blowfish = BlockCipher._createHelper(Blowfish);
      })();
      return CryptoJS2.Blowfish;
    });
  }
});

// node_modules/crypto-js/index.js
var require_crypto_js = __commonJS({
  "node_modules/crypto-js/index.js"(exports, module) {
    "use strict";
    (function(root, factory, undef) {
      if (typeof exports === "object") {
        module.exports = exports = factory(require_core(), require_x64_core(), require_lib_typedarrays(), require_enc_utf16(), require_enc_base64(), require_enc_base64url(), require_md5(), require_sha1(), require_sha256(), require_sha224(), require_sha512(), require_sha384(), require_sha3(), require_ripemd160(), require_hmac(), require_pbkdf2(), require_evpkdf(), require_cipher_core(), require_mode_cfb(), require_mode_ctr(), require_mode_ctr_gladman(), require_mode_ofb(), require_mode_ecb(), require_pad_ansix923(), require_pad_iso10126(), require_pad_iso97971(), require_pad_zeropadding(), require_pad_nopadding(), require_format_hex(), require_aes(), require_tripledes(), require_rc4(), require_rabbit(), require_rabbit_legacy(), require_blowfish());
      } else if (typeof define === "function" && define.amd) {
        define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./enc-base64url", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy", "./blowfish"], factory);
      } else {
        root.CryptoJS = factory(root.CryptoJS);
      }
    })(exports, function(CryptoJS2) {
      return CryptoJS2;
    });
  }
});

// src/index.ts
import JSBI18 from "jsbi";

// src/constants.ts
import JSBI from "jsbi";
var ChainId = /* @__PURE__ */ ((ChainId3) => {
  ChainId3[ChainId3["ETH_MAINNET"] = 1] = "ETH_MAINNET";
  ChainId3[ChainId3["ETH_RINKEBY"] = 4] = "ETH_RINKEBY";
  ChainId3[ChainId3["ETH_KOVAN"] = 42] = "ETH_KOVAN";
  ChainId3[ChainId3["BSC_MAINNET"] = 56] = "BSC_MAINNET";
  ChainId3[ChainId3["BSC_TESTNET"] = 97] = "BSC_TESTNET";
  ChainId3[ChainId3["MATIC_MAINNET"] = 137] = "MATIC_MAINNET";
  ChainId3[ChainId3["MATIC_MUMBAI"] = 80001] = "MATIC_MUMBAI";
  ChainId3[ChainId3["AVAX_MAINNET"] = 43114] = "AVAX_MAINNET";
  ChainId3[ChainId3["AVAX_TESTNET"] = 43113] = "AVAX_TESTNET";
  ChainId3[ChainId3["HECO_MAINNET"] = 128] = "HECO_MAINNET";
  ChainId3[ChainId3["HECO_TESTNET"] = 256] = "HECO_TESTNET";
  ChainId3[ChainId3["OKEX_MAINNET"] = 66] = "OKEX_MAINNET";
  ChainId3[ChainId3["OKEX_TESTNET"] = 65] = "OKEX_TESTNET";
  ChainId3[ChainId3["BOBA_MAINNET"] = 288] = "BOBA_MAINNET";
  ChainId3[ChainId3["BOBA_BNB"] = 56288] = "BOBA_BNB";
  ChainId3[ChainId3["BOBA_AVALANCHE"] = 43288] = "BOBA_AVALANCHE";
  ChainId3[ChainId3["BOBA_RINKEBY"] = 28] = "BOBA_RINKEBY";
  ChainId3[ChainId3["MILKOMEDA_MAINNET"] = 2001] = "MILKOMEDA_MAINNET";
  ChainId3[ChainId3["MILKOMEDA_DEVNET"] = 200101] = "MILKOMEDA_DEVNET";
  ChainId3[ChainId3["BTC_MAINNET"] = 3652501241] = "BTC_MAINNET";
  ChainId3[ChainId3["BTC_MUTINY"] = 2782866891] = "BTC_MUTINY";
  ChainId3[ChainId3["BTC_TESTNET4"] = 675223068] = "BTC_TESTNET4";
  ChainId3[ChainId3["AURORA_MAINNET"] = 1313161554] = "AURORA_MAINNET";
  ChainId3[ChainId3["AURORA_TESTNET"] = 1313161555] = "AURORA_TESTNET";
  ChainId3[ChainId3["TELOS_MAINNET"] = 40] = "TELOS_MAINNET";
  ChainId3[ChainId3["TELOS_TESTNET"] = 41] = "TELOS_TESTNET";
  ChainId3[ChainId3["SHARDEUM_TESTNET_2"] = 8081] = "SHARDEUM_TESTNET_2";
  ChainId3[ChainId3["KAVA_MAINNET"] = 2222] = "KAVA_MAINNET";
  ChainId3[ChainId3["SCROLL_SEPOLIA"] = 534351] = "SCROLL_SEPOLIA";
  ChainId3[ChainId3["SEPOLIA_TESTNET"] = 11155111] = "SEPOLIA_TESTNET";
  ChainId3[ChainId3["ZKSYNC_MAINNET"] = 324] = "ZKSYNC_MAINNET";
  ChainId3[ChainId3["ARBITRUM_MAINNET"] = 42161] = "ARBITRUM_MAINNET";
  ChainId3[ChainId3["ARBITRUM_NOVA"] = 42170] = "ARBITRUM_NOVA";
  ChainId3[ChainId3["OPTIMISM_MAINNET"] = 10] = "OPTIMISM_MAINNET";
  ChainId3[ChainId3["ZETACHAIN_ATHENS_2"] = 7001] = "ZETACHAIN_ATHENS_2";
  ChainId3[ChainId3["POLYGON_ZK"] = 1101] = "POLYGON_ZK";
  ChainId3[ChainId3["TRON_MAINNET"] = 728126428] = "TRON_MAINNET";
  ChainId3[ChainId3["TRON_TESTNET"] = 2494104990] = "TRON_TESTNET";
  ChainId3[ChainId3["LINEA_TESTNET"] = 59140] = "LINEA_TESTNET";
  ChainId3[ChainId3["LINEA_MAINNET"] = 59144] = "LINEA_MAINNET";
  ChainId3[ChainId3["MANTLE_MAINNET"] = 5e3] = "MANTLE_MAINNET";
  ChainId3[ChainId3["MANTLE_TESTNET"] = 5001] = "MANTLE_TESTNET";
  ChainId3[ChainId3["BASE_MAINNET"] = 8453] = "BASE_MAINNET";
  ChainId3[ChainId3["SCROLL_MAINNET"] = 534352] = "SCROLL_MAINNET";
  ChainId3[ChainId3["MANTA_MAINNET"] = 169] = "MANTA_MAINNET";
  ChainId3[ChainId3["METIS_MAINNET"] = 1088] = "METIS_MAINNET";
  ChainId3[ChainId3["OKX_X1_TESTNET"] = 195] = "OKX_X1_TESTNET";
  ChainId3[ChainId3["BAHAMUT_MAINNET"] = 5165] = "BAHAMUT_MAINNET";
  ChainId3[ChainId3["MODE_MAINNET"] = 34443] = "MODE_MAINNET";
  ChainId3[ChainId3["RSK_MAINNET"] = 30] = "RSK_MAINNET";
  ChainId3[ChainId3["BLAST_MAINNET"] = 81457] = "BLAST_MAINNET";
  ChainId3[ChainId3["MERLIN_MAINNET"] = 4200] = "MERLIN_MAINNET";
  ChainId3[ChainId3["ZKLINK_MAINNET"] = 810180] = "ZKLINK_MAINNET";
  ChainId3[ChainId3["CORE_MAINNET"] = 1116] = "CORE_MAINNET";
  ChainId3[ChainId3["TON_MAINNET"] = 85918] = "TON_MAINNET";
  ChainId3[ChainId3["TON_TESTNET"] = 85919] = "TON_TESTNET";
  ChainId3[ChainId3["TAIKO_MAINNET"] = 167e3] = "TAIKO_MAINNET";
  ChainId3[ChainId3["SEI_EVM_MAINNET"] = 1329] = "SEI_EVM_MAINNET";
  ChainId3[ChainId3["ZETACHAIN_MAINNET"] = 7e3] = "ZETACHAIN_MAINNET";
  ChainId3[ChainId3["CRONOS_MAINNET"] = 25] = "CRONOS_MAINNET";
  ChainId3[ChainId3["FRAXTAL_MAINNET"] = 252] = "FRAXTAL_MAINNET";
  ChainId3[ChainId3["GRAVITY_MAINNET"] = 1625] = "GRAVITY_MAINNET";
  ChainId3[ChainId3["BSQUARED_MAINNET"] = 223] = "BSQUARED_MAINNET";
  return ChainId3;
})(ChainId || {});
var TradeType = /* @__PURE__ */ ((TradeType4) => {
  TradeType4[TradeType4["EXACT_INPUT"] = 0] = "EXACT_INPUT";
  TradeType4[TradeType4["EXACT_OUTPUT"] = 1] = "EXACT_OUTPUT";
  return TradeType4;
})(TradeType || {});
var Rounding = /* @__PURE__ */ ((Rounding4) => {
  Rounding4[Rounding4["ROUND_DOWN"] = 0] = "ROUND_DOWN";
  Rounding4[Rounding4["ROUND_HALF_UP"] = 1] = "ROUND_HALF_UP";
  Rounding4[Rounding4["ROUND_UP"] = 2] = "ROUND_UP";
  return Rounding4;
})(Rounding || {});
var FACTORY_ADDRESS = {
  [1 /* ETH_MAINNET */]: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
  [4 /* ETH_RINKEBY */]: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
  [42 /* ETH_KOVAN */]: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
  [56 /* BSC_MAINNET */]: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
  [97 /* BSC_TESTNET */]: "0x6725F303b657a9451d8BA641348b6761A6CC7a17",
  [137 /* MATIC_MAINNET */]: "0x5757371414417b8C6CAad45bAeF941aBc7d3Ab32",
  [80001 /* MATIC_MUMBAI */]: "0x8a628F00710993c1cebbaa02338d2264ee7056C6",
  [43114 /* AVAX_MAINNET */]: "0xefa94DE7a4656D787667C749f7E1223D71E9FD88",
  [43113 /* AVAX_TESTNET */]: "0xb278D63e2E2a4aeb5A398eB87a91FF909B72C8D5",
  [128 /* HECO_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [256 /* HECO_TESTNET */]: "0xca33f6D096BDD7FcB28d708f631cD76E73Ecfc2d",
  [66 /* OKEX_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [65 /* OKEX_TESTNET */]: "0xD68B1DCDe3bAeB3FF1483Ad33c3efC6B6e0A8E4C",
  [288 /* BOBA_MAINNET */]: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
  [43288 /* BOBA_AVALANCHE */]: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
  [56288 /* BOBA_BNB */]: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4",
  [28 /* BOBA_RINKEBY */]: "0xab740666e226cb5b6b451eb943b0257a7cb3ce0a",
  [2001 /* MILKOMEDA_MAINNET */]: "0x2ef06A90b0E7Ae3ae508e83Ea6628a3987945460",
  [200101 /* MILKOMEDA_DEVNET */]: "0x428779a1a596c9cfdb68f5daef78b14901b95566",
  [3652501241 /* BTC_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [2782866891 /* BTC_MUTINY */]: "0x0000000000000000000000000000000000000000",
  [675223068 /* BTC_TESTNET4 */]: "0x0000000000000000000000000000000000000000",
  [1313161554 /* AURORA_MAINNET */]: "0xc66F594268041dB60507F00703b152492fb176E7",
  [1313161555 /* AURORA_TESTNET */]: "0x60913758635b54e6C9685f92201A5704eEe74748",
  [40 /* TELOS_MAINNET */]: "0xb630f53df13645bff0ef55eb44a8a490a7dd4514",
  [41 /* TELOS_TESTNET */]: "0x6db1D2C691DcdF4DA36d3497F68a63C7282a4a44",
  [8081 /* SHARDEUM_TESTNET_2 */]: "0x1DAcbaB28Decd115c8AA6F183877C71b942aE406",
  [2222 /* KAVA_MAINNET */]: "0xA138FAFc30f6Ec6980aAd22656F2F11C38B56a95",
  [534351 /* SCROLL_SEPOLIA */]: "0x0000000000000000000000000000000000000000",
  [324 /* ZKSYNC_MAINNET */]: "0x40be1cba6c5b47cdf9da7f963b6f761f4c60627d",
  [42161 /* ARBITRUM_MAINNET */]: "0xd394e9cc20f43d2651293756f8d320668e850f1b",
  // arbSwap
  [42170 /* ARBITRUM_NOVA */]: "0xf6239423fcf1c19ed2791d9648a90836074242fd",
  // arbSwap
  [10 /* OPTIMISM_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [7001 /* ZETACHAIN_ATHENS_2 */]: "0x9fd96203f7b22bCF72d9DCb40ff98302376cE09c",
  [1101 /* POLYGON_ZK */]: "0x0000000000000000000000000000000000000000",
  [728126428 /* TRON_MAINNET */]: "0x689ABAEEED3F0BB3585773192E23224CAC25DD41",
  // sunswap.io - TKWJdrQkqHisa1X8HUdHEfREvTzw4pMAaY
  [2494104990 /* TRON_TESTNET */]: "0x1df14d5e036019f298d2a358bb234cf301e5e8e3",
  // sunswap.io - TChXfbQLafcoExbcXTtwNZMBKdeW2p1V5G
  [59140 /* LINEA_TESTNET */]: "0x0000000000000000000000000000000000000000",
  [59144 /* LINEA_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [5e3 /* MANTLE_MAINNET */]: "0xE5020961fA51ffd3662CDf307dEf18F9a87Cce7c",
  // fusionX
  [5001 /* MANTLE_TESTNET */]: "0x272465431A6b86E3B9E5b9bD33f5D103a3F59eDb",
  // fusionX
  [8453 /* BASE_MAINNET */]: "0xFDa619b6d20975be80A10332cD39b9a4b0FAa8BB",
  // baseSwap
  [534352 /* SCROLL_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [169 /* MANTA_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [1088 /* METIS_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [195 /* OKX_X1_TESTNET */]: "0x0000000000000000000000000000000000000000",
  [5165 /* BAHAMUT_MAINNET */]: "0xd0C5d23290d63E06a0c4B87F14bD2F7aA551a895",
  [34443 /* MODE_MAINNET */]: "0xc02155946dd8c89d3d3238a6c8a64d04e2cd4500",
  // kim exchange
  [30 /* RSK_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [81457 /* BLAST_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [4200 /* MERLIN_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [810180 /* ZKLINK_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [11155111 /* SEPOLIA_TESTNET */]: "0x7E0987E5b3a30e3f2828572Bb659A548460a3003",
  [1116 /* CORE_MAINNET */]: "0x3E723C7B6188E8Ef638DB9685Af45c7CB66f77B9",
  [85918 /* TON_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [85919 /* TON_TESTNET */]: "0x0000000000000000000000000000000000000000",
  [167e3 /* TAIKO_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [1329 /* SEI_EVM_MAINNET */]: "0x71f6b49ae1558357bBb5A6074f1143c46cBcA03d",
  [7e3 /* ZETACHAIN_MAINNET */]: "0x9fd96203f7b22bCF72d9DCb40ff98302376cE09c",
  [25 /* CRONOS_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [252 /* FRAXTAL_MAINNET */]: "0xE30521fe7f3bEB6Ad556887b50739d6C7CA667E6",
  [1625 /* GRAVITY_MAINNET */]: "0x0000000000000000000000000000000000000000",
  [223 /* BSQUARED_MAINNET */]: "0x0000000000000000000000000000000000000000"
};
var INIT_CODE_HASH = {
  [1 /* ETH_MAINNET */]: "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
  [4 /* ETH_RINKEBY */]: "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
  [42 /* ETH_KOVAN */]: "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
  [56 /* BSC_MAINNET */]: "0x00fb7f630766e6a796048ea87d01acd3068e8ff67d078148a3fa3f4a84f69bd5",
  [97 /* BSC_TESTNET */]: "0xd0d4c4cd0848c93cb4fd1f498d7013ee6bfb25783ea21593d5834f5d250ece66",
  [137 /* MATIC_MAINNET */]: "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
  [80001 /* MATIC_MUMBAI */]: "0x85f8ad645fe62917d6939782650649d3d7c4b5f25d81415a9fac4a9f341793ca",
  [43114 /* AVAX_MAINNET */]: "0x40231f6b438bce0797c9ada29b718a87ea0a5cea3fe9a771abdd76bd41a3e545",
  [43113 /* AVAX_TESTNET */]: "0x85f8ad645fe62917d6939782650649d3d7c4b5f25d81415a9fac4a9f341793ca",
  [128 /* HECO_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [256 /* HECO_TESTNET */]: "0x85f8ad645fe62917d6939782650649d3d7c4b5f25d81415a9fac4a9f341793ca",
  [66 /* OKEX_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [65 /* OKEX_TESTNET */]: "0x7f08f1b43a5b37be17b2d24d4f2c6b1311e19eedc53cc4528f0e72cdfb5d8d37",
  [288 /* BOBA_MAINNET */]: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
  [43288 /* BOBA_AVALANCHE */]: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
  [56288 /* BOBA_BNB */]: "0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303",
  [28 /* BOBA_RINKEBY */]: "0x1db9efb13a1398e31bb71895c392fa1217130f78dc65080174491adcec5da9b9",
  [2001 /* MILKOMEDA_MAINNET */]: "0x0103d86123641edae209ed992b2bf060ae2baab6a28f5b1eb7dad61335915104",
  [200101 /* MILKOMEDA_DEVNET */]: "0x0103d86123641edae209ed992b2bf060ae2baab6a28f5b1eb7dad61335915104",
  [3652501241 /* BTC_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [2782866891 /* BTC_MUTINY */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [675223068 /* BTC_TESTNET4 */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [1313161554 /* AURORA_MAINNET */]: "0x754e1d90e536e4c1df81b7f030f47b4ca80c87120e145c294f098c83a6cb5ace",
  [1313161555 /* AURORA_TESTNET */]: "0x4a697f690d1f46e0f1a897a8662acae31ced3039b00c052392ed0bc179f9f28c",
  [40 /* TELOS_MAINNET */]: "0x73d5f9d3e0db97ca102c315a9a45dfebef394eae36edcce8853bcb1ee049a6dd",
  [41 /* TELOS_TESTNET */]: "0x4386561b28c0ca71b777ab3684458dd9f6c1b3b7fc609c5758f0f00a48625996",
  [8081 /* SHARDEUM_TESTNET_2 */]: "0x3bde95ed3dcb15c415ca128950d4807b9e3698b981ff73007c9d3c220a5b2f6f",
  [2222 /* KAVA_MAINNET */]: "0x851a56ac1b3682251d8341ad09c09bf45fca37af4451453063637d745a94fe1f",
  [534351 /* SCROLL_SEPOLIA */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [324 /* ZKSYNC_MAINNET */]: "0x95d5c05820d58f1c8cc736b47fe10a29ddcd2cf73a0d842e8537b9fe510fc618",
  [42161 /* ARBITRUM_MAINNET */]: "0x8336ef61546f16041265cbd61fb71f00434b515a1f3dba059227802ec4a4be4f",
  // arbSwap
  [42170 /* ARBITRUM_NOVA */]: "0x70b19cf85a176c6b86e2d324be179104bdc8fafee13d548ae07d28b9f53cbc71",
  // arbSwap
  [10 /* OPTIMISM_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [7001 /* ZETACHAIN_ATHENS_2 */]: "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
  [1101 /* POLYGON_ZK */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [59140 /* LINEA_TESTNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [59144 /* LINEA_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [5e3 /* MANTLE_MAINNET */]: "0x58c684aeb03fe49c8a3080db88e425fae262c5ef5bf0e8acffc0526c6e3c03a0",
  // fusionX
  [5001 /* MANTLE_TESTNET */]: "0x58c684aeb03fe49c8a3080db88e425fae262c5ef5bf0e8acffc0526c6e3c03a0",
  // fusionX
  [8453 /* BASE_MAINNET */]: "0xb618a2730fae167f5f8ac7bd659dd8436d571872655bcb6fd11f2158c8a64a3b",
  // baseSwap
  [728126428 /* TRON_MAINNET */]: "0x6d3f89421f83e4b62e628de8fc7ff2b014a79bf8fd8e8b0ea46e4a1d9409b67d",
  // sunswap.io
  [2494104990 /* TRON_TESTNET */]: "0x0e26acb4c8f8d3df2264904ab1e00efdc142a9f341741ca7e0a7ae5f9b0c0fa9",
  // sunswap.io
  [534352 /* SCROLL_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [169 /* MANTA_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [1088 /* METIS_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [195 /* OKX_X1_TESTNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [5165 /* BAHAMUT_MAINNET */]: "0x79cd523bc695c4f4a15256b1eddb22624ae455e51c452c3dac1737955440bfbe",
  [34443 /* MODE_MAINNET */]: "0x7b58b1fadf495e5bef34e311418b22e4f729c080a333619b4318c23bc7fb4c0a",
  // kim exchange
  [30 /* RSK_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [81457 /* BLAST_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [4200 /* MERLIN_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [810180 /* ZKLINK_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [11155111 /* SEPOLIA_TESTNET */]: "0x4156ccc01dad273e6c65c4335c428a2ff4a4b0c95a9a228f6bfed45a069d3fe7",
  [1116 /* CORE_MAINNET */]: "0xee028118a054757b5daded92bc998b195fc653d33f3214aaabeec98d7599f6b8",
  [85918 /* TON_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [85919 /* TON_TESTNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [167e3 /* TAIKO_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [1329 /* SEI_EVM_MAINNET */]: "0x7240a7a71cc85d56ee2e5ca1c5236ce877abc9b49b4696adc94968ef43796fed",
  [7e3 /* ZETACHAIN_MAINNET */]: "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f",
  [25 /* CRONOS_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [252 /* FRAXTAL_MAINNET */]: "0x676b4c9b92980c4e7823b43031b17d7299896d1cd7d147104ad8e21692123fa1",
  [1625 /* GRAVITY_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000",
  [223 /* BSQUARED_MAINNET */]: "0x0000000000000000000000000000000000000000000000000000000000000000"
};
var MINIMUM_LIQUIDITY = JSBI.BigInt(1e3);
var ZERO = JSBI.BigInt(0);
var ONE = JSBI.BigInt(1);
var TWO = JSBI.BigInt(2);
var THREE = JSBI.BigInt(3);
var FIVE = JSBI.BigInt(5);
var TEN = JSBI.BigInt(10);
var _100 = JSBI.BigInt(100);
var _998 = JSBI.BigInt(998);
var _1000 = JSBI.BigInt(1e3);
var SOLIDITY_TYPE_MAXIMA = {
  ["uint8" /* uint8 */]: JSBI.BigInt("0xff"),
  ["uint256" /* uint256 */]: JSBI.BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff")
};
var NATIVE_TOKEN_ADDRESS = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";

// src/errors.ts
var CAN_SET_PROTOTYPE = "setPrototypeOf" in Object;
var InsufficientReservesError = class extends Error {
  constructor() {
    super();
    this.isInsufficientReservesError = true;
    this.name = this.constructor.name;
    if (CAN_SET_PROTOTYPE)
      Object.setPrototypeOf(this, new.target.prototype);
  }
};
var InsufficientInputAmountError = class extends Error {
  constructor() {
    super();
    this.isInsufficientInputAmountError = true;
    this.name = this.constructor.name;
    if (CAN_SET_PROTOTYPE)
      Object.setPrototypeOf(this, new.target.prototype);
  }
};

// src/entities/chain.ts
var Chain = class {
  constructor(params) {
    this.id = params.id;
    this.name = params.name;
    this.disabled = params.disabled;
    this.explorer = params.explorer;
    this.icons = params.icons;
    this.swappable = params?.swappable !== false;
    this.evm = params?.evm !== false;
  }
};
var chains = [
  new Chain({
    id: 85918 /* TON_MAINNET */,
    name: "TON",
    disabled: false,
    explorer: "https://tonviewer.com",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
    },
    evm: false
  }),
  new Chain({
    id: 85919 /* TON_TESTNET */,
    name: "TON",
    disabled: false,
    explorer: "https://testnet.tonviewer.com",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
    },
    evm: false
  }),
  new Chain({
    id: 3652501241 /* BTC_MAINNET */,
    name: "Bitcoin",
    disabled: false,
    explorer: "https://mempool.space",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png"
    },
    evm: false
  }),
  new Chain({
    id: 2782866891 /* BTC_MUTINY */,
    name: "Bitcoin Mutiny",
    disabled: false,
    explorer: "https://mutinynet.com",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png"
    },
    evm: false
  }),
  new Chain({
    id: 675223068 /* BTC_TESTNET4 */,
    name: "Bitcoin Testnet4",
    disabled: false,
    explorer: "https://mempool.space/testnet4",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png"
    },
    evm: false
  }),
  new Chain({
    id: 1 /* ETH_MAINNET */,
    name: "Ethereum",
    disabled: false,
    explorer: "https://etherscan.io",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png"
    }
  }),
  new Chain({
    id: 4 /* ETH_RINKEBY */,
    name: "Rinkeby",
    disabled: false,
    explorer: "https://rinkeby.etherscan.io",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png"
    }
  }),
  new Chain({
    id: 42 /* ETH_KOVAN */,
    name: "Kovan",
    disabled: false,
    explorer: "https://kovan.etherscan.io",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png"
    }
  }),
  new Chain({
    id: 56 /* BSC_MAINNET */,
    name: "BNB",
    disabled: false,
    explorer: "https://bscscan.com",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/info/logo.png"
    }
  }),
  new Chain({
    id: 97 /* BSC_TESTNET */,
    name: "BNB",
    disabled: false,
    explorer: "https://testnet.bscscan.com",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/info/logo.png"
    }
  }),
  new Chain({
    id: 137 /* MATIC_MAINNET */,
    name: "Polygon",
    disabled: false,
    explorer: "https://polygonscan.com",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png"
    }
  }),
  new Chain({
    id: 80001 /* MATIC_MUMBAI */,
    name: "Mumbai",
    // Polygon Testnet
    disabled: false,
    explorer: "https://mumbai.polygonscan.com",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png"
    }
  }),
  new Chain({
    id: 43114 /* AVAX_MAINNET */,
    name: "Avalanche",
    disabled: false,
    explorer: "https://snowtrace.io",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/avalanchex/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/avalanchex/info/logo.png"
    }
  }),
  new Chain({
    id: 43113 /* AVAX_TESTNET */,
    name: "Fuji",
    disabled: false,
    explorer: "https://testnet.snowtrace.io",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/avalanchex/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/avalanchex/info/logo.png"
    }
  }),
  new Chain({
    id: 128 /* HECO_MAINNET */,
    name: "HECO",
    disabled: false,
    explorer: "https://hecoinfo.com",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/heco/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/heco/info/logo.png"
    }
  }),
  new Chain({
    id: 256 /* HECO_TESTNET */,
    name: "HECO",
    disabled: false,
    explorer: "https://testnet.hecoinfo.com",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/heco/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/heco/info/logo.png"
    }
  }),
  new Chain({
    id: 66 /* OKEX_MAINNET */,
    name: "OEC",
    disabled: false,
    explorer: "https://www.oklink.com/oec",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/294.png",
      large: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/294.png"
    }
  }),
  new Chain({
    id: 65 /* OKEX_TESTNET */,
    name: "OEC",
    disabled: false,
    explorer: "https://www.oklink.com/oec-test",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/294.png",
      large: "https://s2.coinmarketcap.com/static/img/exchanges/64x64/294.png"
    }
  }),
  new Chain({
    id: 288 /* BOBA_MAINNET */,
    name: "Boba Ethereum",
    disabled: false,
    explorer: "https://eth.bobascan.com",
    icons: {
      small: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-ethereum/logo.png",
      large: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-ethereum/logo.png"
    }
  }),
  new Chain({
    id: 28 /* BOBA_RINKEBY */,
    name: "Boba Rinkeby",
    disabled: false,
    explorer: "https://blockexplorer.rinkeby.boba.network",
    icons: {
      small: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-ethereum/logo.png",
      large: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-ethereum/logo.png"
    }
  }),
  new Chain({
    id: 43288 /* BOBA_AVALANCHE */,
    name: "Boba Avalanche",
    disabled: false,
    explorer: "https://blockexplorer.avax.boba.network",
    icons: {
      small: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-avalanche/logo.png",
      large: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-avalanche/logo.png"
    }
  }),
  new Chain({
    id: 56288 /* BOBA_BNB */,
    name: "Boba BNB",
    disabled: false,
    explorer: "https://bnb.bobascan.com",
    icons: {
      small: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-bnb/logo.png",
      large: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/boba-bnb/logo.png"
    }
  }),
  new Chain({
    id: 2001 /* MILKOMEDA_MAINNET */,
    name: "Milkomeda",
    disabled: false,
    explorer: "https://explorer-mainnet-cardano-evm.c1.milkomeda.com",
    icons: {
      small: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/milkomeda/logo.png",
      large: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/milkomeda/logo.png"
    }
  }),
  new Chain({
    id: 200101 /* MILKOMEDA_DEVNET */,
    name: "Milkomeda",
    disabled: false,
    explorer: "https://explorer-devnet-cardano-evm.c1.milkomeda.com",
    icons: {
      small: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/milkomeda/logo.png",
      large: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/milkomeda/logo.png"
    }
  }),
  new Chain({
    id: 1313161554 /* AURORA_MAINNET */,
    name: "Aurora",
    disabled: false,
    explorer: "https://aurorascan.dev",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/14803.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/14803.png"
    }
  }),
  new Chain({
    id: 1313161555 /* AURORA_TESTNET */,
    name: "Aurora",
    disabled: false,
    explorer: "https://testnet.aurorascan.dev",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/14803.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/14803.png"
    }
  }),
  new Chain({
    id: 40 /* TELOS_MAINNET */,
    name: "Telos",
    disabled: false,
    explorer: "https://teloscan.io",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4660.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4660.png"
    }
  }),
  new Chain({
    id: 41 /* TELOS_TESTNET */,
    name: "Telos",
    disabled: false,
    explorer: "https://testnet.teloscan.io",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4660.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4660.png"
    }
  }),
  new Chain({
    id: 8081 /* SHARDEUM_TESTNET_2 */,
    name: "Shardeum Liberty 2.X",
    disabled: false,
    explorer: "https://explorer-liberty20.shardeum.org",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/22353.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/22353.png"
    }
  }),
  new Chain({
    id: 2222 /* KAVA_MAINNET */,
    name: "KAVA EVM",
    disabled: false,
    explorer: "https://explorer.kava.io",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4846.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4846.png"
    }
  }),
  new Chain({
    id: 534351 /* SCROLL_SEPOLIA */,
    name: "Scroll Sepolia",
    disabled: false,
    explorer: "https://scroll-sepolia.l2scan.co",
    icons: {
      small: "https://res.cloudinary.com/dzkjyvmsn/image/upload/v1680688496/scroll_p8h6bl.png",
      large: "https://res.cloudinary.com/dzkjyvmsn/image/upload/v1680688496/scroll_p8h6bl.png"
    }
  }),
  new Chain({
    id: 324 /* ZKSYNC_MAINNET */,
    name: "ZkSync Era",
    disabled: false,
    explorer: "https://era.zksync.network",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/24091.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/24091.png"
    }
  }),
  new Chain({
    id: 42161 /* ARBITRUM_MAINNET */,
    name: "Arbitrum One",
    disabled: false,
    explorer: "https://arbiscan.io",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11841.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11841.png"
    }
  }),
  new Chain({
    id: 42170 /* ARBITRUM_NOVA */,
    name: "Arbitrum Nova",
    disabled: false,
    explorer: "https://nova.arbiscan.io",
    icons: {
      small: "https://l2beat.com/icons/nova.png",
      large: "https://l2beat.com/icons/nova.png"
    }
  }),
  new Chain({
    id: 10 /* OPTIMISM_MAINNET */,
    name: "Optimism",
    disabled: false,
    explorer: "https://optimistic.etherscan.io",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11840.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11840.png"
    }
  }),
  new Chain({
    id: 7001 /* ZETACHAIN_ATHENS_2 */,
    name: "ZetaChain",
    disabled: false,
    explorer: "https://explorer.zetachain.com",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/21259.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/21259.png"
    }
  }),
  new Chain({
    id: 1101 /* POLYGON_ZK */,
    name: "Polygon zkEVM",
    disabled: false,
    explorer: "https://zkevm.polygonscan.com",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3890.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3890.png"
    }
  }),
  new Chain({
    id: 728126428 /* TRON_MAINNET */,
    name: "Tron",
    disabled: false,
    explorer: "https://tronscan.org",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png"
    },
    evm: false
  }),
  new Chain({
    id: 2494104990 /* TRON_TESTNET */,
    name: "Tron Testnet",
    disabled: false,
    explorer: "https://shasta.tronscan.org",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png"
    },
    evm: false
  }),
  new Chain({
    id: 59140 /* LINEA_TESTNET */,
    name: "Linea",
    disabled: false,
    explorer: "https://goerli.lineascan.build",
    icons: {
      small: "https://l2beat.com/icons/linea.png",
      large: "https://l2beat.com/icons/linea.png"
    }
  }),
  new Chain({
    id: 59144 /* LINEA_MAINNET */,
    name: "Linea",
    disabled: false,
    explorer: "https://lineascan.build",
    icons: {
      small: "https://l2beat.com/icons/linea.png",
      large: "https://l2beat.com/icons/linea.png"
    }
  }),
  new Chain({
    id: 5e3 /* MANTLE_MAINNET */,
    name: "Mantle",
    disabled: false,
    explorer: "https://explorer.mantle.xyz",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png"
    }
  }),
  new Chain({
    id: 5001 /* MANTLE_TESTNET */,
    name: "Mantle",
    disabled: false,
    explorer: "https://explorer.testnet.mantle.xyz",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png"
    }
  }),
  new Chain({
    id: 8453 /* BASE_MAINNET */,
    name: "Base",
    disabled: false,
    explorer: "https://basescan.org",
    icons: {
      small: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/base/logo.png",
      large: "https://raw.githubusercontent.com/allush/assets/main/images/blockchains/base/logo.png"
    }
  }),
  new Chain({
    id: 534352 /* SCROLL_MAINNET */,
    name: "Scroll",
    disabled: false,
    explorer: "https://scrollscan.com",
    icons: {
      small: "https://res.cloudinary.com/dzkjyvmsn/image/upload/v1680688496/scroll_p8h6bl.png",
      large: "https://res.cloudinary.com/dzkjyvmsn/image/upload/v1680688496/scroll_p8h6bl.png"
    }
  }),
  new Chain({
    id: 169 /* MANTA_MAINNET */,
    name: "Manta",
    disabled: false,
    explorer: "https://pacific-explorer.manta.network",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/13631.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/128x128/13631.png"
    }
  }),
  new Chain({
    id: 1088 /* METIS_MAINNET */,
    name: "Metis",
    disabled: false,
    explorer: "https://explorer.metis.io",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/9640.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/128x128/9640.png"
    }
  }),
  new Chain({
    id: 195 /* OKX_X1_TESTNET */,
    name: "OKX X1 Testnet",
    disabled: false,
    explorer: "https://www.oklink.com/x1-test",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3897.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3897.png"
    }
  }),
  new Chain({
    id: 5165 /* BAHAMUT_MAINNET */,
    name: "Bahamut",
    disabled: false,
    explorer: "https://www.ftnscan.com",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/22615.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/22615.png"
    }
  }),
  new Chain({
    id: 34443 /* MODE_MAINNET */,
    name: "Mode",
    disabled: false,
    explorer: "https://explorer.mode.network",
    icons: {
      small: "https://assets-global.website-files.com/64c906a6ed3c4d809558853b/64d0b081f0331ac3c64c5e4d_flav.png",
      large: "https://assets-global.website-files.com/64c906a6ed3c4d809558853b/64d0b081f0331ac3c64c5e4d_flav.png"
    }
  }),
  new Chain({
    id: 30 /* RSK_MAINNET */,
    name: "Rootstock",
    disabled: false,
    explorer: "https://rootstock.blockscout.com",
    icons: {
      small: "https://rootstock.blockscout.com/assets/favicon/favicon.ico",
      large: "https://rootstock.blockscout.com/assets/favicon/favicon.ico"
    }
  }),
  new Chain({
    id: 81457 /* BLAST_MAINNET */,
    name: "Blast",
    disabled: false,
    explorer: "https://blastscan.io",
    icons: {
      small: "https://assets.coingecko.com/coins/images/35494/standard/blast2.jpeg?1708919600",
      large: "https://assets.coingecko.com/coins/images/35494/standard/blast2.jpeg?1708919600"
    }
  }),
  new Chain({
    id: 4200 /* MERLIN_MAINNET */,
    name: "Merlin",
    disabled: false,
    explorer: "https://scan.merlinchain.io",
    icons: {
      small: "https://assets.coingecko.com/asset_platforms/images/188/small/merlin-chain.jpeg?1708522313",
      large: "https://assets.coingecko.com/asset_platforms/images/188/small/merlin-chain.jpeg?1708522313"
    }
  }),
  new Chain({
    id: 810180 /* ZKLINK_MAINNET */,
    name: "ZkLink",
    disabled: false,
    explorer: "https://explorer.zklink.io",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/13039.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/13039.png"
    }
  }),
  new Chain({
    id: 11155111 /* SEPOLIA_TESTNET */,
    name: "Sepolia",
    disabled: false,
    explorer: "https://sepolia.etherscan.io",
    icons: {
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png",
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png"
    }
  }),
  new Chain({
    id: 1116 /* CORE_MAINNET */,
    name: "CORE",
    disabled: false,
    explorer: "https://scan.coredao.org",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/23254.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/23254.png"
    }
  }),
  new Chain({
    id: 167e3 /* TAIKO_MAINNET */,
    name: "Taiko",
    disabled: false,
    explorer: "https://taikoscan.io",
    icons: {
      small: "https://taikoscan.io/assets/taiko/images/svg/logos/chain-light.svg?v=24.5.4.0",
      large: "https://taikoscan.io/assets/taiko/images/svg/logos/chain-light.svg?v=24.5.4.0"
    }
  }),
  new Chain({
    id: 1329 /* SEI_EVM_MAINNET */,
    name: "Sei v2",
    disabled: false,
    explorer: "https://seitrace.com",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/23149.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/23149.png"
    }
  }),
  new Chain({
    id: 7e3 /* ZETACHAIN_MAINNET */,
    name: "ZetaChain",
    disabled: false,
    explorer: "https://zetachain.blockscout.com",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/21259.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/21259.png"
    }
  }),
  new Chain({
    id: 25 /* CRONOS_MAINNET */,
    name: "Cronos",
    disabled: false,
    explorer: "https://cronoscan.com",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3635.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3635.png"
    }
  }),
  new Chain({
    id: 252 /* FRAXTAL_MAINNET */,
    name: "Fraxtal",
    disabled: false,
    explorer: "https://fraxscan.com",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png"
    }
  }),
  new Chain({
    id: 1625 /* GRAVITY_MAINNET */,
    name: "Gravity",
    disabled: false,
    explorer: "https://explorer.gravity.xyz",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/32120.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/32120.png"
    }
  }),
  new Chain({
    id: 223 /* BSQUARED_MAINNET */,
    name: "B\xB2 Network",
    disabled: false,
    explorer: "https://explorer.bsquared.network",
    icons: {
      small: "https://coin-images.coingecko.com/asset_platforms/images/239/small/bsquared-network.jpeg?1713432732",
      large: "https://coin-images.coingecko.com/asset_platforms/images/239/small/bsquared-network.jpeg?1713432732"
    }
  })
];
var getChainById = (chainId) => {
  if (!chainId)
    return void 0;
  return chains.find((chain) => chain.id === chainId);
};

// src/entities/fractions/fraction.ts
import invariant2 from "tiny-invariant";
import JSBI3 from "jsbi";
import _Decimal from "decimal.js-light";
import _Big from "big.js";
import toFormat from "toformat";

// src/utils.ts
import invariant from "tiny-invariant";
import JSBI2 from "jsbi";
import { getAddress } from "@ethersproject/address";
function validateSolidityTypeInstance(value, solidityType) {
  invariant(JSBI2.greaterThanOrEqual(value, ZERO), `${value} is not a ${solidityType}.`);
  invariant(JSBI2.lessThanOrEqual(value, SOLIDITY_TYPE_MAXIMA[solidityType]), `${value} is not a ${solidityType}.`);
}
function validateAndParseAddress(address2) {
  if (address2 === "") {
    return address2;
  }
  try {
    return getAddress(address2);
  } catch (error) {
    invariant(false, `${address2} is not a valid address.`);
  }
}
function parseBigintIsh(bigintIsh) {
  return bigintIsh instanceof JSBI2 ? bigintIsh : typeof bigintIsh === "bigint" ? JSBI2.BigInt(bigintIsh.toString()) : JSBI2.BigInt(bigintIsh);
}
function sqrt(y) {
  validateSolidityTypeInstance(y, "uint256" /* uint256 */);
  let z = ZERO;
  let x;
  if (JSBI2.greaterThan(y, THREE)) {
    z = y;
    x = JSBI2.add(JSBI2.divide(y, TWO), ONE);
    while (JSBI2.lessThan(x, z)) {
      z = x;
      x = JSBI2.divide(JSBI2.add(JSBI2.divide(y, x), x), TWO);
    }
  } else if (JSBI2.notEqual(y, ZERO)) {
    z = ONE;
  }
  return z;
}
function sortedInsert(items, add, maxSize, comparator) {
  invariant(maxSize > 0, "MAX_SIZE_ZERO");
  invariant(items.length <= maxSize, "ITEMS_SIZE");
  if (items.length === 0) {
    items.push(add);
    return null;
  } else {
    const isFull = items.length === maxSize;
    if (isFull && comparator(items[items.length - 1], add) <= 0) {
      return add;
    }
    let lo = 0, hi = items.length;
    while (lo < hi) {
      const mid = lo + hi >>> 1;
      if (comparator(items[mid], add) <= 0) {
        lo = mid + 1;
      } else {
        hi = mid;
      }
    }
    items.splice(lo, 0, add);
    return isFull ? items.pop() : null;
  }
}
var delay = (ms) => new Promise((res) => setTimeout(res, ms));

// src/entities/fractions/fraction.ts
var Decimal = toFormat(_Decimal);
var Big = toFormat(_Big);
var toSignificantRounding = {
  [0 /* ROUND_DOWN */]: Decimal.ROUND_DOWN,
  [1 /* ROUND_HALF_UP */]: Decimal.ROUND_HALF_UP,
  [2 /* ROUND_UP */]: Decimal.ROUND_UP
};
var toFixedRounding = {
  [0 /* ROUND_DOWN */]: 0 /* RoundDown */,
  [1 /* ROUND_HALF_UP */]: 1 /* RoundHalfUp */,
  [2 /* ROUND_UP */]: 3 /* RoundUp */
};
var Fraction = class _Fraction {
  constructor(numerator, denominator = ONE) {
    this.numerator = parseBigintIsh(numerator);
    this.denominator = parseBigintIsh(denominator);
  }
  // performs floor division
  get quotient() {
    return JSBI3.divide(this.numerator, this.denominator);
  }
  // remainder after floor division
  get remainder() {
    return new _Fraction(JSBI3.remainder(this.numerator, this.denominator), this.denominator);
  }
  invert() {
    return new _Fraction(this.denominator, this.numerator);
  }
  add(other) {
    const otherParsed = other instanceof _Fraction ? other : new _Fraction(parseBigintIsh(other));
    if (JSBI3.equal(this.denominator, otherParsed.denominator)) {
      return new _Fraction(JSBI3.add(this.numerator, otherParsed.numerator), this.denominator);
    }
    return new _Fraction(
      JSBI3.add(
        JSBI3.multiply(this.numerator, otherParsed.denominator),
        JSBI3.multiply(otherParsed.numerator, this.denominator)
      ),
      JSBI3.multiply(this.denominator, otherParsed.denominator)
    );
  }
  subtract(other) {
    const otherParsed = other instanceof _Fraction ? other : new _Fraction(parseBigintIsh(other));
    if (JSBI3.equal(this.denominator, otherParsed.denominator)) {
      return new _Fraction(JSBI3.subtract(this.numerator, otherParsed.numerator), this.denominator);
    }
    return new _Fraction(
      JSBI3.subtract(
        JSBI3.multiply(this.numerator, otherParsed.denominator),
        JSBI3.multiply(otherParsed.numerator, this.denominator)
      ),
      JSBI3.multiply(this.denominator, otherParsed.denominator)
    );
  }
  lessThan(other) {
    const otherParsed = other instanceof _Fraction ? other : new _Fraction(parseBigintIsh(other));
    return JSBI3.lessThan(
      JSBI3.multiply(this.numerator, otherParsed.denominator),
      JSBI3.multiply(otherParsed.numerator, this.denominator)
    );
  }
  equalTo(other) {
    const otherParsed = other instanceof _Fraction ? other : new _Fraction(parseBigintIsh(other));
    return JSBI3.equal(
      JSBI3.multiply(this.numerator, otherParsed.denominator),
      JSBI3.multiply(otherParsed.numerator, this.denominator)
    );
  }
  greaterThan(other) {
    const otherParsed = other instanceof _Fraction ? other : new _Fraction(parseBigintIsh(other));
    return JSBI3.greaterThan(
      JSBI3.multiply(this.numerator, otherParsed.denominator),
      JSBI3.multiply(otherParsed.numerator, this.denominator)
    );
  }
  multiply(other) {
    const otherParsed = other instanceof _Fraction ? other : new _Fraction(parseBigintIsh(other));
    return new _Fraction(
      JSBI3.multiply(this.numerator, otherParsed.numerator),
      JSBI3.multiply(this.denominator, otherParsed.denominator)
    );
  }
  divide(other) {
    const otherParsed = other instanceof _Fraction ? other : new _Fraction(parseBigintIsh(other));
    return new _Fraction(
      JSBI3.multiply(this.numerator, otherParsed.denominator),
      JSBI3.multiply(this.denominator, otherParsed.numerator)
    );
  }
  toSignificant(significantDigits, format = { groupSeparator: "" }, rounding = 1 /* ROUND_HALF_UP */) {
    invariant2(Number.isInteger(significantDigits), `${significantDigits} is not an integer.`);
    invariant2(significantDigits > 0, `${significantDigits} is not positive.`);
    Decimal.set({ precision: significantDigits + 1, rounding: toSignificantRounding[rounding] });
    const quotient = new Decimal(this.numerator.toString()).div(this.denominator.toString()).toSignificantDigits(significantDigits);
    return quotient.toFormat(quotient.decimalPlaces(), format);
  }
  toFixed(decimalPlaces, format = { groupSeparator: "" }, rounding = 1 /* ROUND_HALF_UP */) {
    invariant2(Number.isInteger(decimalPlaces), `${decimalPlaces} is not an integer.`);
    invariant2(decimalPlaces >= 0, `${decimalPlaces} is negative.`);
    Big.DP = decimalPlaces;
    Big.RM = toFixedRounding[rounding];
    return new Big(this.numerator.toString()).div(this.denominator.toString()).toFormat(decimalPlaces, format);
  }
  toExact(decimalPlaces, format = { groupSeparator: "" }) {
    Big.DP = decimalPlaces;
    return new Big(this.numerator.toString()).div(this.denominator.toString()).toFormat(format);
  }
};

// src/entities/fractions/percent.ts
var _100_PERCENT = new Fraction(_100);
var Percent = class extends Fraction {
  toSignificant(significantDigits = 5, format, rounding) {
    return this.multiply(_100_PERCENT).toSignificant(significantDigits, format, rounding);
  }
  toFixed(decimalPlaces = 2, format, rounding) {
    return this.multiply(_100_PERCENT).toFixed(decimalPlaces, format, rounding);
  }
};

// src/entities/fractions/tokenAmount.ts
import invariant3 from "tiny-invariant";
import JSBI4 from "jsbi";
var TokenAmount = class _TokenAmount extends Fraction {
  constructor(token, amount) {
    const parsedAmount = parseBigintIsh(amount);
    validateSolidityTypeInstance(parsedAmount, "uint256" /* uint256 */);
    super(parsedAmount, JSBI4.exponentiate(TEN, JSBI4.BigInt(token.decimals)));
    this.token = token;
  }
  get raw() {
    return this.numerator;
  }
  add(other) {
    invariant3(this.token.equals(other.token), "TOKEN");
    return new _TokenAmount(this.token, JSBI4.add(this.raw, other.raw));
  }
  subtract(other) {
    invariant3(this.token.equals(other.token), "TOKEN");
    return new _TokenAmount(this.token, JSBI4.subtract(this.raw, other.raw));
  }
  greaterThanOrEqual(amount) {
    return JSBI4.greaterThanOrEqual(this.raw, amount);
  }
  toSignificant(significantDigits = 6, format, rounding = 0 /* ROUND_DOWN */) {
    return super.toSignificant(significantDigits, format, rounding);
  }
  toFixed(decimalPlaces = this.token.decimals, format, rounding = 0 /* ROUND_DOWN */) {
    invariant3(decimalPlaces <= this.token.decimals, "DECIMALS");
    return super.toFixed(decimalPlaces, format, rounding);
  }
  toExact(decimalPlaces = this.token.decimals, format = { groupSeparator: "" }) {
    return super.toExact(decimalPlaces, format);
  }
};

// src/entities/token.ts
import JSBI5 from "jsbi";
import invariant4 from "tiny-invariant";

// src/crosschain/chainUtils/tron.ts
import { getAddress as getAddress2 } from "@ethersproject/address";
import { concat, hexDataSlice } from "@ethersproject/bytes";
import { keccak256 as kekKeccak256 } from "@ethersproject/keccak256";
import { utils } from "ethers";
import TronWeb from "tronweb";
function getFunctionSelector(abi) {
  if (abi instanceof utils.FunctionFragment) {
    abi = JSON.parse(abi.format(utils.FormatTypes.json));
  }
  abi.stateMutability = abi.stateMutability ? abi.stateMutability.toLowerCase() : "nonpayable";
  abi.type = abi.type ? abi.type.toLowerCase() : "";
  if (abi.type === "fallback" || abi.type === "receive")
    return "0x";
  const iface = new utils.Interface([abi]);
  if (abi.type === "event") {
    return iface.getEvent(abi.name).format(utils.FormatTypes.sighash);
  }
  return iface.getFunction(abi.name).format(utils.FormatTypes.sighash);
}
function prepareTronTransaction({
  chainId,
  tronWeb,
  abi,
  contractAddress,
  functionName,
  params,
  value,
  ownerAddress
}) {
  const functionFragment = abi.find((item) => item.type === "function" && item.name === functionName);
  if (!functionFragment) {
    throw new Error("Method not found in ABI");
  }
  const functionSelector = getFunctionSelector(functionFragment);
  const rawParameter = tronWeb.utils.abi.encodeParamsV2ByABI(functionFragment, params);
  return {
    chain_id: chainId,
    call_value: value?.toString() ?? 0,
    contract_address: TronWeb.address.fromHex(contractAddress),
    fee_limit: 2e8,
    // 200 TRX
    function_selector: functionSelector,
    owner_address: TronWeb.address.fromHex(ownerAddress),
    raw_parameter: rawParameter
  };
}
var ADDRESS_PREFIX_REGEX = /^(41)/;
function tronAddressToEvm(address2) {
  try {
    return TronWeb.address.toHex(address2).replace(ADDRESS_PREFIX_REGEX, "0x");
  } catch (e) {
    return address2;
  }
}
function isTronChainId(chainId) {
  return [728126428 /* TRON_MAINNET */, 2494104990 /* TRON_TESTNET */].includes(chainId);
}
function isTronChain(chain) {
  return isTronChainId(chain.id);
}
function isTronToken(token) {
  return isTronChainId(token.chainId);
}
async function getTransactionInfoById(tronWeb, txId) {
  const result = await tronWeb.fullNode.request("wallet/gettransactioninfobyid", { value: txId }, "post");
  if (result && Object.keys(result).length > 0) {
    return result;
  }
  return null;
}
function getTronCreate2Address(from, salt, initCodeHash) {
  return getAddress2(hexDataSlice(kekKeccak256(concat(["0x41", getAddress2(from), salt, initCodeHash])), 12));
}

// src/entities/token.ts
var Token = class {
  /**
   * Constructs an instance of the base class `Token`.
   * @param params TokenConstructor
   */
  constructor(params) {
    validateSolidityTypeInstance(JSBI5.BigInt(params.decimals), "uint8" /* uint8 */);
    this.decimals = params.decimals;
    this.symbol = params.symbol;
    this.name = params.name;
    this.chainId = params.chainId;
    this.isNative = !!params.isNative;
    this.icons = params.icons;
    this.chainFromId = params.chainFromId;
    this.userToken = params.userToken;
    this.deprecated = !!params.deprecated;
    if (isTronChainId(params.chainId)) {
      this.address = tronAddressToEvm(params.address);
      return;
    }
    this.address = validateAndParseAddress(params.address);
  }
  /**
   * Returns true if the two tokens are equivalent, i.e. have the same chainId and address.
   * @param other other token to compare
   */
  equals(other) {
    if (this === other) {
      return true;
    }
    return this.chainId === other.chainId && this.address === other.address;
  }
  /**
   * Returns true if the address of this token sorts before the address of the other token
   * @param other other token to compare
   * @throws if the tokens have the same address
   * @throws if the tokens are on different chains
   */
  sortsBefore(other) {
    invariant4(this.chainId === other.chainId, "CHAIN_IDS");
    invariant4(this.address !== other.address, "ADDRESSES");
    return this.address.toLowerCase() < other.address.toLowerCase();
  }
  get isSynthetic() {
    return !!this.chainFromId;
  }
  get chain() {
    return getChainById(this.chainId);
  }
  get chainFrom() {
    return getChainById(this.chainFromId);
  }
};
function tokenEquals(tokenA, tokenB) {
  return tokenA.equals(tokenB);
}
var WETH = {
  // >> FAKE
  [85918 /* TON_MAINNET */]: new Token({
    chainId: 85918 /* TON_MAINNET */,
    address: "",
    decimals: 9
  }),
  [85919 /* TON_TESTNET */]: new Token({
    chainId: 85919 /* TON_TESTNET */,
    address: "",
    decimals: 9
  }),
  [3652501241 /* BTC_MAINNET */]: new Token({
    chainId: 3652501241 /* BTC_MAINNET */,
    address: "",
    decimals: 8
  }),
  [2782866891 /* BTC_MUTINY */]: new Token({
    chainId: 2782866891 /* BTC_MUTINY */,
    address: "",
    decimals: 8
  }),
  [675223068 /* BTC_TESTNET4 */]: new Token({
    chainId: 675223068 /* BTC_TESTNET4 */,
    address: "",
    decimals: 8
  }),
  // << FAKE
  [728126428 /* TRON_MAINNET */]: new Token({
    chainId: 728126428 /* TRON_MAINNET */,
    address: "0x891CDB91D149F23B1A45D9C5CA78A88D0CB44C18",
    decimals: 6,
    symbol: "WTRX",
    isNative: false,
    name: "Wrapped TRX",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png"
    }
  }),
  [1 /* ETH_MAINNET */]: new Token({
    chainId: 1 /* ETH_MAINNET */,
    address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }
  }),
  [4 /* ETH_RINKEBY */]: new Token({
    chainId: 4 /* ETH_RINKEBY */,
    address: "0xc778417e063141139fce010982780140aa0cd5ab",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }
  }),
  [42 /* ETH_KOVAN */]: new Token({
    chainId: 42 /* ETH_KOVAN */,
    address: "0xd0A1E359811322d97991E03f863a0C30C2cF029C",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }
  }),
  [56 /* BSC_MAINNET */]: new Token({
    chainId: 56 /* BSC_MAINNET */,
    address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    decimals: 18,
    symbol: "WBNB",
    isNative: false,
    name: "Wrapped BNB",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/binance/info/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/binance/info/logo.png"
    }
  }),
  [97 /* BSC_TESTNET */]: new Token({
    chainId: 97 /* BSC_TESTNET */,
    address: "0xae13d989dac2f0debff460ac112a837c89baa7cd",
    decimals: 18,
    symbol: "WBNB",
    isNative: false,
    name: "Wrapped BNB",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/binance/info/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/binance/info/logo.png"
    }
  }),
  [137 /* MATIC_MAINNET */]: new Token({
    chainId: 137 /* MATIC_MAINNET */,
    address: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    decimals: 18,
    symbol: "WMATIC",
    isNative: false,
    name: "Wrapped MATIC",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png"
    }
  }),
  [80001 /* MATIC_MUMBAI */]: new Token({
    chainId: 80001 /* MATIC_MUMBAI */,
    address: "0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889",
    decimals: 18,
    symbol: "WMATIC",
    isNative: false,
    name: "Wrapped MATIC",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png"
    }
  }),
  [43114 /* AVAX_MAINNET */]: new Token({
    chainId: 43114 /* AVAX_MAINNET */,
    address: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
    decimals: 18,
    symbol: "WAVAX",
    isNative: false,
    name: "Wrapped AVAX",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/9462.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/9462.png"
    }
  }),
  [43113 /* AVAX_TESTNET */]: new Token({
    chainId: 43113 /* AVAX_TESTNET */,
    address: "0xd00ae08403B9bbb9124bB305C09058E32C39A48c",
    decimals: 18,
    symbol: "WAVAX",
    isNative: false,
    name: "Wrapped AVAX",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/9462.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/9462.png"
    }
  }),
  [128 /* HECO_MAINNET */]: new Token({
    chainId: 128 /* HECO_MAINNET */,
    address: "0x5545153ccfca01fbd7dd11c0b23ba694d9509a6f",
    decimals: 18,
    symbol: "WHT",
    isNative: false,
    name: "Wrapped HT",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/8524.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/8524.png"
    }
  }),
  [256 /* HECO_TESTNET */]: new Token({
    chainId: 256 /* HECO_TESTNET */,
    address: "0x7aF326B6351C8A9b8fb8CD205CBe11d4Ac5FA836",
    decimals: 18,
    symbol: "WHT",
    isNative: false,
    name: "Wrapped HT",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/8524.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/8524.png"
    }
  }),
  [66 /* OKEX_MAINNET */]: new Token({
    chainId: 66 /* OKEX_MAINNET */,
    address: "0x8F8526dbfd6E38E3D8307702cA8469Bae6C56C15",
    decimals: 18,
    symbol: "WOKT",
    isNative: false,
    name: "Wrapped OKT",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11132.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11132.png"
    }
  }),
  [65 /* OKEX_TESTNET */]: new Token({
    chainId: 65 /* OKEX_TESTNET */,
    address: "0x2219845942d28716c0F7C605765fABDcA1a7d9E0",
    decimals: 18,
    symbol: "WOKT",
    isNative: false,
    name: "Wrapped OKT",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11132.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11132.png"
    }
  }),
  [288 /* BOBA_MAINNET */]: new Token({
    chainId: 288 /* BOBA_MAINNET */,
    address: "0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }
  }),
  [43288 /* BOBA_AVALANCHE */]: new Token({
    chainId: 43288 /* BOBA_AVALANCHE */,
    address: "0x26c319B7B2cF823365414d082698C8ac90cbBA63",
    decimals: 18,
    symbol: "WBOBA",
    isNative: false,
    name: "Wrapped BOBA",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/14556.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/14556.png"
    }
  }),
  [56288 /* BOBA_BNB */]: new Token({
    chainId: 56288 /* BOBA_BNB */,
    address: "0xC58aaD327D6D58D979882601ba8DDa0685B505eA",
    decimals: 18,
    symbol: "WBOBA",
    isNative: false,
    name: "Wrapped BOBA",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/14556.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/14556.png"
    }
  }),
  [28 /* BOBA_RINKEBY */]: new Token({
    chainId: 28 /* BOBA_RINKEBY */,
    address: "0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      large: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
      small: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
    }
  }),
  [2001 /* MILKOMEDA_MAINNET */]: new Token({
    chainId: 2001 /* MILKOMEDA_MAINNET */,
    address: "0xAE83571000aF4499798d1e3b0fA0070EB3A3E3F9",
    decimals: 18,
    symbol: "WADA",
    isNative: false,
    name: "Wrapped ADA",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/19369.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/19369.png"
    }
  }),
  [200101 /* MILKOMEDA_DEVNET */]: new Token({
    chainId: 200101 /* MILKOMEDA_DEVNET */,
    // address: '0x65a51E52eCD17B641f8F0D1d56a6c9738951FDC9',
    address: "0x01bbbb9c97fc43e3393e860fc8bbead47b6960db",
    decimals: 18,
    symbol: "WTADA",
    isNative: false,
    name: "Wrapped TADA",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/19369.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/19369.png"
    }
  }),
  [1313161554 /* AURORA_MAINNET */]: new Token({
    chainId: 1313161554 /* AURORA_MAINNET */,
    address: "0xC9BdeEd33CD01541e1eeD10f90519d2C06Fe3feB",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png"
    }
  }),
  [1313161555 /* AURORA_TESTNET */]: new Token({
    chainId: 1313161555 /* AURORA_TESTNET */,
    address: "0x1b6A3d5B5DCdF7a37CFE35CeBC0C4bD28eA7e946",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png"
    }
  }),
  [40 /* TELOS_MAINNET */]: new Token({
    chainId: 40 /* TELOS_MAINNET */,
    address: "0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E",
    decimals: 18,
    symbol: "WTLOS",
    isNative: false,
    name: "Wrapped TLOS",
    icons: {
      large: "https://raw.githubusercontent.com/telosnetwork/token-list/main/logos/wtlos.png",
      small: "https://raw.githubusercontent.com/telosnetwork/token-list/main/logos/wtlos.png"
    }
  }),
  [41 /* TELOS_TESTNET */]: new Token({
    chainId: 41 /* TELOS_TESTNET */,
    address: "0xaE85Bf723A9e74d6c663dd226996AC1b8d075AA9",
    decimals: 18,
    symbol: "WTLOS",
    isNative: false,
    name: "Wrapped TLOS",
    icons: {
      large: "https://raw.githubusercontent.com/telosnetwork/token-list/main/logos/wtlos.png",
      small: "https://raw.githubusercontent.com/telosnetwork/token-list/main/logos/wtlos.png"
    }
  }),
  [8081 /* SHARDEUM_TESTNET_2 */]: new Token({
    chainId: 8081 /* SHARDEUM_TESTNET_2 */,
    address: "0xb6204c4b6b2545cF23F5EC0Bf8AEB8cB56E13C15",
    decimals: 18,
    symbol: "WSHM",
    isNative: false,
    name: "Wrapped SHM",
    icons: {
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/22353.png",
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/22353.png"
    }
  }),
  [2222 /* KAVA_MAINNET */]: new Token({
    chainId: 2222 /* KAVA_MAINNET */,
    address: "0xc86c7C0eFbd6A49B35E8714C5f59D99De09A225b",
    decimals: 18,
    symbol: "WKAVA",
    isNative: false,
    name: "Wrapped KAVA",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4846.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4846.png"
    }
  }),
  [534351 /* SCROLL_SEPOLIA */]: new Token({
    chainId: 534351 /* SCROLL_SEPOLIA */,
    address: "0x5300000000000000000000000000000000000004",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [324 /* ZKSYNC_MAINNET */]: new Token({
    chainId: 324 /* ZKSYNC_MAINNET */,
    address: "0x5aea5775959fbc2557cc8789bc1bf90a239d9a91",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [42161 /* ARBITRUM_MAINNET */]: new Token({
    chainId: 42161 /* ARBITRUM_MAINNET */,
    address: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [42170 /* ARBITRUM_NOVA */]: new Token({
    chainId: 42170 /* ARBITRUM_NOVA */,
    address: "0x722e8bdd2ce80a4422e880164f2079488e115365",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [10 /* OPTIMISM_MAINNET */]: new Token({
    chainId: 10 /* OPTIMISM_MAINNET */,
    address: "0x4200000000000000000000000000000000000006",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [7001 /* ZETACHAIN_ATHENS_2 */]: new Token({
    chainId: 7001 /* ZETACHAIN_ATHENS_2 */,
    address: "0x5F0b1a82749cb4E2278EC87F8BF6B618dC71a8bf",
    decimals: 18,
    symbol: "WZETA",
    isNative: false,
    name: "Wrapped ZETA",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/21259.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/21259.png"
    }
  }),
  [1101 /* POLYGON_ZK */]: new Token({
    chainId: 1101 /* POLYGON_ZK */,
    address: "0x4f9a0e7fd2bf6067db6994cf12e4495df938e6e9",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [2494104990 /* TRON_TESTNET */]: new Token({
    chainId: 2494104990 /* TRON_TESTNET */,
    address: "0xf060b2655346cf3f825c3300177dff8a2acd89aa",
    decimals: 6,
    symbol: "WTRX",
    isNative: false,
    name: "Wrapped TRX",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png"
    }
  }),
  [59140 /* LINEA_TESTNET */]: new Token({
    chainId: 59140 /* LINEA_TESTNET */,
    address: "0x2C1b868d6596a18e32E61B901E4060C872647b6C",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [59144 /* LINEA_MAINNET */]: new Token({
    chainId: 59144 /* LINEA_MAINNET */,
    address: "0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [5e3 /* MANTLE_MAINNET */]: new Token({
    chainId: 5e3 /* MANTLE_MAINNET */,
    address: "0x78c1b0C915c4FAA5FffA6CAbf0219DA63d7f4cb8",
    decimals: 18,
    symbol: "WMNT",
    isNative: false,
    name: "Wrapped MNT",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png"
    }
  }),
  [5001 /* MANTLE_TESTNET */]: new Token({
    chainId: 5001 /* MANTLE_TESTNET */,
    address: "0x8734110e5e1dcF439c7F549db740E546fea82d66",
    decimals: 18,
    symbol: "WBIT",
    isNative: false,
    name: "Wrapped BIT",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/27075.png"
    }
  }),
  [8453 /* BASE_MAINNET */]: new Token({
    chainId: 8453 /* BASE_MAINNET */,
    address: "0x4200000000000000000000000000000000000006",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [534352 /* SCROLL_MAINNET */]: new Token({
    chainId: 534352 /* SCROLL_MAINNET */,
    address: "0x5300000000000000000000000000000000000004",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [169 /* MANTA_MAINNET */]: new Token({
    chainId: 169 /* MANTA_MAINNET */,
    address: "0x0Dc808adcE2099A9F62AA87D9670745AbA741746",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [1088 /* METIS_MAINNET */]: new Token({
    chainId: 1088 /* METIS_MAINNET */,
    address: "0x75cb093E4D61d2A2e65D8e0BBb01DE8d89b53481",
    decimals: 18,
    symbol: "WMETIS",
    isNative: false,
    name: "Wrapped METIS",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/9640.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/9640.png"
    }
  }),
  [195 /* OKX_X1_TESTNET */]: new Token({
    chainId: 195 /* OKX_X1_TESTNET */,
    address: "0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF",
    decimals: 18,
    symbol: "WOKB",
    isNative: false,
    name: "Wrapped OKB",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3897.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3897.png"
    }
  }),
  [5165 /* BAHAMUT_MAINNET */]: new Token({
    chainId: 5165 /* BAHAMUT_MAINNET */,
    address: "0x4084aB20f8ffcA76C19AAF854Fb5fe9DE6217fBB",
    decimals: 18,
    symbol: "WFTN",
    isNative: false,
    name: "Wrapped FTN",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/22615.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/22615.png"
    }
  }),
  [34443 /* MODE_MAINNET */]: new Token({
    chainId: 34443 /* MODE_MAINNET */,
    address: "0x4200000000000000000000000000000000000006",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [30 /* RSK_MAINNET */]: new Token({
    chainId: 30 /* RSK_MAINNET */,
    address: "0x542fda317318ebf1d3deaf76e0b632741a7e677d",
    decimals: 18,
    symbol: "WRBTC",
    isNative: false,
    name: "Wrapped BTC",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3626.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3626.png"
    }
  }),
  [81457 /* BLAST_MAINNET */]: new Token({
    chainId: 81457 /* BLAST_MAINNET */,
    address: "0x4300000000000000000000000000000000000004",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [4200 /* MERLIN_MAINNET */]: new Token({
    chainId: 4200 /* MERLIN_MAINNET */,
    address: "0xF6D226f9Dc15d9bB51182815b320D3fBE324e1bA",
    decimals: 18,
    symbol: "WBTC",
    isNative: false,
    name: "Wrapped BTC",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png"
    }
  }),
  [810180 /* ZKLINK_MAINNET */]: new Token({
    chainId: 810180 /* ZKLINK_MAINNET */,
    address: "0x8280a4e7D5B3B658ec4580d3Bc30f5e50454F169",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [11155111 /* SEPOLIA_TESTNET */]: new Token({
    chainId: 11155111 /* SEPOLIA_TESTNET */,
    address: "0x7b79995e5f793A07Bc00c21412e50Ecae098E7f9",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [1116 /* CORE_MAINNET */]: new Token({
    chainId: 1116 /* CORE_MAINNET */,
    address: "0x191E94fa59739e188dcE837F7f6978d84727AD01",
    decimals: 18,
    symbol: "WCORE",
    isNative: false,
    name: "Wrapped CORE",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/23254.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/23254.png"
    }
  }),
  [167e3 /* TAIKO_MAINNET */]: new Token({
    chainId: 167e3 /* TAIKO_MAINNET */,
    address: "0xA51894664A773981C6C112C43ce576f315d5b1B6",
    decimals: 18,
    symbol: "WETH",
    isNative: false,
    name: "Wrapped ETH",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    }
  }),
  [1329 /* SEI_EVM_MAINNET */]: new Token({
    chainId: 1329 /* SEI_EVM_MAINNET */,
    address: "0xE30feDd158A2e3b13e9badaeABaFc5516e95e8C7",
    decimals: 18,
    symbol: "WSEI",
    isNative: false,
    name: "Wrapped SEI",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/23149.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/23149.png"
    }
  }),
  [7e3 /* ZETACHAIN_MAINNET */]: new Token({
    chainId: 7e3 /* ZETACHAIN_MAINNET */,
    address: "0x5F0b1a82749cb4E2278EC87F8BF6B618dC71a8bf",
    decimals: 18,
    symbol: "WZETA",
    isNative: false,
    name: "Wrapped ZETA",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/29464.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29464.png"
    }
  }),
  [25 /* CRONOS_MAINNET */]: new Token({
    chainId: 25 /* CRONOS_MAINNET */,
    address: "0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23",
    decimals: 18,
    symbol: "WCRO",
    isNative: false,
    name: "Wrapped CRO",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/14532.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/14532.png"
    }
  }),
  [252 /* FRAXTAL_MAINNET */]: new Token({
    chainId: 252 /* FRAXTAL_MAINNET */,
    address: "0xfc00000000000000000000000000000000000006",
    decimals: 18,
    symbol: "wfrxETH",
    isNative: false,
    name: "Wrapped frxETH",
    icons: {
      small: "https://fraxscan.com/token/images/wfrxeth_32.png",
      large: "https://fraxscan.com/token/images/wfrxeth_32.png"
    }
  }),
  [1625 /* GRAVITY_MAINNET */]: new Token({
    chainId: 1625 /* GRAVITY_MAINNET */,
    address: "0xBB859E225ac8Fb6BE1C7e38D87b767e95Fef0EbD",
    decimals: 18,
    symbol: "wG",
    isNative: false,
    name: "Wrapped G",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/32120.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/32120.png"
    }
  }),
  [223 /* BSQUARED_MAINNET */]: new Token({
    chainId: 223 /* BSQUARED_MAINNET */,
    address: "0x4200000000000000000000000000000000000006",
    decimals: 18,
    symbol: "WBTC",
    isNative: false,
    name: "Wrapped BTC",
    icons: {
      small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png",
      large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png"
    }
  })
};

// src/entities/fractions/price.ts
import invariant5 from "tiny-invariant";
import JSBI6 from "jsbi";
var Price = class _Price extends Fraction {
  // denominator and numerator _must_ be raw, i.e. in the native representation
  constructor(baseToken, quoteToken, denominator, numerator) {
    super(numerator, denominator);
    this.baseToken = baseToken;
    this.quoteToken = quoteToken;
    this.scalar = new Fraction(
      JSBI6.exponentiate(TEN, JSBI6.BigInt(baseToken.decimals)),
      JSBI6.exponentiate(TEN, JSBI6.BigInt(quoteToken.decimals))
    );
  }
  // used to adjust the raw fraction w/r/t the decimals of the {base,quote}Token
  static fromRoute(route) {
    const prices = [];
    for (const [i, pair] of route.pairs.entries()) {
      prices.push(
        route.path[i].equals(pair.token0) ? new _Price(pair.reserve0.token, pair.reserve1.token, pair.reserve0.raw, pair.reserve1.raw) : new _Price(pair.reserve1.token, pair.reserve0.token, pair.reserve1.raw, pair.reserve0.raw)
      );
    }
    return prices.slice(1).reduce((accumulator, currentValue) => accumulator.multiply(currentValue), prices[0]);
  }
  get raw() {
    return new Fraction(this.numerator, this.denominator);
  }
  get adjusted() {
    return super.multiply(this.scalar);
  }
  invert() {
    return new _Price(this.quoteToken, this.baseToken, this.numerator, this.denominator);
  }
  multiply(other) {
    invariant5(tokenEquals(this.quoteToken, other.baseToken), "TOKEN");
    const fraction = super.multiply(other);
    return new _Price(this.baseToken, other.quoteToken, fraction.denominator, fraction.numerator);
  }
  // performs floor division on overflow
  quote(tokenAmount) {
    invariant5(tokenEquals(tokenAmount.token, this.baseToken), "TOKEN");
    return new TokenAmount(this.quoteToken, super.multiply(tokenAmount.raw).quotient);
  }
  toSignificant(significantDigits = 6, format, rounding) {
    return this.adjusted.toSignificant(significantDigits, format, rounding);
  }
  toFixed(decimalPlaces = 4, format, rounding) {
    return this.adjusted.toFixed(decimalPlaces, format, rounding);
  }
};

// src/entities/pair.ts
import invariant6 from "tiny-invariant";
import JSBI7 from "jsbi";
import { keccak256, pack } from "@ethersproject/solidity";
import { getCreate2Address as getEvmCreate2Address } from "@ethersproject/address";
var PAIR_ADDRESS_CACHE = {};
var Pair = class _Pair {
  static getAddress(tokenA, tokenB) {
    const tokens = tokenA.sortsBefore(tokenB) ? [tokenA, tokenB] : [tokenB, tokenA];
    const chainId = tokens[0].chainId;
    let types = ["address", "address"];
    let params = [tokens[0].address, tokens[1].address];
    if (chainId === 2222 /* KAVA_MAINNET */) {
      types = [...types, "bool"];
      params = [...params, false];
    }
    if (PAIR_ADDRESS_CACHE?.[tokens[0].address]?.[tokens[1].address] === void 0) {
      const getCreate2Address = isTronToken(tokenA) ? getTronCreate2Address : getEvmCreate2Address;
      PAIR_ADDRESS_CACHE = {
        ...PAIR_ADDRESS_CACHE,
        [tokens[0].address]: {
          ...PAIR_ADDRESS_CACHE?.[tokens[0].address],
          [tokens[1].address]: getCreate2Address(
            FACTORY_ADDRESS[chainId],
            keccak256(["bytes"], [pack(types, params)]),
            INIT_CODE_HASH[chainId]
          )
        }
      };
    }
    return PAIR_ADDRESS_CACHE[tokens[0].address][tokens[1].address];
  }
  constructor(tokenAmountA, tokenAmountB) {
    const tokenAmounts = tokenAmountA.token.sortsBefore(tokenAmountB.token) ? [tokenAmountA, tokenAmountB] : [tokenAmountB, tokenAmountA];
    this.liquidityToken = new Token({
      chainId: tokenAmounts[0].token.chainId,
      address: _Pair.getAddress(tokenAmounts[0].token, tokenAmounts[1].token),
      decimals: 18,
      symbol: "UNI-V2",
      name: "Uniswap V2"
    });
    this.tokenAmounts = tokenAmounts;
  }
  /**
   * Returns true if the token is either token0 or token1
   * @param token to check
   */
  involvesToken(token) {
    return token.equals(this.token0) || token.equals(this.token1);
  }
  /**
   * Returns the current mid price of the pair in terms of token0, i.e. the ratio of reserve1 to reserve0
   */
  get token0Price() {
    return new Price(this.token0, this.token1, this.tokenAmounts[0].raw, this.tokenAmounts[1].raw);
  }
  /**
   * Returns the current mid price of the pair in terms of token1, i.e. the ratio of reserve0 to reserve1
   */
  get token1Price() {
    return new Price(this.token1, this.token0, this.tokenAmounts[1].raw, this.tokenAmounts[0].raw);
  }
  /**
   * Return the price of the given token in terms of the other token in the pair.
   * @param token token to return price of
   */
  priceOf(token) {
    invariant6(this.involvesToken(token), "TOKEN");
    return token.equals(this.token0) ? this.token0Price : this.token1Price;
  }
  /**
   * Returns the chain ID of the tokens in the pair.
   */
  get chainId() {
    return this.token0.chainId;
  }
  get token0() {
    return this.tokenAmounts[0].token;
  }
  get token1() {
    return this.tokenAmounts[1].token;
  }
  get reserve0() {
    return this.tokenAmounts[0];
  }
  get reserve1() {
    return this.tokenAmounts[1];
  }
  reserveOf(token) {
    invariant6(this.involvesToken(token), "TOKEN");
    return token.equals(this.token0) ? this.reserve0 : this.reserve1;
  }
  getOutputAmount(inputAmount) {
    invariant6(this.involvesToken(inputAmount.token), "TOKEN");
    if (JSBI7.equal(this.reserve0.raw, ZERO) || JSBI7.equal(this.reserve1.raw, ZERO)) {
      throw new InsufficientReservesError();
    }
    const inputReserve = this.reserveOf(inputAmount.token);
    const outputReserve = this.reserveOf(inputAmount.token.equals(this.token0) ? this.token1 : this.token0);
    const inputAmountWithFee = JSBI7.multiply(inputAmount.raw, _998);
    const numerator = JSBI7.multiply(inputAmountWithFee, outputReserve.raw);
    const denominator = JSBI7.add(JSBI7.multiply(inputReserve.raw, _1000), inputAmountWithFee);
    const outputAmount = new TokenAmount(
      inputAmount.token.equals(this.token0) ? this.token1 : this.token0,
      JSBI7.divide(numerator, denominator)
    );
    if (JSBI7.equal(outputAmount.raw, ZERO)) {
      throw new InsufficientInputAmountError();
    }
    return [outputAmount, new _Pair(inputReserve.add(inputAmount), outputReserve.subtract(outputAmount))];
  }
  getInputAmount(outputAmount) {
    invariant6(this.involvesToken(outputAmount.token), "TOKEN");
    if (JSBI7.equal(this.reserve0.raw, ZERO) || JSBI7.equal(this.reserve1.raw, ZERO) || JSBI7.greaterThanOrEqual(outputAmount.raw, this.reserveOf(outputAmount.token).raw)) {
      throw new InsufficientReservesError();
    }
    const outputReserve = this.reserveOf(outputAmount.token);
    const inputReserve = this.reserveOf(outputAmount.token.equals(this.token0) ? this.token1 : this.token0);
    const numerator = JSBI7.multiply(JSBI7.multiply(inputReserve.raw, outputAmount.raw), _1000);
    const denominator = JSBI7.multiply(JSBI7.subtract(outputReserve.raw, outputAmount.raw), _998);
    const inputAmount = new TokenAmount(
      outputAmount.token.equals(this.token0) ? this.token1 : this.token0,
      JSBI7.add(JSBI7.divide(numerator, denominator), ONE)
    );
    return [inputAmount, new _Pair(inputReserve.add(inputAmount), outputReserve.subtract(outputAmount))];
  }
  getLiquidityMinted(totalSupply, tokenAmountA, tokenAmountB) {
    invariant6(totalSupply.token.equals(this.liquidityToken), "LIQUIDITY");
    const tokenAmounts = tokenAmountA.token.sortsBefore(tokenAmountB.token) ? [tokenAmountA, tokenAmountB] : [tokenAmountB, tokenAmountA];
    invariant6(tokenAmounts[0].token.equals(this.token0) && tokenAmounts[1].token.equals(this.token1), "TOKEN");
    let liquidity;
    if (JSBI7.equal(totalSupply.raw, ZERO)) {
      liquidity = JSBI7.subtract(sqrt(JSBI7.multiply(tokenAmounts[0].raw, tokenAmounts[1].raw)), MINIMUM_LIQUIDITY);
    } else {
      const amount0 = JSBI7.divide(JSBI7.multiply(tokenAmounts[0].raw, totalSupply.raw), this.reserve0.raw);
      const amount1 = JSBI7.divide(JSBI7.multiply(tokenAmounts[1].raw, totalSupply.raw), this.reserve1.raw);
      liquidity = JSBI7.lessThanOrEqual(amount0, amount1) ? amount0 : amount1;
    }
    if (!JSBI7.greaterThan(liquidity, ZERO)) {
      throw new InsufficientInputAmountError();
    }
    return new TokenAmount(this.liquidityToken, liquidity);
  }
  getLiquidityValue(token, totalSupply, liquidity, feeOn = false, kLast) {
    invariant6(this.involvesToken(token), "TOKEN");
    invariant6(totalSupply.token.equals(this.liquidityToken), "TOTAL_SUPPLY");
    invariant6(liquidity.token.equals(this.liquidityToken), "LIQUIDITY");
    invariant6(JSBI7.lessThanOrEqual(liquidity.raw, totalSupply.raw), "LIQUIDITY");
    let totalSupplyAdjusted;
    if (!feeOn) {
      totalSupplyAdjusted = totalSupply;
    } else {
      invariant6(!!kLast, "K_LAST");
      const kLastParsed = parseBigintIsh(kLast);
      if (!JSBI7.equal(kLastParsed, ZERO)) {
        const rootK = sqrt(JSBI7.multiply(this.reserve0.raw, this.reserve1.raw));
        const rootKLast = sqrt(kLastParsed);
        if (JSBI7.greaterThan(rootK, rootKLast)) {
          const numerator = JSBI7.multiply(totalSupply.raw, JSBI7.subtract(rootK, rootKLast));
          const denominator = JSBI7.add(JSBI7.multiply(rootK, FIVE), rootKLast);
          const feeLiquidity = JSBI7.divide(numerator, denominator);
          totalSupplyAdjusted = totalSupply.add(new TokenAmount(this.liquidityToken, feeLiquidity));
        } else {
          totalSupplyAdjusted = totalSupply;
        }
      } else {
        totalSupplyAdjusted = totalSupply;
      }
    }
    return new TokenAmount(
      token,
      JSBI7.divide(JSBI7.multiply(liquidity.raw, this.reserveOf(token).raw), totalSupplyAdjusted.raw)
    );
  }
};

// src/entities/route.ts
import invariant7 from "tiny-invariant";
var Route = class {
  constructor(pairs, input, output) {
    invariant7(pairs.length > 0, "PAIRS");
    invariant7(
      pairs.every((pair) => pair.chainId === pairs[0].chainId),
      "CHAIN_IDS"
    );
    invariant7(
      pairs[0].involvesToken(input) || input.isNative && pairs[0].involvesToken(WETH[pairs[0].chainId]),
      "INPUT"
    );
    invariant7(
      typeof output === "undefined" || pairs[pairs.length - 1].involvesToken(output) || output.isNative && pairs[pairs.length - 1].involvesToken(WETH[pairs[0].chainId]),
      "OUTPUT"
    );
    const path = [input.isNative ? WETH[pairs[0].chainId] : input];
    for (const [i, pair] of pairs.entries()) {
      const currentInput = path[i];
      invariant7(currentInput.equals(pair.token0) || currentInput.equals(pair.token1), "PATH");
      const output2 = currentInput.equals(pair.token0) ? pair.token1 : pair.token0;
      path.push(output2);
    }
    this.pairs = pairs;
    this.path = path;
    this.midPrice = Price.fromRoute(this);
    this.input = input;
    this.output = output ?? path[path.length - 1];
  }
  get chainId() {
    return this.pairs[0].chainId;
  }
};

// src/entities/gasToken.ts
var GAS = (chainId, symbol, iconId, decimals = 18) => new Token({
  isNative: true,
  name: symbol,
  symbol,
  address: "",
  chainId,
  decimals,
  icons: {
    small: `https://s2.coinmarketcap.com/static/img/coins/64x64/${iconId}.png`,
    large: `https://s2.coinmarketcap.com/static/img/coins/64x64/${iconId}.png`
  }
});
var TOKEN_AS_GAS = (chainId, address2, symbol, iconId, decimals = 18) => new Token({
  name: symbol,
  symbol,
  address: address2,
  chainId,
  decimals,
  icons: {
    small: `https://s2.coinmarketcap.com/static/img/coins/64x64/${iconId}.png`,
    large: `https://s2.coinmarketcap.com/static/img/coins/64x64/${iconId}.png`
  }
});
var GAS_TOKEN = {
  [1 /* ETH_MAINNET */]: GAS(1 /* ETH_MAINNET */, "ETH", 1027),
  [4 /* ETH_RINKEBY */]: GAS(4 /* ETH_RINKEBY */, "ETH", 1027),
  [42 /* ETH_KOVAN */]: GAS(42 /* ETH_KOVAN */, "ETH", 1027),
  [56 /* BSC_MAINNET */]: GAS(56 /* BSC_MAINNET */, "BNB", 1839),
  [97 /* BSC_TESTNET */]: GAS(97 /* BSC_TESTNET */, "BNB", 1839),
  [137 /* MATIC_MAINNET */]: GAS(137 /* MATIC_MAINNET */, "MATIC", 3890),
  [80001 /* MATIC_MUMBAI */]: GAS(80001 /* MATIC_MUMBAI */, "MATIC", 3890),
  [43114 /* AVAX_MAINNET */]: GAS(43114 /* AVAX_MAINNET */, "AVAX", 5805),
  [43113 /* AVAX_TESTNET */]: GAS(43113 /* AVAX_TESTNET */, "AVAX", 5805),
  [128 /* HECO_MAINNET */]: GAS(128 /* HECO_MAINNET */, "HT", 2502),
  [256 /* HECO_TESTNET */]: GAS(256 /* HECO_TESTNET */, "HT", 2502),
  [66 /* OKEX_MAINNET */]: GAS(66 /* OKEX_MAINNET */, "OKT", 8267),
  [65 /* OKEX_TESTNET */]: GAS(65 /* OKEX_TESTNET */, "OKT", 8267),
  [288 /* BOBA_MAINNET */]: GAS(288 /* BOBA_MAINNET */, "ETH", 1027),
  [28 /* BOBA_RINKEBY */]: GAS(28 /* BOBA_RINKEBY */, "ETH", 1027),
  [56288 /* BOBA_BNB */]: GAS(56288 /* BOBA_BNB */, "BOBA", 14556),
  [43288 /* BOBA_AVALANCHE */]: GAS(43288 /* BOBA_AVALANCHE */, "BOBA", 14556),
  [2001 /* MILKOMEDA_MAINNET */]: GAS(2001 /* MILKOMEDA_MAINNET */, "MilkADA", 2010),
  [200101 /* MILKOMEDA_DEVNET */]: GAS(200101 /* MILKOMEDA_DEVNET */, "MilktADA", 2010),
  [3652501241 /* BTC_MAINNET */]: GAS(3652501241 /* BTC_MAINNET */, "BTC", 1, 8),
  [2782866891 /* BTC_MUTINY */]: GAS(2782866891 /* BTC_MUTINY */, "BTC", 1, 8),
  [675223068 /* BTC_TESTNET4 */]: GAS(675223068 /* BTC_TESTNET4 */, "BTC", 1, 8),
  [1313161554 /* AURORA_MAINNET */]: GAS(1313161554 /* AURORA_MAINNET */, "ETH", 1027),
  [1313161555 /* AURORA_TESTNET */]: GAS(1313161555 /* AURORA_TESTNET */, "ETH", 1027),
  [40 /* TELOS_MAINNET */]: GAS(40 /* TELOS_MAINNET */, "TLOS", 4660),
  [41 /* TELOS_TESTNET */]: GAS(41 /* TELOS_TESTNET */, "TLOS", 4660),
  [8081 /* SHARDEUM_TESTNET_2 */]: GAS(8081 /* SHARDEUM_TESTNET_2 */, "SHM", 22353),
  [2222 /* KAVA_MAINNET */]: GAS(2222 /* KAVA_MAINNET */, "KAVA", 4846),
  [534351 /* SCROLL_SEPOLIA */]: GAS(534351 /* SCROLL_SEPOLIA */, "ETH", 1027),
  [324 /* ZKSYNC_MAINNET */]: GAS(324 /* ZKSYNC_MAINNET */, "ETH", 1027),
  [42161 /* ARBITRUM_MAINNET */]: GAS(42161 /* ARBITRUM_MAINNET */, "ETH", 1027),
  [42170 /* ARBITRUM_NOVA */]: GAS(42170 /* ARBITRUM_NOVA */, "ETH", 1027),
  [10 /* OPTIMISM_MAINNET */]: GAS(10 /* OPTIMISM_MAINNET */, "ETH", 1027),
  [7001 /* ZETACHAIN_ATHENS_2 */]: GAS(7001 /* ZETACHAIN_ATHENS_2 */, "ZETA", 21259),
  [1101 /* POLYGON_ZK */]: GAS(1101 /* POLYGON_ZK */, "ETH", 1027),
  [59144 /* LINEA_MAINNET */]: GAS(59144 /* LINEA_MAINNET */, "ETH", 1027),
  [59140 /* LINEA_TESTNET */]: GAS(59140 /* LINEA_TESTNET */, "ETH", 1027),
  [5e3 /* MANTLE_MAINNET */]: GAS(5e3 /* MANTLE_MAINNET */, "MNT", 27075),
  [5001 /* MANTLE_TESTNET */]: GAS(5001 /* MANTLE_TESTNET */, "MNT", 27075),
  [8453 /* BASE_MAINNET */]: GAS(8453 /* BASE_MAINNET */, "ETH", 1027),
  [2494104990 /* TRON_TESTNET */]: GAS(2494104990 /* TRON_TESTNET */, "TRX", 1958, 6),
  [728126428 /* TRON_MAINNET */]: GAS(728126428 /* TRON_MAINNET */, "TRX", 1958, 6),
  [534352 /* SCROLL_MAINNET */]: GAS(534352 /* SCROLL_MAINNET */, "ETH", 1027),
  [169 /* MANTA_MAINNET */]: GAS(169 /* MANTA_MAINNET */, "ETH", 1027),
  [1088 /* METIS_MAINNET */]: TOKEN_AS_GAS(
    1088 /* METIS_MAINNET */,
    "0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000",
    "METIS",
    9640
  ),
  [195 /* OKX_X1_TESTNET */]: GAS(195 /* OKX_X1_TESTNET */, "OKB", 3897),
  [5165 /* BAHAMUT_MAINNET */]: GAS(5165 /* BAHAMUT_MAINNET */, "FTN", 22615),
  [34443 /* MODE_MAINNET */]: GAS(34443 /* MODE_MAINNET */, "ETH", 1027),
  [30 /* RSK_MAINNET */]: GAS(30 /* RSK_MAINNET */, "RBTC", 3626),
  [81457 /* BLAST_MAINNET */]: GAS(81457 /* BLAST_MAINNET */, "ETH", 1027),
  [4200 /* MERLIN_MAINNET */]: GAS(4200 /* MERLIN_MAINNET */, "BTC", 1),
  [810180 /* ZKLINK_MAINNET */]: GAS(810180 /* ZKLINK_MAINNET */, "ETH", 1027),
  [11155111 /* SEPOLIA_TESTNET */]: GAS(11155111 /* SEPOLIA_TESTNET */, "ETH", 1027),
  [1116 /* CORE_MAINNET */]: GAS(1116 /* CORE_MAINNET */, "CORE", 23254),
  [85918 /* TON_MAINNET */]: TOKEN_AS_GAS(
    85918 /* TON_MAINNET */,
    "0xA4f1b5C2fC9b97d4238B3dE3487ccaE2c36dE07C",
    "TON",
    11419,
    9
  ),
  [85919 /* TON_TESTNET */]: TOKEN_AS_GAS(
    85919 /* TON_TESTNET */,
    "0x7eA393298D1077e19ec59F8e3FE8fe642738c08C",
    "TON",
    11419,
    9
  ),
  [167e3 /* TAIKO_MAINNET */]: GAS(167e3 /* TAIKO_MAINNET */, "ETH", 1027),
  [1329 /* SEI_EVM_MAINNET */]: GAS(1329 /* SEI_EVM_MAINNET */, "SEI", 23149),
  [7e3 /* ZETACHAIN_MAINNET */]: GAS(7e3 /* ZETACHAIN_MAINNET */, "ZETA", 21259),
  [25 /* CRONOS_MAINNET */]: GAS(25 /* CRONOS_MAINNET */, "CRO", 3635),
  [252 /* FRAXTAL_MAINNET */]: GAS(252 /* FRAXTAL_MAINNET */, "frxETH", 23225),
  [1625 /* GRAVITY_MAINNET */]: GAS(1625 /* GRAVITY_MAINNET */, "G", 32120),
  [223 /* BSQUARED_MAINNET */]: GAS(223 /* BSQUARED_MAINNET */, "BTC", 1)
};

// src/entities/trade.ts
import invariant8 from "tiny-invariant";
function computePriceImpact(midPrice, inputAmount, outputAmount) {
  const exactQuote = midPrice.raw.multiply(inputAmount.raw);
  const slippage = exactQuote.subtract(outputAmount.raw).divide(exactQuote);
  return new Percent(slippage.numerator, slippage.denominator);
}
function inputOutputComparator(a, b) {
  invariant8(tokenEquals(a.inputAmount.token, b.inputAmount.token), "INPUT_CURRENCY");
  invariant8(tokenEquals(a.outputAmount.token, b.outputAmount.token), "OUTPUT_CURRENCY");
  if (a.outputAmount.equalTo(b.outputAmount)) {
    if (a.inputAmount.equalTo(b.inputAmount)) {
      return 0;
    }
    if (a.inputAmount.lessThan(b.inputAmount)) {
      return -1;
    } else {
      return 1;
    }
  } else {
    if (a.outputAmount.lessThan(b.outputAmount)) {
      return 1;
    } else {
      return -1;
    }
  }
}
function tradeComparator(a, b) {
  const ioComp = inputOutputComparator(a, b);
  if (ioComp !== 0) {
    return ioComp;
  }
  if (a.priceImpact.lessThan(b.priceImpact)) {
    return -1;
  } else if (a.priceImpact.greaterThan(b.priceImpact)) {
    return 1;
  }
  return a.route.path.length - b.route.path.length;
}
function wrappedAmount(tokenAmount) {
  return tokenAmount.token.isNative ? new TokenAmount(WETH[tokenAmount.token.chainId], tokenAmount.raw) : tokenAmount;
}
function wrappedToken(token) {
  return token.isNative ? WETH[token.chainId] : token;
}
var Trade = class _Trade {
  /**
   * Constructs an exact in trade with the given amount in and route
   * @param route route of the exact in trade
   * @param amountIn the amount being passed in
   */
  static exactIn(route, amountIn) {
    return new _Trade(route, amountIn, 0 /* EXACT_INPUT */);
  }
  /**
   * Constructs an exact out trade with the given amount out and route
   * @param route route of the exact out trade
   * @param amountOut the amount returned by the trade
   */
  static exactOut(route, amountOut) {
    return new _Trade(route, amountOut, 1 /* EXACT_OUTPUT */);
  }
  constructor(route, amount, tradeType) {
    const amounts = new Array(route.path.length);
    const nextPairs = new Array(route.pairs.length);
    if (tradeType === 0 /* EXACT_INPUT */) {
      invariant8(tokenEquals(amount.token, route.input), "INPUT");
      amounts[0] = wrappedAmount(amount);
      for (let i = 0; i < route.path.length - 1; i++) {
        const pair = route.pairs[i];
        const [outputAmount, nextPair] = pair.getOutputAmount(amounts[i]);
        amounts[i + 1] = outputAmount;
        nextPairs[i] = nextPair;
      }
    } else {
      invariant8(tokenEquals(amount.token, route.output), "OUTPUT");
      amounts[amounts.length - 1] = wrappedAmount(amount);
      for (let i = route.path.length - 1; i > 0; i--) {
        const pair = route.pairs[i - 1];
        const [inputAmount, nextPair] = pair.getInputAmount(amounts[i]);
        amounts[i - 1] = inputAmount;
        nextPairs[i - 1] = nextPair;
      }
    }
    this.route = route;
    this.tradeType = tradeType;
    this.inputAmount = tradeType === 0 /* EXACT_INPUT */ ? amount : new TokenAmount(route.input, amounts[0].raw);
    this.outputAmount = tradeType === 1 /* EXACT_OUTPUT */ ? amount : new TokenAmount(route.output, amounts[amounts.length - 1].raw);
    this.executionPrice = new Price(
      this.inputAmount.token,
      this.outputAmount.token,
      this.inputAmount.raw,
      this.outputAmount.raw
    );
    this.nextMidPrice = Price.fromRoute(new Route(nextPairs, route.input));
    this.priceImpact = computePriceImpact(route.midPrice, this.inputAmount, this.outputAmount);
  }
  /**
   * Get the minimum amount that must be received from this trade for the given slippage tolerance
   * @param slippageTolerance tolerance of unfavorable slippage from the execution price of this trade
   */
  minimumAmountOut(slippageTolerance) {
    invariant8(!slippageTolerance.lessThan(ZERO), "SLIPPAGE_TOLERANCE");
    if (this.tradeType === 1 /* EXACT_OUTPUT */) {
      return this.outputAmount;
    } else {
      const slippageAdjustedAmountOut = new Fraction(ONE).add(slippageTolerance).invert().multiply(this.outputAmount.raw).quotient;
      return new TokenAmount(this.outputAmount.token, slippageAdjustedAmountOut);
    }
  }
  /**
   * Get the maximum amount in that can be spent via this trade for the given slippage tolerance
   * @param slippageTolerance tolerance of unfavorable slippage from the execution price of this trade
   */
  maximumAmountIn(slippageTolerance) {
    invariant8(!slippageTolerance.lessThan(ZERO), "SLIPPAGE_TOLERANCE");
    if (this.tradeType === 0 /* EXACT_INPUT */) {
      return this.inputAmount;
    } else {
      const slippageAdjustedAmountIn = new Fraction(ONE).add(slippageTolerance).multiply(this.inputAmount.raw).quotient;
      return new TokenAmount(this.inputAmount.token, slippageAdjustedAmountIn);
    }
  }
  /**
   * Given a list of pairs, and a fixed amount in, returns the top `maxNumResults` trades that go from an input token
   * amount to an output token, making at most `maxHops` hops.
   * Note this does not consider aggregation, as routes are linear. It's possible a better route exists by splitting
   * the amount in among multiple routes.
   * @param pairs the pairs to consider in finding the best trade
   * @param tokenAmountIn exact amount of input token to spend
   * @param tokenOut the desired token out
   * @param maxNumResults maximum number of results to return
   * @param maxHops maximum number of hops a returned trade can make, e.g. 1 hop goes through a single pair
   * @param currentPairs used in recursion; the current list of pairs
   * @param originalAmountIn used in recursion; the original value of the tokenAmountIn parameter
   * @param bestTrades used in recursion; the current list of best trades
   */
  static bestTradeExactIn(pairs, tokenAmountIn, tokenOut, { maxNumResults = 3, maxHops = 3 } = {}, currentPairs = [], originalAmountIn = tokenAmountIn, bestTrades = []) {
    invariant8(pairs.length > 0, "PAIRS");
    invariant8(maxHops > 0, "MAX_HOPS");
    invariant8(originalAmountIn === tokenAmountIn || currentPairs.length > 0, "INVALID_RECURSION");
    const amountIn = wrappedAmount(tokenAmountIn);
    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i];
      if (!pair.token0.equals(amountIn.token) && !pair.token1.equals(amountIn.token))
        continue;
      if (pair.reserve0.equalTo(ZERO) || pair.reserve1.equalTo(ZERO))
        continue;
      let amountOut;
      try {
        ;
        [amountOut] = pair.getOutputAmount(amountIn);
      } catch (error) {
        if (error.isInsufficientInputAmountError) {
          continue;
        }
        throw error;
      }
      if (amountOut.token.equals(wrappedToken(tokenOut))) {
        sortedInsert(
          bestTrades,
          new _Trade(
            new Route([...currentPairs, pair], originalAmountIn.token, tokenOut),
            originalAmountIn,
            0 /* EXACT_INPUT */
          ),
          maxNumResults,
          tradeComparator
        );
      } else if (maxHops > 1 && pairs.length > 1) {
        const pairsExcludingThisPair = pairs.slice(0, i).concat(pairs.slice(i + 1, pairs.length));
        _Trade.bestTradeExactIn(
          pairsExcludingThisPair,
          amountOut,
          tokenOut,
          {
            maxNumResults,
            maxHops: maxHops - 1
          },
          [...currentPairs, pair],
          originalAmountIn,
          bestTrades
        );
      }
    }
    return bestTrades;
  }
  /**
   * similar to the above method but instead targets a fixed output amount
   * given a list of pairs, and a fixed amount out, returns the top `maxNumResults` trades that go from an input token
   * to an output token amount, making at most `maxHops` hops
   * note this does not consider aggregation, as routes are linear. it's possible a better route exists by splitting
   * the amount in among multiple routes.
   * @param pairs the pairs to consider in finding the best trade
   * @param tokenIn the token to spend
   * @param tokenAmountOut the exact amount of token out
   * @param maxNumResults maximum number of results to return
   * @param maxHops maximum number of hops a returned trade can make, e.g. 1 hop goes through a single pair
   * @param currentPairs used in recursion; the current list of pairs
   * @param originalAmountOut used in recursion; the original value of the currencyAmountOut parameter
   * @param bestTrades used in recursion; the current list of best trades
   */
  static bestTradeExactOut(pairs, tokenIn, tokenAmountOut, { maxNumResults = 3, maxHops = 3 } = {}, currentPairs = [], originalAmountOut = tokenAmountOut, bestTrades = []) {
    invariant8(pairs.length > 0, "PAIRS");
    invariant8(maxHops > 0, "MAX_HOPS");
    invariant8(originalAmountOut === tokenAmountOut || currentPairs.length > 0, "INVALID_RECURSION");
    const amountOut = wrappedAmount(tokenAmountOut);
    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i];
      if (!pair.token0.equals(amountOut.token) && !pair.token1.equals(amountOut.token))
        continue;
      if (pair.reserve0.equalTo(ZERO) || pair.reserve1.equalTo(ZERO))
        continue;
      let amountIn;
      try {
        ;
        [amountIn] = pair.getInputAmount(amountOut);
      } catch (error) {
        if (error.isInsufficientReservesError) {
          continue;
        }
        throw error;
      }
      if (amountIn.token.equals(wrappedToken(tokenIn))) {
        sortedInsert(
          bestTrades,
          new _Trade(
            new Route([pair, ...currentPairs], tokenIn, originalAmountOut.token),
            originalAmountOut,
            1 /* EXACT_OUTPUT */
          ),
          maxNumResults,
          tradeComparator
        );
      } else if (maxHops > 1 && pairs.length > 1) {
        const pairsExcludingThisPair = pairs.slice(0, i).concat(pairs.slice(i + 1, pairs.length));
        _Trade.bestTradeExactOut(
          pairsExcludingThisPair,
          tokenIn,
          amountIn,
          {
            maxNumResults,
            maxHops: maxHops - 1
          },
          [pair, ...currentPairs],
          originalAmountOut,
          bestTrades
        );
      }
    }
    return bestTrades;
  }
};

// src/router.ts
import invariant9 from "tiny-invariant";
function toHex(tokenAmount) {
  return `0x${tokenAmount.raw.toString(16)}`;
}
var ZERO_HEX = "0x0";
var Router = class {
  /**
   * Produces the on-chain method name to call and the hex encoded parameters to pass as arguments for a given trade.
   * @param trade to produce call parameters for
   * @param options options for the call parameters
   */
  static swapCallParameters(trade, options) {
    invariant9(!(trade.inputAmount.token.isNative && trade.outputAmount.token.isNative), "ETHER_IN_OUT");
    invariant9(options.ttl > 0, "TTL");
    const to = validateAndParseAddress(options.recipient);
    const amountIn = toHex(trade.maximumAmountIn(options.allowedSlippage));
    const amountOut = toHex(trade.minimumAmountOut(options.allowedSlippage));
    let path;
    if (trade.inputAmount.token.chainId === 2222 /* KAVA_MAINNET */) {
      const routes = [];
      for (let i = 0; i < trade.route.path.length - 1; i++) {
        routes.push({
          from: trade.route.path[i].address,
          to: trade.route.path[i + 1].address,
          stable: false
        });
      }
      path = routes;
    } else {
      path = trade.route.path.map((token) => token.address);
    }
    const deadline = `0x${(Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3) + options.ttl).toString(16)}`;
    const useFeeOnTransfer = Boolean(options.feeOnTransfer);
    let methodName;
    let args;
    let value;
    let offset;
    switch (trade.tradeType) {
      case 0 /* EXACT_INPUT */:
        if (trade.inputAmount.token.isNative) {
          methodName = "swapExactETHForTokens";
          args = [amountOut, path, to, deadline];
          if (useFeeOnTransfer) {
            methodName = "swapExactETHForTokensSupportingFeeOnTransferTokens";
            if (trade.outputAmount.token.chainId === 34443 /* MODE_MAINNET */) {
              args = [amountOut, path, to, to, deadline];
            }
          }
          value = amountIn;
          offset = 0;
        } else if (trade.outputAmount.token.isNative) {
          methodName = "swapExactTokensForETH";
          args = [amountIn, amountOut, path, to, deadline];
          if (useFeeOnTransfer) {
            methodName = "swapExactTokensForETHSupportingFeeOnTransferTokens";
            if (trade.outputAmount.token.chainId === 34443 /* MODE_MAINNET */) {
              args = [amountIn, amountOut, path, to, to, deadline];
            }
          }
          value = ZERO_HEX;
          offset = 36;
        } else {
          methodName = "swapExactTokensForTokens";
          args = [amountIn, amountOut, path, to, deadline];
          if (useFeeOnTransfer) {
            methodName = "swapExactTokensForTokensSupportingFeeOnTransferTokens";
            if (trade.outputAmount.token.chainId === 34443 /* MODE_MAINNET */) {
              args = [amountIn, amountOut, path, to, to, deadline];
            }
          }
          value = ZERO_HEX;
          offset = 36;
        }
        break;
      case 1 /* EXACT_OUTPUT */:
        invariant9(!useFeeOnTransfer, "EXACT_OUT_FOT");
        if (trade.inputAmount.token.isNative) {
          methodName = "swapETHForExactTokens";
          args = [amountOut, path, to, deadline];
          value = amountIn;
          offset = 0;
        } else if (trade.outputAmount.token.isNative) {
          methodName = "swapTokensForExactETH";
          args = [amountOut, amountIn, path, to, deadline];
          value = ZERO_HEX;
          offset = 68;
        } else {
          methodName = "swapTokensForExactTokens";
          args = [amountOut, amountIn, path, to, deadline];
          value = ZERO_HEX;
          offset = 68;
        }
        break;
    }
    return {
      methodName,
      args,
      value,
      offset
    };
  }
};

// src/crosschain/symbiosis.ts
import { StaticJsonRpcProvider } from "@ethersproject/providers";
import { utils as utils41 } from "ethers";
import isomorphicFetch from "isomorphic-unfetch";
import JSBI17 from "jsbi";
import TronWeb4 from "tronweb";

// src/crosschain/constants.ts
import { AddressZero } from "@ethersproject/constants";
import JSBI8 from "jsbi";
var CROSS_CHAIN_ID = "0x0000000000000000000000000000000000000000000000000000000000000000";
var CHAINS_PRIORITY = [
  1 /* ETH_MAINNET */,
  4 /* ETH_RINKEBY */,
  42 /* ETH_KOVAN */,
  56 /* BSC_MAINNET */,
  // ChainId.BSC_TESTNET, // NOTE it is a manager chain
  43114 /* AVAX_MAINNET */,
  43113 /* AVAX_TESTNET */,
  288 /* BOBA_MAINNET */,
  43288 /* BOBA_AVALANCHE */,
  // ChainId.BOBA_BNB, // NOTE it is a manager chain
  28 /* BOBA_RINKEBY */,
  1313161554 /* AURORA_MAINNET */,
  1313161555 /* AURORA_TESTNET */,
  40 /* TELOS_MAINNET */,
  41 /* TELOS_TESTNET */,
  137 /* MATIC_MAINNET */,
  80001 /* MATIC_MUMBAI */,
  2001 /* MILKOMEDA_MAINNET */,
  200101 /* MILKOMEDA_DEVNET */,
  66 /* OKEX_MAINNET */,
  65 /* OKEX_TESTNET */,
  128 /* HECO_MAINNET */,
  256 /* HECO_TESTNET */,
  8081 /* SHARDEUM_TESTNET_2 */,
  2222 /* KAVA_MAINNET */,
  534351 /* SCROLL_SEPOLIA */,
  324 /* ZKSYNC_MAINNET */,
  42161 /* ARBITRUM_MAINNET */,
  42170 /* ARBITRUM_NOVA */,
  10 /* OPTIMISM_MAINNET */,
  7001 /* ZETACHAIN_ATHENS_2 */,
  1101 /* POLYGON_ZK */,
  728126428 /* TRON_MAINNET */,
  2494104990 /* TRON_TESTNET */,
  85919 /* TON_TESTNET */,
  59140 /* LINEA_TESTNET */,
  59144 /* LINEA_MAINNET */,
  5e3 /* MANTLE_MAINNET */,
  5001 /* MANTLE_TESTNET */,
  8453 /* BASE_MAINNET */,
  534352 /* SCROLL_MAINNET */,
  169 /* MANTA_MAINNET */,
  1088 /* METIS_MAINNET */,
  195 /* OKX_X1_TESTNET */,
  5165 /* BAHAMUT_MAINNET */,
  34443 /* MODE_MAINNET */,
  30 /* RSK_MAINNET */,
  81457 /* BLAST_MAINNET */,
  4200 /* MERLIN_MAINNET */,
  810180 /* ZKLINK_MAINNET */,
  1116 /* CORE_MAINNET */,
  11155111 /* SEPOLIA_TESTNET */,
  167e3 /* TAIKO_MAINNET */,
  1329 /* SEI_EVM_MAINNET */,
  7e3 /* ZETACHAIN_MAINNET */,
  25 /* CRONOS_MAINNET */,
  252 /* FRAXTAL_MAINNET */,
  1625 /* GRAVITY_MAINNET */,
  223 /* BSQUARED_MAINNET */
];
var ONE_INCH_CHAINS = [
  1 /* ETH_MAINNET */,
  56 /* BSC_MAINNET */,
  137 /* MATIC_MAINNET */,
  10 /* OPTIMISM_MAINNET */,
  42161 /* ARBITRUM_MAINNET */,
  43114 /* AVAX_MAINNET */,
  324 /* ZKSYNC_MAINNET */,
  8453 /* BASE_MAINNET */
];
var ONE_INCH_ORACLE_MAP = {
  [1 /* ETH_MAINNET */]: "0x52cbE0f49CcdD4Dc6E9C13BAb024EABD2842045B",
  [56 /* BSC_MAINNET */]: "0x52cbE0f49CcdD4Dc6E9C13BAb024EABD2842045B",
  [137 /* MATIC_MAINNET */]: "0x52cbE0f49CcdD4Dc6E9C13BAb024EABD2842045B",
  [10 /* OPTIMISM_MAINNET */]: "0x52cbE0f49CcdD4Dc6E9C13BAb024EABD2842045B",
  [42161 /* ARBITRUM_MAINNET */]: "0x52cbE0f49CcdD4Dc6E9C13BAb024EABD2842045B",
  [43114 /* AVAX_MAINNET */]: "0x52cbE0f49CcdD4Dc6E9C13BAb024EABD2842045B",
  [324 /* ZKSYNC_MAINNET */]: "0xC762d56614D3411eC6fABD56cb075D904b801613",
  [8453 /* BASE_MAINNET */]: "0x52cbE0f49CcdD4Dc6E9C13BAb024EABD2842045B"
};
var WETH_ONLY = {
  [1 /* ETH_MAINNET */]: [WETH[1 /* ETH_MAINNET */]],
  [4 /* ETH_RINKEBY */]: [WETH[4 /* ETH_RINKEBY */]],
  [42 /* ETH_KOVAN */]: [WETH[42 /* ETH_KOVAN */]],
  [56 /* BSC_MAINNET */]: [WETH[56 /* BSC_MAINNET */]],
  [97 /* BSC_TESTNET */]: [WETH[97 /* BSC_TESTNET */]],
  [137 /* MATIC_MAINNET */]: [WETH[137 /* MATIC_MAINNET */]],
  [80001 /* MATIC_MUMBAI */]: [WETH[80001 /* MATIC_MUMBAI */]],
  [43114 /* AVAX_MAINNET */]: [WETH[43114 /* AVAX_MAINNET */]],
  [43113 /* AVAX_TESTNET */]: [WETH[43113 /* AVAX_TESTNET */]],
  [128 /* HECO_MAINNET */]: [WETH[128 /* HECO_MAINNET */]],
  [256 /* HECO_TESTNET */]: [WETH[256 /* HECO_TESTNET */]],
  [66 /* OKEX_MAINNET */]: [WETH[66 /* OKEX_MAINNET */]],
  [65 /* OKEX_TESTNET */]: [WETH[65 /* OKEX_TESTNET */]],
  [288 /* BOBA_MAINNET */]: [WETH[288 /* BOBA_MAINNET */]],
  [43288 /* BOBA_AVALANCHE */]: [WETH[43288 /* BOBA_AVALANCHE */]],
  [56288 /* BOBA_BNB */]: [WETH[56288 /* BOBA_BNB */]],
  [28 /* BOBA_RINKEBY */]: [WETH[28 /* BOBA_RINKEBY */]],
  [2001 /* MILKOMEDA_MAINNET */]: [WETH[2001 /* MILKOMEDA_MAINNET */]],
  [200101 /* MILKOMEDA_DEVNET */]: [WETH[200101 /* MILKOMEDA_DEVNET */]],
  [1313161554 /* AURORA_MAINNET */]: [WETH[1313161554 /* AURORA_MAINNET */]],
  [1313161555 /* AURORA_TESTNET */]: [WETH[1313161555 /* AURORA_TESTNET */]],
  [40 /* TELOS_MAINNET */]: [WETH[40 /* TELOS_MAINNET */]],
  [41 /* TELOS_TESTNET */]: [WETH[41 /* TELOS_TESTNET */]],
  [8081 /* SHARDEUM_TESTNET_2 */]: [WETH[8081 /* SHARDEUM_TESTNET_2 */]],
  [2222 /* KAVA_MAINNET */]: [WETH[2222 /* KAVA_MAINNET */]],
  [534351 /* SCROLL_SEPOLIA */]: [WETH[534351 /* SCROLL_SEPOLIA */]],
  [324 /* ZKSYNC_MAINNET */]: [WETH[324 /* ZKSYNC_MAINNET */]],
  [42161 /* ARBITRUM_MAINNET */]: [WETH[42161 /* ARBITRUM_MAINNET */]],
  [42170 /* ARBITRUM_NOVA */]: [WETH[42170 /* ARBITRUM_NOVA */]],
  [10 /* OPTIMISM_MAINNET */]: [WETH[10 /* OPTIMISM_MAINNET */]],
  [7001 /* ZETACHAIN_ATHENS_2 */]: [WETH[7001 /* ZETACHAIN_ATHENS_2 */]],
  [1101 /* POLYGON_ZK */]: [WETH[1101 /* POLYGON_ZK */]],
  [59140 /* LINEA_TESTNET */]: [WETH[59140 /* LINEA_TESTNET */]],
  [59144 /* LINEA_MAINNET */]: [WETH[59144 /* LINEA_MAINNET */]],
  [5e3 /* MANTLE_MAINNET */]: [WETH[5e3 /* MANTLE_MAINNET */]],
  [5001 /* MANTLE_TESTNET */]: [WETH[5001 /* MANTLE_TESTNET */]],
  [8453 /* BASE_MAINNET */]: [WETH[8453 /* BASE_MAINNET */]],
  [728126428 /* TRON_MAINNET */]: [WETH[728126428 /* TRON_MAINNET */]],
  [2494104990 /* TRON_TESTNET */]: [WETH[2494104990 /* TRON_TESTNET */]],
  [534352 /* SCROLL_MAINNET */]: [WETH[534352 /* SCROLL_MAINNET */]],
  [169 /* MANTA_MAINNET */]: [WETH[169 /* MANTA_MAINNET */]],
  [1088 /* METIS_MAINNET */]: [WETH[1088 /* METIS_MAINNET */]],
  [195 /* OKX_X1_TESTNET */]: [WETH[195 /* OKX_X1_TESTNET */]],
  [5165 /* BAHAMUT_MAINNET */]: [WETH[5165 /* BAHAMUT_MAINNET */]],
  [34443 /* MODE_MAINNET */]: [WETH[34443 /* MODE_MAINNET */]],
  [30 /* RSK_MAINNET */]: [WETH[30 /* RSK_MAINNET */]],
  [81457 /* BLAST_MAINNET */]: [WETH[81457 /* BLAST_MAINNET */]],
  [4200 /* MERLIN_MAINNET */]: [WETH[4200 /* MERLIN_MAINNET */]],
  [810180 /* ZKLINK_MAINNET */]: [WETH[810180 /* ZKLINK_MAINNET */]],
  [1116 /* CORE_MAINNET */]: [WETH[1116 /* CORE_MAINNET */]],
  [11155111 /* SEPOLIA_TESTNET */]: [WETH[11155111 /* SEPOLIA_TESTNET */]],
  [167e3 /* TAIKO_MAINNET */]: [WETH[167e3 /* TAIKO_MAINNET */]],
  [1329 /* SEI_EVM_MAINNET */]: [WETH[1329 /* SEI_EVM_MAINNET */]],
  [7e3 /* ZETACHAIN_MAINNET */]: [WETH[7e3 /* ZETACHAIN_MAINNET */]],
  [25 /* CRONOS_MAINNET */]: [WETH[25 /* CRONOS_MAINNET */]],
  [252 /* FRAXTAL_MAINNET */]: [WETH[252 /* FRAXTAL_MAINNET */]],
  [1625 /* GRAVITY_MAINNET */]: [WETH[1625 /* GRAVITY_MAINNET */]],
  [223 /* BSQUARED_MAINNET */]: [WETH[223 /* BSQUARED_MAINNET */]]
};
var DEX_TOKENS_TO_CHECK_TRADES_AGAINST = {
  [1 /* ETH_MAINNET */]: [
    new Token({
      chainId: 1 /* ETH_MAINNET */,
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      decimals: 18,
      symbol: "DAI",
      name: "Dai Stablecoin"
    }),
    new Token({
      chainId: 1 /* ETH_MAINNET */,
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      decimals: 6,
      symbol: "USDC",
      name: "USD//C"
    }),
    new Token({
      chainId: 1 /* ETH_MAINNET */,
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      decimals: 6,
      symbol: "USDT",
      name: "Tether USD"
    })
    // new Token({
    //     chainId: ChainId.ETH_MAINNET,
    //     address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    //     decimals: 8,
    //     symbol: 'WBTC',
    //     name: 'Wrapped BTC',
    // }),
  ],
  [56 /* BSC_MAINNET */]: [
    // new Token({
    //     chainId: ChainId.BSC_MAINNET,
    //     address: '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
    //     decimals: 18,
    //     symbol: 'CAKE',
    //     name: 'PancakeSwap Token',
    // }),
    new Token({
      chainId: 56 /* BSC_MAINNET */,
      address: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
      decimals: 18,
      symbol: "BUSD",
      name: "Binance USD"
    }),
    new Token({
      chainId: 56 /* BSC_MAINNET */,
      address: "0x55d398326f99059fF775485246999027B3197955",
      decimals: 18,
      symbol: "USDT",
      name: "Tether USD"
    }),
    // new Token({
    //     chainId: ChainId.BSC_MAINNET,
    //     address: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    //     decimals: 18,
    //     symbol: 'BTCB',
    //     name: 'Binance BTC',
    // }),
    // new Token({
    //     chainId: ChainId.BSC_MAINNET,
    //     address: '0x23396cF899Ca06c4472205fC903bDB4de249D6fC',
    //     decimals: 18,
    //     symbol: 'UST',
    //     name: 'Wrapped UST Token',
    // }),
    // new Token({
    //     chainId: ChainId.BSC_MAINNET,
    //     address: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    //     decimals: 18,
    //     symbol: 'ETH',
    //     name: 'Binance-Peg Ethereum Token',
    // }),
    new Token({
      chainId: 56 /* BSC_MAINNET */,
      address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
      decimals: 18,
      symbol: "USDC",
      name: "Binance-Peg USD Coin"
    })
  ],
  [43114 /* AVAX_MAINNET */]: [
    // new Token({
    //     chainId: ChainId.AVAX_MAINNET,
    //     address: '0x60781C2586D68229fde47564546784ab3fACA982',
    //     decimals: 18,
    //     symbol: 'PNG',
    //     name: 'Pangolin',
    // }),
    new Token({
      chainId: 43114 /* AVAX_MAINNET */,
      address: "0xc7198437980c041c805A1EDcbA50c1Ce5db95118",
      decimals: 6,
      symbol: "USDT.e",
      name: "Tether USD"
    }),
    new Token({
      chainId: 43114 /* AVAX_MAINNET */,
      address: "0xd586E7F844cEa2F87f50152665BCbc2C279D8d70",
      decimals: 18,
      symbol: "DAI.e",
      name: "Dai Stablecoin"
    }),
    new Token({
      chainId: 43114 /* AVAX_MAINNET */,
      address: "0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664",
      decimals: 6,
      symbol: "USDC.e",
      name: "USD Coin"
    }),
    // new Token({
    //     chainId: ChainId.AVAX_MAINNET,
    //     address: '0x260Bbf5698121EB85e7a74f2E45E16Ce762EbE11',
    //     decimals: 6,
    //     symbol: 'UST',
    //     name: 'Axelar Wrapped UST',
    // }),
    new Token({
      chainId: 43114 /* AVAX_MAINNET */,
      address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin"
    })
  ],
  [137 /* MATIC_MAINNET */]: [
    new Token({
      chainId: 137 /* MATIC_MAINNET */,
      address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
      decimals: 6,
      symbol: "USDC",
      name: "USDC"
    }),
    new Token({
      chainId: 137 /* MATIC_MAINNET */,
      address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
      decimals: 6,
      symbol: "USDT",
      name: "Tether USD"
    }),
    // new Token({
    //     chainId: ChainId.MATIC_MAINNET,
    //     address: '0x831753DD7087CaC61aB5644b308642cc1c33Dc13',
    //     decimals: 18,
    //     symbol: 'QUICK',
    //     name: 'QuickSwap',
    // }),
    // new Token({
    //     chainId: ChainId.MATIC_MAINNET,
    //     address: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    //     decimals: 18,
    //     symbol: 'ETH',
    //     name: 'Ether',
    // }),
    new Token({
      chainId: 137 /* MATIC_MAINNET */,
      address: "0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6",
      decimals: 18,
      symbol: "wBTC",
      name: "Wrapped Bitcoin"
    }),
    new Token({
      chainId: 137 /* MATIC_MAINNET */,
      address: "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
      decimals: 18,
      symbol: "DAI",
      name: "Dai Stablecoin"
    })
  ],
  [43288 /* BOBA_AVALANCHE */]: [],
  [56288 /* BOBA_BNB */]: [],
  [288 /* BOBA_MAINNET */]: [
    new Token({
      chainId: 288 /* BOBA_MAINNET */,
      symbol: "DAI",
      name: "Dai Stablecoin",
      address: "0xf74195Bb8a5cf652411867c5C2C5b8C2a402be35",
      decimals: 18
    }),
    new Token({
      chainId: 288 /* BOBA_MAINNET */,
      symbol: "WBTC",
      name: "Wrapped BTC",
      address: "0xdc0486f8bf31DF57a952bcd3c1d3e166e3d9eC8b",
      decimals: 8
    }),
    new Token({
      chainId: 288 /* BOBA_MAINNET */,
      name: "USD Coin",
      address: "0x66a2A913e447d6b4BF33EFbec43aAeF87890FBbc",
      symbol: "USDC",
      decimals: 6
    }),
    new Token({
      chainId: 288 /* BOBA_MAINNET */,
      symbol: "USDT",
      name: "Tether USD",
      address: "0x5DE1677344D3Cb0D7D465c10b72A8f60699C062d",
      decimals: 6
    }),
    new Token({
      chainId: 288 /* BOBA_MAINNET */,
      symbol: "BOBA",
      name: "Boba Token",
      address: "0xa18bF3994C0Cc6E3b63ac420308E5383f53120D7",
      decimals: 18
    }),
    new Token({
      chainId: 288 /* BOBA_MAINNET */,
      symbol: "OLO",
      name: "OolongSwap Token",
      address: "0x5008F837883EA9a07271a1b5eB0658404F5a9610",
      decimals: 18
    })
  ],
  [2001 /* MILKOMEDA_MAINNET */]: [
    new Token({
      chainId: 2001 /* MILKOMEDA_MAINNET */,
      symbol: "sUSDC",
      name: "USDC from Ethereum",
      address: "0x42110A5133F91B49E32B671Db86E2C44Edc13832",
      decimals: 6
    }),
    new Token({
      chainId: 2001 /* MILKOMEDA_MAINNET */,
      symbol: "SIS",
      name: "SIS from Ethereum",
      address: "0xedd4D7DAa6bf8746997CEbbF974a60B838757601",
      decimals: 18
    })
  ],
  [1313161554 /* AURORA_MAINNET */]: [
    new Token({
      chainId: 1313161554 /* AURORA_MAINNET */,
      symbol: "USDC",
      name: "USD Coin",
      address: "0xB12BFcA5A55806AaF64E99521918A4bf0fC40802",
      decimals: 6
    }),
    new Token({
      chainId: 1313161554 /* AURORA_MAINNET */,
      symbol: "USDT",
      name: "Tether USD",
      address: "0x4988a896b1227218e4A686fdE5EabdcAbd91571f",
      decimals: 6
    }),
    new Token({
      chainId: 1313161554 /* AURORA_MAINNET */,
      symbol: "wNEAR",
      name: "Wrapped NEAR",
      address: "0xC42C30aC6Cc15faC9bD938618BcaA1a1FaE8501d",
      decimals: 24
    }),
    new Token({
      chainId: 1313161554 /* AURORA_MAINNET */,
      symbol: "AURORA",
      name: "AURORA",
      address: "0x8BEc47865aDe3B172A928df8f990Bc7f2A3b9f79",
      decimals: 18
    })
  ],
  [2222 /* KAVA_MAINNET */]: [
    new Token({
      chainId: 2222 /* KAVA_MAINNET */,
      address: "0xfA9343C3897324496A05fC75abeD6bAC29f8A40f",
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin"
    })
  ],
  [534351 /* SCROLL_SEPOLIA */]: [],
  [324 /* ZKSYNC_MAINNET */]: [
    new Token({
      chainId: 324 /* ZKSYNC_MAINNET */,
      address: "0x3355df6D4c9C3035724Fd0e3914dE96A5a83aaf4",
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin"
    })
  ],
  [42161 /* ARBITRUM_MAINNET */]: [
    new Token({
      chainId: 42161 /* ARBITRUM_MAINNET */,
      address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin"
    })
  ],
  [42170 /* ARBITRUM_NOVA */]: [
    new Token({
      chainId: 42170 /* ARBITRUM_NOVA */,
      address: "0x750ba8b76187092B0D1E87E28daaf484d1b5273b",
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin"
    })
  ],
  [10 /* OPTIMISM_MAINNET */]: [
    new Token({
      chainId: 10 /* OPTIMISM_MAINNET */,
      address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin"
    })
  ],
  [7001 /* ZETACHAIN_ATHENS_2 */]: [],
  [1101 /* POLYGON_ZK */]: [],
  [2494104990 /* TRON_TESTNET */]: [
    new Token({
      chainId: 2494104990 /* TRON_TESTNET */,
      address: "TG3XXyExBkPp9nzdajDZsozEu4BkaSJozs",
      decimals: 6,
      symbol: "USDT",
      name: "Tether USD"
    })
  ],
  [728126428 /* TRON_MAINNET */]: [
    new Token({
      chainId: 728126428 /* TRON_MAINNET */,
      address: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
      decimals: 6,
      symbol: "USDT",
      name: "Tether USD"
    })
  ],
  [59140 /* LINEA_TESTNET */]: [],
  [59144 /* LINEA_MAINNET */]: [],
  [5e3 /* MANTLE_MAINNET */]: [],
  [5001 /* MANTLE_TESTNET */]: [],
  [8453 /* BASE_MAINNET */]: [],
  [534352 /* SCROLL_MAINNET */]: [],
  [169 /* MANTA_MAINNET */]: [],
  [1088 /* METIS_MAINNET */]: [],
  [195 /* OKX_X1_TESTNET */]: [],
  [5165 /* BAHAMUT_MAINNET */]: [],
  [34443 /* MODE_MAINNET */]: [],
  [30 /* RSK_MAINNET */]: [],
  [81457 /* BLAST_MAINNET */]: [],
  [4200 /* MERLIN_MAINNET */]: [],
  [810180 /* ZKLINK_MAINNET */]: [],
  [1116 /* CORE_MAINNET */]: [],
  [167e3 /* TAIKO_MAINNET */]: [],
  [1329 /* SEI_EVM_MAINNET */]: [],
  [7e3 /* ZETACHAIN_MAINNET */]: [],
  [25 /* CRONOS_MAINNET */]: [],
  [252 /* FRAXTAL_MAINNET */]: [],
  [1625 /* GRAVITY_MAINNET */]: [],
  [223 /* BSQUARED_MAINNET */]: []
};
var BASES_TO_CHECK_TRADES_AGAINST = {
  ...WETH_ONLY,
  [1 /* ETH_MAINNET */]: [WETH[1 /* ETH_MAINNET */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[1 /* ETH_MAINNET */]],
  [56 /* BSC_MAINNET */]: [WETH[56 /* BSC_MAINNET */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[56 /* BSC_MAINNET */]],
  [43114 /* AVAX_MAINNET */]: [WETH[43114 /* AVAX_MAINNET */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[43114 /* AVAX_MAINNET */]],
  [137 /* MATIC_MAINNET */]: [
    WETH[137 /* MATIC_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[137 /* MATIC_MAINNET */]
  ],
  [288 /* BOBA_MAINNET */]: [WETH[288 /* BOBA_MAINNET */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[288 /* BOBA_MAINNET */]],
  [43288 /* BOBA_AVALANCHE */]: [
    WETH[43288 /* BOBA_AVALANCHE */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[43288 /* BOBA_AVALANCHE */]
  ],
  [56288 /* BOBA_BNB */]: [WETH[56288 /* BOBA_BNB */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[56288 /* BOBA_BNB */]],
  [1313161554 /* AURORA_MAINNET */]: [
    WETH[1313161554 /* AURORA_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[1313161554 /* AURORA_MAINNET */]
  ],
  [2222 /* KAVA_MAINNET */]: [WETH[2222 /* KAVA_MAINNET */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[2222 /* KAVA_MAINNET */]],
  [324 /* ZKSYNC_MAINNET */]: [
    WETH[324 /* ZKSYNC_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[324 /* ZKSYNC_MAINNET */]
  ],
  [42161 /* ARBITRUM_MAINNET */]: [
    WETH[42161 /* ARBITRUM_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[42161 /* ARBITRUM_MAINNET */]
  ],
  [42170 /* ARBITRUM_NOVA */]: [
    WETH[42170 /* ARBITRUM_NOVA */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[42170 /* ARBITRUM_NOVA */]
  ],
  [10 /* OPTIMISM_MAINNET */]: [
    WETH[10 /* OPTIMISM_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[10 /* OPTIMISM_MAINNET */]
  ],
  [1101 /* POLYGON_ZK */]: [WETH[1101 /* POLYGON_ZK */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[1101 /* POLYGON_ZK */]],
  [2494104990 /* TRON_TESTNET */]: [WETH[2494104990 /* TRON_TESTNET */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[2494104990 /* TRON_TESTNET */]],
  [34443 /* MODE_MAINNET */]: [WETH[34443 /* MODE_MAINNET */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[34443 /* MODE_MAINNET */]],
  [30 /* RSK_MAINNET */]: [WETH[30 /* RSK_MAINNET */], ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[30 /* RSK_MAINNET */]],
  [81457 /* BLAST_MAINNET */]: [
    WETH[81457 /* BLAST_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[81457 /* BLAST_MAINNET */]
  ],
  [4200 /* MERLIN_MAINNET */]: [
    WETH[4200 /* MERLIN_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[4200 /* MERLIN_MAINNET */]
  ],
  [810180 /* ZKLINK_MAINNET */]: [
    WETH[810180 /* ZKLINK_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[810180 /* ZKLINK_MAINNET */]
  ],
  [167e3 /* TAIKO_MAINNET */]: [
    WETH[167e3 /* TAIKO_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[167e3 /* TAIKO_MAINNET */]
  ],
  [1329 /* SEI_EVM_MAINNET */]: [
    WETH[1329 /* SEI_EVM_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[1329 /* SEI_EVM_MAINNET */]
  ],
  [7e3 /* ZETACHAIN_MAINNET */]: [
    WETH[7e3 /* ZETACHAIN_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[7e3 /* ZETACHAIN_MAINNET */]
  ],
  [25 /* CRONOS_MAINNET */]: [
    WETH[25 /* CRONOS_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[25 /* CRONOS_MAINNET */]
  ],
  [252 /* FRAXTAL_MAINNET */]: [
    WETH[252 /* FRAXTAL_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[252 /* FRAXTAL_MAINNET */]
  ],
  [1625 /* GRAVITY_MAINNET */]: [
    WETH[1625 /* GRAVITY_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[1625 /* GRAVITY_MAINNET */]
  ],
  [223 /* BSQUARED_MAINNET */]: [
    WETH[223 /* BSQUARED_MAINNET */],
    ...DEX_TOKENS_TO_CHECK_TRADES_AGAINST[223 /* BSQUARED_MAINNET */]
  ]
};
var CUSTOM_BASES = {
  [56 /* BSC_MAINNET */]: {}
};
var ONE_BIPS = new Percent(JSBI8.BigInt(1), JSBI8.BigInt(1e4));
var BIPS_BASE = JSBI8.BigInt(1e4);
var MULTICALL_ADDRESSES = {
  [1 /* ETH_MAINNET */]: "0x5BA1e12693Dc8F9c48aAD8770482f4739bEeD696",
  [4 /* ETH_RINKEBY */]: "0x5BA1e12693Dc8F9c48aAD8770482f4739bEeD696",
  [42 /* ETH_KOVAN */]: "0x5BA1e12693Dc8F9c48aAD8770482f4739bEeD696",
  [56 /* BSC_MAINNET */]: "0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B",
  [97 /* BSC_TESTNET */]: "0xbC4F726A6dB460DcFE49E6a56886470B94Dfc302",
  [137 /* MATIC_MAINNET */]: "0x275617327c958bD06b5D6b871E7f491D76113dd8",
  [80001 /* MATIC_MUMBAI */]: "0xe9939e7Ea7D7fb619Ac57f648Da7B1D425832631",
  [43114 /* AVAX_MAINNET */]: "0x29b6603d17b9d8f021ecb8845b6fd06e1adf89de",
  [43113 /* AVAX_TESTNET */]: "0x9A9b5Ef5CeAbaC69d3B4A71c4da782554A35B638",
  [128 /* HECO_MAINNET */]: AddressZero,
  [256 /* HECO_TESTNET */]: "0x9a9b5ef5ceabac69d3b4a71c4da782554a35b638",
  [66 /* OKEX_MAINNET */]: AddressZero,
  [65 /* OKEX_TESTNET */]: "0x9A9b5Ef5CeAbaC69d3B4A71c4da782554A35B638",
  [288 /* BOBA_MAINNET */]: "0xaeD5b25BE1c3163c907a471082640450F928DDFE",
  [43288 /* BOBA_AVALANCHE */]: "0x92C5b5B66988E6B8931a8CD3faa418b42003DF2F",
  [56288 /* BOBA_BNB */]: "0x31cCe73DA4365342bd081F6a748AAdb7c7a49b7E",
  [28 /* BOBA_RINKEBY */]: "0x773ccf8ba321c9f96a100b4b0fa1ecf7046645f5",
  [2001 /* MILKOMEDA_MAINNET */]: "0xa46157Cda2D019Ba4cDcd8cE12A04760c15C355b",
  [200101 /* MILKOMEDA_DEVNET */]: "0x41b5984f45AfB2560a0ED72bB69A98E8b32B3cCA",
  [1313161554 /* AURORA_MAINNET */]: "0xbf69a56d35b8d6f5a8e0e96b245a72f735751e54",
  [1313161555 /* AURORA_TESTNET */]: "0x4a5143B13C84DB00E6d8c19b9EA00f3b91416d20",
  [40 /* TELOS_MAINNET */]: "0x53dC7535028e2fcaCa0d847AD108b9240C0801b1",
  [41 /* TELOS_TESTNET */]: "0x9a01bf917477dd9f5d715d188618fc8b7350cd22",
  [8081 /* SHARDEUM_TESTNET_2 */]: "0x41b5984f45AfB2560a0ED72bB69A98E8b32B3cCA",
  [2222 /* KAVA_MAINNET */]: "0x30A62aA52Fa099C4B227869EB6aeaDEda054d121",
  [534351 /* SCROLL_SEPOLIA */]: "0xF3Cfa393be621097669BcD2bD4923CEC347E1210",
  [324 /* ZKSYNC_MAINNET */]: "0x52192C3De01535a9Ad2743A5Fe4f774868103C20",
  [42161 /* ARBITRUM_MAINNET */]: "0x80c7dd17b01855a6d2347444a0fcc36136a314de",
  [42170 /* ARBITRUM_NOVA */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [10 /* OPTIMISM_MAINNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [7001 /* ZETACHAIN_ATHENS_2 */]: "0x9a01bf917477dD9F5D715D188618fc8B7350cd22",
  [1101 /* POLYGON_ZK */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [2494104990 /* TRON_TESTNET */]: "0x00e08cb2cd7480ddf6c54430207dff81ce359887",
  [728126428 /* TRON_MAINNET */]: "0x32A4F47A74A6810BD0BF861CABAB99656A75DE9E",
  [59140 /* LINEA_TESTNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [59144 /* LINEA_MAINNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [5e3 /* MANTLE_MAINNET */]: "0xb55cc6B5B402437b66c13c0CEd0EF367aa7c26da",
  [5001 /* MANTLE_TESTNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [8453 /* BASE_MAINNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [534352 /* SCROLL_MAINNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [169 /* MANTA_MAINNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [1088 /* METIS_MAINNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [195 /* OKX_X1_TESTNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [5165 /* BAHAMUT_MAINNET */]: "0xa385B1436fD2A6a1c6865E22c522A1aA40CaDCC6",
  [34443 /* MODE_MAINNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [30 /* RSK_MAINNET */]: "0xca11bde05977b3631167028862be2a173976ca11",
  [81457 /* BLAST_MAINNET */]: "0xca11bde05977b3631167028862be2a173976ca11",
  [4200 /* MERLIN_MAINNET */]: "0x45CFd6FB7999328F189aaD2739Fba4Be6C45E5bf",
  [810180 /* ZKLINK_MAINNET */]: "0x7E06D0CD8D3fDDBB875345dF389d986f810A49F6",
  [11155111 /* SEPOLIA_TESTNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [1116 /* CORE_MAINNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [167e3 /* TAIKO_MAINNET */]: "0x076f5925112b13a4D4c70fc83d9019f1854e4415",
  [1329 /* SEI_EVM_MAINNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [7e3 /* ZETACHAIN_MAINNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [25 /* CRONOS_MAINNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [252 /* FRAXTAL_MAINNET */]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [1625 /* GRAVITY_MAINNET */]: "0xd8db4fb1fEf63045A443202d506Bcf30ef404160",
  [223 /* BSQUARED_MAINNET */]: "0xd8db4fb1fEf63045A443202d506Bcf30ef404160"
};
var MULTICALL_ROUTER_V2 = {
  [1 /* ETH_MAINNET */]: "0x44487a445a7595446309464A82244B4bD4e325D5",
  [42161 /* ARBITRUM_MAINNET */]: "0x5ad095DE83693ba063941f2f2C5A0dF02383B651",
  [324 /* ZKSYNC_MAINNET */]: "0x7D2172C9bf79263FFf6E456c423a5e3E69F9AA4b"
};

// src/crosschain/contracts/factories/AdaRouter__factory.ts
import { Contract, utils as utils2 } from "ethers";
var _abi = [
  {
    type: "constructor",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "_factory",
        internalType: "address"
      },
      {
        type: "address",
        name: "_WADA",
        internalType: "address"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "address"
      }
    ],
    name: "WADA",
    inputs: []
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      }
    ],
    name: "addLiquidity",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "amountADesired",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBDesired",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountAMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      }
    ],
    name: "addLiquidityADA",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "amountTokenDesired",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADAMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "address"
      }
    ],
    name: "factory",
    inputs: []
  },
  {
    type: "function",
    stateMutability: "pure",
    outputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      }
    ],
    name: "getAmountIn",
    inputs: [
      {
        type: "uint256",
        name: "amountOut",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "reserveIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "reserveOut",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "pure",
    outputs: [
      {
        type: "uint256",
        name: "amountOut",
        internalType: "uint256"
      }
    ],
    name: "getAmountOut",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "reserveIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "reserveOut",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "getAmountsIn",
    inputs: [
      {
        type: "uint256",
        name: "amountOut",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "getAmountsOut",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "pure",
    outputs: [
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      }
    ],
    name: "quote",
    inputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "reserveA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "reserveB",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidity",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountAMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADA",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityADA",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADAMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountADA",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityADASupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADAMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADA",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityADAWithPermit",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADAMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      },
      {
        type: "bool",
        name: "approveMax",
        internalType: "bool"
      },
      {
        type: "uint8",
        name: "v",
        internalType: "uint8"
      },
      {
        type: "bytes32",
        name: "r",
        internalType: "bytes32"
      },
      {
        type: "bytes32",
        name: "s",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountADA",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityADAWithPermitSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountADAMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      },
      {
        type: "bool",
        name: "approveMax",
        internalType: "bool"
      },
      {
        type: "uint8",
        name: "v",
        internalType: "uint8"
      },
      {
        type: "bytes32",
        name: "r",
        internalType: "bytes32"
      },
      {
        type: "bytes32",
        name: "s",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityWithPermit",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountAMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      },
      {
        type: "bool",
        name: "approveMax",
        internalType: "bool"
      },
      {
        type: "uint8",
        name: "v",
        internalType: "uint8"
      },
      {
        type: "bytes32",
        name: "r",
        internalType: "bytes32"
      },
      {
        type: "bytes32",
        name: "s",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapADAForExactTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountOut",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapExactADAForTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [],
    name: "swapExactADAForTokensSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapExactTokensForADA",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "swapExactTokensForADASupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapExactTokensForTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapTokensForExactADA",
    inputs: [
      {
        type: "uint256",
        name: "amountOut",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountInMax",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapTokensForExactTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountOut",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountInMax",
        internalType: "uint256"
      },
      {
        type: "address[]",
        name: "path",
        internalType: "address[]"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "receive",
    stateMutability: "payable"
  }
];
var AdaRouter__factory = class {
  static createInterface() {
    return new utils2.Interface(_abi);
  }
  static connect(address2, signerOrProvider) {
    return new Contract(address2, _abi, signerOrProvider);
  }
};
AdaRouter__factory.abi = _abi;

// src/crosschain/contracts/factories/AvaxRouter__factory.ts
import { Contract as Contract2, utils as utils3 } from "ethers";
var _abi2 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "_WAVAX",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WAVAX",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountADesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountTokenDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAXMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidityAVAX",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsIn",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsOut",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveB",
        type: "uint256"
      }
    ],
    name: "quote",
    outputs: [
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAXMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityAVAX",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAX",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAXMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityAVAXSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountAVAX",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAXMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityAVAXWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAX",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAVAXMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityAVAXWithPermitSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountAVAX",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapAVAXForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactAVAXForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactAVAXForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForAVAX",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForAVAXSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactAVAX",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];
var AvaxRouter__factory = class {
  static createInterface() {
    return new utils3.Interface(_abi2);
  }
  static connect(address2, signerOrProvider) {
    return new Contract2(address2, _abi2, signerOrProvider);
  }
};
AvaxRouter__factory.abi = _abi2;

// src/crosschain/contracts/factories/Bridge__factory.ts
import { utils as utils4, Contract as Contract3, ContractFactory } from "ethers";
var _abi3 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "oldMPC",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newMPC",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "effectiveTime",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "chainId",
        type: "uint256"
      }
    ],
    name: "LogChangeMPC",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "bridge",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "callData",
        type: "bytes"
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiveSide",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "oppositeBridge",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "chainId",
        type: "uint256"
      }
    ],
    name: "OracleRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "admin",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "permission",
        type: "bool"
      }
    ],
    name: "SetAdminPermission",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "transmitter",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool"
      }
    ],
    name: "SetTransmitterStatus",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newMPC",
        type: "address"
      }
    ],
    name: "changeMPC",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newMPC",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes"
      }
    ],
    name: "changeMPCSigned",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "currentChainId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_mpc",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "isTransmitter",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mpc",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "newMPC",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "newMPCEffectiveTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "oldMPC",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_callData",
        type: "bytes"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      }
    ],
    name: "receiveRequestV2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_callData",
        type: "bytes"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes"
      }
    ],
    name: "receiveRequestV2Signed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address"
      },
      {
        internalType: "bool",
        name: "_permission",
        type: "bool"
      }
    ],
    name: "setAdminPermission",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_transmitter",
        type: "address"
      },
      {
        internalType: "bool",
        name: "_status",
        type: "bool"
      }
    ],
    name: "setTransmitterStatus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_callData",
        type: "bytes"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainId",
        type: "uint256"
      }
    ],
    name: "transmitRequestV2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "withdrawFee",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var _bytecode = "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";
var isSuperArgs = (xs) => xs.length > 1;
var Bridge__factory = class extends ContractFactory {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs(args)) {
      __super(...args);
    } else {
      __super(_abi3, _bytecode, args[0]);
    }
    this.contractName = "Bridge";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address2) {
    return super.attach(address2);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils4.Interface(_abi3);
  }
  static connect(address2, signerOrProvider) {
    return new Contract3(address2, _abi3, signerOrProvider);
  }
};
Bridge__factory.bytecode = _bytecode;
Bridge__factory.abi = _abi3;

// src/crosschain/contracts/factories/DragonswapRouter__factory.ts
import { Contract as Contract4, utils as utils5 } from "ethers";
var _abi4 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "_WSEI",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WSEI",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountADesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountTokenDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountSEIMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquiditySEI",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountSEI",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsIn",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsOut",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveB",
        type: "uint256"
      }
    ],
    name: "quote",
    outputs: [
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountSEIMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquiditySEI",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountSEI",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountSEIMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquiditySEISupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountSEI",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountSEIMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquiditySEIWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountSEI",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountSEIMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquiditySEIWithPermitSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountSEI",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactSEIForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactSEIForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForSEI",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForSEISupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapSEIForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactSEI",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];
var DragonswapRouter__factory = class {
  static createInterface() {
    return new utils5.Interface(_abi4);
  }
  static connect(address2, signerOrProvider) {
    return new Contract4(address2, _abi4, signerOrProvider);
  }
};
DragonswapRouter__factory.abi = _abi4;

// src/crosschain/contracts/factories/ERC20__factory.ts
import { Contract as Contract5, utils as utils6 } from "ethers";
var _abi5 = [
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "_spender",
        type: "address"
      },
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "_from",
        type: "address"
      },
      {
        name: "_to",
        type: "address"
      },
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [
      {
        name: "",
        type: "uint8"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        name: "_owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        name: "balance",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "_to",
        type: "address"
      },
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        name: "_owner",
        type: "address"
      },
      {
        name: "_spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    payable: true,
    stateMutability: "payable",
    type: "fallback"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  }
];
var ERC20__factory = class {
  static createInterface() {
    return new utils6.Interface(_abi5);
  }
  static connect(address2, signerOrProvider) {
    return new Contract5(address2, _abi5, signerOrProvider);
  }
};
ERC20__factory.abi = _abi5;

// src/crosschain/contracts/factories/Fabric__factory.ts
import { utils as utils7, Contract as Contract6, ContractFactory as ContractFactory2 } from "ethers";
var _abi6 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "rToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "chainID",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "sToken",
        type: "address"
      }
    ],
    name: "RepresentationCreated",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_rtoken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "_stokenName",
        type: "string"
      },
      {
        internalType: "string",
        name: "_stokenSymbol",
        type: "string"
      },
      {
        internalType: "uint8",
        name: "_decimals",
        type: "uint8"
      }
    ],
    name: "createRepresentationByAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_syntTokenAdr",
        type: "address"
      }
    ],
    name: "getRealRepresentation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_realTokenAdr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      }
    ],
    name: "getSyntRepresentation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_key",
        type: "bytes32"
      }
    ],
    name: "getSyntRepresentationByKey",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_synthesis",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "synthesis",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_stoken",
        type: "address"
      }
    ],
    name: "synthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_stoken",
        type: "address"
      }
    ],
    name: "unsynthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var _bytecode2 = "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";
var isSuperArgs2 = (xs) => xs.length > 1;
var Fabric__factory = class extends ContractFactory2 {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs2(args)) {
      __super(...args);
    } else {
      __super(_abi6, _bytecode2, args[0]);
    }
    this.contractName = "Fabric";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address2) {
    return super.attach(address2);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils7.Interface(_abi6);
  }
  static connect(address2, signerOrProvider) {
    return new Contract6(address2, _abi6, signerOrProvider);
  }
};
Fabric__factory.bytecode = _bytecode2;
Fabric__factory.abi = _abi6;

// src/crosschain/contracts/factories/FeeCollector__factory.ts
import { Contract as Contract7, utils as utils8 } from "ethers";
var _abi7 = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "balance",
        type: "uint256"
      }
    ],
    name: "ClaimedTokens",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    name: "OnchainSwap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newFee",
        type: "uint256"
      }
    ],
    name: "changeFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      }
    ],
    name: "claimTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "onchainGateway",
    outputs: [
      {
        internalType: "contract OnchainGateway",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "dex",
        type: "address"
      },
      {
        internalType: "address",
        name: "dexgateway",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "calldata_",
        type: "bytes"
      }
    ],
    name: "onswap",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var FeeCollector__factory = class {
  static createInterface() {
    return new utils8.Interface(_abi7);
  }
  static connect(address2, signerOrProvider) {
    return new Contract7(address2, _abi7, signerOrProvider);
  }
};
FeeCollector__factory.abi = _abi7;

// src/crosschain/contracts/factories/IzumiFactory__factory.ts
import { Contract as Contract8, utils as utils9 } from "ethers";
var _abi8 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_chargeReceiver",
        type: "address"
      },
      {
        internalType: "address",
        name: "_swapX2YModule",
        type: "address"
      },
      {
        internalType: "address",
        name: "_swapY2XModule",
        type: "address"
      },
      {
        internalType: "address",
        name: "_liquidityModule",
        type: "address"
      },
      {
        internalType: "address",
        name: "_limitOrderModule",
        type: "address"
      },
      {
        internalType: "address",
        name: "_flashModule",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        indexed: false,
        internalType: "uint24",
        name: "pointDelta",
        type: "uint24"
      },
      {
        indexed: false,
        internalType: "address",
        name: "pool",
        type: "address"
      }
    ],
    name: "NewPool",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [],
    name: "chargeReceiver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        internalType: "uint24",
        name: "pointDelta",
        type: "uint24"
      }
    ],
    name: "enableFeeAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint24",
        name: "",
        type: "uint24"
      }
    ],
    name: "fee2pointDelta",
    outputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "flashModule",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "limitOrderModule",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "liquidityModule",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_chargeReceiver",
        type: "address"
      }
    ],
    name: "modifyChargeReceiver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        internalType: "int24",
        name: "currentPoint",
        type: "int24"
      }
    ],
    name: "newPool",
    outputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "only_addr_",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "",
        type: "uint24"
      }
    ],
    name: "pool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "swapX2YModule",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "swapY2XModule",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var IzumiFactory__factory = class {
  static createInterface() {
    return new utils9.Interface(_abi8);
  }
  static connect(address2, signerOrProvider) {
    return new Contract8(address2, _abi8, signerOrProvider);
  }
};
IzumiFactory__factory.abi = _abi8;

// src/crosschain/contracts/factories/IzumiPool__factory.ts
import { Contract as Contract9, utils as utils10 } from "ethers";
var _abi9 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "_tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "_tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "_fee",
        type: "uint24"
      },
      {
        internalType: "int24",
        name: "currentPoint",
        type: "int24"
      },
      {
        internalType: "int24",
        name: "_pointDelta",
        type: "int24"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "sellXEarnY",
        type: "bool"
      }
    ],
    name: "AddLimitOrder",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "int24",
        name: "leftPoint",
        type: "int24"
      },
      {
        indexed: true,
        internalType: "int24",
        name: "rightPoint",
        type: "int24"
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "liquidity",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    name: "Burn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "sellXEarnY",
        type: "bool"
      }
    ],
    name: "DecLimitOrder",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "paidX",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "paidY",
        type: "uint256"
      }
    ],
    name: "Flash",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "int24",
        name: "leftPoint",
        type: "int24"
      },
      {
        indexed: true,
        internalType: "int24",
        name: "rightPoint",
        type: "int24"
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "liquidity",
        type: "uint128"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    name: "Mint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "sellXEarnY",
        type: "bool"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    name: "Swap",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "amountX",
        type: "uint128"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "addLimOrderWithX",
    outputs: [
      {
        internalType: "uint128",
        name: "orderX",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "acquireY",
        type: "uint128"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "amountY",
        type: "uint128"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "addLimOrderWithY",
    outputs: [
      {
        internalType: "uint128",
        name: "orderY",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "acquireX",
        type: "uint128"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "assignX",
        type: "uint128"
      }
    ],
    name: "assignLimOrderEarnX",
    outputs: [
      {
        internalType: "uint128",
        name: "actualAssignX",
        type: "uint128"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "assignY",
        type: "uint128"
      }
    ],
    name: "assignLimOrderEarnY",
    outputs: [
      {
        internalType: "uint128",
        name: "actualAssignY",
        type: "uint128"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "leftPt",
        type: "int24"
      },
      {
        internalType: "int24",
        name: "rightPt",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "liquidDelta",
        type: "uint128"
      }
    ],
    name: "burn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "int24",
        name: "leftPt",
        type: "int24"
      },
      {
        internalType: "int24",
        name: "rightPt",
        type: "int24"
      },
      {
        internalType: "uint256",
        name: "amountXLim",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountYLim",
        type: "uint256"
      }
    ],
    name: "collect",
    outputs: [
      {
        internalType: "uint256",
        name: "actualAmountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "actualAmountY",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "collectFeeCharged",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "collectDec",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "collectEarn",
        type: "uint128"
      },
      {
        internalType: "bool",
        name: "isEarnY",
        type: "bool"
      }
    ],
    name: "collectLimOrder",
    outputs: [
      {
        internalType: "uint128",
        name: "actualCollectDec",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "actualCollectEarn",
        type: "uint128"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "deltaX",
        type: "uint128"
      }
    ],
    name: "decLimOrderWithX",
    outputs: [
      {
        internalType: "uint128",
        name: "actualDeltaX",
        type: "uint128"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "point",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "deltaY",
        type: "uint128"
      }
    ],
    name: "decLimOrderWithY",
    outputs: [
      {
        internalType: "uint128",
        name: "actualDeltaY",
        type: "uint128"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "newNextQueueLen",
        type: "uint16"
      }
    ],
    name: "expandObservationQueue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "fee",
    outputs: [
      {
        internalType: "uint24",
        name: "",
        type: "uint24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "feeChargePercent",
    outputs: [
      {
        internalType: "uint24",
        name: "",
        type: "uint24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "feeScaleX_128",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "feeScaleY_128",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "flash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "leftMostPt",
    outputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    name: "limitOrderData",
    outputs: [
      {
        internalType: "uint128",
        name: "sellingX",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "earnY",
        type: "uint128"
      },
      {
        internalType: "uint256",
        name: "accEarnY",
        type: "uint256"
      },
      {
        internalType: "uint128",
        name: "sellingY",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "earnX",
        type: "uint128"
      },
      {
        internalType: "uint256",
        name: "accEarnX",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "leftPoint",
        type: "int24"
      },
      {
        internalType: "int24",
        name: "rightPoint",
        type: "int24"
      }
    ],
    name: "limitOrderSnapshot",
    outputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "sellingX",
            type: "uint128"
          },
          {
            internalType: "uint128",
            name: "earnY",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "accEarnY",
            type: "uint256"
          },
          {
            internalType: "uint128",
            name: "sellingY",
            type: "uint128"
          },
          {
            internalType: "uint128",
            name: "earnX",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "accEarnX",
            type: "uint256"
          }
        ],
        internalType: "struct IiZiSwapPool.LimitOrderStruct[]",
        name: "limitOrders",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "liquidity",
    outputs: [
      {
        internalType: "uint128",
        name: "liquidity",
        type: "uint128"
      },
      {
        internalType: "uint256",
        name: "lastFeeScaleX_128",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "lastFeeScaleY_128",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "tokenOwedX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "tokenOwedY",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "leftPoint",
        type: "int24"
      },
      {
        internalType: "int24",
        name: "rightPoint",
        type: "int24"
      }
    ],
    name: "liquiditySnapshot",
    outputs: [
      {
        internalType: "int128[]",
        name: "deltaLiquidities",
        type: "int128[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "maxLiquidPt",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "int24",
        name: "leftPt",
        type: "int24"
      },
      {
        internalType: "int24",
        name: "rightPt",
        type: "int24"
      },
      {
        internalType: "uint128",
        name: "liquidDelta",
        type: "uint128"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "observations",
    outputs: [
      {
        internalType: "uint32",
        name: "timestamp",
        type: "uint32"
      },
      {
        internalType: "int56",
        name: "accPoint",
        type: "int56"
      },
      {
        internalType: "bool",
        name: "init",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32[]",
        name: "secondsAgos",
        type: "uint32[]"
      }
    ],
    name: "observe",
    outputs: [
      {
        internalType: "int56[]",
        name: "accPoints",
        type: "int56[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    name: "orderOrEndpoint",
    outputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int16",
        name: "",
        type: "int16"
      }
    ],
    name: "pointBitmap",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pointDelta",
    outputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    name: "points",
    outputs: [
      {
        internalType: "uint128",
        name: "liquidSum",
        type: "uint128"
      },
      {
        internalType: "int128",
        name: "liquidDelta",
        type: "int128"
      },
      {
        internalType: "uint256",
        name: "accFeeXOut_128",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "accFeeYOut_128",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "isEndpt",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "rightMostPt",
    outputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "sqrtRate_96",
    outputs: [
      {
        internalType: "uint160",
        name: "",
        type: "uint160"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "state",
    outputs: [
      {
        internalType: "uint160",
        name: "sqrtPrice_96",
        type: "uint160"
      },
      {
        internalType: "int24",
        name: "currentPoint",
        type: "int24"
      },
      {
        internalType: "uint16",
        name: "observationCurrentIndex",
        type: "uint16"
      },
      {
        internalType: "uint16",
        name: "observationQueueLen",
        type: "uint16"
      },
      {
        internalType: "uint16",
        name: "observationNextQueueLen",
        type: "uint16"
      },
      {
        internalType: "bool",
        name: "locked",
        type: "bool"
      },
      {
        internalType: "uint128",
        name: "liquidity",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "liquidityX",
        type: "uint128"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "lowPt",
        type: "int24"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swapX2Y",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "desireY",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "lowPt",
        type: "int24"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swapX2YDesireY",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "highPt",
        type: "int24"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swapY2X",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint128",
        name: "desireX",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "highPt",
        type: "int24"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swapY2XDesireX",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "tokenX",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "tokenY",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalFeeXCharged",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalFeeYCharged",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "userEarnX",
    outputs: [
      {
        internalType: "uint256",
        name: "lastAccEarn",
        type: "uint256"
      },
      {
        internalType: "uint128",
        name: "sellingRemain",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "sellingDec",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "earn",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "earnAssign",
        type: "uint128"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "userEarnY",
    outputs: [
      {
        internalType: "uint256",
        name: "lastAccEarn",
        type: "uint256"
      },
      {
        internalType: "uint128",
        name: "sellingRemain",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "sellingDec",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "earn",
        type: "uint128"
      },
      {
        internalType: "uint128",
        name: "earnAssign",
        type: "uint128"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var IzumiPool__factory = class {
  static createInterface() {
    return new utils10.Interface(_abi9);
  }
  static connect(address2, signerOrProvider) {
    return new Contract9(address2, _abi9, signerOrProvider);
  }
};
IzumiPool__factory.abi = _abi9;

// src/crosschain/contracts/factories/IzumiQuoter__factory.ts
import { Contract as Contract10, utils as utils11 } from "ethers";
var _abi10 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WETH9",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      }
    ],
    name: "pool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "refundETH",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128"
      },
      {
        internalType: "bytes",
        name: "path",
        type: "bytes"
      }
    ],
    name: "swapAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "acquire",
        type: "uint256"
      },
      {
        internalType: "int24[]",
        name: "pointAfterList",
        type: "int24[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "desire",
        type: "uint128"
      },
      {
        internalType: "bytes",
        name: "path",
        type: "bytes"
      }
    ],
    name: "swapDesire",
    outputs: [
      {
        internalType: "uint256",
        name: "cost",
        type: "uint256"
      },
      {
        internalType: "int24[]",
        name: "pointAfterList",
        type: "int24[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "lowPt",
        type: "int24"
      }
    ],
    name: "swapX2Y",
    outputs: [
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      },
      {
        internalType: "int24",
        name: "finalPoint",
        type: "int24"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "x",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "y",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "path",
        type: "bytes"
      }
    ],
    name: "swapX2YCallback",
    outputs: [],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        internalType: "uint128",
        name: "desireY",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "lowPt",
        type: "int24"
      }
    ],
    name: "swapX2YDesireY",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "int24",
        name: "finalPoint",
        type: "int24"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "highPt",
        type: "int24"
      }
    ],
    name: "swapY2X",
    outputs: [
      {
        internalType: "uint256",
        name: "amountX",
        type: "uint256"
      },
      {
        internalType: "int24",
        name: "finalPoint",
        type: "int24"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "x",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "y",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "path",
        type: "bytes"
      }
    ],
    name: "swapY2XCallback",
    outputs: [],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        internalType: "uint128",
        name: "desireX",
        type: "uint128"
      },
      {
        internalType: "int24",
        name: "highPt",
        type: "int24"
      }
    ],
    name: "swapY2XDesireX",
    outputs: [
      {
        internalType: "uint256",
        name: "amountY",
        type: "uint256"
      },
      {
        internalType: "int24",
        name: "finalPoint",
        type: "int24"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "minAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "sweepToken",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];
var IzumiQuoter__factory = class {
  static createInterface() {
    return new utils11.Interface(_abi10);
  }
  static connect(address2, signerOrProvider) {
    return new Contract10(address2, _abi10, signerOrProvider);
  }
};
IzumiQuoter__factory.abi = _abi10;

// src/crosschain/contracts/factories/IzumiSwap__factory.ts
import { Contract as Contract11, utils as utils12 } from "ethers";
var _abi11 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WETH9",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenX",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenY",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      }
    ],
    name: "pool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "refundETH",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "path",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint128",
            name: "amount",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "minAcquired",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          }
        ],
        internalType: "struct Swap.SwapAmountParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "swapAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "cost",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "acquire",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "path",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint128",
            name: "desire",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "maxPayed",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          }
        ],
        internalType: "struct Swap.SwapDesireParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "swapDesire",
    outputs: [
      {
        internalType: "uint256",
        name: "cost",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "acquire",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenX",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenY",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "int24",
            name: "boundaryPt",
            type: "int24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint128",
            name: "amount",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "maxPayed",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "minAcquired",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          }
        ],
        internalType: "struct Swap.SwapParams",
        name: "swapParams",
        type: "tuple"
      }
    ],
    name: "swapX2Y",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "x",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "y",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swapX2YCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenX",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenY",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "int24",
            name: "boundaryPt",
            type: "int24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint128",
            name: "amount",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "maxPayed",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "minAcquired",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          }
        ],
        internalType: "struct Swap.SwapParams",
        name: "swapParams",
        type: "tuple"
      }
    ],
    name: "swapX2YDesireY",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenX",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenY",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "int24",
            name: "boundaryPt",
            type: "int24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint128",
            name: "amount",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "maxPayed",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "minAcquired",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          }
        ],
        internalType: "struct Swap.SwapParams",
        name: "swapParams",
        type: "tuple"
      }
    ],
    name: "swapY2X",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "x",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "y",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swapY2XCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenX",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenY",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "int24",
            name: "boundaryPt",
            type: "int24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint128",
            name: "amount",
            type: "uint128"
          },
          {
            internalType: "uint256",
            name: "maxPayed",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "minAcquired",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256"
          }
        ],
        internalType: "struct Swap.SwapParams",
        name: "swapParams",
        type: "tuple"
      }
    ],
    name: "swapY2XDesireX",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "minAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "sweepToken",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];
var IzumiSwap__factory = class {
  static createInterface() {
    return new utils12.Interface(_abi11);
  }
  static connect(address2, signerOrProvider) {
    return new Contract11(address2, _abi11, signerOrProvider);
  }
};
IzumiSwap__factory.abi = _abi11;

// src/crosschain/contracts/factories/KavaRouter__factory.ts
import { Contract as Contract12, utils as utils13 } from "ethers";
var _abi12 = [
  {
    type: "constructor",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "_factory",
        internalType: "address"
      },
      {
        type: "address",
        name: "_weth",
        internalType: "address"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "",
        internalType: "uint256[]"
      }
    ],
    name: "UNSAFE_swapExactTokensForTokens",
    inputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      }
    ],
    name: "addLiquidity",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "amountADesired",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBDesired",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountAMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETH",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      }
    ],
    name: "addLiquidityETH",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "amountTokenDesired",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETHMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "address"
      }
    ],
    name: "factory",
    inputs: []
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "amount",
        internalType: "uint256"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      }
    ],
    name: "getAmountOut",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "tokenIn",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenOut",
        internalType: "address"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "getAmountsOut",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "reserveA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "reserveB",
        internalType: "uint256"
      }
    ],
    name: "getReserves",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "bool",
        name: "",
        internalType: "bool"
      }
    ],
    name: "isPair",
    inputs: [
      {
        type: "address",
        name: "pair",
        internalType: "address"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "pair",
        internalType: "address"
      }
    ],
    name: "pairFor",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      }
    ],
    name: "quoteAddLiquidity",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "amountADesired",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBDesired",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      }
    ],
    name: "quoteRemoveLiquidity",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidity",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountAMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETH",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityETH",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETHMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETH",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityETHSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETHMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETH",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityETHWithPermit",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETHMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      },
      {
        type: "bool",
        name: "approveMax",
        internalType: "bool"
      },
      {
        type: "uint8",
        name: "v",
        internalType: "uint8"
      },
      {
        type: "bytes32",
        name: "r",
        internalType: "bytes32"
      },
      {
        type: "bytes32",
        name: "s",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountToken",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETH",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "address",
        name: "token",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountTokenMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountETHMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      },
      {
        type: "bool",
        name: "approveMax",
        internalType: "bool"
      },
      {
        type: "uint8",
        name: "v",
        internalType: "uint8"
      },
      {
        type: "bytes32",
        name: "r",
        internalType: "bytes32"
      },
      {
        type: "bytes32",
        name: "s",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256",
        name: "amountA",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountB",
        internalType: "uint256"
      }
    ],
    name: "removeLiquidityWithPermit",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "uint256",
        name: "liquidity",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountAMin",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountBMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      },
      {
        type: "bool",
        name: "approveMax",
        internalType: "bool"
      },
      {
        type: "uint8",
        name: "v",
        internalType: "uint8"
      },
      {
        type: "bytes32",
        name: "r",
        internalType: "bytes32"
      },
      {
        type: "bytes32",
        name: "s",
        internalType: "bytes32"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "pure",
    outputs: [
      {
        type: "address",
        name: "token0",
        internalType: "address"
      },
      {
        type: "address",
        name: "token1",
        internalType: "address"
      }
    ],
    name: "sortTokens",
    inputs: [
      {
        type: "address",
        name: "tokenA",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenB",
        internalType: "address"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapExactETHForTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [],
    name: "swapExactETHForTokensSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapExactTokensForETH",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "swapExactTokensForETHSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapExactTokensForTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [
      {
        type: "uint256[]",
        name: "amounts",
        internalType: "uint256[]"
      }
    ],
    name: "swapExactTokensForTokensSimple",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "address",
        name: "tokenFrom",
        internalType: "address"
      },
      {
        type: "address",
        name: "tokenTo",
        internalType: "address"
      },
      {
        type: "bool",
        name: "stable",
        internalType: "bool"
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    inputs: [
      {
        type: "uint256",
        name: "amountIn",
        internalType: "uint256"
      },
      {
        type: "uint256",
        name: "amountOutMin",
        internalType: "uint256"
      },
      {
        type: "tuple[]",
        name: "routes",
        internalType: "struct Router.route[]",
        components: [
          {
            type: "address",
            name: "from",
            internalType: "address"
          },
          {
            type: "address",
            name: "to",
            internalType: "address"
          },
          {
            type: "bool",
            name: "stable",
            internalType: "bool"
          }
        ]
      },
      {
        type: "address",
        name: "to",
        internalType: "address"
      },
      {
        type: "uint256",
        name: "deadline",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [
      {
        type: "address",
        name: "",
        internalType: "contract IWETH"
      }
    ],
    name: "weth",
    inputs: []
  },
  {
    type: "receive",
    stateMutability: "payable"
  }
];
var KavaRouter__factory = class {
  static createInterface() {
    return new utils13.Interface(_abi12);
  }
  static connect(address2, signerOrProvider) {
    return new Contract12(address2, _abi12, signerOrProvider);
  }
};
KavaRouter__factory.abi = _abi12;

// src/crosschain/contracts/factories/KimRouter__factory.ts
import { Contract as Contract13, utils as utils14 } from "ethers";
var _abi13 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "_WETH",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountADesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountTokenDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "feeSharingContract",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "assign",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsOut",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token1",
        type: "address"
      },
      {
        internalType: "address",
        name: "token2",
        type: "address"
      }
    ],
    name: "getPair",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveB",
        type: "uint256"
      }
    ],
    name: "quote",
    outputs: [
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "feeSharingContract",
        type: "address"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "register",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityETHSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityETHWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "address",
        name: "referrer",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactETHForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "address",
        name: "referrer",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForETHSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "address",
        name: "referrer",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];
var KimRouter__factory = class {
  static createInterface() {
    return new utils14.Interface(_abi13);
  }
  static connect(address2, signerOrProvider) {
    return new Contract13(address2, _abi13, signerOrProvider);
  }
};
KimRouter__factory.abi = _abi13;

// src/crosschain/contracts/factories/MetaRouter__factory.ts
import { utils as utils15, Contract as Contract14, ContractFactory as ContractFactory3 } from "ethers";
var _abi14 = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "TransitTokenSent",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_calldata",
        type: "bytes"
      },
      {
        internalType: "uint256",
        name: "_offset",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      }
    ],
    name: "externalCall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "crossChainID",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "externalID",
            type: "bytes32"
          },
          {
            internalType: "address",
            name: "tokenReal",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "to",
            type: "address"
          },
          {
            internalType: "address[]",
            name: "swapTokens",
            type: "address[]"
          },
          {
            internalType: "address",
            name: "secondDexRouter",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "secondSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "finalReceiveSide",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "finalCalldata",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "finalOffset",
            type: "uint256"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaMintTransaction",
        name: "_metaMintTransaction",
        type: "tuple"
      }
    ],
    name: "metaMintSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "firstSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "bytes",
            name: "secondSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "address[]",
            name: "approvedTokens",
            type: "address[]"
          },
          {
            internalType: "address",
            name: "firstDexRouter",
            type: "address"
          },
          {
            internalType: "address",
            name: "secondDexRouter",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bool",
            name: "nativeIn",
            type: "bool"
          },
          {
            internalType: "address",
            name: "relayRecipient",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "otherSideCalldata",
            type: "bytes"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaRouteTransaction",
        name: "_metarouteTransaction",
        type: "tuple"
      }
    ],
    name: "metaRoute",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "metaRouterGateway",
    outputs: [
      {
        internalType: "contract MetaRouterGateway",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_router",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_swapCalldata",
        type: "bytes"
      },
      {
        internalType: "address",
        name: "_burnToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "_synthesis",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_burnCalldata",
        type: "bytes"
      }
    ],
    name: "returnSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var _bytecode3 = "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";
var isSuperArgs3 = (xs) => xs.length > 1;
var MetaRouter__factory = class extends ContractFactory3 {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs3(args)) {
      __super(...args);
    } else {
      __super(_abi14, _bytecode3, args[0]);
    }
    this.contractName = "MetaRouter";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address2) {
    return super.attach(address2);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils15.Interface(_abi14);
  }
  static connect(address2, signerOrProvider) {
    return new Contract14(address2, _abi14, signerOrProvider);
  }
};
MetaRouter__factory.bytecode = _bytecode3;
MetaRouter__factory.abi = _abi14;

// src/crosschain/contracts/factories/Multicall__factory.ts
import { Contract as Contract15, utils as utils16 } from "ethers";
var _abi15 = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes"
          }
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256"
      },
      {
        internalType: "bytes[]",
        name: "returnData",
        type: "bytes[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes"
          }
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "blockAndAggregate",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32"
      },
      {
        components: [
          {
            internalType: "bool",
            name: "success",
            type: "bool"
          },
          {
            internalType: "bytes",
            name: "returnData",
            type: "bytes"
          }
        ],
        internalType: "struct Multicall2.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256"
      }
    ],
    name: "getBlockHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getBlockNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockCoinbase",
    outputs: [
      {
        internalType: "address",
        name: "coinbase",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockDifficulty",
    outputs: [
      {
        internalType: "uint256",
        name: "difficulty",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockGasLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "gaslimit",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "getEthBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getLastBlockHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "requireSuccess",
        type: "bool"
      },
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes"
          }
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "tryAggregate",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "success",
            type: "bool"
          },
          {
            internalType: "bytes",
            name: "returnData",
            type: "bytes"
          }
        ],
        internalType: "struct Multicall2.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "requireSuccess",
        type: "bool"
      },
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes"
          }
        ],
        internalType: "struct Multicall2.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "tryBlockAndAggregate",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32"
      },
      {
        components: [
          {
            internalType: "bool",
            name: "success",
            type: "bool"
          },
          {
            internalType: "bytes",
            name: "returnData",
            type: "bytes"
          }
        ],
        internalType: "struct Multicall2.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var Multicall__factory = class {
  static createInterface() {
    return new utils16.Interface(_abi15);
  }
  static connect(address2, signerOrProvider) {
    return new Contract15(address2, _abi15, signerOrProvider);
  }
};
Multicall__factory.abi = _abi15;

// src/crosschain/contracts/factories/MulticallRouter__factory.ts
import { utils as utils17, Contract as Contract16, ContractFactory as ContractFactory4 } from "ethers";
var _abi16 = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amountIn",
        type: "uint256"
      },
      {
        internalType: "bytes[]",
        name: "_calldata",
        type: "bytes[]"
      },
      {
        internalType: "address[]",
        name: "_receiveSides",
        type: "address[]"
      },
      {
        internalType: "address[]",
        name: "_path",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "_offset",
        type: "uint256[]"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      }
    ],
    name: "multicall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var _bytecode4 = "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";
var isSuperArgs4 = (xs) => xs.length > 1;
var MulticallRouter__factory = class extends ContractFactory4 {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs4(args)) {
      __super(...args);
    } else {
      __super(_abi16, _bytecode4, args[0]);
    }
    this.contractName = "MulticallRouter";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address2) {
    return super.attach(address2);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils17.Interface(_abi16);
  }
  static connect(address2, signerOrProvider) {
    return new Contract16(address2, _abi16, signerOrProvider);
  }
};
MulticallRouter__factory.bytecode = _bytecode4;
MulticallRouter__factory.abi = _abi16;

// src/crosschain/contracts/factories/MulticallRouterV2__factory.ts
import { utils as utils18, Contract as Contract17, ContractFactory as ContractFactory5 } from "ethers";
var _abi17 = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amountIn",
        type: "uint256"
      },
      {
        internalType: "bytes[]",
        name: "_calldata",
        type: "bytes[]"
      },
      {
        internalType: "address[]",
        name: "_receiveSides",
        type: "address[]"
      },
      {
        internalType: "address[]",
        name: "_path",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "_offset",
        type: "uint256[]"
      },
      {
        internalType: "bool[]",
        name: "_isNativeIn",
        type: "bool[]"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      }
    ],
    name: "multicall",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];
var _bytecode5 = "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";
var isSuperArgs5 = (xs) => xs.length > 1;
var MulticallRouterV2__factory = class extends ContractFactory5 {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs5(args)) {
      __super(...args);
    } else {
      __super(_abi17, _bytecode5, args[0]);
    }
    this.contractName = "MulticallRouterV2";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address2) {
    return super.attach(address2);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils18.Interface(_abi17);
  }
  static connect(address2, signerOrProvider) {
    return new Contract17(address2, _abi17, signerOrProvider);
  }
};
MulticallRouterV2__factory.bytecode = _bytecode5;
MulticallRouterV2__factory.abi = _abi17;

// src/crosschain/contracts/factories/OctoPoolFeeCollector__factory.ts
import { utils as utils19, Contract as Contract18, ContractFactory as ContractFactory6 } from "ethers";
var _abi18 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_feeReceiver",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_feeRate",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "balance",
        type: "uint256"
      }
    ],
    name: "ClaimedTokens",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    name: "FeeCollected",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [],
    name: "WAD",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newFeeRate",
        type: "uint256"
      }
    ],
    name: "changeFeeRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "collectFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "feeRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "feeReceiver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newFeeReceiver",
        type: "address"
      }
    ],
    name: "setFeeReceiver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var _bytecode6 = "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";
var isSuperArgs6 = (xs) => xs.length > 1;
var OctoPoolFeeCollector__factory = class extends ContractFactory6 {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs6(args)) {
      __super(...args);
    } else {
      __super(_abi18, _bytecode6, args[0]);
    }
    this.contractName = "OctoPoolFeeCollector";
  }
  deploy(_feeReceiver, _feeRate, overrides) {
    return super.deploy(_feeReceiver, _feeRate, overrides || {});
  }
  getDeployTransaction(_feeReceiver, _feeRate, overrides) {
    return super.getDeployTransaction(_feeReceiver, _feeRate, overrides || {});
  }
  attach(address2) {
    return super.attach(address2);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils19.Interface(_abi18);
  }
  static connect(address2, signerOrProvider) {
    return new Contract18(address2, _abi18, signerOrProvider);
  }
};
OctoPoolFeeCollector__factory.bytecode = _bytecode6;
OctoPoolFeeCollector__factory.abi = _abi18;

// src/crosschain/contracts/factories/OmniPool__factory.ts
import { utils as utils20, Contract as Contract19, ContractFactory as ContractFactory7 } from "ethers";
var _abi19 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "AssetAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "bool",
        name: "status",
        type: "bool"
      }
    ],
    name: "AssetStatusChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Deposit",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "FillPool",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "NewA",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "lpDividendRatio",
        type: "uint256"
      }
    ],
    name: "NewFee",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "NewFeeTo",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "NewLPFee",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "newMaxSupply",
        type: "uint256"
      }
    ],
    name: "NewMaxSupply",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "NewMintFeeThreshold",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newVeSIS",
        type: "address"
      }
    ],
    name: "NewVeSIS",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "fromToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "toToken",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fromAmount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "toAmount",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]"
      }
    ],
    name: "TransferBatch",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "TransferSingle",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "URI",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Withdraw",
    type: "event"
  },
  {
    inputs: [],
    name: "a",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_maxSupply",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "_decimals",
        type: "uint8"
      }
    ],
    name: "addAssetOcto",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "assetToIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      }
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenID",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_newMaxSupply",
        type: "uint256"
      }
    ],
    name: "changeMaxSupply",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_minimumLiquidity",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_deadline",
        type: "uint256"
      }
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "devaddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "feeTo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "globalEquilCovRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "equilCovRatio",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "invariant",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "indexToAsset",
    outputs: [
      {
        internalType: "uint256",
        name: "cash",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liability",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "maxSupply",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "totalSupply",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "decimals",
        type: "uint8"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "bool",
        name: "active",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_a",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_lpFee",
        type: "uint256"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lastIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lpDividendRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lpFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256"
      }
    ],
    name: "mintFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "mintFeeThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newA",
        type: "uint256"
      }
    ],
    name: "setA",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "_active",
        type: "bool"
      }
    ],
    name: "setAssetStatus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newLpDividendRatio",
        type: "uint256"
      }
    ],
    name: "setFeeRatio",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newFeeTo",
        type: "address"
      }
    ],
    name: "setFeeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newLpFee",
        type: "uint256"
      }
    ],
    name: "setLPFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newMintFeeThreshold",
        type: "uint256"
      }
    ],
    name: "setMintFeeThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newVeSIS",
        type: "address"
      }
    ],
    name: "setVeSISAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "spreadAccumulatedError",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_fromID",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_toID",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_fromAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_minToAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_deadline",
        type: "uint256"
      }
    ],
    name: "swap",
    outputs: [
      {
        internalType: "uint256",
        name: "actualToAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "lpFeeAmount",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "veSIS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_minAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_deadline",
        type: "uint256"
      }
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var _bytecode7 = "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";
var isSuperArgs7 = (xs) => xs.length > 1;
var OmniPool__factory = class extends ContractFactory7 {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs7(args)) {
      __super(...args);
    } else {
      __super(_abi19, _bytecode7, args[0]);
    }
    this.contractName = "OmniPool";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address2) {
    return super.attach(address2);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils20.Interface(_abi19);
  }
  static connect(address2, signerOrProvider) {
    return new Contract19(address2, _abi19, signerOrProvider);
  }
};
OmniPool__factory.bytecode = _bytecode7;
OmniPool__factory.abi = _abi19;

// src/crosschain/contracts/factories/OmniPoolOracle__factory.ts
import { utils as utils21, Contract as Contract20, ContractFactory as ContractFactory8 } from "ethers";
var _abi20 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    inputs: [],
    name: "a",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "devaddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_pool",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "lastIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lpDividendRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lpFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "poolDev",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "quoteDeposit",
    outputs: [
      {
        internalType: "uint256",
        name: "lpTokenToMint",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liabilityToMint",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_fromAsset",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_toAsset",
        type: "uint256"
      },
      {
        internalType: "int256",
        name: "_fromAmount",
        type: "int256"
      }
    ],
    name: "quoteFrom",
    outputs: [
      {
        internalType: "uint256",
        name: "actualToAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "lpFeeAmount",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_liquidity",
        type: "uint256"
      }
    ],
    name: "quoteWithdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liabilityToBurn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "fee",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var _bytecode8 = "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";
var isSuperArgs8 = (xs) => xs.length > 1;
var OmniPoolOracle__factory = class extends ContractFactory8 {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs8(args)) {
      __super(...args);
    } else {
      __super(_abi20, _bytecode8, args[0]);
    }
    this.contractName = "OmniPoolOracle";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address2) {
    return super.attach(address2);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils21.Interface(_abi20);
  }
  static connect(address2, signerOrProvider) {
    return new Contract20(address2, _abi20, signerOrProvider);
  }
};
OmniPoolOracle__factory.bytecode = _bytecode8;
OmniPoolOracle__factory.abi = _abi20;

// src/crosschain/contracts/factories/OneInchOracle__factory.ts
import { Contract as Contract21, utils as utils22 } from "ethers";
var _abi21 = [
  {
    inputs: [
      {
        internalType: "contract MultiWrapper",
        name: "_multiWrapper",
        type: "address"
      },
      {
        internalType: "contract IOracle[]",
        name: "existingOracles",
        type: "address[]"
      },
      {
        internalType: "enum OffchainOracle.OracleType[]",
        name: "oracleTypes",
        type: "uint8[]"
      },
      {
        internalType: "contract IERC20[]",
        name: "existingConnectors",
        type: "address[]"
      },
      {
        internalType: "contract IERC20",
        name: "wBase",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract IERC20",
        name: "connector",
        type: "address"
      }
    ],
    name: "ConnectorAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract IERC20",
        name: "connector",
        type: "address"
      }
    ],
    name: "ConnectorRemoved",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract MultiWrapper",
        name: "multiWrapper",
        type: "address"
      }
    ],
    name: "MultiWrapperUpdated",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract IOracle",
        name: "oracle",
        type: "address"
      },
      {
        indexed: false,
        internalType: "enum OffchainOracle.OracleType",
        name: "oracleType",
        type: "uint8"
      }
    ],
    name: "OracleAdded",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract IOracle",
        name: "oracle",
        type: "address"
      },
      {
        indexed: false,
        internalType: "enum OffchainOracle.OracleType",
        name: "oracleType",
        type: "uint8"
      }
    ],
    name: "OracleRemoved",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "connector",
        type: "address"
      }
    ],
    name: "addConnector",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IOracle",
        name: "oracle",
        type: "address"
      },
      {
        internalType: "enum OffchainOracle.OracleType",
        name: "oracleKind",
        type: "uint8"
      }
    ],
    name: "addOracle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "connectors",
    outputs: [
      {
        internalType: "contract IERC20[]",
        name: "allConnectors",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "srcToken",
        type: "address"
      },
      {
        internalType: "contract IERC20",
        name: "dstToken",
        type: "address"
      },
      {
        internalType: "bool",
        name: "useWrappers",
        type: "bool"
      }
    ],
    name: "getRate",
    outputs: [
      {
        internalType: "uint256",
        name: "weightedRate",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "srcToken",
        type: "address"
      },
      {
        internalType: "bool",
        name: "useSrcWrappers",
        type: "bool"
      }
    ],
    name: "getRateToEth",
    outputs: [
      {
        internalType: "uint256",
        name: "weightedRate",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "multiWrapper",
    outputs: [
      {
        internalType: "contract MultiWrapper",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "oracles",
    outputs: [
      {
        internalType: "contract IOracle[]",
        name: "allOracles",
        type: "address[]"
      },
      {
        internalType: "enum OffchainOracle.OracleType[]",
        name: "oracleTypes",
        type: "uint8[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "connector",
        type: "address"
      }
    ],
    name: "removeConnector",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IOracle",
        name: "oracle",
        type: "address"
      },
      {
        internalType: "enum OffchainOracle.OracleType",
        name: "oracleKind",
        type: "uint8"
      }
    ],
    name: "removeOracle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract MultiWrapper",
        name: "_multiWrapper",
        type: "address"
      }
    ],
    name: "setMultiWrapper",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var OneInchOracle__factory = class {
  static createInterface() {
    return new utils22.Interface(_abi21);
  }
  static connect(address2, signerOrProvider) {
    return new Contract21(address2, _abi21, signerOrProvider);
  }
};
OneInchOracle__factory.abi = _abi21;

// src/crosschain/contracts/factories/Pair__factory.ts
import { Contract as Contract22, utils as utils23 } from "ethers";
var _abi22 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Burn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1",
        type: "uint256"
      }
    ],
    name: "Mint",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1In",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "Swap",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint112",
        name: "reserve0",
        type: "uint112"
      },
      {
        indexed: false,
        internalType: "uint112",
        name: "reserve1",
        type: "uint112"
      }
    ],
    name: "Sync",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    constant: true,
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "MINIMUM_LIQUIDITY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "pure",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "PERMIT_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    payable: false,
    stateMutability: "pure",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "burn",
    outputs: [
      {
        internalType: "uint256",
        name: "amount0",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount1",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    payable: false,
    stateMutability: "pure",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "getReserves",
    outputs: [
      {
        internalType: "uint112",
        name: "reserve0",
        type: "uint112"
      },
      {
        internalType: "uint112",
        name: "reserve1",
        type: "uint112"
      },
      {
        internalType: "uint32",
        name: "blockTimestampLast",
        type: "uint32"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "kLast",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    payable: false,
    stateMutability: "pure",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "permit",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "price0CumulativeLast",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "price1CumulativeLast",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "skim",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "uint256",
        name: "amount0Out",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount1Out",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "swap",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    payable: false,
    stateMutability: "pure",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "sync",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "token0",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "token1",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  }
];
var Pair__factory = class {
  static createInterface() {
    return new utils23.Interface(_abi22);
  }
  static connect(address2, signerOrProvider) {
    return new Contract22(address2, _abi22, signerOrProvider);
  }
};
Pair__factory.abi = _abi22;

// src/crosschain/contracts/factories/Portal__factory.ts
import { utils as utils24, Contract as Contract23, ContractFactory as ContractFactory9 } from "ethers";
var _abi23 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "crossChainID",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bridgingFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "BurnCompleted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "clientId",
        type: "bytes32"
      }
    ],
    name: "ClientIdLog",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "MetaRevertRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "RevertBurnRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bridgingFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "RevertSynthesizeCompleted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "metaRouter",
        type: "address"
      }
    ],
    name: "SetMetaRouter",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "threshold",
        type: "uint256"
      }
    ],
    name: "SetTokenThreshold",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "activate",
        type: "bool"
      }
    ],
    name: "SetWhitelistToken",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "chainID",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "revertableAddress",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "SynthesizeRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "bridge",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address"
      },
      {
        internalType: "address",
        name: "_wrapper",
        type: "address"
      },
      {
        internalType: "address",
        name: "_whitelistedToken",
        type: "address"
      },
      {
        internalType: "contract IMetaRouter",
        name: "_metaRouter",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address"
      }
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "internalID",
            type: "bytes32"
          },
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "managerChainBridge",
            type: "address"
          },
          {
            internalType: "address",
            name: "sourceChainBridge",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "managerChainId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "sourceChainId",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "router",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "swapCalldata",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "sourceChainSynthesis",
            type: "address"
          },
          {
            internalType: "address",
            name: "burnToken",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "burnCalldata",
            type: "bytes"
          },
          {
            internalType: "bytes32",
            name: "clientID",
            type: "bytes32"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaRevertTransaction",
        name: "_metaRevertTransaction",
        type: "tuple"
      }
    ],
    name: "metaRevertRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "metaRouter",
    outputs: [
      {
        internalType: "contract IMetaRouter",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "rtoken",
            type: "address"
          },
          {
            internalType: "address",
            name: "chain2address",
            type: "address"
          },
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "oppositeBridge",
            type: "address"
          },
          {
            internalType: "address",
            name: "syntCaller",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "address[]",
            name: "swapTokens",
            type: "address[]"
          },
          {
            internalType: "address",
            name: "secondDexRouter",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "secondSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "finalReceiveSide",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "finalCalldata",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "finalOffset",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "revertableAddress",
            type: "address"
          },
          {
            internalType: "bytes32",
            name: "clientID",
            type: "bytes32"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaSynthesizeTransaction",
        name: "_metaSynthesizeTransaction",
        type: "tuple"
      }
    ],
    name: "metaSynthesize",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_crossChainID",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_rToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "_finalReceiveSide",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_finalCalldata",
        type: "bytes"
      },
      {
        internalType: "uint256",
        name: "_finalOffset",
        type: "uint256"
      }
    ],
    name: "metaUnsynthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "requestCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "requests",
    outputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "address",
        name: "chain2address",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "rtoken",
        type: "address"
      },
      {
        internalType: "enum Portal.RequestState",
        name: "state",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_internalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainId",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "revertBurnRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      }
    ],
    name: "revertSynthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IMetaRouter",
        name: "_metaRouter",
        type: "address"
      }
    ],
    name: "setMetaRouter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_threshold",
        type: "uint256"
      }
    ],
    name: "setTokenThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "bool",
        name: "_activate",
        type: "bool"
      }
    ],
    name: "setWhitelistToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_chain2address",
        type: "address"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_revertableAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "synthesize",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_chain2address",
        type: "address"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_revertableAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "synthesizeNative",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "bytes",
            name: "approvalData",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "token",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "chain2address",
            type: "address"
          },
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "oppositeBridge",
            type: "address"
          },
          {
            internalType: "address",
            name: "revertableAddress",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "clientID",
            type: "bytes32"
          }
        ],
        internalType: "struct Portal.SynthesizeWithPermitTransaction",
        name: "_syntWithPermitTx",
        type: "tuple"
      }
    ],
    name: "synthesizeWithPermit",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "tokenThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "tokenWhitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "_crossChainID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      }
    ],
    name: "unsynthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "unsynthesizeStates",
    outputs: [
      {
        internalType: "enum Portal.UnsynthesizeState",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "versionRecipient",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "wrapper",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var _bytecode9 = "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";
var isSuperArgs9 = (xs) => xs.length > 1;
var Portal__factory = class extends ContractFactory9 {
  constructor(...args) {
    var __super = (...args) => {
      super(...args);
    };
    if (isSuperArgs9(args)) {
      __super(...args);
    } else {
      __super(_abi23, _bytecode9, args[0]);
    }
    this.contractName = "Portal";
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address2) {
    return super.attach(address2);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static createInterface() {
    return new utils24.Interface(_abi23);
  }
  static connect(address2, signerOrProvider) {
    return new Contract23(address2, _abi23, signerOrProvider);
  }
};
Portal__factory.bytecode = _bytecode9;
Portal__factory.abi = _abi23;

// src/crosschain/contracts/factories/SymBtc__factory.ts
import { Contract as Contract24, utils as utils25 } from "ethers";
var _abi24 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [],
    name: "bridge",
    outputs: [
      {
        internalType: "contract BridgeV2",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "btcChainId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "btcTokenAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_btcFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_btcTxId",
        type: "bytes32"
      },
      {
        internalType: "SymBtc.BtcInputIndex",
        name: "_inputIndex",
        type: "uint32"
      },
      {
        internalType: "BtcSerial",
        name: "_wrapSerial",
        type: "uint64"
      },
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        components: [
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "receiveSideCalldata",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "receiveSideOffset",
            type: "uint256"
          }
        ],
        internalType: "struct SymBtc.FromBTCTransactionTail",
        name: "_tail",
        type: "tuple"
      }
    ],
    name: "getBTCCalldata",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_btcTxId",
        type: "bytes32"
      },
      {
        internalType: "SymBtc.BtcInputIndex",
        name: "_inputIndex",
        type: "uint32"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      }
    ],
    name: "getBTCExternalID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_btcTxId",
        type: "bytes32"
      },
      {
        internalType: "SymBtc.BtcInputIndex",
        name: "_inputIndex",
        type: "uint32"
      }
    ],
    name: "getBTCInternalID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "getBtcTotalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_btcFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_btcTxId",
        type: "bytes32"
      },
      {
        internalType: "SymBtc.BtcInputIndex",
        name: "_inputIndex",
        type: "uint32"
      },
      {
        internalType: "BtcSerial",
        name: "_wrapSerial",
        type: "uint64"
      },
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        components: [
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "receiveSideCalldata",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "receiveSideOffset",
            type: "uint256"
          }
        ],
        internalType: "struct SymBtc.FromBTCTransactionTail",
        name: "_transactionTail",
        type: "tuple"
      }
    ],
    name: "getHashBTC",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newMPC",
        type: "address"
      }
    ],
    name: "getMpcHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getSyntToken",
    outputs: [
      {
        internalType: "contract SyntERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridgeAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_synthesisAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_tokenAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainId",
        type: "uint256"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "mpc",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "receiveSideCalldata",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "receiveSideOffset",
            type: "uint256"
          }
        ],
        internalType: "struct SymBtc.FromBTCTransactionTail",
        name: "_transactionTail",
        type: "tuple"
      }
    ],
    name: "packBTCTransactionTail",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "synthesis",
    outputs: [
      {
        internalType: "contract Synthesis",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_transactionTail",
        type: "bytes"
      }
    ],
    name: "unpackBTCTransactionTail",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "receiveSideCalldata",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "receiveSideOffset",
            type: "uint256"
          }
        ],
        internalType: "struct SymBtc.FromBTCTransactionTail",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "pure",
    type: "function"
  }
];
var SymBtc__factory = class {
  static createInterface() {
    return new utils25.Interface(_abi24);
  }
  static connect(address2, signerOrProvider) {
    return new Contract24(address2, _abi24, signerOrProvider);
  }
};
SymBtc__factory.abi = _abi24;

// src/crosschain/contracts/factories/Synthesis__factory.ts
import { Contract as Contract25, utils as utils26 } from "ethers";
var _abi25 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "BtcSerial",
        name: "serial",
        type: "uint64"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bridgingFee",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "BTCSynthesizeCompleted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "chainID",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "revertableAddress",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "BurnRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "BtcSerial",
        name: "burnSerial",
        type: "uint64"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "to",
        type: "bytes"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stableBridgingFee",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "rtoken",
        type: "address"
      }
    ],
    name: "BurnRequestBTC",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "chainID",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "revertableAddress",
        type: "address"
      },
      {
        components: [
          {
            internalType: "int8",
            name: "workchain",
            type: "int8"
          },
          {
            internalType: "bytes32",
            name: "address_hash",
            type: "bytes32"
          }
        ],
        indexed: false,
        internalType: "struct Synthesis.TonAddress",
        name: "to",
        type: "tuple"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "BurnRequestTON",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "clientId",
        type: "bytes32"
      }
    ],
    name: "ClientIdLog",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "BtcSerial",
        name: "burnSerial",
        type: "uint64"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "clientId",
        type: "bytes32"
      }
    ],
    name: "ClientIdLogBTC",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bridgingFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "RevertBurnCompleted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "RevertSynthesizeRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "fabric",
        type: "address"
      }
    ],
    name: "SetFabric",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "metaRouter",
        type: "address"
      }
    ],
    name: "SetMetaRouter",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "minFee",
        type: "uint256"
      }
    ],
    name: "SetMinFeeBTC",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "threshold",
        type: "uint256"
      }
    ],
    name: "SetTokenThreshold",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "crossChainID",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bridgingFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "SynthesizeCompleted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    inputs: [],
    name: "bridge",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_stoken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_chain2address",
        type: "address"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_revertableAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "burnSyntheticToken",
    outputs: [
      {
        internalType: "bytes32",
        name: "internalID",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "_to",
        type: "bytes"
      },
      {
        internalType: "address",
        name: "_stoken",
        type: "address"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "burnSyntheticTokenBTC",
    outputs: [
      {
        internalType: "BtcSerial",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_stoken",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_crossChainID",
        type: "bytes32"
      },
      {
        components: [
          {
            internalType: "int8",
            name: "workchain",
            type: "int8"
          },
          {
            internalType: "bytes32",
            name: "address_hash",
            type: "bytes32"
          }
        ],
        internalType: "struct Synthesis.TonAddress",
        name: "_chain2address",
        type: "tuple"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_revertableAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "burnSyntheticTokenTON",
    outputs: [
      {
        internalType: "bytes32",
        name: "internalID",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "fabric",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address"
      },
      {
        internalType: "contract IMetaRouter",
        name: "_metaRouter",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address"
      }
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "crossChainID",
            type: "bytes32"
          },
          {
            internalType: "address",
            name: "syntCaller",
            type: "address"
          },
          {
            internalType: "address",
            name: "finalReceiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "sToken",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "finalCallData",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "finalOffset",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "chain2address",
            type: "address"
          },
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "oppositeBridge",
            type: "address"
          },
          {
            internalType: "address",
            name: "revertableAddress",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "clientID",
            type: "bytes32"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaBurnTransaction",
        name: "_metaBurnTransaction",
        type: "tuple"
      }
    ],
    name: "metaBurnSyntheticToken",
    outputs: [
      {
        internalType: "bytes32",
        name: "internalID",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "crossChainID",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "externalID",
            type: "bytes32"
          },
          {
            internalType: "address",
            name: "tokenReal",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "to",
            type: "address"
          },
          {
            internalType: "address[]",
            name: "swapTokens",
            type: "address[]"
          },
          {
            internalType: "address",
            name: "secondDexRouter",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "secondSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "finalReceiveSide",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "finalCalldata",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "finalOffset",
            type: "uint256"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaMintTransaction",
        name: "_metaMintTransaction",
        type: "tuple"
      }
    ],
    name: "metaMintSyntheticToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "BtcSerial",
            name: "serial",
            type: "uint64"
          },
          {
            internalType: "bytes32",
            name: "crossChainID",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "externalID",
            type: "bytes32"
          },
          {
            internalType: "address",
            name: "tokenReal",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "to",
            type: "address"
          },
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "receiveSideCalldata",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "receiveSideOffset",
            type: "uint256"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaMintTransactionBTC",
        name: "_metaMintTransaction",
        type: "tuple"
      }
    ],
    name: "metaMintSyntheticTokenBTC",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "metaRouter",
    outputs: [
      {
        internalType: "contract IMetaRouter",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "_crossChainID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_tokenReal",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      }
    ],
    name: "mintSyntheticToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "realToBurnSerialBTC",
    outputs: [
      {
        internalType: "BtcSerial",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "realToMintSerialBTC",
    outputs: [
      {
        internalType: "BtcSerial",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "requestCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "requests",
    outputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "address",
        name: "chain2address",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "address",
        name: "stoken",
        type: "address"
      },
      {
        internalType: "enum Synthesis.RequestState",
        name: "state",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      }
    ],
    name: "revertBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_revertableAddress",
        type: "address"
      }
    ],
    name: "revertBurnAndBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_router",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_swapCalldata",
        type: "bytes"
      },
      {
        internalType: "address",
        name: "_synthesis",
        type: "address"
      },
      {
        internalType: "address",
        name: "_burnToken",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_burnCalldata",
        type: "bytes"
      }
    ],
    name: "revertMetaBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_internalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "revertSynthesizeRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_internalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_sender",
        type: "address"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "revertSynthesizeRequestByBridge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_fabric",
        type: "address"
      }
    ],
    name: "setFabric",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IMetaRouter",
        name: "_metaRouter",
        type: "address"
      }
    ],
    name: "setMetaRouter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_synt",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_minFee",
        type: "uint256"
      }
    ],
    name: "setMinFeeBTC",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_threshold",
        type: "uint256"
      }
    ],
    name: "setTokenThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "syntToMinFeeBTC",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "synthesizeStates",
    outputs: [
      {
        internalType: "enum Synthesis.SynthesizeState",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "tokenThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "versionRecipient",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "pure",
    type: "function"
  }
];
var Synthesis__factory = class {
  static createInterface() {
    return new utils26.Interface(_abi25);
  }
  static connect(address2, signerOrProvider) {
    return new Contract25(address2, _abi25, signerOrProvider);
  }
};
Synthesis__factory.abi = _abi25;

// src/crosschain/contracts/factories/ThorRouter__factory.ts
import { Contract as Contract26, utils as utils27 } from "ethers";
var _abi26 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "rune",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "string",
        name: "memo",
        type: "string"
      }
    ],
    name: "Deposit",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "oldVault",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newVault",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "string",
        name: "memo",
        type: "string"
      }
    ],
    name: "TransferAllowance",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "vault",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "string",
        name: "memo",
        type: "string"
      }
    ],
    name: "TransferOut",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "vault",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "finalAsset",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "string",
        name: "memo",
        type: "string"
      }
    ],
    name: "TransferOutAndCall",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "oldVault",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newVault",
        type: "address"
      },
      {
        components: [
          {
            internalType: "address",
            name: "asset",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          }
        ],
        indexed: false,
        internalType: "struct THORChain_Router.Coin[]",
        name: "coins",
        type: "tuple[]"
      },
      {
        indexed: false,
        internalType: "string",
        name: "memo",
        type: "string"
      }
    ],
    name: "VaultTransfer",
    type: "event"
  },
  {
    inputs: [],
    name: "RUNE",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "vault",
        type: "address"
      },
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "memo",
        type: "string"
      }
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "vault",
        type: "address"
      },
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "memo",
        type: "string"
      },
      {
        internalType: "uint256",
        name: "expiration",
        type: "uint256"
      }
    ],
    name: "depositWithExpiry",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "router",
        type: "address"
      },
      {
        internalType: "address payable",
        name: "asgard",
        type: "address"
      },
      {
        components: [
          {
            internalType: "address",
            name: "asset",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          }
        ],
        internalType: "struct THORChain_Router.Coin[]",
        name: "coins",
        type: "tuple[]"
      },
      {
        internalType: "string",
        name: "memo",
        type: "string"
      }
    ],
    name: "returnVaultAssets",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "router",
        type: "address"
      },
      {
        internalType: "address",
        name: "newVault",
        type: "address"
      },
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "memo",
        type: "string"
      }
    ],
    name: "transferAllowance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "to",
        type: "address"
      },
      {
        internalType: "address",
        name: "asset",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "memo",
        type: "string"
      }
    ],
    name: "transferOut",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "aggregator",
        type: "address"
      },
      {
        internalType: "address",
        name: "finalToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "memo",
        type: "string"
      }
    ],
    name: "transferOutAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "vault",
        type: "address"
      },
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "vaultAllowance",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var ThorRouter__factory = class {
  static createInterface() {
    return new utils27.Interface(_abi26);
  }
  static connect(address2, signerOrProvider) {
    return new Contract26(address2, _abi26, signerOrProvider);
  }
};
ThorRouter__factory.abi = _abi26;

// src/crosschain/contracts/factories/TonBridge__factory.ts
import { Contract as Contract27, utils as utils28 } from "ethers";
var _abi27 = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newBridgeChainId",
        type: "uint256"
      }
    ],
    name: "ChangeBridgeChainId",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newBroadcaster",
        type: "address"
      }
    ],
    name: "ChangeBroadcaster",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newBridge",
        type: "address"
      }
    ],
    name: "ChangeSymbiosisBridge",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newBridge",
        type: "address"
      }
    ],
    name: "ChangeTonBridge",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [],
    name: "bridgeChainId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "broadcaster",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        components: [
          {
            internalType: "int8",
            name: "workchain",
            type: "int8"
          },
          {
            internalType: "bytes32",
            name: "address_hash",
            type: "bytes32"
          }
        ],
        internalType: "struct TonBridge.TonAddress",
        name: "_tonAddress",
        type: "tuple"
      }
    ],
    name: "callBridgeRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newBridgeChainId",
        type: "uint256"
      }
    ],
    name: "changeBridgeChainId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newBroadcaster",
        type: "address"
      }
    ],
    name: "changeBroadcaster",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newSymbiosisBridge",
        type: "address"
      }
    ],
    name: "changeSymbiosisBridge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newTonBridge",
        type: "address"
      }
    ],
    name: "changeTonBridge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tonBridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_symbiosisBridge",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_bridgeChainId",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_broadcaster",
        type: "address"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "symbiosisBridge",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "tonBridge",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var TonBridge__factory = class {
  static createInterface() {
    return new utils28.Interface(_abi27);
  }
  static connect(address2, signerOrProvider) {
    return new Contract27(address2, _abi27, signerOrProvider);
  }
};
TonBridge__factory.abi = _abi27;

// src/crosschain/contracts/factories/UniLikeRouter__factory.ts
import { Contract as Contract28, utils as utils29 } from "ethers";
var _abi28 = [
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountADesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountTokenDesired",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "addLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveOut",
        type: "uint256"
      }
    ],
    name: "getAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsIn",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      }
    ],
    name: "getAmountsOut",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "reserveB",
        type: "uint256"
      }
    ],
    name: "quote",
    outputs: [
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityETH",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "removeLiquidityETHSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityETHWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountToken",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountTokenMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountETHMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountETH",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "liquidity",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountAMin",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountBMin",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bool",
        name: "approveMax",
        type: "bool"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "removeLiquidityWithPermit",
    outputs: [
      {
        internalType: "uint256",
        name: "amountA",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountB",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapETHForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactETHForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactETHForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForETH",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForETHSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactETH",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      }
    ],
    name: "swapTokensForExactTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var UniLikeRouter__factory = class {
  static createInterface() {
    return new utils29.Interface(_abi28);
  }
  static connect(address2, signerOrProvider) {
    return new Contract28(address2, _abi28, signerOrProvider);
  }
};
UniLikeRouter__factory.abi = _abi28;

// src/crosschain/contracts/factories/UniV3Factory__factory.ts
import { Contract as Contract29, utils as utils30 } from "ethers";
var _abi29 = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        indexed: true,
        internalType: "int24",
        name: "tickSpacing",
        type: "int24"
      }
    ],
    name: "FeeAmountEnabled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "oldOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnerChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token0",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "token1",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        indexed: false,
        internalType: "int24",
        name: "tickSpacing",
        type: "int24"
      },
      {
        indexed: false,
        internalType: "address",
        name: "pool",
        type: "address"
      }
    ],
    name: "PoolCreated",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenA",
        type: "address"
      },
      {
        internalType: "address",
        name: "tokenB",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      }
    ],
    name: "createPool",
    outputs: [
      {
        internalType: "address",
        name: "pool",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        internalType: "int24",
        name: "tickSpacing",
        type: "int24"
      }
    ],
    name: "enableFeeAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint24",
        name: "",
        type: "uint24"
      }
    ],
    name: "feeAmountTickSpacing",
    outputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "",
        type: "uint24"
      }
    ],
    name: "getPool",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "parameters",
    outputs: [
      {
        internalType: "address",
        name: "factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "token0",
        type: "address"
      },
      {
        internalType: "address",
        name: "token1",
        type: "address"
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24"
      },
      {
        internalType: "int24",
        name: "tickSpacing",
        type: "int24"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address"
      }
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var UniV3Factory__factory = class {
  static createInterface() {
    return new utils30.Interface(_abi29);
  }
  static connect(address2, signerOrProvider) {
    return new Contract29(address2, _abi29, signerOrProvider);
  }
};
UniV3Factory__factory.abi = _abi29;

// src/crosschain/contracts/factories/UniV3Quoter__factory.ts
import { Contract as Contract30, utils as utils31 } from "ethers";
var _abi30 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address"
      },
      {
        internalType: "address",
        name: "_WETH9",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WETH9",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "path",
        type: "bytes"
      },
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    name: "quoteExactInput",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint160[]",
        name: "sqrtPriceX96AfterList",
        type: "uint160[]"
      },
      {
        internalType: "uint32[]",
        name: "initializedTicksCrossedList",
        type: "uint32[]"
      },
      {
        internalType: "uint256",
        name: "gasEstimate",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenIn",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenOut",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amountIn",
            type: "uint256"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160"
          }
        ],
        internalType: "struct IQuoterV2.QuoteExactInputSingleParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "quoteExactInputSingle",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint160",
        name: "sqrtPriceX96After",
        type: "uint160"
      },
      {
        internalType: "uint32",
        name: "initializedTicksCrossed",
        type: "uint32"
      },
      {
        internalType: "uint256",
        name: "gasEstimate",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "path",
        type: "bytes"
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    name: "quoteExactOutput",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint160[]",
        name: "sqrtPriceX96AfterList",
        type: "uint160[]"
      },
      {
        internalType: "uint32[]",
        name: "initializedTicksCrossedList",
        type: "uint32[]"
      },
      {
        internalType: "uint256",
        name: "gasEstimate",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenIn",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenOut",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160"
          }
        ],
        internalType: "struct IQuoterV2.QuoteExactOutputSingleParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "quoteExactOutputSingle",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint160",
        name: "sqrtPriceX96After",
        type: "uint160"
      },
      {
        internalType: "uint32",
        name: "initializedTicksCrossed",
        type: "uint32"
      },
      {
        internalType: "uint256",
        name: "gasEstimate",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "amount0Delta",
        type: "int256"
      },
      {
        internalType: "int256",
        name: "amount1Delta",
        type: "int256"
      },
      {
        internalType: "bytes",
        name: "path",
        type: "bytes"
      }
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "view",
    type: "function"
  }
];
var UniV3Quoter__factory = class {
  static createInterface() {
    return new utils31.Interface(_abi30);
  }
  static connect(address2, signerOrProvider) {
    return new Contract30(address2, _abi30, signerOrProvider);
  }
};
UniV3Quoter__factory.abi = _abi30;

// src/crosschain/contracts/factories/UniV3Router__factory.ts
import { Contract as Contract31, utils as utils32 } from "ethers";
var _abi31 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_factoryV2",
        type: "address"
      },
      {
        internalType: "address",
        name: "factoryV3",
        type: "address"
      },
      {
        internalType: "address",
        name: "_positionManager",
        type: "address"
      },
      {
        internalType: "address",
        name: "_WETH9",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "WETH9",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "approveMax",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "approveMaxMinusOne",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "approveZeroThenMax",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "approveZeroThenMaxMinusOne",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "callPositionManager",
    outputs: [
      {
        internalType: "bytes",
        name: "result",
        type: "bytes"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "paths",
        type: "bytes[]"
      },
      {
        internalType: "uint128[]",
        name: "amounts",
        type: "uint128[]"
      },
      {
        internalType: "uint24",
        name: "maximumTickDivergence",
        type: "uint24"
      },
      {
        internalType: "uint32",
        name: "secondsAgo",
        type: "uint32"
      }
    ],
    name: "checkOracleSlippage",
    outputs: [],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "path",
        type: "bytes"
      },
      {
        internalType: "uint24",
        name: "maximumTickDivergence",
        type: "uint24"
      },
      {
        internalType: "uint32",
        name: "secondsAgo",
        type: "uint32"
      }
    ],
    name: "checkOracleSlippage",
    outputs: [],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "path",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amountIn",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountOutMinimum",
            type: "uint256"
          }
        ],
        internalType: "struct IV3SwapRouter.ExactInputParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactInput",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenIn",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenOut",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amountIn",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountOutMinimum",
            type: "uint256"
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160"
          }
        ],
        internalType: "struct IV3SwapRouter.ExactInputSingleParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactInputSingle",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "path",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amountOut",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountInMaximum",
            type: "uint256"
          }
        ],
        internalType: "struct IV3SwapRouter.ExactOutputParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactOutput",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tokenIn",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenOut",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amountOut",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amountInMaximum",
            type: "uint256"
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160"
          }
        ],
        internalType: "struct IV3SwapRouter.ExactOutputSingleParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "exactOutputSingle",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "factoryV2",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "getApprovalType",
    outputs: [
      {
        internalType: "enum IApproveAndCall.ApprovalType",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token0",
            type: "address"
          },
          {
            internalType: "address",
            name: "token1",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount0Min",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount1Min",
            type: "uint256"
          }
        ],
        internalType: "struct IApproveAndCall.IncreaseLiquidityParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "increaseLiquidity",
    outputs: [
      {
        internalType: "bytes",
        name: "result",
        type: "bytes"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token0",
            type: "address"
          },
          {
            internalType: "address",
            name: "token1",
            type: "address"
          },
          {
            internalType: "uint24",
            name: "fee",
            type: "uint24"
          },
          {
            internalType: "int24",
            name: "tickLower",
            type: "int24"
          },
          {
            internalType: "int24",
            name: "tickUpper",
            type: "int24"
          },
          {
            internalType: "uint256",
            name: "amount0Min",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount1Min",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address"
          }
        ],
        internalType: "struct IApproveAndCall.MintParams",
        name: "params",
        type: "tuple"
      }
    ],
    name: "mint",
    outputs: [
      {
        internalType: "bytes",
        name: "result",
        type: "bytes"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "previousBlockhash",
        type: "bytes32"
      },
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "",
        type: "bytes[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "",
        type: "bytes[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "positionManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "pull",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "refundETH",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermit",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermitAllowed",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermitAllowedIfNecessary",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256"
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8"
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32"
      }
    ],
    name: "selfPermitIfNecessary",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountOutMin",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "swapExactTokensForTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amountInMax",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "path",
        type: "address[]"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "swapTokensForExactTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "sweepToken",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      }
    ],
    name: "sweepToken",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "sweepTokenWithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "sweepTokenWithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "amount0Delta",
        type: "int256"
      },
      {
        internalType: "int256",
        name: "amount1Delta",
        type: "int256"
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes"
      }
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      }
    ],
    name: "unwrapWETH9",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9WithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountMinimum",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "feeBips",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "feeRecipient",
        type: "address"
      }
    ],
    name: "unwrapWETH9WithFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "wrapETH",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    stateMutability: "payable",
    type: "receive"
  }
];
var UniV3Router__factory = class {
  static createInterface() {
    return new utils32.Interface(_abi31);
  }
  static connect(address2, signerOrProvider) {
    return new Contract31(address2, _abi31, signerOrProvider);
  }
};
UniV3Router__factory.abi = _abi31;

// src/crosschain/contracts/factories/Unwrapper__factory.ts
import { Contract as Contract32, utils as utils33 } from "ethers";
var _abi32 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_wrapper",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newWrapper",
        type: "address"
      }
    ],
    name: "setWrapper",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amountIn",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      }
    ],
    name: "unwrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "wrapper",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var Unwrapper__factory = class {
  static createInterface() {
    return new utils33.Interface(_abi32);
  }
  static connect(address2, signerOrProvider) {
    return new Contract32(address2, _abi32, signerOrProvider);
  }
};
Unwrapper__factory.abi = _abi32;

// src/crosschain/contracts/factories/Weth__factory.ts
import { Contract as Contract33, utils as utils34 } from "ethers";
var _abi33 = [
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "guy",
        type: "address"
      },
      {
        name: "wad",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "src",
        type: "address"
      },
      {
        name: "dst",
        type: "address"
      },
      {
        name: "wad",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "wad",
        type: "uint256"
      }
    ],
    name: "withdraw",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [
      {
        name: "",
        type: "uint8"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        name: "",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "dst",
        type: "address"
      },
      {
        name: "wad",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "deposit",
    outputs: [],
    payable: true,
    stateMutability: "payable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        name: "",
        type: "address"
      },
      {
        name: "",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    payable: true,
    stateMutability: "payable",
    type: "fallback"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "src",
        type: "address"
      },
      {
        indexed: true,
        name: "guy",
        type: "address"
      },
      {
        indexed: false,
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "src",
        type: "address"
      },
      {
        indexed: true,
        name: "dst",
        type: "address"
      },
      {
        indexed: false,
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "dst",
        type: "address"
      },
      {
        indexed: false,
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Deposit",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "src",
        type: "address"
      },
      {
        indexed: false,
        name: "wad",
        type: "uint256"
      }
    ],
    name: "Withdrawal",
    type: "event"
  }
];
var Weth__factory = class {
  static createInterface() {
    return new utils34.Interface(_abi33);
  }
  static connect(address2, signerOrProvider) {
    return new Contract33(address2, _abi33, signerOrProvider);
  }
};
Weth__factory.abi = _abi33;

// src/crosschain/contracts/factories/WTON__factory.ts
import { Contract as Contract34, utils as utils35 } from "ethers";
var _abi34 = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string"
      },
      {
        internalType: "address[]",
        name: "initialSet",
        type: "address[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "int256",
        name: "oracleSetHash",
        type: "int256"
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "newOracles",
        type: "address[]"
      }
    ],
    name: "NewOracleSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: false,
        internalType: "int8",
        name: "to_wc",
        type: "int8"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "to_addr_hash",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "SwapEthToTon",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "int8",
        name: "workchain",
        type: "int8"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "ton_address_hash",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "ton_tx_hash",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "lt",
        type: "uint64"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "SwapTonToEth",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [],
    name: "allowBurn",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        components: [
          {
            internalType: "int8",
            name: "workchain",
            type: "int8"
          },
          {
            internalType: "bytes32",
            name: "address_hash",
            type: "bytes32"
          }
        ],
        internalType: "struct TonUtils.TonAddress",
        name: "addr",
        type: "tuple"
      }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        components: [
          {
            internalType: "int8",
            name: "workchain",
            type: "int8"
          },
          {
            internalType: "bytes32",
            name: "address_hash",
            type: "bytes32"
          }
        ],
        internalType: "struct TonUtils.TonAddress",
        name: "addr",
        type: "tuple"
      }
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "digest",
        type: "bytes32"
      },
      {
        components: [
          {
            internalType: "address",
            name: "signer",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes"
          }
        ],
        internalType: "struct TonUtils.Signature",
        name: "sig",
        type: "tuple"
      }
    ],
    name: "checkSignature",
    outputs: [],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256"
      }
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "finishedVotings",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getFullOracleSet",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "newBurnStatus",
        type: "bool"
      },
      {
        internalType: "int256",
        name: "nonce",
        type: "int256"
      }
    ],
    name: "getNewBurnStatusId",
    outputs: [
      {
        internalType: "bytes32",
        name: "result",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "oracleSetHash",
        type: "int256"
      },
      {
        internalType: "address[]",
        name: "set",
        type: "address[]"
      }
    ],
    name: "getNewSetId",
    outputs: [
      {
        internalType: "bytes32",
        name: "result",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "receiver",
            type: "address"
          },
          {
            internalType: "uint64",
            name: "amount",
            type: "uint64"
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "int8",
                    name: "workchain",
                    type: "int8"
                  },
                  {
                    internalType: "bytes32",
                    name: "address_hash",
                    type: "bytes32"
                  }
                ],
                internalType: "struct TonUtils.TonAddress",
                name: "address_",
                type: "tuple"
              },
              {
                internalType: "bytes32",
                name: "tx_hash",
                type: "bytes32"
              },
              {
                internalType: "uint64",
                name: "lt",
                type: "uint64"
              }
            ],
            internalType: "struct TonUtils.TonTxID",
            name: "tx",
            type: "tuple"
          }
        ],
        internalType: "struct TonUtils.SwapData",
        name: "data",
        type: "tuple"
      }
    ],
    name: "getSwapDataId",
    outputs: [
      {
        internalType: "bytes32",
        name: "result",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256"
      }
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "isOracle",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "oraclesSet",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "receiver",
            type: "address"
          },
          {
            internalType: "uint64",
            name: "amount",
            type: "uint64"
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "int8",
                    name: "workchain",
                    type: "int8"
                  },
                  {
                    internalType: "bytes32",
                    name: "address_hash",
                    type: "bytes32"
                  }
                ],
                internalType: "struct TonUtils.TonAddress",
                name: "address_",
                type: "tuple"
              },
              {
                internalType: "bytes32",
                name: "tx_hash",
                type: "bytes32"
              },
              {
                internalType: "uint64",
                name: "lt",
                type: "uint64"
              }
            ],
            internalType: "struct TonUtils.TonTxID",
            name: "tx",
            type: "tuple"
          }
        ],
        internalType: "struct TonUtils.SwapData",
        name: "data",
        type: "tuple"
      },
      {
        components: [
          {
            internalType: "address",
            name: "signer",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes"
          }
        ],
        internalType: "struct TonUtils.Signature[]",
        name: "signatures",
        type: "tuple[]"
      }
    ],
    name: "voteForMinting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "oracleSetHash",
        type: "int256"
      },
      {
        internalType: "address[]",
        name: "newOracles",
        type: "address[]"
      },
      {
        components: [
          {
            internalType: "address",
            name: "signer",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes"
          }
        ],
        internalType: "struct TonUtils.Signature[]",
        name: "signatures",
        type: "tuple[]"
      }
    ],
    name: "voteForNewOracleSet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "newBurnStatus",
        type: "bool"
      },
      {
        internalType: "int256",
        name: "nonce",
        type: "int256"
      },
      {
        components: [
          {
            internalType: "address",
            name: "signer",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes"
          }
        ],
        internalType: "struct TonUtils.Signature[]",
        name: "signatures",
        type: "tuple[]"
      }
    ],
    name: "voteForSwitchBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
var WTON__factory = class {
  static createInterface() {
    return new utils35.Interface(_abi34);
  }
  static connect(address2, signerOrProvider) {
    return new Contract34(address2, _abi34, signerOrProvider);
  }
};
WTON__factory.abi = _abi34;

// src/crosschain/error.ts
var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2[ErrorCode2["DEFAULT"] = 0] = "DEFAULT";
  ErrorCode2[ErrorCode2["NO_REPRESENTATION_FOUND"] = 1] = "NO_REPRESENTATION_FOUND";
  ErrorCode2[ErrorCode2["AMOUNT_LESS_THAN_FEE"] = 2] = "AMOUNT_LESS_THAN_FEE";
  ErrorCode2[ErrorCode2["NO_TRANSIT_TOKEN"] = 3] = "NO_TRANSIT_TOKEN";
  ErrorCode2[ErrorCode2["MIN_THORCHAIN_AMOUNT_IN"] = 4] = "MIN_THORCHAIN_AMOUNT_IN";
  ErrorCode2[ErrorCode2["ADVISOR_ERROR"] = 5] = "ADVISOR_ERROR";
  ErrorCode2[ErrorCode2["AMOUNT_TOO_HIGH"] = 6] = "AMOUNT_TOO_HIGH";
  ErrorCode2[ErrorCode2["AMOUNT_TOO_LOW"] = 7] = "AMOUNT_TOO_LOW";
  ErrorCode2[ErrorCode2["MIN_TON_AMOUNT_IN"] = 8] = "MIN_TON_AMOUNT_IN";
  ErrorCode2[ErrorCode2["THORCHAIN_NOT_SUPPORTED_ADDRESS"] = 9] = "THORCHAIN_NOT_SUPPORTED_ADDRESS";
  return ErrorCode2;
})(ErrorCode || {});
var Error2 = class {
  constructor(message, code) {
    this.code = code || 0 /* DEFAULT */;
    this.message = message;
  }
};

// src/crosschain/revert.ts
import { MaxUint256 } from "@ethersproject/constants";
import { AddressZero as AddressZero4 } from "@ethersproject/constants/lib/addresses";
import JSBI13 from "jsbi";

// src/crosschain/chainUtils/evm.ts
import { parseUnits as parseUnits2 } from "@ethersproject/units";
import { BigNumber as BigNumber2, utils as utils36 } from "ethers";
import JSBI9 from "jsbi";

// src/crosschain/types.ts
var Field = /* @__PURE__ */ ((Field2) => {
  Field2["INPUT"] = "INPUT";
  Field2["OUTPUT"] = "OUTPUT";
  return Field2;
})(Field || {});

// src/crosschain/chainUtils/evm.ts
import flatMap from "lodash.flatmap";

// src/crosschain/mempool.ts
async function getFastestFee() {
  const response = await fetch("https://mempool.space/api/v1/fees/recommended");
  if (!response.ok) {
    const text = await response.text();
    const json = JSON.parse(text);
    throw new Error2(json.message ?? text);
  }
  const { fastestFee } = await response.json();
  return fastestFee;
}

// src/crosschain/chainUtils/btc.ts
import { BigNumber } from "ethers";
var getToBtcFee = async (syBtc, synthesis, dataProvider) => {
  let fee = await dataProvider.get(
    ["syntToMinFeeBTC", synthesis.address, syBtc.address],
    async () => {
      return synthesis.syntToMinFeeBTC(syBtc.address);
    },
    600
    // 10 minutes
  );
  try {
    const fastestFee = await dataProvider.get(["getFastestFee"], getFastestFee, 60);
    const recommendedFee = BigNumber.from(fastestFee * 300);
    if (recommendedFee.gt(fee)) {
      fee = recommendedFee;
    }
  } catch {
  }
  return new TokenAmount(syBtc, fee.toString());
};
function isBtcChainId(chainId) {
  if (!chainId)
    return false;
  return [3652501241 /* BTC_MAINNET */, 2782866891 /* BTC_MUTINY */, 675223068 /* BTC_TESTNET4 */].includes(chainId);
}

// src/crosschain/chainUtils/ton.ts
import { Address, beginCell, toNano } from "@ton/core";
import { JettonMaster } from "@ton/ton";
import { parseUnits } from "@ethersproject/units";
var TON_TOKEN_DECIMALS = 9;
var TON_ADDRESSES_MAP = [
  {
    evm: "0xA4f1b5C2fC9b97d4238B3dE3487ccaE2c36dE07C",
    ton: "EQD8AErK5HbmnftlHQuk8bXC_JuX1COLPeNIfMriw23gfO3I"
    // TON
  },
  {
    evm: "0x9328Eb759596C38a25f59028B146Fecdc3621Dfe",
    ton: "EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs"
    // USDT
  },
  {
    evm: "0x7eA393298D1077e19ec59F8e3FE8fe642738c08C",
    // TON testnet
    ton: "EQCgXxcoCXhsAiLyeG5-o5MpjRB34Z7Fn44_6P5kJzjAjKH4"
  },
  {
    evm: "0x46deec715e419a1f0f5959b5c8450894959d2dbf",
    ton: "EQD73uqQJHKAg140YSlG3uxxXkGaHw9ZWbXIRQiUlZ0tv79a"
    // USDT testnet
  }
];
var WTON_TOKEN = {
  decimals: TON_TOKEN_DECIMALS,
  name: "Wrapped Toncoin",
  symbol: "WTON",
  icons: {
    small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
    large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
  }
};
var NATIVE_TON_BRIDGE_OPTIONS = [
  {
    chainId: 11155111 /* SEPOLIA_TESTNET */,
    bridge: "0x3A1e6dA810637fb1c99fa0899b4F402A60E131D2",
    wTon: new Token({
      chainId: 11155111 /* SEPOLIA_TESTNET */,
      address: "0x331f40cc27aC106e1d5242CE633dc6436626a6F8",
      ...WTON_TOKEN
    }),
    bridgeTonAddr: "Ef-56ZiqKUbtp_Ax2Qg4Vwh7yXXJCO8cNJAb229J6XXe4-aC"
  },
  {
    chainId: 56 /* BSC_MAINNET */,
    bridge: "0x35D39bB2cbc51ce6c03f0306d0D8d56948b1f990",
    wTon: new Token({
      chainId: 56 /* BSC_MAINNET */,
      address: "0x76A797A59Ba2C17726896976B7B3747BfD1d220f",
      ...WTON_TOKEN
    }),
    bridgeTonAddr: "Ef9NXAIQs12t2qIZ-sRZ26D977H65Ol6DQeXc5_gUNaUys5r"
  },
  {
    chainId: 1 /* ETH_MAINNET */,
    bridge: "0x195A07D222a82b50DB84e8f47B71504D1E8C5fa2",
    wTon: new Token({
      chainId: 1 /* ETH_MAINNET */,
      address: "0x582d872A1B094FC48F5DE31D3B73F2D9bE47def1",
      ...WTON_TOKEN
    }),
    bridgeTonAddr: "Ef_dJMSh8riPi3BTUTtcxsWjG8RLKnLctNjAM4rw8NN-xWdr"
  }
];
function getTonTokenAddress(address2) {
  const found = TON_ADDRESSES_MAP.find((item) => {
    return item.evm.toLowerCase() === address2.toLowerCase();
  });
  if (!found) {
    throw new Error2(`TON address was not found by evm address ${address2}`);
  }
  return found.ton;
}
function isTonChainId(chainId) {
  if (!chainId)
    return false;
  return [85918 /* TON_MAINNET */, 85919 /* TON_TESTNET */].includes(chainId);
}
function callDataToCell(finalCallData) {
  const MAX_BYTES_IN_CELL = 127;
  function padBuffer(buf) {
    const targetLength = Math.ceil(buf.length / 32) * 32;
    const paddingLength = targetLength - buf.length;
    if (paddingLength === 0) {
      return buf;
    }
    const paddedBuffer = Buffer.alloc(targetLength);
    buf.copy(paddedBuffer);
    return paddedBuffer;
  }
  function createCell(buf) {
    const builder = beginCell();
    const bytesToStore = buf.subarray(0, MAX_BYTES_IN_CELL);
    builder.storeBuffer(bytesToStore);
    if (buf.length > MAX_BYTES_IN_CELL) {
      const remainingBuffer = buf.subarray(MAX_BYTES_IN_CELL);
      builder.storeRef(createCell(remainingBuffer));
    }
    return builder.endCell();
  }
  return createCell(padBuffer(finalCallData));
}
var Opcodes = {
  EpSynthesize: 2048159929,
  EpMetaSynthesize: 1585287200
};
var EventIds = {
  MPCChanged: BigInt(3246037916),
  BurnCompleted: BigInt(1659197634),
  SetJettonThreshold: BigInt(3303282619),
  OracleRequest: BigInt(2067945553)
};
var Bridge = class {
  constructor(address2, init) {
    this.address = address2;
    this.init = init;
  }
  // Creates forward payload for 'synthesize' endpoint
  static synthesizeMessage({
    stableBridgingFee,
    token,
    amount,
    chain2Address,
    receiveSide,
    oppositeBridge,
    revertableAddress,
    chainId
  }) {
    const payloadCell1 = beginCell().storeCoins(stableBridgingFee).storeAddress(token).storeCoins(amount).storeBuffer(chain2Address).storeBuffer(receiveSide).endCell();
    const payloadCell2 = beginCell().storeBuffer(oppositeBridge).storeBuffer(revertableAddress).storeUint(chainId, 256).endCell();
    return beginCell().storeUint(Opcodes.EpSynthesize, 32).storeRef(payloadCell1).storeRef(payloadCell2).endCell();
  }
  static metaSynthesizeMessage({
    stableBridgingFee,
    token,
    amount,
    chain2Address,
    receiveSide,
    oppositeBridge,
    chainId,
    finalReceiveSide,
    finalOffset,
    revertableAddress,
    swapTokens,
    secondDexRouter,
    secondSwapCallData,
    finalCallData
  }) {
    const payloadCell1 = beginCell().storeCoins(stableBridgingFee).storeAddress(token).storeCoins(amount).storeBuffer(chain2Address);
    const payloadCell2 = beginCell().storeBuffer(receiveSide).storeBuffer(oppositeBridge).storeUint(chainId, 256).storeBuffer(finalReceiveSide);
    const swapTokensCellBuilder = beginCell();
    swapTokens.forEach((tokenAddr) => swapTokensCellBuilder.storeBuffer(tokenAddr));
    const finalCallDataCell = callDataToCell(finalCallData);
    const secondSwapCallDataCell = callDataToCell(secondSwapCallData);
    const payloadCell3 = beginCell().storeUint(finalOffset, 256).storeBuffer(revertableAddress).storeUint(finalCallData.length, 64).storeRef(swapTokensCellBuilder.endCell()).storeRef(finalCallDataCell).storeBuffer(secondDexRouter).storeRef(secondSwapCallDataCell).storeUint(secondSwapCallData.length, 64).endCell();
    return beginCell().storeUint(Opcodes.EpMetaSynthesize, 32).storeRef(payloadCell1).storeRef(payloadCell2).storeRef(payloadCell3).endCell();
  }
};
var MIN_META_SYNTH_TONS = toNano("0.02");
var MIN_META_SYNTH_JETTONS = toNano("0.1");
var MIN_SYNTH_TONS = toNano("0.015");
var MIN_SYNTH_JETTONS = toNano("0.1");
var NOTIFICATION_PAYMENT = toNano("0.05");
function isWTon(symbiosis, token) {
  const wton = symbiosis.tokens().find((token2) => isTonChainId(token2.chainId) && token2.symbol?.toLowerCase() === "ton");
  if (!wton) {
    return false;
  }
  return wton.equals(token);
}
function isUsdt(symbiosis, token) {
  const usdt = symbiosis.tokens().find((token2) => isTonChainId(token2.chainId) && token2.symbol?.toLowerCase() === "usdt");
  if (!usdt) {
    return false;
  }
  return usdt.equals(token);
}
async function buildMetaSynthesize(params) {
  const {
    symbiosis,
    fee,
    from,
    to,
    revertableAddress,
    amountIn,
    chainIdOut,
    swapTokens,
    secondDexRouter,
    secondSwapCallData,
    finalReceiveSide,
    finalCallData,
    finalOffset,
    validUntil
  } = params;
  const tonChainConfig = symbiosis.config.chains.find((chain) => chain.id === amountIn.token.chainId);
  if (!tonChainConfig) {
    throw new Error2(`No TON chain config for chain ${amountIn.token.chainId}`);
  }
  const tonPortal = tonChainConfig.tonPortal;
  if (!tonPortal) {
    throw new Error2(`No TON portal for chain ${amountIn.token.chainId}`);
  }
  const tonTokenAddress = getTonTokenAddress(amountIn.token.address);
  const metaSynthesizeBody = Bridge.metaSynthesizeMessage({
    stableBridgingFee: BigInt(fee.raw.toString()),
    token: Address.parse(tonTokenAddress),
    // simulate jetton for gas token TEP-161
    amount: BigInt(amountIn.raw.toString()),
    chain2Address: Buffer.from(to.slice(2), "hex"),
    receiveSide: Buffer.from(symbiosis.synthesis(chainIdOut).address.slice(2), "hex"),
    oppositeBridge: Buffer.from(symbiosis.bridge(chainIdOut).address.slice(2), "hex"),
    chainId: BigInt(chainIdOut),
    revertableAddress: Buffer.from(revertableAddress.slice(2), "hex"),
    swapTokens: swapTokens.map((token) => Buffer.from(token.slice(2), "hex")),
    // sTON, sWTON host chain tokens
    secondDexRouter: Buffer.from(secondDexRouter.slice(2), "hex"),
    secondSwapCallData: Buffer.from(secondSwapCallData.slice(2), "hex"),
    finalCallData: Buffer.from(finalCallData.slice(2), "hex"),
    // metaBurnSyntheticToken host chain (synthesis.sol) hostchain (include extra swap on 3-rd chain)
    finalReceiveSide: Buffer.from(finalReceiveSide.slice(2), "hex"),
    // synthesis host chain address
    finalOffset: BigInt(finalOffset)
  });
  const tonFee = new TokenAmount(amountIn.token, MIN_META_SYNTH_TONS);
  if (isWTon(symbiosis, amountIn.token)) {
    return {
      validUntil,
      messages: [
        {
          address: tonPortal,
          amount: amountIn.add(tonFee).raw.toString(),
          payload: metaSynthesizeBody.toBoc().toString("base64")
        }
      ]
    };
  } else if (isUsdt(symbiosis, amountIn.token)) {
    const tonTokenAddress2 = getTonTokenAddress(amountIn.token.address);
    const jettonMaster = JettonMaster.create(Address.parse(tonTokenAddress2));
    const tonClient = await symbiosis.getTonClient();
    const provider = tonClient.provider(jettonMaster.address);
    const jettonWalletAddress = await jettonMaster.getWalletAddress(provider, Address.parse(from));
    const cell = beginCell().storeUint(260734629, 32).storeUint(0, 64).storeCoins(BigInt(amountIn.raw.toString())).storeAddress(Address.parse(tonPortal)).storeAddress(Address.parse(from)).storeBit(0).storeCoins(NOTIFICATION_PAYMENT).storeMaybeRef(metaSynthesizeBody).endCell();
    return {
      validUntil,
      messages: [
        {
          address: jettonWalletAddress.toString(),
          amount: MIN_META_SYNTH_JETTONS.toString(),
          payload: cell.toBoc().toString("base64")
        }
      ]
    };
  }
  throw new Error2("No TON transaction request. Unsupported token");
}
async function buildSynthesize(params) {
  const { symbiosis, fee, from, amountIn, to, chainIdOut, validUntil, revertableAddress } = params;
  const tonChainConfig = symbiosis.config.chains.find((chain) => chain.id === amountIn.token.chainId);
  if (!tonChainConfig) {
    throw new Error2(`No TON chain config for chain ${amountIn.token.chainId}`);
  }
  const tonPortal = tonChainConfig.tonPortal;
  if (!tonPortal) {
    throw new Error2(`No TON portal for chain ${amountIn.token.chainId}`);
  }
  const tonTokenAddress = getTonTokenAddress(amountIn.token.address);
  const synthesizeMessage = Bridge.synthesizeMessage({
    stableBridgingFee: BigInt(fee.raw.toString()),
    token: Address.parse(tonTokenAddress),
    amount: BigInt(amountIn.raw.toString()),
    chain2Address: Buffer.from(to.slice(2), "hex"),
    receiveSide: Buffer.from(symbiosis.synthesis(chainIdOut).address.slice(2), "hex"),
    oppositeBridge: Buffer.from(symbiosis.bridge(chainIdOut).address.slice(2), "hex"),
    revertableAddress: Buffer.from(revertableAddress.slice(2), "hex"),
    chainId: BigInt(chainIdOut)
  });
  const tonFee = new TokenAmount(amountIn.token, MIN_SYNTH_TONS);
  if (isWTon(symbiosis, amountIn.token)) {
    return {
      validUntil,
      messages: [
        {
          address: tonPortal,
          amount: amountIn.add(tonFee).raw.toString(),
          payload: synthesizeMessage.toBoc().toString("base64")
        }
      ]
    };
  } else if (isUsdt(symbiosis, amountIn.token)) {
    const tonTokenAddress2 = getTonTokenAddress(amountIn.token.address);
    const jettonMaster = JettonMaster.create(Address.parse(tonTokenAddress2));
    const tonClient = await symbiosis.getTonClient();
    const provider = tonClient.provider(jettonMaster.address);
    const jettonWalletAddress = await jettonMaster.getWalletAddress(provider, Address.parse(from));
    const cell = beginCell().storeUint(260734629, 32).storeUint(0, 64).storeCoins(BigInt(amountIn.raw.toString())).storeAddress(Address.parse(tonPortal)).storeAddress(Address.parse(from)).storeBit(0).storeCoins(NOTIFICATION_PAYMENT).storeMaybeRef(synthesizeMessage).endCell();
    return {
      validUntil,
      messages: [
        {
          address: jettonWalletAddress.toString(),
          amount: MIN_SYNTH_JETTONS.toString(),
          payload: cell.toBoc().toString("base64")
        }
      ]
    };
  }
  throw new Error2("No TON transaction request. Unsupported token");
}
function tonAdvisorMock(feeToken) {
  let feeRaw = "0.1";
  if (feeToken.symbol?.toLowerCase().includes("usdt")) {
    feeRaw = "0.6";
  }
  return {
    fee: new TokenAmount(feeToken, parseUnits(feeRaw, feeToken.decimals).toString()),
    save: new TokenAmount(feeToken, "0")
  };
}

// src/crosschain/chainUtils/evm.ts
function isEvmChainId(chainId) {
  if (!chainId)
    return false;
  return !isBtcChainId(chainId) && !isTronChainId(chainId) && !isTonChainId(chainId);
}
var canOneInch = (chainId) => {
  return ONE_INCH_CHAINS.includes(chainId);
};
function getInternalId({ contractAddress, requestCount, chainId }) {
  return utils36.solidityKeccak256(["address", "uint256", "uint256"], [contractAddress, requestCount, chainId]);
}
function getExternalId({
  internalId,
  contractAddress,
  revertableAddress,
  chainId
}) {
  return utils36.solidityKeccak256(
    ["bytes32", "address", "address", "uint256"],
    [internalId, contractAddress, revertableAddress, chainId]
  );
}
function calculateGasMargin(value) {
  return value.mul(BigNumber2.from(1e4).add(BigNumber2.from(5e3))).div(BigNumber2.from(1e4));
}
function computeTradePriceBreakdown(trade, dexFee) {
  const BASE_FEE = new Percent(JSBI9.BigInt(dexFee || 30), JSBI9.BigInt(1e4));
  const ONE_HUNDRED_PERCENT = new Percent(JSBI9.BigInt(1e4), JSBI9.BigInt(1e4));
  const INPUT_FRACTION_AFTER_FEE = ONE_HUNDRED_PERCENT.subtract(BASE_FEE);
  const realizedLPFee = !trade ? void 0 : ONE_HUNDRED_PERCENT.subtract(
    trade.route.pairs.reduce(
      (currentFee) => currentFee.multiply(INPUT_FRACTION_AFTER_FEE),
      ONE_HUNDRED_PERCENT
    )
  );
  const priceImpactWithoutFeeFraction = trade && realizedLPFee ? trade.priceImpact.subtract(realizedLPFee) : void 0;
  const priceImpactWithoutFeePercent = priceImpactWithoutFeeFraction ? new Percent(
    JSBI9.multiply(priceImpactWithoutFeeFraction?.numerator, JSBI9.BigInt("-1")),
    priceImpactWithoutFeeFraction?.denominator
  ) : void 0;
  const realizedLPFeeAmount = realizedLPFee && trade && new TokenAmount(trade.inputAmount.token, realizedLPFee.multiply(trade.inputAmount.raw).quotient);
  return {
    priceImpactWithoutFee: priceImpactWithoutFeePercent,
    realizedLPFee: realizedLPFeeAmount
  };
}
function basisPointsToPercent(num) {
  return new Percent(JSBI9.BigInt(Math.floor(num)), JSBI9.BigInt(1e4));
}
function getMinAmount(slippage, amount) {
  const slippageTolerance = basisPointsToPercent(slippage);
  return new Fraction(ONE).subtract(slippageTolerance).multiply(amount).quotient;
}
function computeSlippageAdjustedAmounts(trade, allowedSlippage) {
  const pct = basisPointsToPercent(allowedSlippage);
  return {
    ["INPUT" /* INPUT */]: trade?.maximumAmountIn(pct),
    ["OUTPUT" /* OUTPUT */]: trade?.minimumAmountOut(pct)
  };
}
function calculatePriceImpact(tokenAmountIn, tokenAmountOut) {
  const typedValueParsed = parseUnits2(
    tokenAmountOut.toExact(tokenAmountIn.token.decimals),
    tokenAmountIn.token.decimals
  ).toString();
  if (typedValueParsed === "0") {
    throw new Error2("Cannot parse amountOut with decimals");
  }
  const amountIn = tokenAmountIn.raw;
  const amountOut = JSBI9.BigInt(typedValueParsed);
  const diff = JSBI9.subtract(amountOut, amountIn);
  const value = JSBI9.divide(JSBI9.multiply(diff, BIPS_BASE), amountIn);
  return new Percent(value, BIPS_BASE);
}
var GetLogTimeoutExceededError = class extends Error2 {
  constructor(filter) {
    super(`Timed out waiting for logs matching filter: ${JSON.stringify(filter)}`);
    this.filter = filter;
  }
};
var DEFAULT_EXCEED_DELAY = 1e3 * 60 * 20;
function _promiseRaceResolved(promises) {
  let rejectCounter = 0;
  const totalPromises = promises.length;
  return new Promise((resolve, reject) => {
    const onReject = () => {
      rejectCounter++;
      if (rejectCounter === totalPromises) {
        reject(new Error2("All promises were rejected."));
      }
    };
    promises.forEach((promise) => {
      Promise.resolve(promise).then(resolve).catch(onReject);
    });
  });
}
async function getLogWithTimeout({
  symbiosis,
  chainId,
  filter,
  exceedDelay: exceedTimeout = DEFAULT_EXCEED_DELAY
}) {
  const spareRpcs = symbiosis.config.chains.find((chain) => chain.id === chainId)?.spareRpcs ?? [];
  const spareProviders = spareRpcs.map((rpc) => symbiosis.getProvider(chainId, rpc));
  const provider = symbiosis.getProvider(chainId);
  let activeFilter = filter;
  if (!activeFilter.fromBlock) {
    const fromBlock = await symbiosis.getFromBlockWithOffset(chainId);
    activeFilter = { ...filter, fromBlock };
  }
  return new Promise((resolve, reject) => {
    const period = 1e3 * 10;
    let pastTime = 0;
    let logs = [];
    const getLogs = async () => {
      pastTime += period;
      if (pastTime > exceedTimeout) {
        clearInterval(interval);
        reject(new GetLogTimeoutExceededError(activeFilter));
        return;
      }
      try {
        logs = await provider.getLogs(activeFilter);
      } catch (error) {
        logs = await _promiseRaceResolved(
          spareProviders.map((spareProvider) => spareProvider.getLogs(activeFilter))
        );
      } finally {
        if (logs.length > 0) {
          resolve(logs[0]);
          clearInterval(interval);
        }
      }
    };
    const interval = setInterval(getLogs, period);
  });
}
var TELOS_MPC_ADDRESS = "0xDcB7d65b15436CE9B608864ACcff75871C6556FC";
async function prepareTransactionRequest(transactionRequest, signer) {
  const { provider } = signer;
  if (!provider) {
    throw new Error2("Signer has no provider");
  }
  const preparedTransactionRequest = { ...transactionRequest };
  let { from } = transactionRequest;
  if (transactionRequest.chainId === 40 /* TELOS_MAINNET */) {
    from = TELOS_MPC_ADDRESS;
  }
  const gasLimit = await provider.estimateGas({ ...transactionRequest, from });
  preparedTransactionRequest.gasLimit = calculateGasMargin(gasLimit);
  const { chainId: requestChainId } = preparedTransactionRequest;
  if (requestChainId === 137 /* MATIC_MAINNET */ || requestChainId === 80001 /* MATIC_MUMBAI */) {
    const gasPrice = await signer.getGasPrice();
    preparedTransactionRequest.gasPrice = gasPrice.mul(2);
  }
  return preparedTransactionRequest;
}
function getAllPairCombinations(tokenIn, tokenOut) {
  const chainId = tokenIn.chainId;
  const bases = BASES_TO_CHECK_TRADES_AGAINST[chainId];
  if (!bases) {
    throw new Error2("Bases not found");
  }
  const basePairs = flatMap(
    bases,
    (base) => bases.map((otherBase) => [base, otherBase])
  ).filter(([t0, t1]) => t0.address !== t1.address);
  const [tokenA, tokenB] = [wrappedToken(tokenIn), wrappedToken(tokenOut)];
  if (!tokenA || !tokenB) {
    return [];
  }
  return [
    // the direct pair
    [tokenA, tokenB],
    // token A against all bases
    ...bases.map((base) => [tokenA, base]),
    // token B against all bases
    ...bases.map((base) => [tokenB, base]),
    // each base against all bases
    ...basePairs
  ].filter((tokens) => Boolean(tokens[0] && tokens[1])).filter(([t0, t1]) => t0.address !== t1.address).filter(([t0, t1]) => {
    if (!chainId)
      return true;
    const customBases = CUSTOM_BASES[chainId];
    if (!customBases)
      return true;
    const customBasesA = customBases[t0.address];
    const customBasesB = customBases[t1.address];
    if (!customBasesA && !customBasesB)
      return true;
    if (customBasesA && !customBasesA.find((base) => t1.equals(base)))
      return false;
    if (customBasesB && !customBasesB.find((base) => t0.equals(base)))
      return false;
    return true;
  });
}
function splitSlippage(totalSlippage, hasTradeA, hasTradeC) {
  const MINIMUM_SLIPPAGE = 20;
  if (totalSlippage < MINIMUM_SLIPPAGE) {
    throw new Error2("Slippage cannot be less than 0.2%");
  }
  let swapsCount = 1;
  let extraSwapsCount = 0;
  if (hasTradeA) {
    extraSwapsCount += 1;
  }
  if (hasTradeC) {
    extraSwapsCount += 1;
  }
  swapsCount += extraSwapsCount;
  const slippage = Math.floor(totalSlippage * 10 / swapsCount) / 10;
  const MAX_STABLE_SLIPPAGE = 50;
  if (slippage > MAX_STABLE_SLIPPAGE) {
    const diff = slippage - MAX_STABLE_SLIPPAGE;
    const addition = extraSwapsCount > 0 ? Math.floor(diff * 10 / extraSwapsCount) / 10 : 0;
    return {
      A: hasTradeA ? slippage + addition : 0,
      B: MAX_STABLE_SLIPPAGE,
      C: hasTradeC ? totalSlippage : 0
    };
  }
  return {
    A: hasTradeA ? slippage : 0,
    B: slippage,
    C: hasTradeC ? totalSlippage : 0
  };
}

// src/crosschain/revertRequest.ts
import { parseUnits as parseUnits3 } from "@ethersproject/units";
import { utils as utils37 } from "ethers";
var PendingRequestState = /* @__PURE__ */ ((PendingRequestState2) => {
  PendingRequestState2[PendingRequestState2["Default"] = 0] = "Default";
  PendingRequestState2[PendingRequestState2["Sent"] = 1] = "Sent";
  PendingRequestState2[PendingRequestState2["Reverted"] = 2] = "Reverted";
  return PendingRequestState2;
})(PendingRequestState || {});
var findSourceChainData = async (symbiosis, chainIdFrom, chainIdTo, txHash, revertableAddress, omniPoolConfig, synthesizeRequestFinder) => {
  const synthesis = symbiosis.synthesis(omniPoolConfig.chainId);
  const filter = synthesis.filters.SynthesizeCompleted();
  const tx = await synthesis.provider.getTransactionReceipt(txHash);
  const foundSynthesizeCompleted = tx.logs.find((i) => {
    return i.topics[0] === filter.topics?.[0];
  });
  if (!foundSynthesizeCompleted)
    return void 0;
  const externalId = foundSynthesizeCompleted.topics?.[1];
  const chains2 = symbiosis.chains().filter((chain) => {
    return chain.id !== chainIdFrom && chain.id !== chainIdTo;
  });
  const promises = chains2.map((chain) => {
    return findSynthesizeRequestOnChain(symbiosis, chain.id, revertableAddress, externalId, omniPoolConfig);
  });
  const results = await Promise.allSettled(promises);
  let sourceChainId = void 0;
  let fromAddress = void 0;
  let error = void 0;
  for (let i = 0; i < results.length; i++) {
    const item = results[i];
    const chainId = chains2[i].id;
    if (item.status !== "fulfilled") {
      error = `Error occurred on chain ${chainId} while loading findSynthesizeRequestOnChain`;
      console.error(error, item);
      continue;
    }
    if (item.value) {
      sourceChainId = chainId;
      fromAddress = item.value.args.from;
      break;
    }
  }
  if (error && !synthesizeRequestFinder) {
    throw new Error2(error);
  }
  if (!fromAddress && synthesizeRequestFinder) {
    const data = await synthesizeRequestFinder(externalId);
    sourceChainId = data?.sourceChainId;
    fromAddress = data?.fromAddress;
  }
  if (!fromAddress || !sourceChainId) {
    return;
  }
  return {
    sourceChainId,
    fromAddress
  };
};
var findSynthesizeRequestOnChain = async (symbiosis, chainId, revertableAddress, originExternalId, omniPoolConfig) => {
  const portal = symbiosis.portal(chainId);
  const eventFragment = portal.interface.getEvent("SynthesizeRequest");
  const topics = portal.interface.encodeFilterTopics(eventFragment, [
    void 0,
    void 0,
    // from
    omniPoolConfig.chainId,
    // chains IDs
    revertableAddress
    // revertableAddress
  ]);
  const blockOffset = symbiosis.filterBlockOffset(chainId);
  const toBlock = await portal.provider.getBlockNumber();
  const fromBlock = toBlock - blockOffset;
  const events = await portal.queryFilter({ topics }, fromBlock, toBlock);
  const synthesis = symbiosis.synthesis(omniPoolConfig.chainId);
  return events.find((e) => {
    const { id } = e.args;
    const externalId = getExternalId({
      internalId: id,
      contractAddress: synthesis.address,
      revertableAddress,
      chainId: omniPoolConfig.chainId
    });
    return originExternalId === externalId;
  });
};
var isSynthesizeV2 = async (symbiosis, chainId, txHash) => {
  const id = utils37.id(
    "metaBurnSyntheticToken((uint256,uint256,bytes32,address,address,address,bytes,uint256,address,address,address,address,uint256,bytes32))"
  );
  const hash = id.slice(2, 10);
  const tx = await symbiosis.getProvider(chainId).getTransaction(txHash);
  return tx.data.includes(hash);
};
var RevertRequest = class {
  constructor(symbiosis, chainId, transactionHash) {
    this.symbiosis = symbiosis;
    this.chainId = chainId;
    this.transactionHash = transactionHash;
  }
  async init({ validateState = false, synthesizeRequestFinder }) {
    const provider = this.symbiosis.getProvider(this.chainId);
    await provider.ready;
    const receipt = await provider.getTransactionReceipt(this.transactionHash);
    if (!receipt) {
      throw new Error2(
        `Tx ${this.transactionHash} does not exist on chain ${this.chainId}. Provider ${provider.connection.url}`
      );
    }
    let type = "synthesize";
    let log = this.findSynthesizeRequest(receipt);
    if (!log) {
      type = "burn";
      log = this.findBurnRequest(receipt);
    }
    if (!log) {
      throw new Error2("Tx does not contain mint/burn event and cannot be reverted");
    }
    const { id, amount, token: tokenAddress, from: fromOrigin, to, chainID, revertableAddress } = log.args;
    const chainIdTo = chainID.toNumber();
    let chainIdFrom = this.chainId;
    let from = fromOrigin;
    const token = this.symbiosis.findToken(tokenAddress, this.chainId);
    if (!token) {
      throw new Error2(`Cannot find token ${tokenAddress} at chain ${this.chainId}`);
    }
    const omniPoolConfig = this.symbiosis.getOmniPoolByToken(token);
    if (!omniPoolConfig) {
      throw new Error2(`Cannot find omni pool config by token ${tokenAddress}`);
    }
    let fromTokenAmount = new TokenAmount(token, amount);
    const originalFromTokenAmount = fromTokenAmount;
    if (type === "synthesize") {
      const isV2 = await isSynthesizeV2(this.symbiosis, this.chainId, receipt.transactionHash);
      if (isV2) {
        type = "synthesize-v2";
      }
    }
    if (type === "burn") {
      const metaRouterAddress = this.symbiosis.metaRouter(omniPoolConfig.chainId).address;
      if (from.toLowerCase() === metaRouterAddress.toLowerCase()) {
        type = "burn-v2";
        const data = await findSourceChainData(
          this.symbiosis,
          this.chainId,
          chainIdTo,
          receipt.transactionHash,
          revertableAddress,
          omniPoolConfig,
          synthesizeRequestFinder
        );
        if (data) {
          const { sourceChainId, fromAddress } = data;
          from = fromAddress;
          const sourceChainToken = this.symbiosis.transitToken(sourceChainId, omniPoolConfig);
          chainIdFrom = sourceChainToken.chainId;
          fromTokenAmount = new TokenAmount(
            sourceChainToken,
            parseUnits3(
              fromTokenAmount.toExact(sourceChainToken.decimals),
              sourceChainToken.decimals
            ).toString()
          );
        } else {
          const transitToken = this.symbiosis.transitToken(chainIdTo, omniPoolConfig);
          type = "burn-v2-revert";
          fromTokenAmount = new TokenAmount(transitToken, fromTokenAmount.raw);
        }
      }
    }
    let contractAddress;
    if (["synthesize", "synthesize-v2"].includes(type)) {
      contractAddress = this.symbiosis.synthesis(chainIdTo).address;
    } else {
      contractAddress = this.symbiosis.portal(chainIdTo).address;
    }
    const externalId = getExternalId({
      internalId: id,
      contractAddress,
      revertableAddress,
      chainId: chainIdTo
    });
    let state = 0 /* Default */;
    if (validateState) {
      if (["synthesize", "synthesize-v2"].includes(type)) {
        state = await this.symbiosis.synthesis(chainIdTo).synthesizeStates(externalId);
      } else {
        state = await this.symbiosis.portal(chainIdTo).unsynthesizeStates(externalId);
      }
      if (state === 1) {
        throw new Error2(`Tx is success and cannot be reverted.`);
      }
    }
    let revertChainId = chainIdTo;
    if (type === "synthesize-v2") {
      revertChainId = this.chainId;
    }
    return {
      internalId: id,
      externalId,
      transactionHash: this.transactionHash,
      state,
      type,
      from,
      to,
      revertableAddress,
      chainIdFrom,
      chainIdTo,
      fromTokenAmount,
      revertChainId,
      originalFromTokenAmount
    };
  }
  findSynthesizeRequest(receipt) {
    const contract = Portal__factory.createInterface();
    const event = contract.events["SynthesizeRequest(bytes32,address,uint256,address,address,uint256,address)"];
    const log = receipt.logs.find((log2) => {
      const topic = contract.getEventTopic(event);
      return log2.topics[0].toLowerCase() === topic.toLowerCase();
    });
    if (!log)
      return null;
    return contract.parseLog(log);
  }
  findBurnRequest(receipt) {
    const contract = Synthesis__factory.createInterface();
    const burnRequest = contract.events["BurnRequest(bytes32,address,uint256,address,address,uint256,address)"];
    const log = receipt.logs.find((log2) => {
      const topic = contract.getEventTopic(burnRequest);
      return log2.topics[0].toLowerCase() === topic.toLowerCase();
    });
    if (!log)
      return null;
    return contract.parseLog(log);
  }
};

// src/crosschain/legacyWaitForComplete.ts
var TransactionStuckError = class extends Error {
  constructor(pendingRequest) {
    super(`Transaction stuck: ${JSON.stringify(pendingRequest)}`);
    this.pendingRequest = pendingRequest;
  }
};
var LegacyWaitForComplete = class {
  constructor({ direction, symbiosis, chainIdOut, revertableAddress, chainIdIn }) {
    this.direction = direction;
    this.symbiosis = symbiosis;
    this.chainIdOut = chainIdOut;
    this.revertableAddress = revertableAddress;
    this.chainIdIn = chainIdIn;
  }
  async waitForComplete(receipt) {
    const filter = this.buildOtherSideFilter(receipt);
    return getLogWithTimeout({
      symbiosis: this.symbiosis,
      chainId: this.chainIdOut,
      filter
    }).catch((e) => {
      if (!(e instanceof GetLogTimeoutExceededError)) {
        throw e;
      }
      const pendingRequest = this.getPendingRequest(receipt);
      if (!pendingRequest) {
        throw e;
      }
      throw new TransactionStuckError(pendingRequest);
    });
  }
  getRequestArgs(receipt) {
    let contract;
    let eventName;
    if (this.direction === "burn") {
      contract = this.symbiosis.synthesis(this.chainIdIn);
      eventName = "BurnRequest";
    } else {
      contract = this.symbiosis.portal(this.chainIdIn);
      eventName = "SynthesizeRequest";
    }
    let args;
    receipt.logs.forEach((log) => {
      let event;
      try {
        event = contract.interface.parseLog(log);
      } catch {
        return;
      }
      if (event.name === eventName) {
        args = event.args;
      }
    });
    return args;
  }
  buildOtherSideFilter(receipt) {
    if (!this.chainIdOut) {
      throw new Error("Tokens are not set");
    }
    const args = this.getRequestArgs(receipt);
    if (!args) {
      throw new Error("Log not found");
    }
    const requestId = args.id;
    const receiveSide = this.direction === "burn" ? this.symbiosis.portal(this.chainIdOut).address : this.symbiosis.synthesis(this.chainIdOut).address;
    const externalId = getExternalId({
      internalId: requestId,
      contractAddress: receiveSide,
      revertableAddress: this.revertableAddress,
      chainId: this.chainIdOut
    });
    const event = this.direction === "burn" ? this.symbiosis.portal(this.chainIdOut).filters.BurnCompleted() : this.symbiosis.synthesis(this.chainIdOut).filters.SynthesizeCompleted();
    if (!event || !event.topics || event.topics.length === 0) {
      throw new Error("Event not found");
    }
    const topic0 = event.topics[0];
    return {
      address: receiveSide,
      topics: [topic0, externalId]
    };
  }
  getPendingRequest(receipt) {
    const args = this.getRequestArgs(receipt);
    if (!args) {
      return;
    }
    const { id, amount: amountFrom, token: tokenIdFrom, from, to, chainID, revertableAddress } = args;
    const chainId = chainID.toNumber();
    const fromToken = this.symbiosis.findToken(tokenIdFrom, this.chainIdIn);
    if (!fromToken) {
      return;
    }
    const fromTokenAmount = new TokenAmount(fromToken, amountFrom.toHexString());
    let contractAddress;
    let type;
    if (this.direction === "burn") {
      contractAddress = this.symbiosis.synthesis(this.chainIdIn).address;
      type = "burn";
    } else {
      contractAddress = this.symbiosis.portal(this.chainIdIn).address;
      type = "synthesize";
    }
    const externalId = getExternalId({
      internalId: id,
      contractAddress,
      revertableAddress,
      chainId
    });
    return {
      chainIdFrom: this.chainIdIn,
      chainIdTo: chainId,
      externalId,
      from,
      fromTokenAmount,
      internalId: id,
      revertableAddress,
      state: 0 /* Default */,
      to,
      transactionHash: receipt.transactionHash,
      type,
      revertChainId: chainId,
      // FIXME ?? depends of type
      originalFromTokenAmount: fromTokenAmount
      // FIXME ?? depends of type
    };
  }
};

// src/crosschain/trade/aggregatorTrade.ts
import { utils as utils38 } from "ethers";

// src/crosschain/trade/getTradePriceImpact.ts
import { BigNumber as BigNumber3 } from "@ethersproject/bignumber";
import { formatUnits } from "@ethersproject/units";
import JSBI10 from "jsbi";

// src/crosschain/multicall.ts
var NoMulticallAddressError = class extends Error {
  constructor(chainId) {
    super(
      `Failed to create Multicall instance. We do not know the multicall address on this network. ChainId: ${chainId}`
    );
  }
};
async function getMulticall(provider) {
  const { chainId } = await provider.getNetwork();
  const address2 = MULTICALL_ADDRESSES[chainId];
  if (!address2) {
    throw new NoMulticallAddressError(chainId);
  }
  return Multicall__factory.connect(address2, provider);
}

// src/crosschain/trade/getTradePriceImpact.ts
async function getRateToEth(tokens, oracle) {
  const calls = tokens.map((token) => ({
    target: oracle.address,
    callData: oracle.interface.encodeFunctionData(
      "getRateToEth",
      [token.address, true]
      // use wrapper
    )
  }));
  const multicall = await getMulticall(oracle.provider);
  return multicall.callStatic.tryAggregate(false, calls);
}
async function getTradePriceImpact({
  dataProvider,
  oracle,
  tokenAmountIn,
  tokenAmountOut
}) {
  const tokens = [wrappedToken(tokenAmountIn.token), wrappedToken(tokenAmountOut.token)];
  const aggregated = await dataProvider.getOneInchRateToEth(tokens, oracle);
  const denominator = BigNumber3.from(10).pow(18);
  const data = aggregated.map(([success, returnData], i) => {
    if (!success || returnData === "0x")
      return;
    const result = oracle.interface.decodeFunctionResult("getRateToEth", returnData);
    const numerator = BigNumber3.from(10).pow(tokens[i].decimals);
    return BigNumber3.from(result.weightedRate).mul(numerator).div(denominator);
  });
  if (!data[0] || !data[1]) {
    throw new Error("OneInch oracle: cannot to receive rate to ETH");
  }
  const multiplierPow = 18;
  const multiplier = BigNumber3.from(10).pow(multiplierPow);
  const spot = data[1].mul(multiplier).div(data[0]);
  const inBn = BigNumber3.from(tokenAmountIn.raw.toString()).mul(BigNumber3.from(10).pow(tokenAmountOut.token.decimals));
  const outBn = BigNumber3.from(tokenAmountOut.raw.toString()).mul(
    BigNumber3.from(10).pow(tokenAmountIn.token.decimals)
  );
  const real = inBn.mul(multiplier).div(outBn);
  const impact = real.mul(multiplier).div(spot);
  const impactNumber = 1 - Number.parseFloat(formatUnits(impact, multiplierPow));
  return new Percent(parseInt(`${impactNumber * JSBI10.toNumber(BIPS_BASE)}`).toString(), BIPS_BASE);
}

// src/crosschain/trade/oneInchTrade.ts
var OneInchTrade = class {
  constructor(symbiosis, tokenAmountIn, tokenOut, from, to, slippage, oracle, dataProvider, protocols) {
    this.tradeType = "1inch";
    this.symbiosis = symbiosis;
    this.tokenAmountIn = tokenAmountIn;
    this.tokenOut = tokenOut;
    this.from = from;
    this.to = to;
    this.slippage = slippage;
    this.oracle = oracle;
    this.dataProvider = dataProvider;
    this.protocols = protocols || [];
  }
  static isAvailable(chainId) {
    return canOneInch(chainId);
  }
  async init() {
    let fromTokenAddress = this.tokenAmountIn.token.address;
    if (this.tokenAmountIn.token.isNative) {
      fromTokenAddress = NATIVE_TOKEN_ADDRESS;
    }
    let toTokenAddress = this.tokenOut.address;
    if (this.tokenOut.isNative) {
      toTokenAddress = NATIVE_TOKEN_ADDRESS;
    }
    const protocolsOrigin = await this.dataProvider.getOneInchProtocols(this.tokenAmountIn.token.chainId);
    let protocols = this.protocols.filter((x) => protocolsOrigin.includes(x));
    if (protocols.length === 0) {
      protocols = protocolsOrigin;
    }
    const searchParams = new URLSearchParams();
    searchParams.set("src", fromTokenAddress);
    searchParams.set("dst", toTokenAddress);
    searchParams.set("amount", this.tokenAmountIn.raw.toString());
    searchParams.set("from", this.from);
    searchParams.set("slippage", (this.slippage / 100).toFixed(4));
    searchParams.set("receiver", this.to);
    searchParams.set("disableEstimate", "true");
    searchParams.set("allowPartialFill", "false");
    searchParams.set("usePatching", "true");
    searchParams.set("protocols", protocols.join(","));
    let json;
    try {
      json = await this.symbiosis.makeOneInchRequest(`${this.tokenAmountIn.token.chainId}/swap`, searchParams);
    } catch (error) {
      const message = error instanceof Error ? error.message : "Unknown error";
      throw new Error(`Cannot get 1inch swap on chain ${this.tokenAmountIn.token.chainId}: ${message}`);
    }
    const tx = json["tx"];
    const amountOutRaw = json["toAmount"];
    this.routerAddress = tx.to;
    this.callData = tx.data;
    this.callDataOffset = this.getOffset(tx.data);
    this.amountOut = new TokenAmount(this.tokenOut, amountOutRaw);
    const amountOutMinRaw = getMinAmount(this.slippage, amountOutRaw);
    this.amountOutMin = new TokenAmount(this.tokenOut, amountOutMinRaw);
    this.route = [this.tokenAmountIn.token, this.tokenOut];
    this.priceImpact = await getTradePriceImpact({
      dataProvider: this.dataProvider,
      oracle: this.oracle,
      tokenAmountIn: this.tokenAmountIn,
      tokenAmountOut: this.amountOut
    });
    return this;
  }
  static async getProtocols(symbiosis, chainId) {
    try {
      const json = await symbiosis.makeOneInchRequest(`${chainId}/liquidity-sources`);
      return json["protocols"].reduce((acc, protocol) => {
        if (protocol.id.includes("ONE_INCH_LIMIT_ORDER")) {
          return acc;
        }
        if (protocol.id.includes("PMM")) {
          return acc;
        }
        acc.push(protocol.id);
        return acc;
      }, []);
    } catch (error) {
      const message = error instanceof Error ? error.message : "Unknown error";
      throw new Error(`Cannot get 1inch swap on chain ${chainId}: ${message}`);
    }
  }
  getOffset(callData) {
    const methods = [
      // V4
      {
        // swap(address,(address,address,address,address,uint256,uint256,uint256,bytes),bytes)
        sigHash: "7c025200",
        offset: 260
      },
      {
        // clipperSwapTo(address,address,address,uint256,uint256)
        sigHash: "9994dd15",
        offset: 132
      },
      {
        // fillOrderRFQTo((uint256,address,address,address,address,uint256,uint256),bytes,uint256,uint256,address)
        sigHash: "baba5855",
        offset: 292
      },
      {
        // uniswapV3SwapTo(address,uint256,uint256,uint256[])
        sigHash: "bc80f1a8",
        offset: 68
      },
      // V5
      {
        // clipperSwapTo(address,address,address,address,uint256,uint256,uint256,bytes32,bytes32)
        sigHash: "093d4fa5",
        offset: 164
        // +
      },
      {
        // swap(address,(address,address,address,address,uint256,uint256,uint256),bytes,bytes)
        sigHash: "12aa3caf",
        offset: 196
        // +/-
      },
      {
        // fillOrderRFQTo((uint256,address,address,address,address,uint256,uint256),bytes,uint256,address)
        sigHash: "5a099843",
        offset: 196
      },
      {
        // unoswapTo(address,address,uint256,uint256,uint256[])
        sigHash: "f78dc253",
        offset: 100
      },
      {
        // uniswapV3SwapTo(address,uint256,uint256,uint256[])
        sigHash: "bc80f1a8",
        offset: 68
      }
    ];
    const sigHash = callData.slice(2, 10);
    const method = methods.find((i) => {
      return i.sigHash === sigHash;
    });
    return method?.offset;
  }
};

// src/crosschain/trade/openOceanTrade.ts
import BigNumber4 from "bignumber.js";
import { AddressZero as AddressZero2 } from "@ethersproject/constants/lib/addresses";
var OPEN_OCEAN_NETWORKS = {
  // ---  1inch supported chains
  [1 /* ETH_MAINNET */]: {
    slug: "eth",
    nativeTokenAddress: NATIVE_TOKEN_ADDRESS
  },
  [56 /* BSC_MAINNET */]: {
    slug: "bsc",
    nativeTokenAddress: NATIVE_TOKEN_ADDRESS
  },
  [324 /* ZKSYNC_MAINNET */]: {
    slug: "zksync",
    nativeTokenAddress: NATIVE_TOKEN_ADDRESS
  },
  [137 /* MATIC_MAINNET */]: {
    slug: "polygon",
    nativeTokenAddress: "0x0000000000000000000000000000000000001010"
  },
  [8453 /* BASE_MAINNET */]: {
    slug: "base",
    nativeTokenAddress: NATIVE_TOKEN_ADDRESS
  },
  [43114 /* AVAX_MAINNET */]: {
    slug: "avax",
    nativeTokenAddress: AddressZero2
  },
  [42161 /* ARBITRUM_MAINNET */]: {
    slug: "arbitrum",
    nativeTokenAddress: NATIVE_TOKEN_ADDRESS
  },
  [10 /* OPTIMISM_MAINNET */]: {
    slug: "optimism",
    nativeTokenAddress: NATIVE_TOKEN_ADDRESS
  },
  // --- OpenOcean supported only chains
  [2222 /* KAVA_MAINNET */]: {
    slug: "kava",
    nativeTokenAddress: AddressZero2
  },
  [1101 /* POLYGON_ZK */]: {
    slug: "polygon_zkevm",
    nativeTokenAddress: NATIVE_TOKEN_ADDRESS
  },
  [59144 /* LINEA_MAINNET */]: {
    slug: "linea",
    nativeTokenAddress: NATIVE_TOKEN_ADDRESS
  },
  [534352 /* SCROLL_MAINNET */]: {
    slug: "scroll",
    nativeTokenAddress: NATIVE_TOKEN_ADDRESS
  },
  [5e3 /* MANTLE_MAINNET */]: {
    slug: "mantle",
    nativeTokenAddress: AddressZero2
  },
  [169 /* MANTA_MAINNET */]: {
    slug: "manta",
    nativeTokenAddress: NATIVE_TOKEN_ADDRESS
  },
  [1088 /* METIS_MAINNET */]: {
    slug: "metis",
    nativeTokenAddress: "0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000"
  },
  [81457 /* BLAST_MAINNET */]: {
    slug: "blast",
    nativeTokenAddress: NATIVE_TOKEN_ADDRESS
  },
  [34443 /* MODE_MAINNET */]: {
    slug: "mode",
    nativeTokenAddress: NATIVE_TOKEN_ADDRESS
  },
  [30 /* RSK_MAINNET */]: {
    slug: "rootstock",
    nativeTokenAddress: NATIVE_TOKEN_ADDRESS
  },
  [25 /* CRONOS_MAINNET */]: {
    slug: "cronos",
    nativeTokenAddress: AddressZero2
  },
  [1329 /* SEI_EVM_MAINNET */]: {
    slug: "sei",
    nativeTokenAddress: AddressZero2
  },
  [40 /* TELOS_MAINNET */]: {
    slug: "telos",
    nativeTokenAddress: AddressZero2
  },
  [1625 /* GRAVITY_MAINNET */]: {
    slug: "gravity",
    nativeTokenAddress: AddressZero2
  }
};
var BASE_URL = "https://open-api.openocean.finance/v3";
var OpenOceanTrade = class {
  constructor({ symbiosis, tokenAmountIn, tokenOut, to, slippage }) {
    this.tradeType = "open-ocean";
    this.symbiosis = symbiosis;
    this.tokenAmountIn = tokenAmountIn;
    this.tokenOut = tokenOut;
    this.to = to;
    this.slippage = slippage;
    this.endpoint = BASE_URL;
  }
  static isAvailable(chainId) {
    return Object.keys(OPEN_OCEAN_NETWORKS).includes(chainId.toString());
  }
  async init() {
    this.chain = OPEN_OCEAN_NETWORKS[this.tokenAmountIn.token.chainId];
    if (!this.chain) {
      throw new Error("Unsupported chain");
    }
    this.endpoint = `${BASE_URL}/${this.chain.slug}`;
    let fromTokenAddress = this.tokenAmountIn.token.address;
    if (this.tokenAmountIn.token.isNative) {
      fromTokenAddress = this.chain.nativeTokenAddress;
    }
    let toTokenAddress = this.tokenOut.address;
    if (this.tokenOut.isNative) {
      toTokenAddress = this.chain.nativeTokenAddress;
    }
    const url = new URL(`${this.endpoint}/swap_quote`);
    url.searchParams.set("inTokenAddress", fromTokenAddress);
    url.searchParams.set("outTokenAddress", toTokenAddress);
    url.searchParams.set("amount", this.tokenAmountIn.toFixed());
    url.searchParams.set("gasPrice", "5");
    url.searchParams.set("slippage", (this.slippage / 100).toString());
    url.searchParams.set("account", this.to);
    url.searchParams.set("referrer", "0x3254aE00947e44B7fD03F50b93B9acFEd59F9620");
    const response = await this.symbiosis.fetch(url.toString());
    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Cannot build OpenOcean trade for chain ${this.tokenAmountIn.token.chainId}: ${text}`);
    }
    const json = await response.json();
    if (json.code !== 200) {
      throw new Error(
        `Cannot build OpenOcean trade for chain ${this.tokenAmountIn.token.chainId}: ${JSON.stringify(json)}}`
      );
    }
    const { data, outAmount, to, price_impact: priceImpactString } = json.data;
    this.routerAddress = to;
    this.callData = data;
    this.callDataOffset = this.getOffset(data);
    this.amountOut = new TokenAmount(this.tokenOut, outAmount);
    const amountOutMinRaw = getMinAmount(this.slippage, outAmount);
    this.amountOutMin = new TokenAmount(this.tokenOut, amountOutMinRaw);
    this.route = [this.tokenAmountIn.token, this.tokenOut];
    this.priceImpact = this.convertPriceImpact(priceImpactString);
    return this;
  }
  getOffset(callData) {
    const methods = [
      {
        // swap
        sigHash: "90411a32",
        offset: 260
      },
      {
        // uniswapV3SwapTo
        sigHash: "bc80f1a8",
        offset: 68
      },
      {
        // callUniswapTo
        sigHash: "6b58f2f0",
        offset: 68
      }
    ];
    const sigHash = callData.slice(2, 10);
    const method = methods.find((i) => {
      return i.sigHash === sigHash;
    });
    if (method === void 0) {
      throw new Error("Unknown OpenOcean swap method encoded to calldata");
    }
    return method.offset;
  }
  convertPriceImpact(value) {
    if (!value) {
      return new Percent("0");
    }
    const number = new BigNumber4(value.split("%")[0]);
    if (number.isNaN()) {
      return new Percent("0");
    }
    return new Percent(number.multipliedBy(100).integerValue().toString(), BIPS_BASE);
  }
};

// src/crosschain/trade/izumiTrade.ts
import BNJS from "bignumber.js";
import { BigNumber as BigNumber5 } from "ethers";
import { AbiCoder } from "ethers/lib/utils";
var POSSIBLE_FEES = [100, 400, 500, 2e3, 3e3, 1e4];
var IZUMI_ADDRESSES = {
  [5e3 /* MANTLE_MAINNET */]: {
    factory: "0x45e5F26451CDB01B0fA1f8582E0aAD9A6F27C218",
    quoter: "0x032b241De86a8660f1Ae0691a4760B426EA246d7",
    swap: "0x25C030116Feb2E7BbA054b9de0915E5F51b03e31",
    baseTokens: [
      new Token({
        chainId: 5e3 /* MANTLE_MAINNET */,
        address: "0x201eba5cc46d216ce6dc03f6a759e8e766e956ae",
        decimals: 6,
        symbol: "USDT",
        name: "USDT"
      }),
      new Token({
        chainId: 5e3 /* MANTLE_MAINNET */,
        address: "0xdeaddeaddeaddeaddeaddeaddeaddeaddead1111",
        decimals: 18,
        symbol: "WETH",
        name: "Wrapped Ether"
      }),
      new Token({
        chainId: 5e3 /* MANTLE_MAINNET */,
        address: "0x78c1b0c915c4faa5fffa6cabf0219da63d7f4cb8",
        decimals: 18,
        symbol: "WMNT",
        name: "WMNT"
      }),
      new Token({
        chainId: 5e3 /* MANTLE_MAINNET */,
        address: "0x0a3bb08b3a15a19b4de82f8acfc862606fb69a2d",
        decimals: 18,
        symbol: "iUSD",
        name: "iZUMi Bond USD"
      })
    ]
  },
  [59144 /* LINEA_MAINNET */]: {
    factory: "0x45e5F26451CDB01B0fA1f8582E0aAD9A6F27C218",
    quoter: "0xe6805638db944eA605e774e72c6F0D15Fb6a1347",
    swap: "0x032b241De86a8660f1Ae0691a4760B426EA246d7",
    baseTokens: [
      new Token({
        chainId: 59144 /* LINEA_MAINNET */,
        name: "Wrapped Ether",
        symbol: "WETH",
        address: "0xe5d7c2a44ffddf6b295a15c148167daaaf5cf34f",
        decimals: 18
      }),
      new Token({
        chainId: 59144 /* LINEA_MAINNET */,
        name: "iZUMi Bond USD",
        symbol: "iUSD",
        address: "0x0a3bb08b3a15a19b4de82f8acfc862606fb69a2d",
        decimals: 18
      })
    ]
  },
  [534352 /* SCROLL_MAINNET */]: {
    factory: "0x8c7d3063579BdB0b90997e18A770eaE32E1eBb08",
    quoter: "0x33531bDBFE34fa6Fd5963D0423f7699775AacaaF",
    swap: "0x2db0AFD0045F3518c77eC6591a542e326Befd3D7",
    baseTokens: [
      new Token({
        chainId: 534352 /* SCROLL_MAINNET */,
        name: "Wrapped Ether",
        symbol: "WETH",
        address: "0x5300000000000000000000000000000000000004",
        decimals: 18
      }),
      new Token({
        chainId: 534352 /* SCROLL_MAINNET */,
        name: "USD Coin",
        symbol: "USDC",
        address: "0x06eFdBFf2a14a7c8E15944D1F4A48F9F95F663A4",
        decimals: 18
      })
    ]
  },
  [195 /* OKX_X1_TESTNET */]: {
    factory: "0x64c2F1306b4ED3183E7B345158fd01c19C0d8c5E",
    quoter: "0xF6FFe4f3FdC8BBb7F70FFD48e61f17D1e343dDfD",
    swap: "0xa9754f0D9055d14EB0D2d196E4C51d8B2Ee6f4d3",
    baseTokens: [
      new Token({
        name: "WETH",
        symbol: "WETH",
        address: "0xbec7859bc3d0603bec454f7194173e36bf2aa5c8",
        chainId: 195 /* OKX_X1_TESTNET */,
        decimals: 18,
        icons: {
          large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
          small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
        }
      }),
      new Token({
        chainId: 195 /* OKX_X1_TESTNET */,
        address: "0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF",
        decimals: 18,
        symbol: "WOKB",
        isNative: false,
        name: "Wrapped OKB",
        icons: {
          small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3897.png",
          large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3897.png"
        }
      })
    ]
  },
  [4200 /* MERLIN_MAINNET */]: {
    swap: "0x1aFa5D7f89743219576Ef48a9826261bE6378a68",
    factory: "0xE29a6620DAc789B8a76e9b9eC8fE9B7cf2B663D5",
    quoter: "0x2569bcE69287618e2cd004f785d016F7DF29232F",
    baseTokens: [
      new Token({
        chainId: 4200 /* MERLIN_MAINNET */,
        name: "Wrapped BTC",
        symbol: "WBTC",
        address: "0xF6D226f9Dc15d9bB51182815b320D3fBE324e1bA",
        decimals: 18
      }),
      new Token({
        chainId: 4200 /* MERLIN_MAINNET */,
        name: "iZUMi Bond USD",
        symbol: "iUSD",
        address: "0x0A3BB08b3a15A19b4De82F8AcFc862606FB69A2D",
        decimals: 18
      })
    ]
  },
  [810180 /* ZKLINK_MAINNET */]: {
    swap: "0x377EC7c9ae5a0787F384668788a1654249059dD6",
    factory: "0x33D9936b7B7BC155493446B5E6dDC0350EB83AEC",
    quoter: "0x3EC82C07981D6D213DA9bd35A0ba4cd324feA438",
    baseTokens: [
      new Token({
        chainId: 810180 /* ZKLINK_MAINNET */,
        name: "Wrapped ETH",
        symbol: "WETH",
        address: "0x8280a4e7D5B3B658ec4580d3Bc30f5e50454F169",
        decimals: 18
      }),
      new Token({
        chainId: 810180 /* ZKLINK_MAINNET */,
        name: "Tether USD (Ethereum)",
        symbol: "USDT.Eth",
        address: "0x0ace5E8e1Be0d3Df778f639d79fa8231b376b9F1",
        decimals: 6
      }),
      new Token({
        chainId: 810180 /* ZKLINK_MAINNET */,
        name: "USD Coin (Ethereum)",
        symbol: "USDC.Eth",
        address: "0x220B1C622c8c169a9174f42CEA89a9E2f83B63F6",
        decimals: 6
      }),
      new Token({
        chainId: 810180 /* ZKLINK_MAINNET */,
        name: "USD Coin (Arbitrum)",
        symbol: "USDC.Arbi",
        address: "0x7581469cb53E786F39ff26E8aF6Fd750213dAcEd",
        decimals: 6
      })
    ]
  },
  [7e3 /* ZETACHAIN_MAINNET */]: {
    swap: "0x34bc1b87f60e0a30c0e24FD7Abada70436c71406",
    factory: "0x8c7d3063579BdB0b90997e18A770eaE32E1eBb08",
    quoter: "0x3F559139C2Fc7B97Ad6FE9B4d1f75149F551DB18",
    baseTokens: [
      new Token({
        chainId: 7e3 /* ZETACHAIN_MAINNET */,
        name: "Wrapped ZETA",
        symbol: "WZETA",
        address: "0x5F0b1a82749cb4E2278EC87F8BF6B618dC71a8bf",
        decimals: 18
      }),
      new Token({
        chainId: 7e3 /* ZETACHAIN_MAINNET */,
        name: "ZetaChain ZRC20 USDT on ETH",
        symbol: "USDT.ETH",
        address: "0x7c8dDa80bbBE1254a7aACf3219EBe1481c6E01d7",
        decimals: 6
      }),
      new Token({
        chainId: 7e3 /* ZETACHAIN_MAINNET */,
        name: "ZetaChain ZRC20 USDC on ETH",
        symbol: "USDC.ETH",
        address: "0x0cbe0dF132a6c6B4a2974Fa1b7Fb953CF0Cc798a",
        decimals: 6
      }),
      new Token({
        chainId: 7e3 /* ZETACHAIN_MAINNET */,
        name: "ZetaChain ZRC20 ETH-eth_mainnet",
        symbol: "ETH.ETH",
        address: "0xd97B1de3619ed2c6BEb3860147E30cA8A7dC9891",
        decimals: 18
      })
    ]
  },
  [167e3 /* TAIKO_MAINNET */]: {
    swap: "0x04830cfCED9772b8ACbAF76Cfc7A630Ad82c9148",
    factory: "0x8c7d3063579BdB0b90997e18A770eaE32E1eBb08",
    quoter: "0x2C6Df0fDbCE9D2Ded2B52A117126F2Dc991f770f",
    baseTokens: []
  },
  [1625 /* GRAVITY_MAINNET */]: {
    swap: "0x3EF68D3f7664b2805D4E88381b64868a56f88bC4",
    factory: "0x8c7d3063579BdB0b90997e18A770eaE32E1eBb08",
    quoter: "0x33531bDBFE34fa6Fd5963D0423f7699775AacaaF",
    baseTokens: []
  }
};
var IzumiTrade = class {
  constructor(params) {
    this.tradeType = "izumi";
    this.priceImpact = new Percent("0");
    const { symbiosis, tokenAmountIn, tokenOut, slippage, ttl, to } = params;
    this.symbiosis = symbiosis;
    this.tokenAmountIn = tokenAmountIn;
    this.tokenOut = tokenOut;
    this.slippage = slippage;
    this.ttl = ttl;
    this.to = to;
  }
  static isSupported(chainId) {
    return !!IZUMI_ADDRESSES[chainId];
  }
  async init() {
    const addresses = IZUMI_ADDRESSES[this.tokenAmountIn.token.chainId];
    if (!addresses) {
      throw new Error("Unsupported chain");
    }
    const { quoter, swap } = addresses;
    const allRoutes = [];
    const tokenIn = this.tokenAmountIn.token;
    const tokenOut = this.tokenOut;
    POSSIBLE_FEES.forEach((fee) => {
      const path2 = getTokenChainPath([tokenIn, tokenOut], [fee]);
      allRoutes.push({ tokens: [tokenIn, tokenOut], path: path2, fees: [fee] });
    });
    const wrappedTokenIn = wrappedToken(tokenIn);
    const wrappedTokenOut = wrappedToken(tokenOut);
    for (const baseToken of addresses.baseTokens) {
      if (baseToken.equals(wrappedTokenIn) || baseToken.equals(wrappedTokenOut)) {
        continue;
      }
      POSSIBLE_FEES.forEach((firstFee) => {
        POSSIBLE_FEES.forEach((secondFee) => {
          const fees = [firstFee, secondFee];
          const path2 = getTokenChainPath([tokenIn, baseToken, tokenOut], fees);
          allRoutes.push({ tokens: [tokenIn, baseToken, tokenOut], path: path2, fees });
        });
      });
    }
    const provider = this.symbiosis.getProvider(this.tokenAmountIn.token.chainId);
    const multicall = await getMulticall(provider);
    const quoterInterface = IzumiQuoter__factory.createInterface();
    const calls = allRoutes.map(({ path: path2 }) => ({
      target: quoter,
      callData: quoterInterface.encodeFunctionData("swapAmount", [this.tokenAmountIn.raw.toString(), path2])
    }));
    const maxChunkLength = 100;
    const chunks = Math.floor(calls.length / maxChunkLength) + 1;
    let results = [];
    for (let i = 0; i < chunks; i++) {
      const from = i * maxChunkLength;
      let to = (i + 1) * maxChunkLength;
      if (to > calls.length) {
        to = calls.length;
      }
      const callsPart = calls.slice(from, to);
      const part = await multicall.callStatic.tryAggregate(false, callsPart);
      results = [...results, ...part];
    }
    let bestRoute;
    let bestOutput;
    for (let i = 0; i < results.length; i++) {
      const [success, returnData] = results[i];
      if (!success) {
        continue;
      }
      const { acquire } = quoterInterface.decodeFunctionResult("swapAmount", returnData);
      if (!bestOutput || BigNumber5.from(acquire).gt(bestOutput)) {
        bestRoute = allRoutes[i];
        bestOutput = acquire;
      }
    }
    if (!bestRoute || !bestOutput) {
      throw new Error("No path found");
    }
    const { path, tokens } = bestRoute;
    const pointsBefore = await this.getCurrentPoolPoints(bestRoute);
    const initDecimalPriceEndByStart = getPriceDecimalEndByStart(bestRoute, pointsBefore);
    const initDecimalPriceEndByStartTrimmed = new BNJS(initDecimalPriceEndByStart.toFixed(4));
    this.priceImpact = new Percent("0");
    if (!initDecimalPriceEndByStartTrimmed.isEqualTo("0")) {
      const spotPriceBNJS = new BNJS(this.tokenAmountIn.raw.toString()).dividedBy(10 ** this.tokenAmountIn.token.decimals).dividedBy(initDecimalPriceEndByStart);
      const bestOutputBNJS = new BNJS(bestOutput.toString()).dividedBy(10 ** this.tokenOut.decimals);
      const impactBNJS = spotPriceBNJS.minus(bestOutputBNJS).div(bestOutputBNJS).negated();
      this.priceImpact = new Percent(impactBNJS.times(BIPS_BASE.toString()).toFixed(0).toString(), BIPS_BASE);
    }
    this.amountOut = new TokenAmount(this.tokenOut, bestOutput.toString());
    const minAcquired = getMinAmount(this.slippage, bestOutput.toString());
    this.amountOutMin = new TokenAmount(this.tokenOut, minAcquired.toString());
    const outputToken = tokens[tokens.length - 1];
    const finalRecipientAddress = this.to;
    const innerRecipientAddress = outputToken.isNative ? "0x0000000000000000000000000000000000000000" : finalRecipientAddress;
    const swapInterface = IzumiSwap__factory.createInterface();
    const swapCalls = [];
    const swapData = swapInterface.encodeFunctionData("swapAmount", [
      {
        path,
        recipient: innerRecipientAddress,
        amount: this.tokenAmountIn.raw.toString(),
        minAcquired: minAcquired.toString(),
        deadline: Math.floor(Date.now() / 1e3) + this.ttl
      }
    ]);
    swapCalls.push(swapData);
    if (outputToken.isNative) {
      swapCalls.push(swapInterface.encodeFunctionData("unwrapWETH9", ["0", finalRecipientAddress]));
    }
    let callData;
    if (swapCalls.length === 1) {
      callData = swapCalls[0];
    } else {
      callData = swapInterface.encodeFunctionData("multicall", [swapCalls]);
    }
    const abiCoder = new AbiCoder();
    const encodedCallData = abiCoder.encode(["uint128"], [this.tokenAmountIn.raw.toString()]).replace("0x", "");
    const position = callData.indexOf(encodedCallData) + encodedCallData.length;
    this.callDataOffset = (position - 2) / 2;
    this.routerAddress = swap;
    this.callData = callData;
    this.route = tokens;
    return this;
  }
  async getCurrentPoolPoints({ fees, tokens }) {
    const addresses = IZUMI_ADDRESSES[this.tokenAmountIn.token.chainId];
    if (!addresses) {
      throw new Error("Unsupported chain");
    }
    const provider = this.symbiosis.getProvider(this.tokenAmountIn.token.chainId);
    const multicall = await getMulticall(provider);
    const factoryInterface = IzumiFactory__factory.createInterface();
    const getPoolAddressesCalls = [];
    for (let i = 0; i < fees.length; i++) {
      getPoolAddressesCalls.push({
        target: addresses.factory,
        callData: factoryInterface.encodeFunctionData("pool", [
          wrappedToken(tokens[i]).address,
          wrappedToken(tokens[i + 1]).address,
          fees[i]
        ])
      });
    }
    const getPoolAddressesResults = await multicall.callStatic.tryAggregate(false, getPoolAddressesCalls);
    const poolsAddresses = getPoolAddressesResults.map(
      ([, returnData]) => factoryInterface.decodeFunctionResult("pool", returnData)[0]
    );
    const poolInterface = IzumiPool__factory.createInterface();
    const statesResults = await multicall.callStatic.tryAggregate(
      false,
      poolsAddresses.map((poolAddress) => ({
        target: poolAddress,
        callData: poolInterface.encodeFunctionData("state")
      }))
    );
    const points = statesResults.map(
      ([, returnData]) => poolInterface.decodeFunctionResult("state", returnData).currentPoint
    );
    return points;
  }
};
function num2Hex(n) {
  if (n < 10) {
    return String(n);
  }
  const str = "ABCDEF";
  return str[n - 10];
}
function appendHex(hexString, newHexString) {
  return hexString + newHexString.slice(2);
}
function fee2Hex(fee) {
  const n0 = fee % 16;
  const n1 = Math.floor(fee / 16) % 16;
  const n2 = Math.floor(fee / 256) % 16;
  const n3 = Math.floor(fee / 4096) % 16;
  const n4 = 0;
  const n5 = 0;
  return "0x" + num2Hex(n5) + num2Hex(n4) + num2Hex(n3) + num2Hex(n2) + num2Hex(n1) + num2Hex(n0);
}
var getTokenChainPath = (tokenChain, feeChain) => {
  let hexString = wrappedToken(tokenChain[0]).address;
  for (let i = 0; i < feeChain.length; i++) {
    hexString = appendHex(hexString, fee2Hex(feeChain[i]));
    hexString = appendHex(hexString, wrappedToken(tokenChain[i + 1]).address);
  }
  return hexString;
};
var getTokenXYFromToken = (tokenA, tokenB) => {
  const addressA = wrappedToken(tokenA).address;
  const addressB = wrappedToken(tokenB).address;
  if (addressA.toLowerCase() < addressB.toLowerCase()) {
    return { tokenX: tokenA, tokenY: tokenB };
  }
  return { tokenX: tokenB, tokenY: tokenA };
};
var priceUndecimal2PriceDecimal = (tokenA, tokenB, priceUndecimalAByB) => {
  return Number(priceUndecimalAByB.times(10 ** tokenA.decimals).div(10 ** tokenB.decimals));
};
var point2PriceDecimal = (tokenA, tokenB, point) => {
  let priceDecimal = 0;
  let needReverse = false;
  const { tokenX, tokenY } = getTokenXYFromToken(tokenA, tokenB);
  const addressA = wrappedToken(tokenA).address;
  const addressB = wrappedToken(tokenB).address;
  if (point > 0) {
    priceDecimal = priceUndecimal2PriceDecimal(tokenX, tokenY, new BNJS(1.0001 ** point));
    needReverse = addressA.toLowerCase() > addressB.toLowerCase();
  } else {
    priceDecimal = priceUndecimal2PriceDecimal(tokenY, tokenX, new BNJS(1.0001 ** -point));
    needReverse = addressA.toLowerCase() < addressB.toLowerCase();
  }
  if (needReverse) {
    priceDecimal = 1 / priceDecimal;
  }
  return priceDecimal;
};
function getPriceDecimalEndByStart(route, points) {
  const { tokens, fees } = route;
  let decimalPriceEndByStart = 1;
  for (let i = 0; i < fees.length; i++) {
    const decimalPriceBackByFront = point2PriceDecimal(tokens[i + 1], tokens[i], points[i]);
    decimalPriceEndByStart *= decimalPriceBackByFront;
  }
  return decimalPriceEndByStart;
}

// src/crosschain/trade/uniLikeTrade.ts
import JSBI11 from "jsbi";
import { AddressZero as AddressZero3 } from "@ethersproject/constants/lib/addresses";
var UniLikeTrade = class _UniLikeTrade {
  constructor(tokenAmountIn, tokenOut, to, slippage, deadline, router, dexFee) {
    this.tradeType = "dex";
    this.tokenAmountIn = tokenAmountIn;
    this.tokenOut = tokenOut;
    this.to = to;
    this.slippage = slippage;
    this.deadline = deadline;
    this.router = router;
    this.routerAddress = router.address;
    this.dexFee = dexFee;
  }
  async init(dataProvider) {
    if (this.routerAddress === AddressZero3) {
      throw new Error("Router address is zero");
    }
    if (dataProvider) {
      this.pairs = await dataProvider.getPairs(this.tokenAmountIn.token, this.tokenOut);
    } else {
      this.pairs = await _UniLikeTrade.getPairs(this.router.provider, this.tokenAmountIn.token, this.tokenOut);
    }
    const [trade] = Trade.bestTradeExactIn(this.pairs, this.tokenAmountIn, this.tokenOut, {
      maxHops: 3,
      maxNumResults: 1
    });
    if (!trade) {
      throw new Error("Cannot create trade");
    }
    this.trade = trade;
    const priceImpact = computeTradePriceBreakdown(this.trade, this.dexFee).priceImpactWithoutFee;
    if (!priceImpact) {
      throw new Error("Cannot calculate priceImpact");
    }
    this.priceImpact = priceImpact;
    this.route = trade.route.path;
    this.amountOut = trade.outputAmount;
    const amountOutMin = computeSlippageAdjustedAmounts(trade, this.slippage).OUTPUT;
    if (!amountOutMin) {
      throw new Error("Cannot compute amountOutMin");
    }
    this.amountOutMin = amountOutMin;
    const { data, offset, functionSelector } = this.buildCallData(trade);
    this.callData = data;
    this.callDataOffset = offset;
    this.functionSelector = functionSelector;
    if (!this.callData) {
      throw new Error("Cannot build callData");
    }
    return this;
  }
  buildCallData(trade) {
    const { methodName, args, offset } = Router.swapCallParameters(trade, {
      allowedSlippage: new Percent(JSBI11.BigInt(Math.floor(this.slippage)), BIPS_BASE),
      recipient: this.to,
      ttl: this.deadline,
      feeOnTransfer: trade.inputAmount.token.chainId === 34443 /* MODE_MAINNET */
      // kim.exchange has extra param `referrer`
    });
    let method = methodName;
    if (trade.inputAmount.token.chainId === 43114 /* AVAX_MAINNET */) {
      method = methodName.replace("ETH", "AVAX");
    } else if ([200101 /* MILKOMEDA_DEVNET */, 2001 /* MILKOMEDA_MAINNET */].includes(trade.inputAmount.token.chainId)) {
      method = methodName.replace("ETH", "ADA");
    } else if ([1329 /* SEI_EVM_MAINNET */].includes(trade.inputAmount.token.chainId)) {
      method = methodName.replace("ETH", "SEI");
    }
    const functionAbi = this.router.interface.getFunction(method);
    return {
      functionSelector: getFunctionSelector(functionAbi),
      data: this.router.interface.encodeFunctionData(method, args),
      offset
    };
  }
  static async getPairs(provider, tokenIn, tokenOut) {
    const allPairCombinations = getAllPairCombinations(tokenIn, tokenOut);
    return await _UniLikeTrade.allPairs(provider, allPairCombinations);
  }
  static async allPairs(provider, tokens) {
    const wrappedTokens = tokens.map(([tokenA, tokenB]) => [wrappedToken(tokenA), wrappedToken(tokenB)]);
    const multicall = await getMulticall(provider);
    const pairAddresses = wrappedTokens.map(([tokenA, tokenB]) => {
      if (!tokenA || !tokenB)
        throw new Error();
      if (tokenA.chainId !== tokenB.chainId)
        throw new Error();
      if (tokenA.equals(tokenB))
        throw new Error();
      return Pair.getAddress(tokenA, tokenB);
    });
    const pairInterface = Pair__factory.createInterface();
    const getReservesData = pairInterface.encodeFunctionData("getReserves");
    const calls = pairAddresses.map((pairAddress) => ({
      target: pairAddress,
      callData: getReservesData
    }));
    const aggregateResult = await multicall.callStatic.tryAggregate(false, calls);
    const validPairs = /* @__PURE__ */ new Map();
    aggregateResult.forEach(([success, returnData], i) => {
      if (!success || returnData === "0x") {
        return;
      }
      const tokenA = wrappedTokens[i][0];
      const tokenB = wrappedTokens[i][1];
      if (!tokenA || !tokenB || tokenA.equals(tokenB)) {
        return;
      }
      const reserve = pairInterface.decodeFunctionResult("getReserves", returnData);
      const { reserve0, reserve1 } = reserve;
      const [token0, token1] = tokenA.sortsBefore(tokenB) ? [tokenA, tokenB] : [tokenB, tokenA];
      const pair = new Pair(
        new TokenAmount(token0, reserve0.toString()),
        new TokenAmount(token1, reserve1.toString())
      );
      validPairs.set(pair.liquidityToken.address, pair);
    });
    return Array.from(validPairs.values());
  }
};

// src/crosschain/trade/uniV3Trade.ts
import {
  encodeRouteToPath,
  FeeAmount,
  Multicall as Multicall2,
  Payments,
  Route as Route3,
  SelfPermit,
  toHex as toHex2,
  Trade as Trade3
} from "@uniswap/v3-sdk";

// node_modules/@uniswap/v3-core/artifacts/contracts/interfaces/IUniswapV3Pool.sol/IUniswapV3Pool.json
var IUniswapV3Pool_default = {
  _format: "hh-sol-artifact-1",
  contractName: "IUniswapV3Pool",
  sourceName: "contracts/interfaces/IUniswapV3Pool.sol",
  abi: [
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address"
        },
        {
          indexed: true,
          internalType: "int24",
          name: "tickLower",
          type: "int24"
        },
        {
          indexed: true,
          internalType: "int24",
          name: "tickUpper",
          type: "int24"
        },
        {
          indexed: false,
          internalType: "uint128",
          name: "amount",
          type: "uint128"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount0",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount1",
          type: "uint256"
        }
      ],
      name: "Burn",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address"
        },
        {
          indexed: false,
          internalType: "address",
          name: "recipient",
          type: "address"
        },
        {
          indexed: true,
          internalType: "int24",
          name: "tickLower",
          type: "int24"
        },
        {
          indexed: true,
          internalType: "int24",
          name: "tickUpper",
          type: "int24"
        },
        {
          indexed: false,
          internalType: "uint128",
          name: "amount0",
          type: "uint128"
        },
        {
          indexed: false,
          internalType: "uint128",
          name: "amount1",
          type: "uint128"
        }
      ],
      name: "Collect",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "sender",
          type: "address"
        },
        {
          indexed: true,
          internalType: "address",
          name: "recipient",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint128",
          name: "amount0",
          type: "uint128"
        },
        {
          indexed: false,
          internalType: "uint128",
          name: "amount1",
          type: "uint128"
        }
      ],
      name: "CollectProtocol",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "sender",
          type: "address"
        },
        {
          indexed: true,
          internalType: "address",
          name: "recipient",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount0",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount1",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "paid0",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "paid1",
          type: "uint256"
        }
      ],
      name: "Flash",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint16",
          name: "observationCardinalityNextOld",
          type: "uint16"
        },
        {
          indexed: false,
          internalType: "uint16",
          name: "observationCardinalityNextNew",
          type: "uint16"
        }
      ],
      name: "IncreaseObservationCardinalityNext",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint160",
          name: "sqrtPriceX96",
          type: "uint160"
        },
        {
          indexed: false,
          internalType: "int24",
          name: "tick",
          type: "int24"
        }
      ],
      name: "Initialize",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "sender",
          type: "address"
        },
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address"
        },
        {
          indexed: true,
          internalType: "int24",
          name: "tickLower",
          type: "int24"
        },
        {
          indexed: true,
          internalType: "int24",
          name: "tickUpper",
          type: "int24"
        },
        {
          indexed: false,
          internalType: "uint128",
          name: "amount",
          type: "uint128"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount0",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount1",
          type: "uint256"
        }
      ],
      name: "Mint",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint8",
          name: "feeProtocol0Old",
          type: "uint8"
        },
        {
          indexed: false,
          internalType: "uint8",
          name: "feeProtocol1Old",
          type: "uint8"
        },
        {
          indexed: false,
          internalType: "uint8",
          name: "feeProtocol0New",
          type: "uint8"
        },
        {
          indexed: false,
          internalType: "uint8",
          name: "feeProtocol1New",
          type: "uint8"
        }
      ],
      name: "SetFeeProtocol",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "sender",
          type: "address"
        },
        {
          indexed: true,
          internalType: "address",
          name: "recipient",
          type: "address"
        },
        {
          indexed: false,
          internalType: "int256",
          name: "amount0",
          type: "int256"
        },
        {
          indexed: false,
          internalType: "int256",
          name: "amount1",
          type: "int256"
        },
        {
          indexed: false,
          internalType: "uint160",
          name: "sqrtPriceX96",
          type: "uint160"
        },
        {
          indexed: false,
          internalType: "uint128",
          name: "liquidity",
          type: "uint128"
        },
        {
          indexed: false,
          internalType: "int24",
          name: "tick",
          type: "int24"
        }
      ],
      name: "Swap",
      type: "event"
    },
    {
      inputs: [
        {
          internalType: "int24",
          name: "tickLower",
          type: "int24"
        },
        {
          internalType: "int24",
          name: "tickUpper",
          type: "int24"
        },
        {
          internalType: "uint128",
          name: "amount",
          type: "uint128"
        }
      ],
      name: "burn",
      outputs: [
        {
          internalType: "uint256",
          name: "amount0",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "amount1",
          type: "uint256"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "recipient",
          type: "address"
        },
        {
          internalType: "int24",
          name: "tickLower",
          type: "int24"
        },
        {
          internalType: "int24",
          name: "tickUpper",
          type: "int24"
        },
        {
          internalType: "uint128",
          name: "amount0Requested",
          type: "uint128"
        },
        {
          internalType: "uint128",
          name: "amount1Requested",
          type: "uint128"
        }
      ],
      name: "collect",
      outputs: [
        {
          internalType: "uint128",
          name: "amount0",
          type: "uint128"
        },
        {
          internalType: "uint128",
          name: "amount1",
          type: "uint128"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "recipient",
          type: "address"
        },
        {
          internalType: "uint128",
          name: "amount0Requested",
          type: "uint128"
        },
        {
          internalType: "uint128",
          name: "amount1Requested",
          type: "uint128"
        }
      ],
      name: "collectProtocol",
      outputs: [
        {
          internalType: "uint128",
          name: "amount0",
          type: "uint128"
        },
        {
          internalType: "uint128",
          name: "amount1",
          type: "uint128"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "factory",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "fee",
      outputs: [
        {
          internalType: "uint24",
          name: "",
          type: "uint24"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "feeGrowthGlobal0X128",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "feeGrowthGlobal1X128",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "recipient",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amount0",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "amount1",
          type: "uint256"
        },
        {
          internalType: "bytes",
          name: "data",
          type: "bytes"
        }
      ],
      name: "flash",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint16",
          name: "observationCardinalityNext",
          type: "uint16"
        }
      ],
      name: "increaseObservationCardinalityNext",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint160",
          name: "sqrtPriceX96",
          type: "uint160"
        }
      ],
      name: "initialize",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "liquidity",
      outputs: [
        {
          internalType: "uint128",
          name: "",
          type: "uint128"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "maxLiquidityPerTick",
      outputs: [
        {
          internalType: "uint128",
          name: "",
          type: "uint128"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "recipient",
          type: "address"
        },
        {
          internalType: "int24",
          name: "tickLower",
          type: "int24"
        },
        {
          internalType: "int24",
          name: "tickUpper",
          type: "int24"
        },
        {
          internalType: "uint128",
          name: "amount",
          type: "uint128"
        },
        {
          internalType: "bytes",
          name: "data",
          type: "bytes"
        }
      ],
      name: "mint",
      outputs: [
        {
          internalType: "uint256",
          name: "amount0",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "amount1",
          type: "uint256"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "index",
          type: "uint256"
        }
      ],
      name: "observations",
      outputs: [
        {
          internalType: "uint32",
          name: "blockTimestamp",
          type: "uint32"
        },
        {
          internalType: "int56",
          name: "tickCumulative",
          type: "int56"
        },
        {
          internalType: "uint160",
          name: "secondsPerLiquidityCumulativeX128",
          type: "uint160"
        },
        {
          internalType: "bool",
          name: "initialized",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint32[]",
          name: "secondsAgos",
          type: "uint32[]"
        }
      ],
      name: "observe",
      outputs: [
        {
          internalType: "int56[]",
          name: "tickCumulatives",
          type: "int56[]"
        },
        {
          internalType: "uint160[]",
          name: "secondsPerLiquidityCumulativeX128s",
          type: "uint160[]"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "key",
          type: "bytes32"
        }
      ],
      name: "positions",
      outputs: [
        {
          internalType: "uint128",
          name: "_liquidity",
          type: "uint128"
        },
        {
          internalType: "uint256",
          name: "feeGrowthInside0LastX128",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "feeGrowthInside1LastX128",
          type: "uint256"
        },
        {
          internalType: "uint128",
          name: "tokensOwed0",
          type: "uint128"
        },
        {
          internalType: "uint128",
          name: "tokensOwed1",
          type: "uint128"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "protocolFees",
      outputs: [
        {
          internalType: "uint128",
          name: "token0",
          type: "uint128"
        },
        {
          internalType: "uint128",
          name: "token1",
          type: "uint128"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint8",
          name: "feeProtocol0",
          type: "uint8"
        },
        {
          internalType: "uint8",
          name: "feeProtocol1",
          type: "uint8"
        }
      ],
      name: "setFeeProtocol",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "slot0",
      outputs: [
        {
          internalType: "uint160",
          name: "sqrtPriceX96",
          type: "uint160"
        },
        {
          internalType: "int24",
          name: "tick",
          type: "int24"
        },
        {
          internalType: "uint16",
          name: "observationIndex",
          type: "uint16"
        },
        {
          internalType: "uint16",
          name: "observationCardinality",
          type: "uint16"
        },
        {
          internalType: "uint16",
          name: "observationCardinalityNext",
          type: "uint16"
        },
        {
          internalType: "uint8",
          name: "feeProtocol",
          type: "uint8"
        },
        {
          internalType: "bool",
          name: "unlocked",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "int24",
          name: "tickLower",
          type: "int24"
        },
        {
          internalType: "int24",
          name: "tickUpper",
          type: "int24"
        }
      ],
      name: "snapshotCumulativesInside",
      outputs: [
        {
          internalType: "int56",
          name: "tickCumulativeInside",
          type: "int56"
        },
        {
          internalType: "uint160",
          name: "secondsPerLiquidityInsideX128",
          type: "uint160"
        },
        {
          internalType: "uint32",
          name: "secondsInside",
          type: "uint32"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "recipient",
          type: "address"
        },
        {
          internalType: "bool",
          name: "zeroForOne",
          type: "bool"
        },
        {
          internalType: "int256",
          name: "amountSpecified",
          type: "int256"
        },
        {
          internalType: "uint160",
          name: "sqrtPriceLimitX96",
          type: "uint160"
        },
        {
          internalType: "bytes",
          name: "data",
          type: "bytes"
        }
      ],
      name: "swap",
      outputs: [
        {
          internalType: "int256",
          name: "amount0",
          type: "int256"
        },
        {
          internalType: "int256",
          name: "amount1",
          type: "int256"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "int16",
          name: "wordPosition",
          type: "int16"
        }
      ],
      name: "tickBitmap",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "tickSpacing",
      outputs: [
        {
          internalType: "int24",
          name: "",
          type: "int24"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "int24",
          name: "tick",
          type: "int24"
        }
      ],
      name: "ticks",
      outputs: [
        {
          internalType: "uint128",
          name: "liquidityGross",
          type: "uint128"
        },
        {
          internalType: "int128",
          name: "liquidityNet",
          type: "int128"
        },
        {
          internalType: "uint256",
          name: "feeGrowthOutside0X128",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "feeGrowthOutside1X128",
          type: "uint256"
        },
        {
          internalType: "int56",
          name: "tickCumulativeOutside",
          type: "int56"
        },
        {
          internalType: "uint160",
          name: "secondsPerLiquidityOutsideX128",
          type: "uint160"
        },
        {
          internalType: "uint32",
          name: "secondsOutside",
          type: "uint32"
        },
        {
          internalType: "bool",
          name: "initialized",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "token0",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "token1",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    }
  ],
  bytecode: "0x",
  deployedBytecode: "0x",
  linkReferences: {},
  deployedLinkReferences: {}
};

// src/crosschain/trade/uniV3Trade/pool.ts
import { computePoolAddress, Pool } from "@uniswap/v3-sdk";
import { ethers } from "ethers";
import { Token as Token10 } from "@uniswap/sdk-core";
async function getPool(factory, tokenA, tokenB, fee) {
  const currentPoolAddress = computePoolAddress({
    factoryAddress: factory.address,
    tokenA,
    tokenB,
    fee
  });
  const poolContract = new ethers.Contract(currentPoolAddress, IUniswapV3Pool_default.abi, factory.provider);
  try {
    const [token0, token1, liquidity, slot0] = await Promise.all([
      poolContract.token0(),
      poolContract.token1(),
      poolContract.liquidity(),
      poolContract.slot0()
    ]);
    const tokens = {
      [tokenA.address]: tokenA,
      [tokenB.address]: tokenB
    };
    return new Pool(
      new Token10(tokens[token0].chainId, token0, tokens[token0].decimals),
      new Token10(tokens[token1].chainId, token1, tokens[token1].decimals),
      fee,
      slot0[0].toString(),
      // sqrtPriceX96
      liquidity.toString(),
      slot0[1]
      // tick
    );
  } catch (e) {
    return;
  }
}

// src/crosschain/trade/uniV3Trade.ts
import { CurrencyAmount as CurrencyAmount3, Percent as PercentUni, TradeType as TradeType3, validateAndParseAddress as validateAndParseAddress2 } from "@uniswap/sdk-core";

// src/crosschain/trade/uniV3Trade/getOutputQuote.ts
import { TradeType as TradeType2 } from "@uniswap/sdk-core";
import { SwapQuoter } from "@uniswap/v3-sdk";
import { ethers as ethers2 } from "ethers";
async function getOutputQuote(quoter, currencyAmount, route) {
  const { calldata } = await SwapQuoter.quoteCallParameters(route, currencyAmount, TradeType2.EXACT_INPUT, {
    useQuoterV2: true
  });
  const quoteCallReturnData = await quoter.provider.call({
    to: quoter.address,
    data: calldata
  });
  return ethers2.utils.defaultAbiCoder.decode(["uint256"], quoteCallReturnData);
}

// src/crosschain/trade/uniV3Trade.ts
import JSBI12 from "jsbi";

// src/crosschain/trade/uniV3Trade/toUniTypes.ts
import { Token as TokenUni, CurrencyAmount as CurrencyAmount2 } from "@uniswap/sdk-core";

// src/crosschain/trade/uniV3Trade/gasToken.ts
import { NativeCurrency } from "@uniswap/sdk-core";
import invariant10 from "tiny-invariant";
var _GasToken = class _GasToken extends NativeCurrency {
  constructor(chainId) {
    super(chainId, 18, "RBTC", "RBTC");
  }
  get wrapped() {
    const weth9 = WETH[this.chainId];
    invariant10(!!weth9, "WRAPPED");
    return toUniToken(weth9);
  }
  static onChain(chainId) {
    return this._cache[chainId] ?? (this._cache[chainId] = new _GasToken(chainId));
  }
  equals(other) {
    return other.isNative && other.chainId === this.chainId;
  }
};
_GasToken._cache = {};
var GasToken = _GasToken;

// src/crosschain/trade/uniV3Trade/toUniTypes.ts
function toUniToken(token) {
  return new TokenUni(token.chainId, token.address, token.decimals);
}
function toUniCurrency(token) {
  if (token.isNative) {
    return GasToken.onChain(token.chainId);
  }
  return toUniToken(token);
}
function toUniCurrencyAmount(tokenAmount) {
  const currency = toUniCurrency(tokenAmount.token);
  return CurrencyAmount2.fromRawAmount(currency, tokenAmount.raw.toString());
}

// src/crosschain/trade/uniV3Trade.ts
import invariant11 from "tiny-invariant";
var POSSIBLE_FEES2 = [FeeAmount.LOWEST, FeeAmount.LOW, FeeAmount.MEDIUM, FeeAmount.HIGH];
var DEPLOYMENT_ADDRESSES = {
  [30 /* RSK_MAINNET */]: {
    factory: "0xaF37EC98A00FD63689CF3060BF3B6784E00caD82",
    quoter: "0xb51727c996C68E60F598A923a5006853cd2fEB31",
    swap: "0x0B14ff67f0014046b4b99057Aec4509640b3947A",
    baseTokens: [
      new Token({
        name: "Tether USD",
        symbol: "rUSDT",
        address: "0xef213441a85df4d7acbdae0cf78004e1e486bb96",
        chainId: 30 /* RSK_MAINNET */,
        decimals: 18
      })
    ]
  }
  // [ChainId.CORE_MAINNET]: {
  //     factory: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
  //     quoter: '0x640129e6b5C31B3b12640A5b39FECdCa9F81C640',
  //     swap: '0x734583f62Bb6ACe3c9bA9bd5A53143CA2Ce8C55A',
  //     baseTokens: [
  //         new Token({
  //             name: 'Tether USD',
  //             symbol: 'USDT',
  //             address: '0x900101d06A7426441Ae63e9AB3B9b0F63Be145F1',
  //             chainId: ChainId.CORE_MAINNET,
  //             decimals: 6,
  //         }),
  //     ],
  // },
};
var UniV3Trade = class _UniV3Trade {
  constructor(params) {
    this.tradeType = "uni-v3";
    this.priceImpact = new Percent("0", "100");
    const { symbiosis, tokenAmountIn, tokenOut, slippage, ttl, to } = params;
    this.symbiosis = symbiosis;
    this.tokenAmountIn = tokenAmountIn;
    this.tokenOut = tokenOut;
    this.slippage = slippage;
    this.ttl = ttl;
    this.to = to;
  }
  static isSupported(chainId) {
    return !!DEPLOYMENT_ADDRESSES[chainId];
  }
  async init() {
    const chainId = this.tokenAmountIn.token.chainId;
    const addresses = DEPLOYMENT_ADDRESSES[chainId];
    if (!addresses) {
      throw new Error2("Unsupported chain");
    }
    const provider = this.symbiosis.getProvider(chainId);
    const { quoter, swap, factory } = addresses;
    const currencyIn = toUniCurrency(this.tokenAmountIn.token);
    const currencyOut = toUniCurrency(this.tokenOut);
    const factoryContract = UniV3Factory__factory.connect(factory, provider);
    const quoterContract = UniV3Quoter__factory.connect(quoter, provider);
    const promises = POSSIBLE_FEES2.map(async (fee) => {
      const pool = await getPool(factoryContract, currencyIn.wrapped, currencyOut.wrapped, fee);
      if (!pool) {
        return;
      }
      const swapRoute = new Route3([pool], currencyIn, currencyOut);
      const result = await getOutputQuote(quoterContract, toUniCurrencyAmount(this.tokenAmountIn), swapRoute);
      return {
        fee,
        swapRoute,
        amountOut: JSBI12.BigInt(result.toString())
      };
    });
    const results = await Promise.allSettled(promises);
    let bestSwapRoute = void 0;
    let bestAmountOut = void 0;
    for (const result of results) {
      if (result.status === "rejected") {
        console.error(`UniV3Trade rejected: ${JSON.stringify(result.reason?.toString())}`);
        continue;
      }
      if (!result.value) {
        continue;
      }
      const { amountOut, swapRoute } = result.value;
      if (!bestAmountOut || JSBI12.greaterThan(amountOut, bestAmountOut)) {
        bestAmountOut = amountOut;
        bestSwapRoute = swapRoute;
      }
    }
    if (!bestAmountOut || !bestSwapRoute) {
      throw new Error2("Route not found");
    }
    this.amountOut = new TokenAmount(this.tokenOut, bestAmountOut.toString());
    this.amountOutMin = new TokenAmount(this.tokenOut, bestAmountOut.toString());
    const trade = Trade3.createUncheckedTrade({
      route: bestSwapRoute,
      inputAmount: CurrencyAmount3.fromRawAmount(currencyIn, this.tokenAmountIn.raw.toString()),
      outputAmount: CurrencyAmount3.fromRawAmount(currencyOut, bestAmountOut),
      tradeType: TradeType3.EXACT_INPUT
    });
    const slippageTolerance = new PercentUni((this.slippage * 100).toFixed(0), "1000000");
    const options = {
      slippageTolerance,
      deadline: Math.floor(Date.now() / 1e3) + this.ttl,
      recipient: this.to
    };
    const methodParameters = _UniV3Trade.swapCallParameters([trade], options, swap);
    this.priceImpact = new Percent(
      JSBI12.multiply(trade.priceImpact.numerator, JSBI12.BigInt("-1")),
      trade.priceImpact.denominator
    );
    this.callDataOffset = _UniV3Trade.getOffset(methodParameters.calldata);
    this.routerAddress = swap;
    this.callData = methodParameters.calldata;
    this.route = [this.tokenAmountIn.token, this.tokenOut];
    return this;
  }
  static getOffset(callData) {
    const methods = [
      {
        // exactInputSingle
        sigHash: "04e45aaf",
        offset: 4 + 5 * 32
      },
      {
        // multicall
        sigHash: "ac9650d8",
        offset: 328
      }
    ];
    const sigHash = callData.slice(2, 10);
    const method = methods.find((i) => {
      return i.sigHash === sigHash;
    });
    return method?.offset;
  }
  static swapCallParameters(trades, options, routerAddress) {
    if (!Array.isArray(trades)) {
      trades = [trades];
    }
    const sampleTrade = trades[0];
    const tokenIn = sampleTrade.inputAmount.currency.wrapped;
    const tokenOut = sampleTrade.outputAmount.currency.wrapped;
    invariant11(
      trades.every((trade) => trade.inputAmount.currency.wrapped.equals(tokenIn)),
      "TOKEN_IN_DIFF"
    );
    invariant11(
      trades.every((trade) => trade.outputAmount.currency.wrapped.equals(tokenOut)),
      "TOKEN_OUT_DIFF"
    );
    const calldatas = [];
    const ZERO_IN = CurrencyAmount3.fromRawAmount(trades[0].inputAmount.currency, 0);
    const ZERO_OUT = CurrencyAmount3.fromRawAmount(trades[0].outputAmount.currency, 0);
    const totalAmountOut = trades.reduce(
      (sum, trade) => sum.add(trade.minimumAmountOut(options.slippageTolerance)),
      ZERO_OUT
    );
    const mustRefund = sampleTrade.inputAmount.currency.isNative && sampleTrade.tradeType === TradeType3.EXACT_OUTPUT;
    const inputIsNative = sampleTrade.inputAmount.currency.isNative;
    const outputIsNative = sampleTrade.outputAmount.currency.isNative;
    const routerMustCustody = outputIsNative || !!options.fee;
    const totalValue = inputIsNative ? trades.reduce((sum, trade) => sum.add(trade.maximumAmountIn(options.slippageTolerance)), ZERO_IN) : ZERO_IN;
    if (options.inputTokenPermit) {
      invariant11(sampleTrade.inputAmount.currency.isToken, "NON_TOKEN_PERMIT");
      calldatas.push(SelfPermit.encodePermit(sampleTrade.inputAmount.currency, options.inputTokenPermit));
    }
    const recipient = validateAndParseAddress2(options.recipient);
    for (const trade of trades) {
      for (const { route, inputAmount, outputAmount } of trade.swaps) {
        const amountIn = toHex2(trade.maximumAmountIn(options.slippageTolerance, inputAmount).quotient);
        const amountOut = toHex2(
          trade.minimumAmountOut(options.slippageTolerance, outputAmount).quotient
        );
        const singleHop = route.pools.length === 1;
        if (singleHop) {
          if (trade.tradeType === TradeType3.EXACT_INPUT) {
            const exactInputSingleParams = {
              tokenIn: route.tokenPath[0].address,
              tokenOut: route.tokenPath[1].address,
              fee: route.pools[0].fee,
              recipient: routerMustCustody ? routerAddress : recipient,
              amountIn,
              amountOutMinimum: amountOut,
              sqrtPriceLimitX96: toHex2(options.sqrtPriceLimitX96 ?? 0)
            };
            calldatas.push(
              UniV3Router__factory.createInterface().encodeFunctionData("exactInputSingle", [
                exactInputSingleParams
              ])
            );
          } else {
            const exactOutputSingleParams = {
              tokenIn: route.tokenPath[0].address,
              tokenOut: route.tokenPath[1].address,
              fee: route.pools[0].fee,
              recipient: routerMustCustody ? routerAddress : recipient,
              amountOut,
              amountInMaximum: amountIn,
              sqrtPriceLimitX96: toHex2(options.sqrtPriceLimitX96 ?? 0)
            };
            calldatas.push(
              UniV3Router__factory.createInterface().encodeFunctionData("exactOutputSingle", [
                exactOutputSingleParams
              ])
            );
          }
        } else {
          invariant11(options.sqrtPriceLimitX96 === void 0, "MULTIHOP_PRICE_LIMIT");
          const path = encodeRouteToPath(route, trade.tradeType === TradeType3.EXACT_OUTPUT);
          if (trade.tradeType === TradeType3.EXACT_INPUT) {
            const exactInputParams = {
              path,
              recipient: routerMustCustody ? routerAddress : recipient,
              amountIn,
              amountOutMinimum: amountOut
            };
            calldatas.push(
              UniV3Router__factory.createInterface().encodeFunctionData("exactInput", [exactInputParams])
            );
          } else {
            const exactOutputParams = {
              path,
              recipient: routerMustCustody ? routerAddress : recipient,
              amountOut,
              amountInMaximum: amountIn
            };
            calldatas.push(
              UniV3Router__factory.createInterface().encodeFunctionData("exactOutput", [
                exactOutputParams
              ])
            );
          }
        }
      }
    }
    if (routerMustCustody) {
      if (options.fee) {
        if (outputIsNative) {
          calldatas.push(Payments.encodeUnwrapWETH9(totalAmountOut.quotient, recipient, options.fee));
        } else {
          calldatas.push(
            Payments.encodeSweepToken(
              sampleTrade.outputAmount.currency.wrapped,
              totalAmountOut.quotient,
              recipient,
              options.fee
            )
          );
        }
      } else {
        calldatas.push(Payments.encodeUnwrapWETH9(totalAmountOut.quotient, recipient));
      }
    }
    if (mustRefund) {
      calldatas.push(Payments.encodeRefundETH());
    }
    return {
      calldata: Multicall2.encodeMulticall(calldatas),
      value: toHex2(totalValue.quotient)
    };
  }
};

// src/crosschain/trade/aggregatorTrade.ts
var TradeNotInitializedError = class extends Error {
  constructor() {
    super("Trade is not initialized");
  }
};
var OPEN_OCEAN_CLIENT_ID = utils38.formatBytes32String("openocean");
function limitOpenOceanPromise() {
  return new Promise((_resolve, reject) => {
    setTimeout(() => {
      reject(new Error("Timeout OO"));
    }, 5 * 1e3);
  });
}
var AggregatorTrade = class {
  constructor(params) {
    this.params = params;
  }
  static isAvailable(chainId) {
    return OneInchTrade.isAvailable(chainId) || OpenOceanTrade.isAvailable(chainId) || IzumiTrade.isSupported(chainId) || UniV3Trade.isSupported(chainId);
  }
  async init() {
    const { dataProvider, from, slippage, symbiosis, to, tokenAmountIn, tokenOut, clientId, ttl } = this.params;
    const aggregators = [];
    if (OneInchTrade.isAvailable(tokenAmountIn.token.chainId)) {
      const oracle = symbiosis.oneInchOracle(this.params.tokenAmountIn.token.chainId);
      const oneInchTrade = new OneInchTrade(
        this.params.symbiosis,
        tokenAmountIn,
        tokenOut,
        from,
        to,
        slippage,
        oracle,
        dataProvider,
        this.params.oneInchProtocols
      );
      aggregators.push(oneInchTrade.init());
    }
    if (OpenOceanTrade.isAvailable(tokenAmountIn.token.chainId)) {
      const openOceanTrade = new OpenOceanTrade({
        symbiosis,
        slippage,
        to,
        tokenAmountIn,
        tokenOut
      });
      const promises = [openOceanTrade.init()];
      if (clientId !== OPEN_OCEAN_CLIENT_ID) {
        promises.push(limitOpenOceanPromise());
      }
      aggregators.push(Promise.race(promises));
    }
    if (IzumiTrade.isSupported(tokenAmountIn.token.chainId)) {
      const izumiTrade = new IzumiTrade({
        symbiosis,
        tokenAmountIn,
        tokenOut,
        slippage,
        ttl,
        to
      });
      aggregators.push(izumiTrade.init());
    }
    if (UniV3Trade.isSupported(tokenAmountIn.token.chainId)) {
      const uniV3Trade = new UniV3Trade({
        symbiosis,
        tokenAmountIn,
        tokenOut,
        slippage,
        ttl,
        to
      });
      aggregators.push(uniV3Trade.init());
    }
    aggregators.push(this.buildUniLikeTrade());
    const tradesResults = await Promise.allSettled(aggregators);
    let bestTrade;
    for (const trade of tradesResults) {
      if (trade.status === "rejected") {
        console.error(`AggregatorTrade rejected: ${JSON.stringify(trade.reason?.toString())}`);
        continue;
      }
      if (!bestTrade) {
        bestTrade = trade.value;
        continue;
      }
      if (trade.value.amountOut.greaterThan(bestTrade.amountOut)) {
        bestTrade = trade.value;
      }
    }
    this.trade = bestTrade;
    return this;
  }
  assertTradeInitialized() {
    if (!this.trade) {
      throw new TradeNotInitializedError();
    }
  }
  async buildUniLikeTrade() {
    const { symbiosis, tokenAmountIn, tokenOut, to, slippage, ttl } = this.params;
    const { chainId } = tokenAmountIn.token;
    let router = symbiosis.uniLikeRouter(chainId);
    if (chainId === 43114 /* AVAX_MAINNET */) {
      router = symbiosis.avaxRouter(chainId);
    }
    if ([200101 /* MILKOMEDA_DEVNET */, 2001 /* MILKOMEDA_MAINNET */].includes(chainId)) {
      router = symbiosis.adaRouter(chainId);
    }
    if ([2222 /* KAVA_MAINNET */].includes(chainId)) {
      router = symbiosis.kavaRouter(chainId);
    }
    if ([34443 /* MODE_MAINNET */].includes(chainId)) {
      router = symbiosis.kimRouter(chainId);
    }
    if ([1329 /* SEI_EVM_MAINNET */].includes(chainId)) {
      const address2 = symbiosis.chainConfig(chainId).router;
      const provider = symbiosis.getProvider(chainId);
      router = DragonswapRouter__factory.connect(address2, provider);
    }
    const dexFee = symbiosis.dexFee(chainId);
    const trade = new UniLikeTrade(tokenAmountIn, tokenOut, to, slippage, ttl, router, dexFee);
    await trade.init();
    return trade;
  }
  /**
   * TODO: Use proxy to avoid code duplication
   */
  get callData() {
    this.assertTradeInitialized();
    return this.trade.callData;
  }
  get callDataOffset() {
    this.assertTradeInitialized();
    return this.trade.callDataOffset || 0;
  }
  get tokenAmountIn() {
    this.assertTradeInitialized();
    return this.trade.tokenAmountIn;
  }
  get amountOut() {
    this.assertTradeInitialized();
    return this.trade.amountOut;
  }
  get amountOutMin() {
    this.assertTradeInitialized();
    return this.trade.amountOutMin;
  }
  get routerAddress() {
    this.assertTradeInitialized();
    return this.trade.routerAddress;
  }
  get priceImpact() {
    this.assertTradeInitialized();
    return this.trade.priceImpact;
  }
  get route() {
    this.assertTradeInitialized();
    return this.trade.route;
  }
  get tradeType() {
    this.assertTradeInitialized();
    return this.trade.tradeType;
  }
  get functionSelector() {
    this.assertTradeInitialized();
    if ("functionSelector" in this.trade) {
      return this.trade.functionSelector;
    }
    return void 0;
  }
};

// src/crosschain/trade/omniTrade.ts
import { BigNumber as BigNumber6 } from "ethers";
var EXTRA_FEE_COLLECTORS = [
  {
    // 0.6%
    chainId: 56288 /* BOBA_BNB */,
    address: "0xe8035f3e32E1728A0558B67C6F410607d7Da2B6b",
    eligibleChains: []
  },
  {
    // 0.5%
    chainId: 56288 /* BOBA_BNB */,
    address: "0xe63a8E9fD72e70121f99974A4E288Fb9e8668BBe",
    eligibleChains: []
  },
  {
    // 0.4%
    chainId: 56288 /* BOBA_BNB */,
    address: "0x5f5829F7CDca871b16ed76E498EeE35D4250738A",
    eligibleChains: []
  },
  {
    // 0.3%
    chainId: 56288 /* BOBA_BNB */,
    address: "0x0E8c084c7Edcf863eDdf0579A013b5c9f85462a2",
    eligibleChains: [25 /* CRONOS_MAINNET */]
  },
  {
    // 0.2%
    chainId: 56288 /* BOBA_BNB */,
    address: "0x56aE0251a9059fb35C21BffBe127d8E769A34D0D",
    eligibleChains: [728126428 /* TRON_MAINNET */]
  },
  {
    // 0.1%
    chainId: 56288 /* BOBA_BNB */,
    address: "0x602Bf79772763fEe47701FA2772F5aA9d505Fbf4",
    eligibleChains: [1329 /* SEI_EVM_MAINNET */, 85918 /* TON_MAINNET */]
  }
];
var OmniTrade = class {
  constructor(tokenAmountIn, tokenAmountInMin, tokenOut, slippage, deadline, symbiosis, to, omniPoolConfig) {
    this.tokenAmountIn = tokenAmountIn;
    this.tokenAmountInMin = tokenAmountInMin;
    this.tokenOut = tokenOut;
    this.slippage = slippage;
    this.deadline = deadline;
    this.symbiosis = symbiosis;
    this.to = to;
    this.omniPoolConfig = omniPoolConfig;
    this.pool = this.symbiosis.omniPool(omniPoolConfig);
    this.poolOracle = this.symbiosis.omniPoolOracle(omniPoolConfig);
    this.callDataOffset = 100;
  }
  async init() {
    this.route = [this.tokenAmountIn.token, this.tokenOut];
    const indexIn = this.symbiosis.getOmniPoolTokenIndex(this.omniPoolConfig, this.tokenAmountIn.token);
    const indexOut = this.symbiosis.getOmniPoolTokenIndex(this.omniPoolConfig, this.tokenOut);
    let amountIn = BigNumber6.from(this.tokenAmountIn.raw.toString());
    let amountInMin = BigNumber6.from(this.tokenAmountInMin.raw.toString());
    const preFeeCollector = this.getExtraFeeCollector(this.tokenAmountIn.token);
    const postFeeCollector = this.getExtraFeeCollector(this.tokenOut);
    const feeRateBase = BigNumber6.from(10).pow(18);
    const [preFeeRate, postFeeRate] = await Promise.all([
      preFeeCollector ? this.getFeeRate(preFeeCollector) : BigNumber6.from(0),
      postFeeCollector ? this.getFeeRate(postFeeCollector) : BigNumber6.from(0)
    ]);
    if (preFeeCollector) {
      amountIn = amountIn.sub(amountIn.mul(preFeeRate).div(feeRateBase));
      amountInMin = amountInMin.sub(amountInMin.mul(preFeeRate).div(feeRateBase));
    }
    let { actualToAmount: quote } = await this.poolOracle.quoteFrom(indexIn, indexOut, amountIn);
    let quoteMin = quote;
    if (!amountIn.eq(amountInMin)) {
      const response = await this.poolOracle.quoteFrom(indexIn, indexOut, amountInMin);
      quoteMin = response.actualToAmount;
    }
    if (postFeeCollector) {
      quote = quote.sub(quote.mul(postFeeRate).div(feeRateBase));
      quoteMin = quoteMin.sub(quoteMin.mul(postFeeRate).div(feeRateBase));
    }
    this.amountOut = new TokenAmount(this.tokenOut, quote.toString());
    const amountOutMinRaw = getMinAmount(this.slippage, quoteMin.toString());
    this.amountOutMin = new TokenAmount(this.tokenOut, amountOutMinRaw);
    this.callData = this.pool.interface.encodeFunctionData("swap", [
      indexIn,
      indexOut,
      this.tokenAmountIn.raw.toString(),
      amountOutMinRaw.toString(),
      this.to,
      this.deadline
    ]);
    const priceImpact = calculatePriceImpact(this.tokenAmountIn, this.amountOut);
    if (!priceImpact) {
      throw new Error("Cannot calculate priceImpact");
    }
    this.priceImpact = priceImpact;
    return this;
  }
  buildFeePreCall() {
    return this.buildFeeCall(this.tokenAmountIn);
  }
  buildFeePostCall() {
    return this.buildFeeCall(this.amountOut);
  }
  // private
  async getFeeRate(extraFeeCollector) {
    const { chainId, address: address2 } = extraFeeCollector;
    const provider = this.symbiosis.getProvider(chainId);
    const feeCollector = OctoPoolFeeCollector__factory.connect(address2, provider);
    return feeCollector.feeRate();
  }
  getExtraFeeCollector(token) {
    if (!token.chainFromId) {
      return void 0;
    }
    return EXTRA_FEE_COLLECTORS.find((i) => {
      return i.chainId === this.omniPoolConfig.chainId && i.eligibleChains.includes(token.chainFromId);
    });
  }
  buildFeeCall(tokenAmount) {
    const extraFeeCollector = this.getExtraFeeCollector(tokenAmount.token);
    if (!extraFeeCollector) {
      return;
    }
    const calldata = OctoPoolFeeCollector__factory.createInterface().encodeFunctionData("collectFee", [
      tokenAmount.raw.toString(),
      tokenAmount.token.address
    ]);
    return {
      calldata,
      receiveSide: extraFeeCollector.address,
      path: tokenAmount.token.address,
      offset: 36
    };
  }
};

// src/crosschain/trade/wrapTrade.ts
var UNWRAP_ADDRESSES = {
  [1 /* ETH_MAINNET */]: "0x5ad095DE83693ba063941f2f2C5A0dF02383B651",
  [169 /* MANTA_MAINNET */]: "0xf39D9A9ABb98593ceaC395D7A37c572Da48fCfD5",
  [59144 /* LINEA_MAINNET */]: "0xF5b0861e787706195c98E2F0d2D6EFBDAC1D1e08",
  [1101 /* POLYGON_ZK */]: "0xf02bBC9de6e443eFDf3FC41851529C2c3B9E5e0C",
  [8453 /* BASE_MAINNET */]: "0x8e1d36F9da8CFe842bCf8670A12ACd51c26d195D",
  [534352 /* SCROLL_MAINNET */]: "0x42Cd64f48496dDdfEfF8F3704df9175dbe20d325",
  [42161 /* ARBITRUM_MAINNET */]: "0x5Eb4ED9F745531221FAE41906e11d37642B15da6",
  [42170 /* ARBITRUM_NOVA */]: "0xf02bBC9de6e443eFDf3FC41851529C2c3B9E5e0C",
  [10 /* OPTIMISM_MAINNET */]: "0x88139ad1199e8c78a0804d4bEBF4FbAD89EF9D89",
  [324 /* ZKSYNC_MAINNET */]: "0x1Cd08E632DfC63998add8840c8B9c97A4cA6DAb4",
  [288 /* BOBA_MAINNET */]: "0xA257F3FE4E4032291516DC355eDF90664e9eB932",
  [34443 /* MODE_MAINNET */]: "0xE75C7E85FE6ADd07077467064aD15847E6ba9877",
  [81457 /* BLAST_MAINNET */]: "0x2b7Aa8bDc40B6d3d19d0dE7480c4db8d5B6495e2",
  [30 /* RSK_MAINNET */]: "0x5b1bab64961cf72822817ef32950ff7fcab28b62",
  [4200 /* MERLIN_MAINNET */]: "0x8a7F930003BedD63A1ebD99C5917FD6aE7E3dedf",
  [810180 /* ZKLINK_MAINNET */]: "0xd17Ee77a10376Dab561d947F5e5FC5cf6de67441",
  [534351 /* SCROLL_SEPOLIA */]: "0x97A5B271421b443b3F53F3DF485B2716Db85fA4b",
  [11155111 /* SEPOLIA_TESTNET */]: "0x97A5B271421b443b3F53F3DF485B2716Db85fA4b",
  [167e3 /* TAIKO_MAINNET */]: "0x6AEb9b27590387b8Fd0560C52f6B968C59C10Fab",
  [1625 /* GRAVITY_MAINNET */]: "0x1cEaeda3D17936916D0F3E866Aa5Ef861F544840",
  [223 /* BSQUARED_MAINNET */]: "0x6AEb9b27590387b8Fd0560C52f6B968C59C10Fab"
};
var WrapTrade = class {
  constructor(tokenAmountIn, tokenOut, to) {
    this.tokenAmountIn = tokenAmountIn;
    this.tokenOut = tokenOut;
    this.to = to;
    this.tradeType = "wrap";
    this.priceImpact = new Percent("0");
  }
  static isSupported(tokenAmountIn, tokenOut) {
    const wrappedInToken = wrappedToken(tokenAmountIn.token);
    if (tokenAmountIn.token.isNative && wrappedInToken.equals(tokenOut)) {
      return true;
    }
    const unwrapAddress = UNWRAP_ADDRESSES[tokenAmountIn.token.chainId];
    const wrappedOutToken = wrappedToken(tokenOut);
    return !!unwrapAddress && tokenOut.isNative && wrappedOutToken.equals(tokenAmountIn.token);
  }
  async init() {
    const wethInterface = Weth__factory.createInterface();
    if (this.tokenAmountIn.token.isNative) {
      const wethToken = wrappedToken(this.tokenAmountIn.token);
      this.route = [this.tokenAmountIn.token, wethToken];
      this.amountOut = new TokenAmount(wethToken, this.tokenAmountIn.raw);
      this.amountOutMin = this.amountOut;
      this.routerAddress = wethToken.address;
      this.callData = wethInterface.encodeFunctionData("deposit");
      this.functionSelector = getFunctionSelector(wethInterface.getFunction("deposit"));
      return this;
    }
    const unwrapperAddress = UNWRAP_ADDRESSES[this.tokenAmountIn.token.chainId];
    if (!unwrapperAddress) {
      throw new Error("Cannot unwrap on this network");
    }
    const unwrapperInterface = Unwrapper__factory.createInterface();
    this.route = [this.tokenAmountIn.token, this.tokenOut];
    this.amountOut = new TokenAmount(this.tokenOut, this.tokenAmountIn.raw);
    this.amountOutMin = this.amountOut;
    this.routerAddress = unwrapperAddress;
    this.callData = unwrapperInterface.encodeFunctionData("unwrap", [this.tokenAmountIn.raw.toString(), this.to]);
    this.functionSelector = getFunctionSelector(unwrapperInterface.getFunction("unwrap"));
    this.callDataOffset = 4 + 32;
    return this;
  }
};

// src/crosschain/tronAbis/tronPortalAbi.ts
var TRON_PORTAL_ABI = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_wrapper",
        type: "address"
      },
      {
        internalType: "address",
        name: "_whitelistedToken",
        type: "address"
      },
      {
        internalType: "contract IMetaRouter",
        name: "_metaRouter",
        type: "address"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "crossChainID",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bridgingFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "BurnCompleted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "clientId",
        type: "bytes32"
      }
    ],
    name: "ClientIdLog",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "MetaRevertRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferStarted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "RevertBurnRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bridgingFee",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "RevertSynthesizeCompleted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "tokens",
        type: "address[]"
      }
    ],
    name: "SetBalanceOf",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "metaRouter",
        type: "address"
      }
    ],
    name: "SetMetaRouter",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "timelock",
        type: "address"
      }
    ],
    name: "SetTimelock",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "threshold",
        type: "uint256"
      }
    ],
    name: "SetTokenThreshold",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "activate",
        type: "bool"
      }
    ],
    name: "SetWhitelistToken",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "chainID",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "revertableAddress",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "SynthesizeRequest",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "portal",
        type: "address"
      }
    ],
    name: "TokenTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "bridge",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getChainID",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "internalID",
            type: "bytes32"
          },
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "managerChainBridge",
            type: "address"
          },
          {
            internalType: "address",
            name: "sourceChainBridge",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "managerChainId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "sourceChainId",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "router",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "swapCalldata",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "sourceChainSynthesis",
            type: "address"
          },
          {
            internalType: "address",
            name: "burnToken",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "burnCalldata",
            type: "bytes"
          },
          {
            internalType: "bytes32",
            name: "clientID",
            type: "bytes32"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaRevertTransaction",
        name: "_metaRevertTransaction",
        type: "tuple"
      }
    ],
    name: "metaRevertRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "metaRouter",
    outputs: [
      {
        internalType: "contract IMetaRouter",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "rtoken",
            type: "address"
          },
          {
            internalType: "address",
            name: "chain2address",
            type: "address"
          },
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "oppositeBridge",
            type: "address"
          },
          {
            internalType: "address",
            name: "syntCaller",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "address[]",
            name: "swapTokens",
            type: "address[]"
          },
          {
            internalType: "address",
            name: "secondDexRouter",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "secondSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "finalReceiveSide",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "finalCalldata",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "finalOffset",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "revertableAddress",
            type: "address"
          },
          {
            internalType: "bytes32",
            name: "clientID",
            type: "bytes32"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaSynthesizeTransaction",
        name: "_metaSynthesizeTransaction",
        type: "tuple"
      }
    ],
    name: "metaSynthesize",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_crossChainID",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_rToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "_finalReceiveSide",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_finalCalldata",
        type: "bytes"
      },
      {
        internalType: "uint256",
        name: "_finalOffset",
        type: "uint256"
      }
    ],
    name: "metaUnsynthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "requestCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "requests",
    outputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "address",
        name: "chain2address",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "rtoken",
        type: "address"
      },
      {
        internalType: "enum Portal.RequestState",
        name: "state",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_internalID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainId",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "revertBurnRequest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      }
    ],
    name: "revertSynthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]"
      }
    ],
    name: "setBalanceOf",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "contract IMetaRouter",
        name: "_metaRouter",
        type: "address"
      }
    ],
    name: "setMetaRouter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_timelock",
        type: "address"
      }
    ],
    name: "setTimelock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_threshold",
        type: "uint256"
      }
    ],
    name: "setTokenThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "bool",
        name: "_activate",
        type: "bool"
      }
    ],
    name: "setWhitelistToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_chain2address",
        type: "address"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_revertableAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "synthesize",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_chain2address",
        type: "address"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "address",
        name: "_oppositeBridge",
        type: "address"
      },
      {
        internalType: "address",
        name: "_revertableAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_chainID",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_clientID",
        type: "bytes32"
      }
    ],
    name: "synthesizeNative",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "bytes",
            name: "approvalData",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "token",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "chain2address",
            type: "address"
          },
          {
            internalType: "address",
            name: "receiveSide",
            type: "address"
          },
          {
            internalType: "address",
            name: "oppositeBridge",
            type: "address"
          },
          {
            internalType: "address",
            name: "revertableAddress",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "clientID",
            type: "bytes32"
          }
        ],
        internalType: "struct Portal.SynthesizeWithPermitTransaction",
        name: "_syntWithPermitTx",
        type: "tuple"
      }
    ],
    name: "synthesizeWithPermit",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "timelock",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "tokenThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "tokenWhitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_portal",
        type: "address"
      },
      {
        internalType: "address",
        name: "_token",
        type: "address"
      }
    ],
    name: "transfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stableBridgingFee",
        type: "uint256"
      },
      {
        internalType: "bytes32",
        name: "_externalID",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "_crossChainID",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      }
    ],
    name: "unsynthesize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "unsynthesizeStates",
    outputs: [
      {
        internalType: "enum Portal.UnsynthesizeState",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "versionRecipient",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "wrapper",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];

// src/crosschain/tronAbis/tronTRC20Abi.ts
var TRON_TRC20_ABI = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      { indexed: true, name: "owner", type: "address" },
      { indexed: true, name: "spender", type: "address" },
      { name: "value", type: "uint256" }
    ],
    name: "Approval",
    type: "event"
  },
  {
    inputs: [
      { indexed: true, name: "from", type: "address" },
      { indexed: true, name: "to", type: "address" },
      { name: "value", type: "uint256" }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    outputs: [{ type: "uint256" }],
    constant: true,
    inputs: [
      { name: "owner", type: "address" },
      { name: "spender", type: "address" }
    ],
    name: "allowance",
    stateMutability: "view",
    type: "function"
  },
  {
    outputs: [{ type: "bool" }],
    inputs: [
      { name: "spender", type: "address" },
      { name: "value", type: "uint256" }
    ],
    name: "approve",
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    outputs: [{ type: "uint256" }],
    constant: true,
    inputs: [{ name: "account", type: "address" }],
    name: "balanceOf",
    stateMutability: "view",
    type: "function"
  },
  {
    outputs: [{ type: "uint8" }],
    inputs: [],
    constant: true,
    name: "decimals",
    stateMutability: "view",
    type: "function"
  },
  {
    outputs: [{ type: "bool" }],
    inputs: [
      { name: "spender", type: "address" },
      { name: "subtractedValue", type: "uint256" }
    ],
    name: "decreaseAllowance",
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    outputs: [{ type: "bool" }],
    inputs: [
      { name: "spender", type: "address" },
      { name: "addedValue", type: "uint256" }
    ],
    name: "increaseAllowance",
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    outputs: [{ type: "string" }],
    constant: true,
    name: "name",
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    outputs: [{ type: "string" }],
    constant: true,
    name: "symbol",
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    outputs: [{ type: "uint256" }],
    constant: true,
    name: "totalSupply",
    stateMutability: "view",
    type: "function"
  },
  {
    outputs: [{ type: "bool" }],
    inputs: [
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" }
    ],
    name: "transfer",
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    outputs: [{ type: "bool" }],
    inputs: [
      { name: "sender", type: "address" },
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" }
    ],
    name: "transferFrom",
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/crosschain/tronAbis/tronMetaRouterAbi.ts
var TRON_METAROUTER_ABI = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address"
      }
    ],
    name: "TransitTokenSent",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_receiveSide",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_calldata",
        type: "bytes"
      },
      {
        internalType: "uint256",
        name: "_offset",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_to",
        type: "address"
      }
    ],
    name: "externalCall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stableBridgingFee",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bytes32",
            name: "crossChainID",
            type: "bytes32"
          },
          {
            internalType: "bytes32",
            name: "externalID",
            type: "bytes32"
          },
          {
            internalType: "address",
            name: "tokenReal",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "chainID",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "to",
            type: "address"
          },
          {
            internalType: "address[]",
            name: "swapTokens",
            type: "address[]"
          },
          {
            internalType: "address",
            name: "secondDexRouter",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "secondSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "address",
            name: "finalReceiveSide",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "finalCalldata",
            type: "bytes"
          },
          {
            internalType: "uint256",
            name: "finalOffset",
            type: "uint256"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaMintTransaction",
        name: "_metaMintTransaction",
        type: "tuple"
      }
    ],
    name: "metaMintSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes",
            name: "firstSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "bytes",
            name: "secondSwapCalldata",
            type: "bytes"
          },
          {
            internalType: "address[]",
            name: "approvedTokens",
            type: "address[]"
          },
          {
            internalType: "address",
            name: "firstDexRouter",
            type: "address"
          },
          {
            internalType: "address",
            name: "secondDexRouter",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "bool",
            name: "nativeIn",
            type: "bool"
          },
          {
            internalType: "address",
            name: "relayRecipient",
            type: "address"
          },
          {
            internalType: "bytes",
            name: "otherSideCalldata",
            type: "bytes"
          }
        ],
        internalType: "struct MetaRouteStructs.MetaRouteTransaction",
        name: "_metarouteTransaction",
        type: "tuple"
      }
    ],
    name: "metaRoute",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "metaRouterGateway",
    outputs: [
      {
        internalType: "contract MetaRouterGateway",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_router",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_swapCalldata",
        type: "bytes"
      },
      {
        internalType: "address",
        name: "_burnToken",
        type: "address"
      },
      {
        internalType: "address",
        name: "_synthesis",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "_burnCalldata",
        type: "bytes"
      }
    ],
    name: "returnSwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/crosschain/revert.ts
var RevertPending = class {
  constructor(symbiosis, request) {
    this.symbiosis = symbiosis;
    this.request = request;
    const token = this.request.fromTokenAmount.token;
    const omniPoolConfig = symbiosis.getOmniPoolByToken(token);
    if (!omniPoolConfig) {
      throw new Error2(`Cannot find omni pool config by token ${token.address}`);
    }
    this.omniPoolConfig = omniPoolConfig;
    this.multicallRouter = this.symbiosis.multicallRouter(this.omniPoolConfig.chainId);
  }
  async revert(slippage, deadline) {
    this.slippage = slippage;
    this.deadline = deadline;
    this.transitTokenFrom = this.symbiosis.transitToken(this.request.chainIdFrom, this.omniPoolConfig);
    this.transitTokenTo = this.symbiosis.transitToken(this.request.chainIdTo, this.omniPoolConfig);
    const fee = await this.getFee();
    const feeV2 = this.request.type === "burn-v2" ? await this.getFeeV2() : void 0;
    const transactionRequest = await this.getTransactionRequest(fee, feeV2);
    if ("call_value" in transactionRequest) {
      return {
        type: "tron",
        fee,
        transactionRequest
      };
    }
    return {
      type: "evm",
      fee,
      transactionRequest,
      execute: (signer) => this.execute(transactionRequest, signer)
    };
  }
  async waitForCompleteV2() {
    const { chainIdFrom, internalId, chainIdTo, revertableAddress } = this.request;
    const externalId = getExternalId({
      internalId,
      chainId: chainIdTo,
      revertableAddress,
      contractAddress: this.symbiosis.portal(chainIdTo).address
    });
    const mChainSynthesis = this.symbiosis.synthesis(this.omniPoolConfig.chainId);
    const revertBurnLog = await getLogWithTimeout({
      chainId: this.omniPoolConfig.chainId,
      filter: mChainSynthesis.filters.RevertBurnCompleted(externalId),
      symbiosis: this.symbiosis
    });
    const receipt = await mChainSynthesis.provider.getTransactionReceipt(revertBurnLog.transactionHash);
    const wfc = new LegacyWaitForComplete({
      direction: "burn",
      symbiosis: this.symbiosis,
      revertableAddress,
      chainIdIn: this.omniPoolConfig.chainId,
      chainIdOut: chainIdFrom
    });
    const log = await wfc.waitForComplete(receipt);
    return log.transactionHash;
  }
  async waitForCompleteV2Revert() {
    const { chainIdFrom, chainIdTo, revertableAddress } = this.request;
    const synthesis = this.symbiosis.synthesis(chainIdFrom);
    const externalId = this.getExternalId();
    const filter = synthesis.filters.RevertBurnCompleted(externalId);
    const revertBurnLog = await getLogWithTimeout({ chainId: chainIdFrom, filter, symbiosis: this.symbiosis });
    const receipt = await synthesis.provider.getTransactionReceipt(revertBurnLog.transactionHash);
    const wfc = new LegacyWaitForComplete({
      direction: "burn",
      symbiosis: this.symbiosis,
      revertableAddress,
      chainIdIn: chainIdFrom,
      chainIdOut: chainIdTo
    });
    const log = await wfc.waitForComplete(receipt);
    return log.transactionHash;
  }
  // Wait for the revert transaction to be mined on the original chain
  async waitForComplete() {
    const { type } = this.request;
    if (type === "burn-v2") {
      return this.waitForCompleteV2();
    }
    if (type === "burn-v2-revert") {
      return this.waitForCompleteV2Revert();
    }
    const { chainIdFrom } = this.request;
    const externalId = this.getExternalId();
    let filter;
    if (type === "synthesize" || type === "synthesize-v2") {
      const otherPortal = this.symbiosis.portal(chainIdFrom);
      filter = otherPortal.filters.RevertSynthesizeCompleted(externalId);
    } else {
      const otherSynthesis = this.symbiosis.synthesis(chainIdFrom);
      filter = otherSynthesis.filters.RevertBurnCompleted(externalId);
    }
    const log = await getLogWithTimeout({ chainId: chainIdFrom, filter, symbiosis: this.symbiosis });
    return log.transactionHash;
  }
  async getFeeV2() {
    const feeToken = this.transitTokenFrom;
    const [receiveSide, calldata] = await this.feeBurnCallDataV2();
    const { price: fee } = await this.symbiosis.getBridgeFee({
      receiveSide,
      calldata,
      chainIdFrom: this.omniPoolConfig.chainId,
      chainIdTo: this.request.chainIdFrom
    });
    return new TokenAmount(feeToken, fee);
  }
  async feeBurnCallDataV2() {
    const chainIdIn = this.omniPoolConfig.chainId;
    const chainIdOut = this.request.chainIdFrom;
    const { revertableAddress, fromTokenAmount } = this.request;
    const synthesis = this.symbiosis.synthesis(chainIdIn);
    const portal = this.symbiosis.portal(chainIdOut);
    const internalId = getInternalId({
      contractAddress: synthesis.address,
      requestCount: MaxUint256,
      chainId: chainIdIn
    });
    const externalId = getExternalId({
      internalId,
      contractAddress: portal.address,
      revertableAddress,
      chainId: chainIdOut
    });
    const calldata = portal.interface.encodeFunctionData("metaUnsynthesize", [
      "0",
      // _stableBridgingFee
      CROSS_CHAIN_ID,
      // crossChainID
      externalId,
      // _externalID,
      revertableAddress,
      // _to
      fromTokenAmount.raw.toString(),
      // _amount
      this.transitTokenFrom.address,
      // _rToken
      AddressZero4,
      // _finalReceiveSide
      [],
      // _finalCalldata
      0
      // _finalOffset
    ]);
    return [portal.address, calldata];
  }
  buildMetaBurnCalldata(feeV2) {
    const { from, chainIdFrom } = this.request;
    const synthesis = this.symbiosis.synthesis(this.omniPoolConfig.chainId);
    const synth = this.getSyntheticToken(this.transitTokenFrom);
    if (!synth) {
      throw new Error2(`Cannot find synthetic token between mChain and ${chainIdFrom}`);
    }
    const metarouter = this.symbiosis.metaRouter(this.omniPoolConfig.chainId);
    let revertableAddress;
    if (isTronChainId(chainIdFrom)) {
      revertableAddress = this.symbiosis.getRevertableAddress(chainIdFrom);
    } else {
      revertableAddress = from;
    }
    const calldata = synthesis.interface.encodeFunctionData("metaBurnSyntheticToken", [
      {
        stableBridgingFee: feeV2 ? feeV2.raw.toString() : "0",
        amount: "0",
        crossChainID: CROSS_CHAIN_ID,
        syntCaller: metarouter.address,
        finalReceiveSide: AddressZero4,
        sToken: synth.address,
        finalCallData: [],
        finalOffset: 0,
        chain2address: from,
        // NOTE: funds will be returned there if got stuck
        receiveSide: this.symbiosis.portal(chainIdFrom).address,
        oppositeBridge: this.symbiosis.bridge(chainIdFrom).address,
        revertableAddress,
        chainID: chainIdFrom,
        clientID: this.symbiosis.clientId
      }
    ]);
    return [synth.address, calldata];
  }
  async getFee() {
    const { type, chainIdTo, chainIdFrom, internalId, revertableAddress } = this.request;
    const externalId = this.getExternalId();
    let receiveSide;
    let calldata;
    let advisorChainIdFrom = chainIdTo;
    let advisorChainIdTo = chainIdFrom;
    const feeToken = this.request.originalFromTokenAmount.token;
    if (type === "synthesize") {
      const portal = this.symbiosis.portal(chainIdFrom);
      calldata = portal.interface.encodeFunctionData("revertSynthesize", ["0", externalId]);
      receiveSide = portal.address;
    } else if (type === "burn") {
      const synthesis = this.symbiosis.synthesis(chainIdFrom);
      calldata = synthesis.interface.encodeFunctionData("revertBurn", ["0", externalId]);
      receiveSide = synthesis.address;
    } else if (type === "synthesize-v2") {
      advisorChainIdFrom = chainIdFrom;
      advisorChainIdTo = chainIdTo;
      const synthesis = this.symbiosis.synthesis(chainIdTo);
      calldata = synthesis.interface.encodeFunctionData("revertSynthesizeRequestByBridge", [
        "0",
        internalId,
        this.symbiosis.portal(chainIdFrom).address,
        // _receiveSide
        this.symbiosis.bridge(chainIdFrom).address,
        // _oppositeBridge
        chainIdFrom,
        // _chainId
        revertableAddress,
        // _sender
        this.symbiosis.clientId
        // _clientId
      ]);
      receiveSide = synthesis.address;
    } else if (type === "burn-v2") {
      advisorChainIdTo = this.omniPoolConfig.chainId;
      const synthesis = this.symbiosis.synthesis(this.omniPoolConfig.chainId);
      const [router, swapCalldata] = await this.buildSwapCalldata();
      const [burnToken, burnCalldata] = this.buildMetaBurnCalldata();
      calldata = synthesis.interface.encodeFunctionData("revertMetaBurn", [
        "0",
        // stableBridgingFee
        externalId,
        router,
        swapCalldata,
        synthesis.address,
        burnToken,
        burnCalldata
      ]);
      receiveSide = synthesis.address;
    } else {
      const synthesis = this.symbiosis.synthesis(chainIdFrom);
      calldata = synthesis.interface.encodeFunctionData("revertBurnAndBurn", [
        "0",
        // stableBridgingFee
        externalId,
        this.symbiosis.portal(chainIdTo).address,
        // _receiveSide
        this.symbiosis.bridge(chainIdTo).address,
        // _oppositeBridge
        chainIdTo,
        // _chainId
        revertableAddress
        // _revertableAddress
      ]);
      receiveSide = synthesis.address;
    }
    const { price: fee } = await this.symbiosis.getBridgeFee({
      receiveSide,
      calldata,
      chainIdFrom: advisorChainIdFrom,
      chainIdTo: advisorChainIdTo
    });
    const feeTokenAmount = new TokenAmount(feeToken, fee);
    if (this.request.originalFromTokenAmount.lessThan(feeTokenAmount) || this.request.originalFromTokenAmount.equalTo(feeTokenAmount)) {
      throw new Error2(
        `Amount ${this.request.fromTokenAmount.toSignificant()} ${this.request.fromTokenAmount.token.symbol} less than fee ${feeTokenAmount.toSignificant()} ${feeTokenAmount.token.symbol}`,
        2 /* AMOUNT_LESS_THAN_FEE */
      );
    }
    return feeTokenAmount;
  }
  async getTransactionRequest(fee, feeV2) {
    if (this.request.type === "synthesize") {
      return this.getRevertSynthesizeTransactionRequest(fee);
    }
    if (this.request.type === "synthesize-v2") {
      return this.getRevertSynthesizeTransactionRequestV2(fee);
    }
    if (this.request.type === "burn") {
      return this.getRevertBurnTransactionRequest(fee);
    }
    if (this.request.type === "burn-v2") {
      return await this.getRevertBurnTransactionRequestV2(fee, feeV2);
    }
    return await this.getRevertBurnTransactionRequestV2Revert(fee);
  }
  getRevertSynthesizeTransactionRequestV2(fee) {
    const { internalId, chainIdFrom, revertableAddress } = this.request;
    const portal = this.symbiosis.portal(chainIdFrom);
    const params = {
      stableBridgingFee: fee.raw.toString(),
      internalID: internalId,
      receiveSide: portal.address,
      managerChainBridge: this.symbiosis.bridge(this.omniPoolConfig.chainId).address,
      sourceChainBridge: this.symbiosis.bridge(chainIdFrom).address,
      managerChainId: this.omniPoolConfig.chainId,
      sourceChainId: chainIdFrom,
      router: AddressZero4,
      // multicall router
      swapCalldata: [],
      // swapCalldata,
      sourceChainSynthesis: this.symbiosis.synthesis(this.omniPoolConfig.chainId).address,
      burnToken: AddressZero4,
      //burnToken,
      burnCalldata: [],
      // burnCalldata,
      clientID: this.symbiosis.clientId
    };
    if (isTronChainId(chainIdFrom)) {
      return prepareTronTransaction({
        chainId: chainIdFrom,
        tronWeb: this.symbiosis.tronWeb(chainIdFrom),
        abi: TRON_PORTAL_ABI,
        contractAddress: portal.address,
        functionName: "metaRevertRequest",
        params: [
          [
            fee.raw.toString(),
            // stableBridgingFee, uint256
            internalId,
            // internalID, bytes32
            portal.address,
            // receiveSide, address
            this.symbiosis.bridge(this.omniPoolConfig.chainId).address,
            // managerChainBridge, address
            this.symbiosis.bridge(chainIdFrom).address,
            // sourceChainBridge, address
            this.omniPoolConfig.chainId,
            // managerChainId, uint256
            chainIdFrom,
            // sourceChainId, uint256
            AddressZero4,
            // router, address
            [],
            // swapCalldata, bytes
            this.symbiosis.synthesis(this.omniPoolConfig.chainId).address,
            // sourceChainSynthesis, address
            AddressZero4,
            // burnToken, address
            [],
            // burnCalldata, bytes
            this.symbiosis.clientId
            // clientID, bytes32
          ]
        ],
        ownerAddress: revertableAddress,
        value: 0
      });
    }
    return {
      to: portal.address,
      data: portal.interface.encodeFunctionData("metaRevertRequest", [params]),
      chainId: chainIdFrom
    };
  }
  getRevertSynthesizeTransactionRequest(fee) {
    const { internalId, chainIdTo, chainIdFrom } = this.request;
    const synthesis = this.symbiosis.synthesis(chainIdTo);
    const otherPortal = this.symbiosis.portal(chainIdFrom);
    const otherBridge = this.symbiosis.bridge(chainIdFrom);
    return {
      to: synthesis.address,
      data: synthesis.interface.encodeFunctionData("revertSynthesizeRequest", [
        fee.raw.toString(),
        internalId,
        otherPortal.address,
        otherBridge.address,
        chainIdFrom,
        this.symbiosis.clientId
      ]),
      chainId: chainIdTo
    };
  }
  getRevertBurnTransactionRequest(fee) {
    const { internalId, chainIdTo, chainIdFrom } = this.request;
    const otherBridge = this.symbiosis.bridge(chainIdFrom);
    const portal = this.symbiosis.portal(chainIdTo);
    const otherSynthesis = this.symbiosis.synthesis(chainIdFrom);
    const params = [
      fee.raw.toString(),
      internalId,
      otherSynthesis.address,
      otherBridge.address,
      chainIdFrom,
      this.symbiosis.clientId
    ];
    if (isTronChainId(chainIdTo)) {
      return prepareTronTransaction({
        chainId: chainIdTo,
        tronWeb: this.symbiosis.tronWeb(chainIdTo),
        abi: TRON_PORTAL_ABI,
        contractAddress: portal.address,
        functionName: "revertBurnRequest",
        params,
        ownerAddress: this.request.revertableAddress,
        value: 0
      });
    }
    return {
      to: portal.address,
      data: portal.interface.encodeFunctionData("revertBurnRequest", params),
      chainId: chainIdTo
    };
  }
  getSyntheticToken(realToken) {
    return this.symbiosis.getRepresentation(realToken, this.omniPoolConfig.chainId);
  }
  async buildSwapCalldata(fee) {
    const { originalFromTokenAmount, chainIdFrom, chainIdTo } = this.request;
    const tokenIn = this.getSyntheticToken(this.transitTokenTo);
    if (!tokenIn) {
      throw new Error2(`Cannot find synthetic token between mChain and ${chainIdTo}`);
    }
    const tokenAmountIn = new TokenAmount(tokenIn, originalFromTokenAmount.raw);
    const amount = fee ? new TokenAmount(tokenIn, JSBI13.subtract(tokenAmountIn.raw, fee.raw)) : tokenAmountIn;
    const tokenOut = this.getSyntheticToken(this.transitTokenFrom);
    if (!tokenOut) {
      throw new Error2(`Cannot find synthetic token between mChain and ${chainIdFrom}`);
    }
    const to = this.symbiosis.metaRouter(this.omniPoolConfig.chainId).address;
    const omniTrade = new OmniTrade(
      amount,
      amount,
      // amountInMin
      tokenOut,
      this.slippage,
      this.deadline,
      this.symbiosis,
      to,
      this.omniPoolConfig
    );
    await omniTrade.init();
    return [
      this.multicallRouter.address,
      this.multicallRouter.interface.encodeFunctionData("multicall", [
        amount.raw.toString(),
        [omniTrade.callData],
        // calldata
        [omniTrade.pool.address],
        // receiveSides
        [tokenIn.address, tokenOut.address],
        // path
        [100],
        // offset
        to
      ])
    ];
  }
  async getRevertBurnTransactionRequestV2(fee, feeV2) {
    const { internalId, chainIdTo } = this.request;
    const mChainBridge = this.symbiosis.bridge(this.omniPoolConfig.chainId);
    const portal = this.symbiosis.portal(chainIdTo);
    const mChainSynthesis = this.symbiosis.synthesis(this.omniPoolConfig.chainId);
    const [router, swapCalldata] = await this.buildSwapCalldata(fee);
    const [burnToken, burnCalldata] = this.buildMetaBurnCalldata(feeV2);
    const params = {
      stableBridgingFee: fee.raw.toString(),
      internalID: internalId,
      receiveSide: mChainSynthesis.address,
      managerChainBridge: mChainBridge.address,
      managerChainId: this.omniPoolConfig.chainId,
      sourceChainBridge: AddressZero4,
      sourceChainId: this.request.chainIdFrom,
      sourceChainSynthesis: mChainSynthesis.address,
      router,
      // multicall router
      swapCalldata,
      burnToken,
      burnCalldata,
      clientID: this.symbiosis.clientId
    };
    if (isTronChainId(chainIdTo)) {
      return prepareTronTransaction({
        chainId: chainIdTo,
        tronWeb: this.symbiosis.tronWeb(chainIdTo),
        abi: TRON_PORTAL_ABI,
        contractAddress: portal.address,
        functionName: "metaRevertRequest",
        params: [
          [
            fee.raw.toString(),
            // stableBridgingFee, uint256
            internalId,
            // internalID, bytes32
            mChainSynthesis.address,
            // receiveSide, address
            mChainBridge.address,
            // managerChainBridge, address
            AddressZero4,
            // sourceChainBridge, address
            this.omniPoolConfig.chainId,
            // managerChainId, uint256
            this.request.chainIdFrom,
            // sourceChainId, uint256
            router,
            // router, address
            swapCalldata,
            // swapCalldata, bytes
            mChainSynthesis.address,
            // sourceChainSynthesis, address
            burnToken,
            // burnToken, address
            burnCalldata,
            // burnCalldata, bytes
            this.symbiosis.clientId
            // clientID, bytes32
          ]
        ],
        ownerAddress: this.request.revertableAddress,
        // correct??
        value: 0
      });
    }
    return {
      to: portal.address,
      data: portal.interface.encodeFunctionData("metaRevertRequest", [params]),
      chainId: chainIdTo
    };
  }
  async getRevertBurnTransactionRequestV2Revert(fee) {
    const { internalId, chainIdTo } = this.request;
    const portal = this.symbiosis.portal(chainIdTo);
    const params = {
      stableBridgingFee: fee.raw.toString(),
      internalID: internalId,
      receiveSide: portal.address,
      managerChainBridge: this.symbiosis.bridge(this.omniPoolConfig.chainId).address,
      sourceChainBridge: AddressZero4,
      managerChainId: this.omniPoolConfig.chainId,
      sourceChainId: chainIdTo,
      router: AddressZero4,
      // multicall router
      swapCalldata: [],
      sourceChainSynthesis: this.symbiosis.synthesis(this.omniPoolConfig.chainId).address,
      burnToken: AddressZero4,
      burnCalldata: "0x00",
      // any not empty calldata
      clientID: this.symbiosis.clientId
    };
    if (isTronChainId(chainIdTo)) {
      return prepareTronTransaction({
        chainId: chainIdTo,
        tronWeb: this.symbiosis.tronWeb(chainIdTo),
        abi: TRON_PORTAL_ABI,
        contractAddress: portal.address,
        functionName: "metaRevertRequest",
        params: [
          [
            fee.raw.toString(),
            // stableBridgingFee, uint256
            internalId,
            // internalID, bytes32
            portal.address,
            // receiveSide, address
            this.symbiosis.bridge(this.omniPoolConfig.chainId).address,
            // managerChainBridge, address
            AddressZero4,
            // sourceChainBridge, address
            this.omniPoolConfig.chainId,
            // managerChainId, uint256
            chainIdTo,
            // sourceChainId, uint256
            AddressZero4,
            // multicall router, address
            [],
            // swapCalldata, bytes
            this.symbiosis.synthesis(this.omniPoolConfig.chainId).address,
            // sourceChainSynthesis, address
            AddressZero4,
            // burnToken, address
            "0x00",
            // burnCalldata, bytes, any not empty calldata
            this.symbiosis.clientId
            // clientID, bytes32
          ]
        ],
        ownerAddress: this.request.revertableAddress,
        value: 0
      });
    }
    return {
      to: portal.address,
      data: portal.interface.encodeFunctionData("metaRevertRequest", [params]),
      chainId: chainIdTo
    };
  }
  async execute(transactionRequest, signer) {
    const preparedTransactionRequest = await prepareTransactionRequest(transactionRequest, signer);
    const transaction = await signer.sendTransaction(preparedTransactionRequest);
    return {
      waitForMined: (confirmations = 1) => this.waitForMined(confirmations, transaction),
      transaction
    };
  }
  async waitForMined(confirmations, response) {
    const receipt = await response.wait(confirmations);
    return {
      receipt,
      waitForComplete: () => this.waitForComplete()
    };
  }
  getExternalId() {
    const { type, internalId, chainIdTo, revertableAddress } = this.request;
    let contractAddress;
    if (type === "synthesize" || type === "synthesize-v2") {
      contractAddress = this.symbiosis.synthesis(chainIdTo).address;
    } else {
      contractAddress = this.symbiosis.portal(chainIdTo).address;
    }
    return getExternalId({ internalId, chainId: chainIdTo, revertableAddress, contractAddress });
  }
};

// src/crosschain/zapping.ts
import { AddressZero as AddressZero5 } from "@ethersproject/constants/lib/addresses";
import { MaxUint256 as MaxUint2562 } from "@ethersproject/constants";
import { BigNumber as BigNumber7 } from "ethers";
import JSBI14 from "jsbi";

// src/crosschain/coingecko/constants.ts
var COINGECKO_PLATFORMS = {
  [8453 /* BASE_MAINNET */]: "base",
  [1 /* ETH_MAINNET */]: "ethereum",
  [56 /* BSC_MAINNET */]: "binance-smart-chain",
  [43114 /* AVAX_MAINNET */]: "avalanche",
  [137 /* MATIC_MAINNET */]: "polygon-pos",
  [40 /* TELOS_MAINNET */]: "telos",
  [288 /* BOBA_MAINNET */]: "boba",
  [56288 /* BOBA_BNB */]: "boba",
  [2222 /* KAVA_MAINNET */]: "kava",
  [324 /* ZKSYNC_MAINNET */]: "zksync",
  [42161 /* ARBITRUM_MAINNET */]: "arbitrum-one",
  [10 /* OPTIMISM_MAINNET */]: "optimistic-ethereum",
  [42170 /* ARBITRUM_NOVA */]: "arbitrum-nova",
  [1101 /* POLYGON_ZK */]: "polygon-zkevm",
  [59144 /* LINEA_MAINNET */]: "linea",
  [5e3 /* MANTLE_MAINNET */]: "mantle",
  [534352 /* SCROLL_MAINNET */]: "scroll",
  [169 /* MANTA_MAINNET */]: "manta-pacific",
  [1088 /* METIS_MAINNET */]: "metis-andromeda",
  [34443 /* MODE_MAINNET */]: "mode",
  [30 /* RSK_MAINNET */]: "rootstock",
  [81457 /* BLAST_MAINNET */]: "blast",
  [4200 /* MERLIN_MAINNET */]: "merlin-chain",
  [810180 /* ZKLINK_MAINNET */]: "zklink-nova",
  [85918 /* TON_MAINNET */]: "the-open-network",
  [85919 /* TON_TESTNET */]: "the-open-network",
  [3652501241 /* BTC_MAINNET */]: "bitcoin",
  [728126428 /* TRON_MAINNET */]: "tron",
  [7e3 /* ZETACHAIN_MAINNET */]: "zetachain",
  [25 /* CRONOS_MAINNET */]: "cronos",
  [252 /* FRAXTAL_MAINNET */]: "fraxtal",
  [1625 /* GRAVITY_MAINNET */]: "gravity-alpha",
  [223 /* BSQUARED_MAINNET */]: "bsquared-network"
};
var COINGECKO_GAS_TOKEN_IDS = {
  [8453 /* BASE_MAINNET */]: "ethereum",
  [1 /* ETH_MAINNET */]: "ethereum",
  [56 /* BSC_MAINNET */]: "binancecoin",
  [43114 /* AVAX_MAINNET */]: "avalanche-2",
  [137 /* MATIC_MAINNET */]: "matic-network",
  [40 /* TELOS_MAINNET */]: "telos",
  [288 /* BOBA_MAINNET */]: "ethereum",
  [56288 /* BOBA_BNB */]: "boba-network",
  [2222 /* KAVA_MAINNET */]: "kava",
  [324 /* ZKSYNC_MAINNET */]: "ethereum",
  [42161 /* ARBITRUM_MAINNET */]: "ethereum",
  [10 /* OPTIMISM_MAINNET */]: "ethereum",
  [42170 /* ARBITRUM_NOVA */]: "ethereum",
  [1101 /* POLYGON_ZK */]: "ethereum",
  [59144 /* LINEA_MAINNET */]: "ethereum",
  [5e3 /* MANTLE_MAINNET */]: "mantle",
  [534352 /* SCROLL_MAINNET */]: "ethereum",
  [169 /* MANTA_MAINNET */]: "ethereum",
  [1088 /* METIS_MAINNET */]: "metis-token",
  [34443 /* MODE_MAINNET */]: "ethereum",
  [30 /* RSK_MAINNET */]: "rootstock",
  [81457 /* BLAST_MAINNET */]: "ethereum",
  [4200 /* MERLIN_MAINNET */]: "bitcoin",
  [810180 /* ZKLINK_MAINNET */]: "ethereum",
  [85918 /* TON_MAINNET */]: "the-open-network",
  [85919 /* TON_TESTNET */]: "the-open-network",
  [3652501241 /* BTC_MAINNET */]: "bitcoin",
  [728126428 /* TRON_MAINNET */]: "tron",
  [167e3 /* TAIKO_MAINNET */]: "ethereum",
  [1329 /* SEI_EVM_MAINNET */]: "sei-network",
  [7e3 /* ZETACHAIN_MAINNET */]: "zetachain",
  [25 /* CRONOS_MAINNET */]: "crypto-com-chain",
  [252 /* FRAXTAL_MAINNET */]: "frax-ether",
  [1625 /* GRAVITY_MAINNET */]: "g-token",
  [223 /* BSQUARED_MAINNET */]: "bitcoin"
};

// src/crosschain/coingecko/getTokenPriceUsd.ts
import TronWeb2 from "tronweb";
var getGasTokenPrice = async (token) => {
  const { chainId } = token;
  const tokenId = COINGECKO_GAS_TOKEN_IDS[chainId];
  if (!tokenId) {
    console.error("CoinGecko: cannot find tokenId");
    return 0;
  }
  const vs = "usd";
  const API_URL = "https://api.coingecko.com";
  const url = new URL(`/api/v3/simple/price`, API_URL);
  url.searchParams.set("ids", tokenId);
  url.searchParams.set("vs_currencies", vs);
  const response = await fetch(url.toString());
  if (!response.ok) {
    console.error("CoinGecko: failed to get gas token price");
    return 0;
  }
  const json = await response.json();
  if (!json[tokenId]) {
    console.error("CoinGecko: cannot find address");
    return 0;
  }
  return parseFloat(json[tokenId][vs]);
};
var getTokenPrice = async (token, map) => {
  const newAddress = map?.get(token.address);
  if (newAddress) {
    token = new Token({
      address: newAddress,
      chainId: token.chainId,
      decimals: token.decimals
    });
  }
  const platform = COINGECKO_PLATFORMS[token.chainId];
  if (!platform) {
    console.error("CoinGecko: cannot find asset platform");
    return 0;
  }
  let address2 = token.address.toLowerCase();
  if (isTronToken(token)) {
    address2 = TronWeb2.address.fromHex(address2);
  } else if (isTonChainId(token.chainId)) {
    address2 = getTonTokenAddress(address2);
  }
  const vs = "usd";
  const API_URL = "https://api.coingecko.com";
  const url = new URL(`/api/v3/simple/token_price/${platform}`, API_URL);
  url.searchParams.set("contract_addresses", address2);
  url.searchParams.set("vs_currencies", vs);
  const response = await fetch(url.toString());
  if (!response.ok) {
    console.error("CoinGecko: failed to get token price");
    return 0;
  }
  const json = await response.json();
  if (!json[address2]) {
    console.error("CoinGecko: cannot find address");
    return 0;
  }
  return parseFloat(json[address2][vs]);
};
var getTokenPriceUsd = async (token, map) => {
  if (token.isNative || token.equals(GAS_TOKEN[token.chainId]) || isBtcChainId(token.chainId)) {
    return getGasTokenPrice(token);
  }
  return getTokenPrice(token, map);
};
var getTokenAmountUsd = (tokenAmount, price) => {
  return parseFloat((parseFloat(tokenAmount.toSignificant()) * price).toFixed(2));
};

// src/crosschain/dataProvider.ts
var DataProvider = class {
  constructor(symbiosis) {
    this.symbiosis = symbiosis;
    this.cache = /* @__PURE__ */ new Map();
  }
  async getPairs(tokenIn, tokenOut) {
    return this.fromCache(["getPairs", tokenIn.address, tokenIn.address], () => {
      const provider = this.symbiosis.getProvider(tokenIn.chainId);
      return UniLikeTrade.getPairs(provider, tokenIn, tokenOut);
    });
  }
  async getOneInchProtocols(chainId) {
    return this.fromCache(["getOneInchProtocols", chainId], () => {
      return OneInchTrade.getProtocols(this.symbiosis, chainId);
    });
  }
  async getOneInchRateToEth(tokens, oracle) {
    return this.fromCache(
      ["getOneInchRateToEth", ...tokens.map((i) => i.address)],
      () => {
        return getRateToEth(tokens, oracle);
      },
      60
      // 1 minute
    );
  }
  async getTokenPrice(token) {
    return this.fromCache(
      ["getTokenPriceUsd", token.chainId, token.address],
      () => {
        return getTokenPriceUsd(token);
      },
      600
      // 10 minutes
    );
  }
  async get(key, func, ttl) {
    return this.fromCache(
      key,
      () => {
        return func();
      },
      ttl
    );
  }
  async fromCache(key, func, ttl) {
    const stringKey = key.join("-");
    const now = Math.floor(Date.now() / 1e3);
    const cached = this.cache.get(stringKey);
    if (cached) {
      const { value, expiresAt } = cached;
      if (expiresAt === null || now < expiresAt) {
        return value;
      }
    }
    const newValue = await func();
    this.cache.set(stringKey, {
      value: newValue,
      expiresAt: ttl ? now + ttl : null
    });
    return newValue;
  }
};

// src/crosschain/omniLiquidity.ts
var OmniLiquidity = class {
  constructor(tokenAmountIn, to, slippage, deadline, pool, poolOracle) {
    this.tokenAmountIn = tokenAmountIn;
    this.to = to;
    this.slippage = slippage;
    this.deadline = deadline;
    this.pool = pool;
    this.poolOracle = poolOracle;
    this.callDataOffset = 4 + 32 * 2;
  }
  async init() {
    const network = await this.pool.provider.getNetwork();
    const index = await this.pool.assetToIndex(this.tokenAmountIn.token.address);
    const depositEstimate = await this.poolOracle.quoteDeposit(index, this.tokenAmountIn.raw.toString());
    const lpToken = new Token({
      address: this.pool.address,
      decimals: 18,
      chainId: network.chainId
    });
    this.amountOut = new TokenAmount(lpToken, depositEstimate.lpTokenToMint.toString());
    const slippageAdjustedAmountOut = getMinAmount(this.slippage, this.amountOut.raw);
    this.callData = this.pool.interface.encodeFunctionData("deposit", [
      index,
      this.tokenAmountIn.raw.toString(),
      slippageAdjustedAmountOut.toString(),
      this.to,
      this.deadline
    ]);
    return this;
  }
};

// src/crosschain/zapping.ts
var Zapping = class {
  constructor(symbiosis, omniPoolConfig) {
    this.symbiosis = symbiosis;
    this.omniPoolConfig = omniPoolConfig;
    this.dataProvider = new DataProvider(symbiosis);
    this.pool = this.symbiosis.omniPool(omniPoolConfig);
    this.poolOracle = this.symbiosis.omniPoolOracle(omniPoolConfig);
    this.multicallRouter = this.symbiosis.multicallRouter(omniPoolConfig.chainId);
  }
  async exactIn({
    tokenAmountIn,
    from,
    to,
    slippage,
    deadline
  }) {
    this.tokenAmountIn = tokenAmountIn;
    this.from = tronAddressToEvm(from);
    this.to = tronAddressToEvm(to);
    this.slippage = slippage;
    this.deadline = deadline;
    this.ttl = deadline - Math.floor(Date.now() / 1e3);
    if (isTronToken(this.tokenAmountIn.token)) {
      this.revertableAddress = this.symbiosis.getRevertableAddress(this.omniPoolConfig.chainId);
    } else if (isTonChainId(this.tokenAmountIn.token.chainId)) {
      this.revertableAddress = this.symbiosis.getRevertableAddress(this.omniPoolConfig.chainId);
    } else {
      this.revertableAddress = this.from;
    }
    const targetPool = this.symbiosis.getOmniPoolByConfig(this.omniPoolConfig);
    if (!targetPool) {
      throw new Error2(`Unknown pool ${this.omniPoolConfig.address}`);
    }
    const wrapped = wrappedToken(tokenAmountIn.token);
    const tokenPool = this.symbiosis.getOmniPoolByToken(wrapped);
    if (tokenPool?.id === targetPool.id) {
      this.transitTokenIn = wrapped;
    } else {
      this.transitTokenIn = this.symbiosis.transitToken(tokenAmountIn.token.chainId, this.omniPoolConfig);
    }
    if (!this.transitTokenIn.equals(tokenAmountIn.token)) {
      this.tradeA = this.buildTradeA();
      await this.tradeA.init();
    }
    this.synthToken = await this.getSynthToken();
    this.omniLiquidity = this.buildOmniLiquidity();
    await this.omniLiquidity.init();
    const fee = await this.getFee();
    this.omniLiquidity = this.buildOmniLiquidity(fee);
    await this.omniLiquidity.init();
    let payload;
    if (isTronChainId(this.tokenAmountIn.token.chainId)) {
      const transactionRequest = this.getTronTransactionRequest(fee);
      payload = {
        transactionType: "tron",
        transactionRequest
      };
    } else if (isTonChainId(this.tokenAmountIn.token.chainId)) {
      const transactionRequest = await this.getTonTransactionRequest(fee);
      payload = {
        transactionType: "ton",
        transactionRequest
      };
    } else {
      const transactionRequest = this.getEvmTransactionRequest(fee);
      payload = {
        transactionType: "evm",
        transactionRequest
      };
    }
    const routes = [];
    if (this.tradeA) {
      routes.push({
        provider: this.tradeA.tradeType,
        tokens: [this.tradeA.tokenAmountIn.token, this.tradeA.amountOut.token]
      });
    }
    routes.push({
      provider: "symbiosis",
      tokens: [this.getPortalTokenAmountIn().token, this.omniLiquidity.tokenAmountIn.token]
    });
    return {
      ...payload,
      fees: [
        {
          provider: "symbiosis",
          value: fee
        }
      ],
      routes,
      kind: "crosschain-swap",
      approveTo: this.symbiosis.chainConfig(tokenAmountIn.token.chainId).metaRouterGateway,
      priceImpact: this.calculatePriceImpact(),
      amountInUsd: this.getSynthAmount(fee),
      tokenAmountOut: this.omniLiquidity.amountOut,
      tokenAmountOutMin: this.omniLiquidity.amountOut
    };
  }
  async getTonTransactionRequest(fee) {
    return buildMetaSynthesize({
      symbiosis: this.symbiosis,
      fee,
      validUntil: this.deadline,
      from: this.from,
      to: this.to,
      revertableAddress: this.revertableAddress,
      amountIn: this.tokenAmountIn,
      chainIdOut: this.omniPoolConfig.chainId,
      secondDexRouter: this.multicallRouter.address,
      secondSwapCallData: this.getMulticallData(),
      swapTokens: [this.synthToken.address, this.synthToken.address],
      finalCallData: "",
      finalReceiveSide: AddressZero5,
      finalOffset: 0
    });
  }
  getEvmTransactionRequest(fee) {
    const [relayRecipient, otherSideCalldata] = this.otherSideSynthCallData(fee);
    let firstToken = this.tradeA ? this.tradeA.tokenAmountIn.token.address : this.tokenAmountIn.token.address;
    if (!firstToken) {
      firstToken = AddressZero5;
    }
    const approvedTokens = [firstToken, this.getPortalTokenAmountIn().token.address];
    const value = this.tradeA && this.tokenAmountIn.token.isNative ? BigNumber7.from(this.tradeA.tokenAmountIn.raw.toString()) : void 0;
    const params = {
      firstSwapCalldata: this.tradeA?.callData || [],
      secondSwapCalldata: [],
      approvedTokens,
      firstDexRouter: this.tradeA?.routerAddress || AddressZero5,
      secondDexRouter: AddressZero5,
      amount: this.tokenAmountIn.raw.toString(),
      nativeIn: this.tokenAmountIn.token.isNative,
      relayRecipient,
      otherSideCalldata
    };
    const { chainId } = this.tokenAmountIn.token;
    const metaRouter = this.symbiosis.metaRouter(chainId);
    const data = metaRouter.interface.encodeFunctionData("metaRoute", [params]);
    return {
      chainId,
      to: metaRouter.address,
      data,
      value
    };
  }
  getTronTransactionRequest(fee) {
    const [relayRecipient, otherSideCalldata] = this.otherSideSynthCallData(fee);
    let firstToken = this.tradeA ? this.tradeA.tokenAmountIn.token.address : this.tokenAmountIn.token.address;
    if (!firstToken) {
      firstToken = AddressZero5;
    }
    const approvedTokens = [firstToken, this.getPortalTokenAmountIn().token.address];
    const { chainId } = this.tokenAmountIn.token;
    const metaRouter = this.symbiosis.metaRouter(chainId);
    return prepareTronTransaction({
      chainId,
      tronWeb: this.symbiosis.tronWeb(chainId),
      abi: TRON_METAROUTER_ABI,
      contractAddress: metaRouter.address,
      functionName: "metaRoute",
      params: [
        [
          this.tradeA?.callData || [],
          [],
          approvedTokens,
          this.tradeA?.routerAddress || AddressZero5,
          AddressZero5,
          this.tokenAmountIn.raw.toString(),
          this.tokenAmountIn.token.isNative,
          relayRecipient,
          otherSideCalldata
        ]
      ],
      ownerAddress: this.from,
      value: 0
    });
  }
  calculatePriceImpact() {
    const zero = new Percent(JSBI14.BigInt(0), BIPS_BASE);
    let pi = this.tradeA?.priceImpact || zero;
    const max = new Percent(JSBI14.BigInt(1e4), BIPS_BASE);
    if (pi.greaterThan(max))
      pi = max;
    return new Percent(pi.numerator, pi.denominator);
  }
  getPortalTokenAmountIn() {
    return this.tradeA ? this.tradeA.amountOut : this.tokenAmountIn;
  }
  getSynthAmount(fee) {
    let synthAmount = new TokenAmount(this.synthToken, this.getPortalTokenAmountIn().raw);
    if (fee) {
      synthAmount = synthAmount.subtract(fee);
    }
    return synthAmount;
  }
  buildTradeA() {
    const chainId = this.tokenAmountIn.token.chainId;
    const tokenOut = this.transitTokenIn;
    const from = this.symbiosis.metaRouter(chainId).address;
    const to = from;
    if (WrapTrade.isSupported(this.tokenAmountIn, tokenOut)) {
      return new WrapTrade(this.tokenAmountIn, tokenOut, this.to);
    }
    return new AggregatorTrade({
      tokenAmountIn: this.tokenAmountIn,
      tokenOut,
      from,
      to,
      slippage: this.slippage / 100,
      dataProvider: this.dataProvider,
      symbiosis: this.symbiosis,
      clientId: this.symbiosis.clientId,
      ttl: this.ttl
    });
  }
  buildOmniLiquidity(fee) {
    const tokenAmountIn = this.getSynthAmount(fee);
    return new OmniLiquidity(tokenAmountIn, this.to, this.slippage, this.deadline, this.pool, this.poolOracle);
  }
  getMulticallData() {
    return this.multicallRouter.interface.encodeFunctionData("multicall", [
      "0",
      // amount will be patched
      [this.omniLiquidity.callData],
      // _calldata
      [this.pool.address],
      // _receiveSides
      [this.synthToken.address],
      // _path
      [this.omniLiquidity.callDataOffset],
      // _offset
      this.to
      // _to
    ]);
  }
  otherSideSynthCallData(fee) {
    if (!this.tokenAmountIn) {
      throw new Error2("Token is not set");
    }
    const chainIdIn = this.tokenAmountIn.token.chainId;
    const chainIdOut = this.omniPoolConfig.chainId;
    const tokenAmount = this.getPortalTokenAmountIn();
    const portal = this.symbiosis.portal(chainIdIn);
    return [
      portal.address,
      portal.interface.encodeFunctionData("metaSynthesize", [
        {
          stableBridgingFee: fee.raw.toString(),
          amount: tokenAmount.raw.toString(),
          rtoken: tokenAmount.token.address,
          chain2address: this.to,
          receiveSide: this.symbiosis.synthesis(chainIdOut).address,
          oppositeBridge: this.symbiosis.bridge(chainIdOut).address,
          syntCaller: this.from,
          chainID: chainIdOut,
          swapTokens: [this.synthToken.address, this.synthToken.address],
          secondDexRouter: this.multicallRouter.address,
          secondSwapCalldata: this.getMulticallData(),
          finalReceiveSide: AddressZero5,
          finalCalldata: [],
          finalOffset: 0,
          revertableAddress: this.revertableAddress,
          clientID: this.symbiosis.clientId
        }
      ])
    ];
  }
  async getSynthToken() {
    const chainIdOut = this.omniPoolConfig.chainId;
    const rep = this.symbiosis.getRepresentation(this.transitTokenIn, chainIdOut);
    if (!rep) {
      throw new Error2(
        `Representation of ${this.transitTokenIn.symbol} in chain ${chainIdOut} not found`,
        1 /* NO_REPRESENTATION_FOUND */
      );
    }
    return rep;
  }
  async getFee() {
    const chainIdIn = this.tokenAmountIn.token.chainId;
    const chainIdOut = this.omniPoolConfig.chainId;
    const portal = this.symbiosis.portal(chainIdIn);
    const synthesis = this.symbiosis.synthesis(chainIdOut);
    const amount = this.getPortalTokenAmountIn();
    const internalId = getInternalId({
      contractAddress: portal.address,
      requestCount: MaxUint2562,
      chainId: chainIdIn
    });
    const externalId = getExternalId({
      internalId,
      contractAddress: synthesis.address,
      revertableAddress: this.revertableAddress,
      chainId: chainIdOut
    });
    const calldata = synthesis.interface.encodeFunctionData("metaMintSyntheticToken", [
      {
        stableBridgingFee: "1",
        amount: amount.raw.toString(),
        crossChainID: CROSS_CHAIN_ID,
        externalID: externalId,
        tokenReal: amount.token.address,
        chainID: chainIdIn,
        to: this.to,
        swapTokens: [this.synthToken.address, this.synthToken.address],
        secondDexRouter: this.multicallRouter.address,
        secondSwapCalldata: this.getMulticallData(),
        finalReceiveSide: AddressZero5,
        finalCalldata: [],
        finalOffset: 0
      }
    ]);
    const { price: fee } = await this.symbiosis.getBridgeFee({
      receiveSide: synthesis.address,
      calldata,
      chainIdFrom: this.tokenAmountIn.token.chainId,
      chainIdTo: chainIdOut
    });
    return new TokenAmount(this.synthToken, fee);
  }
};

// src/crosschain/config/mainnet.ts
var config = {
  advisor: {
    url: "https://api.symbiosis.finance/calculations"
  },
  limits: [],
  transitFeeMap: {
    ETH: "0.0003",
    USD: "0.3",
    SIS: "1",
    BTC: "0.00001",
    LADYS: "3000000",
    FRAX: "0.3"
  },
  omniPools: [
    {
      // usd
      chainId: 56288 /* BOBA_BNB */,
      address: "0x6148FD6C649866596C3d8a971fC313E5eCE84882",
      oracle: "0x7775b274f0C3fA919B756b22A4d9674e55927ab8",
      generalPurpose: true
    },
    {
      // eth
      chainId: 56288 /* BOBA_BNB */,
      address: "0xBcc2637DFa64999F75abB53a7265b5B4932e40eB",
      oracle: "0x628613064b1902a1A422825cf11B687C6f17961E",
      generalPurpose: true
    },
    {
      // btc
      chainId: 56288 /* BOBA_BNB */,
      address: "0xA267C428b16728831Be52b144F78b8F054411f55",
      oracle: "0xECBe427C8F8ea1Ee5258cAf5aB0A9d26b4D91769",
      generalPurpose: true
    },
    {
      // ladys
      chainId: 56288 /* BOBA_BNB */,
      address: "0x7b905059Bdd00844280EBf54E00A087006B2D242",
      oracle: "0x82E7034ED28674c185E0d03dF5eBd8cAa5f37Bb5",
      generalPurpose: false
    },
    {
      // sis
      chainId: 56288 /* BOBA_BNB */,
      address: "0xB5D99bE6089720d1aD3DB2a5a16D5765605704df",
      oracle: "0xcd3DCFabA22CE28fA8b8D9e8bf545D642F4f458E",
      generalPurpose: false
    },
    // {
    //     // puf
    //     chainId: ChainId.BOBA_BNB,
    //     address: '0x50DF155DAab4548F4512F6568deD8d42dbf3EE96',
    //     oracle: '0xBc70e59BFF8abcC0f18a40D2c6fF6A4AE42586F9',
    //     generalPurpose: false,
    // },
    {
      // frax
      chainId: 56288 /* BOBA_BNB */,
      address: "0xdc25D04cb14E114426bFc43877e1Fd32C336eA4E",
      oracle: "0x4CD678FF53538E6b084464da0020422738B46038",
      generalPurpose: false,
      chainExceptions: [252 /* FRAXTAL_MAINNET */]
    },
    {
      // G
      chainId: 56288 /* BOBA_BNB */,
      address: "0x8D2209E88f68324c6241bCAA7d24538ebe94e2Ee",
      oracle: "0xA7614e3427f52b04EeD23c7371a382640bD6C463",
      generalPurpose: false,
      chainExceptions: [1625 /* GRAVITY_MAINNET */]
    },
    {
      // WTON
      chainId: 56288 /* BOBA_BNB */,
      address: "0xDFCaCf059062C5c495436cE534AEeDcD2265Cc23",
      oracle: "0xe717C95007cA64334c9facFFC1975310C3B98EE8",
      generalPurpose: false,
      chainExceptions: [1 /* ETH_MAINNET */, 56 /* BSC_MAINNET */]
    }
  ],
  revertableAddress: {
    [728126428 /* TRON_MAINNET */]: "0xd99ac0681b904991169a4f398B9043781ADbe0C3",
    default: "0xd99ac0681b904991169a4f398B9043781ADbe0C3"
  },
  chains: [
    {
      id: 3652501241 /* BTC_MAINNET */,
      rpc: "https://mempool.space/api",
      filterBlockOffset: 0,
      stables: [
        {
          name: "Bitcoin",
          symbol: "BTC",
          address: "0xc102C66D4a1e1865Ee962084626Cf4c27D5BFc74",
          chainId: 3652501241 /* BTC_MAINNET */,
          decimals: 8,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0x0000000000000000000000000000000000000000",
      metaRouterGateway: "0x0000000000000000000000000000000000000000",
      bridge: "0x0000000000000000000000000000000000000000",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x0000000000000000000000000000000000000000",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x0000000000000000000000000000000000000000",
      symBtc: {
        address: "0x49731d3c7234619a74B4c095838AfbC19cC44f28",
        chainId: 324 /* ZKSYNC_MAINNET */
      },
      forwarderUrl: "https://btc-forwarder.symbiosis.finance/zksync/forwarder/api/v1"
    },
    {
      id: 1 /* ETH_MAINNET */,
      rpc: "https://ethereum-rpc.publicnode.com",
      spareRpcs: ["https://rpc.ankr.com/eth", "https://eth.llamarpc.com", "https://eth-pokt.nodies.app"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "USD Coin",
          address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
          symbol: "USDC",
          decimals: 6,
          chainId: 1 /* ETH_MAINNET */,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Symbiosis",
          symbol: "SIS",
          address: "0xd38BB40815d2B0c2d2c866e0c72c5728ffC76dd9",
          chainId: 1 /* ETH_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          chainId: 1 /* ETH_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        },
        {
          name: "Tether USD",
          symbol: "USDT",
          address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
          chainId: 1 /* ETH_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
          }
        },
        {
          name: "Wrapped BTC",
          symbol: "WBTC",
          address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
          chainId: 1 /* ETH_MAINNET */,
          decimals: 8,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png"
          }
        },
        {
          name: "Milady Meme Coin",
          symbol: "LADYS",
          address: "0x12970E6868f88f6557B76120662c1B3E50A646bf",
          chainId: 1 /* ETH_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/25023.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/25023.png"
          }
        },
        {
          name: "pufETH",
          symbol: "pufETH",
          address: "0xD9A442856C234a39a81a089C06451EBAa4306a72",
          chainId: 1 /* ETH_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
          }
        },
        {
          name: "Frax",
          symbol: "FRAX",
          address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
          chainId: 1 /* ETH_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/6952.png"
          }
        },
        {
          name: "Gravity",
          symbol: "G",
          address: "0x9C7BEBa8F6eF6643aBd725e45a4E8387eF260649",
          chainId: 1 /* ETH_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/32120.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/32120.png"
          }
        },
        {
          name: "Wrapped TON",
          symbol: "WTON",
          address: "0x582d872A1B094FC48F5DE31D3B73F2D9bE47def1",
          chainId: 1 /* ETH_MAINNET */,
          decimals: 9,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
          }
        }
      ],
      router: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
      dexFee: 30,
      metaRouter: "0xf621Fb08BBE51aF70e7E0F4EA63496894166Ff7F",
      metaRouterGateway: "0xfCEF2Fe72413b65d3F393d278A714caD87512bcd",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x49d3Fc00f3ACf80FABCb42D7681667B20F60889A"
    },
    {
      id: 56 /* BSC_MAINNET */,
      rpc: "https://bsc-rpc.publicnode.com",
      spareRpcs: ["https://rpc.ankr.com/bsc", "https://binance.llamarpc.com"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "USD Coin",
          address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
          symbol: "USDC",
          decimals: 18,
          chainId: 56 /* BSC_MAINNET */,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          deprecated: true,
          name: "BUSD Token",
          address: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
          symbol: "BUSD",
          decimals: 18,
          chainId: 56 /* BSC_MAINNET */,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png"
          }
        },
        {
          name: "Ethereum Token",
          symbol: "ETH",
          address: "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
          chainId: 56 /* BSC_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        },
        {
          name: "Binance-Peg BTCB Token",
          symbol: "BTCB",
          address: "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
          chainId: 56 /* BSC_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4023.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/4023.png"
          }
        },
        {
          name: "Symbiosis",
          symbol: "SIS",
          address: "0xF98b660AdF2ed7d9d9D9dAACC2fb0CAce4F21835",
          chainId: 56 /* BSC_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
          }
        },
        {
          name: "Gravity",
          symbol: "G",
          address: "0x9C7BEBa8F6eF6643aBd725e45a4E8387eF260649",
          chainId: 56 /* BSC_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/32120.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/32120.png"
          }
        },
        {
          name: "Wrapped TON",
          symbol: "WTON",
          address: "0x76A797A59Ba2C17726896976B7B3747BfD1d220f",
          chainId: 56 /* BSC_MAINNET */,
          decimals: 9,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
          }
        }
      ],
      router: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
      dexFee: 25,
      metaRouter: "0x44487a445a7595446309464A82244B4bD4e325D5",
      metaRouterGateway: "0x5c97D726bf5130AE15408cE32bc764e458320D2f",
      bridge: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      synthesis: "0x6B1bbd301782FF636601fC594Cd7Bfe74871bfaA",
      portal: "0x5Aa5f7f84eD0E5db0a4a85C3947eA16B53352FD4",
      fabric: "0xc17d768Bf4FdC6f20a4A0d8Be8767840D106D077",
      multicallRouter: "0x44b5d0F16Ad55c4e7113310614745e8771b963bB"
    },
    {
      id: 43114 /* AVAX_MAINNET */,
      rpc: "https://avalanche-c-chain-rpc.publicnode.com",
      spareRpcs: ["https://rpc.ankr.com/avalanche", "https://avalanche.drpc.org", "https://avax.meowrpc.com"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "USD Coin",
          address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
          symbol: "USDC",
          decimals: 6,
          chainId: 43114,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          deprecated: true,
          name: "USD Coin",
          address: "0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664",
          symbol: "USDC.e",
          decimals: 6,
          chainId: 43114,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        }
      ],
      router: "0xE54Ca86531e17Ef3616d22Ca28b0D458b6C89106",
      dexFee: 30,
      metaRouter: "0x6F0f6393e45fE0E7215906B6f9cfeFf53EA139cf",
      metaRouterGateway: "0x4cfA66497Fa84D739a0f785FBcEe9196f1C64e4a",
      bridge: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xE75C7E85FE6ADd07077467064aD15847E6ba9877",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xDc9a6a26209A450caC415fb78487e907c660cf6a"
    },
    {
      id: 137 /* MATIC_MAINNET */,
      rpc: "https://polygon-bor-rpc.publicnode.com",
      spareRpcs: ["https://rpc.ankr.com/polygon", "https://polygon.llamarpc.com", "https://polygon.meowrpc.com"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "USD Coin (PoS) (USDC.e)",
          address: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
          symbol: "USDC.e",
          decimals: 6,
          chainId: 137 /* MATIC_MAINNET */,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
          chainId: 137 /* MATIC_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        },
        {
          name: "Frax",
          symbol: "FRAX",
          address: "0x45c32fA6DF82ead1e2EF74d17b76547EDdFaFF89",
          chainId: 137 /* MATIC_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/6952.png"
          }
        }
      ],
      router: "0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff",
      dexFee: 30,
      metaRouter: "0xa260E3732593E4EcF9DdC144fD6C4c5fe7077978",
      metaRouterGateway: "0xAb83653fd41511D638b69229afBf998Eb9B0F30c",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xc5B61b9abC3C6229065cAD0e961aF585C5E0135c"
    },
    {
      id: 40 /* TELOS_MAINNET */,
      rpc: "https://mainnet15.telos.net/evm",
      spareRpcs: ["https://rpc3.telos.net/evm", "https://rpc.ankr.com/telos"],
      filterBlockOffset: 3e3,
      stables: [
        {
          name: "syUSDC",
          address: "0xe6E5f3d264117E030C21920356641DbD5B3d660c",
          symbol: "USDC",
          decimals: 6,
          chainId: 40,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        }
      ],
      router: "0x9b1adec00a25fffd87a5bb17f61916e1c26f6844",
      dexFee: 25,
      metaRouter: "0x8097f0B9f06C27AF9579F75762F971D745bb222F",
      metaRouterGateway: "0x4949e74094D6F9C06D68e5Ffe388f6542C4b1A34",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x1a039cE63AE35a67Bf0E9F6DbFaE969639D59eC8",
      portal: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      fabric: "0x8a7F930003BedD63A1ebD99C5917FD6aE7E3dedf",
      multicallRouter: "0xcB28fbE3E9C0FEA62E0E63ff3f232CECfE555aD4"
    },
    {
      id: 2222 /* KAVA_MAINNET */,
      rpc: "https://evm.kava.io",
      spareRpcs: [
        "https://kava-evm-rpc.publicnode.com",
        "https://rpc.ankr.com/kava_evm",
        "https://evm.kava-rpc.com"
      ],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "Tether USDt",
          symbol: "USDt",
          address: "0x919C1c267BC06a7039e03fcc2eF738525769109c",
          chainId: 2222,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
          }
        }
      ],
      router: "0xA7544C409d772944017BB95B99484B6E0d7B6388",
      dexFee: 30,
      metaRouter: "0x77Ed285AD9d1c8C0307eA23DcE68B8a5A6AfB39A",
      metaRouterGateway: "0x0c4313a5dD4990f2fC15c6aA4d287D4602645a05",
      bridge: "0xda8057acB94905eb6025120cB2c38415Fd81BfEB",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8"
    },
    {
      id: 288 /* BOBA_MAINNET */,
      rpc: "https://lightning-replica.boba.network",
      spareRpcs: ["https://replica.boba.network", "https://1rpc.io/boba/eth", "https://mainnet.boba.network"],
      filterBlockOffset: 3e3,
      stables: [
        {
          name: "USD Coin",
          address: "0x66a2A913e447d6b4BF33EFbec43aAeF87890FBbc",
          symbol: "USDC",
          decimals: 6,
          chainId: 288 /* BOBA_MAINNET */,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        }
      ],
      router: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
      dexFee: 30,
      metaRouter: "0xca506793A420E901BbCa8066be5661E3C52c84c2",
      metaRouterGateway: "0xd92Ca299F1C2518E78E48C207b64591BA6E9b9a8",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x506803495B1876FE1fA6Cd9dC65fB060057A4Cc3"
    },
    {
      id: 56288 /* BOBA_BNB */,
      rpc: "https://replica.bnb.boba.network",
      spareRpcs: ["https://bnb.boba.network", "https://gateway.tenderly.co/public/boba-bnb"],
      filterBlockOffset: 3e3,
      stables: [
        {
          name: "USD Coin",
          address: "0x9F98f9F312D23d078061962837042b8918e6aff2",
          symbol: "USDC",
          decimals: 18,
          chainId: 56288 /* BOBA_BNB */,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        }
      ],
      router: "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
      dexFee: 30,
      metaRouter: "0x2cBABD7329b84e2c0A317702410E7c73D0e0246d",
      metaRouterGateway: "0xd666ab407c8E77DB239F473a49E309514aa55e0C",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8",
      portal: "0x0000000000000000000000000000000000000000",
      fabric: "0x5Aa5f7f84eD0E5db0a4a85C3947eA16B53352FD4",
      multicallRouter: "0xcB28fbE3E9C0FEA62E0E63ff3f232CECfE555aD4"
    },
    {
      id: 324 /* ZKSYNC_MAINNET */,
      rpc: "https://mainnet.era.zksync.io",
      spareRpcs: ["https://rpc.ankr.com/zksync_era", "https://zksync.meowrpc.com", "https://zksync.drpc.org"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "USD Coin",
          symbol: "USDC.e",
          address: "0x3355df6D4c9C3035724Fd0e3914dE96A5a83aaf4",
          chainId: 324 /* ZKSYNC_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          deprecated: true,
          name: "USD Coin",
          symbol: "USDC",
          address: "0x1d17CBcF0D6D143135aE902365D2E5e2A16538D4",
          chainId: 324 /* ZKSYNC_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x5aea5775959fbc2557cc8789bc1bf90a239d9a91",
          chainId: 324 /* ZKSYNC_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        },
        {
          deprecated: true,
          name: "Wrapped BTC",
          symbol: "WBTC",
          address: "0xBBeB516fb02a01611cBBE0453Fe3c580D7281011",
          chainId: 324 /* ZKSYNC_MAINNET */,
          decimals: 8,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3717.png"
          }
        },
        {
          name: "Symbiosis",
          symbol: "SIS",
          address: "0xdd9f72afED3631a6C85b5369D84875e6c42f1827",
          chainId: 324 /* ZKSYNC_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
          }
        },
        {
          name: "Symbiosis BTC",
          symbol: "syBTC",
          address: "0xED0c95EBe5a3E687cB2224687024FeC6518E683e",
          chainId: 324 /* ZKSYNC_MAINNET */,
          decimals: 8,
          icons: {
            large: "https://assets.coingecko.com/coins/images/50472/standard/NewOption_06.png?1727849200",
            small: "https://assets.coingecko.com/coins/images/50472/standard/NewOption_06.png?1727849200"
          }
        }
      ],
      router: "0x8B791913eB07C32779a16750e3868aA8495F5964",
      dexFee: 30,
      metaRouter: "0x38307CB291Af47Af9847c134a34E9477c939Ca28",
      metaRouterGateway: "0x8cA239448AdD34b057D1CB5934F12AC899DB66e1",
      bridge: "0x51eE73BEC8521E88042b426F31864f456f2a866e",
      synthesis: "0x07bffC25011901CB01a00127518A154b47eB6e80",
      portal: "0x4f5456d4d0764473DfCA1ffBB8524C151c4F19b9",
      fabric: "0xa43772bC9EA21625A2B0070B7bf006324B7A7FAE",
      multicallRouter: "0xe004DE550074856bD64Cc1A89A8B3b56bD3eAf31"
    },
    {
      id: 42161 /* ARBITRUM_MAINNET */,
      rpc: "https://arb1.arbitrum.io/rpc",
      spareRpcs: ["https://rpc.ankr.com/arbitrum", "https://arbitrum.llamarpc.com", "https://1rpc.io/arb"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
          chainId: 42161 /* ARBITRUM_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          deprecated: true,
          name: "USD Coin (Arb1)",
          symbol: "USDC.e",
          address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
          chainId: 42161 /* ARBITRUM_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
          chainId: 42161 /* ARBITRUM_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        },
        {
          name: "Symbiosis",
          symbol: "SIS",
          address: "0x9E758B8a98a42d612b3D38B66a22074DC03D7370",
          chainId: 42161 /* ARBITRUM_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
          }
        },
        {
          name: "Milady Meme Coin",
          symbol: "LADYS",
          address: "0x3b60FF35D3f7F62d636b067dD0dC0dFdAd670E4E",
          chainId: 42161 /* ARBITRUM_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/25023.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/25023.png"
          }
        },
        {
          name: "Frax",
          symbol: "FRAX",
          address: "0x17FC002b466eEc40DaE837Fc4bE5c67993ddBd6F",
          chainId: 42161 /* ARBITRUM_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/6952.png"
          }
        }
      ],
      router: "0xD01319f4b65b79124549dE409D36F25e04B3e551",
      dexFee: 30,
      metaRouter: "0xf7e96217347667064DEE8f20DB747B1C7df45DDe",
      metaRouterGateway: "0x80ddDDa846e779cceE463bDC0BCc2Ae296feDaF9",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x326adbE46D7E6C1B3927e9309B96DF478bda6D16",
      portal: "0x01A3c8E513B758EBB011F7AFaf6C37616c9C24d9",
      fabric: "0x2eE9559387b806E88fd46b9DA160D64A29CE7Da0",
      multicallRouter: "0xda8057acB94905eb6025120cB2c38415Fd81BfEB"
    },
    {
      id: 10 /* OPTIMISM_MAINNET */,
      rpc: "https://mainnet.optimism.io",
      spareRpcs: ["https://optimism-rpc.publicnode.com", "https://rpc.ankr.com/optimism"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "USD Coin",
          symbol: "USDC.e",
          address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
          chainId: 10,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x4200000000000000000000000000000000000006",
          chainId: 10,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0x0f91052dc5B4baE53d0FeA5DAe561A117268f5d2",
      metaRouterGateway: "0x200a0fe876421DC49A26508e3Efd0a1008fD12B5",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8"
    },
    {
      id: 42170 /* ARBITRUM_NOVA */,
      rpc: "https://arbitrum-nova-rpc.publicnode.com",
      spareRpcs: [
        "https://nova.arbitrum.io/rpc",
        "https://rpc.ankr.com/arbitrumnova",
        "https://arbitrum-nova.drpc.org"
      ],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0x750ba8b76187092B0D1E87E28daaf484d1b5273b",
          chainId: 42170,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x722e8bdd2ce80a4422e880164f2079488e115365",
          chainId: 42170,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0xEe01c0CD76354C383B8c7B4e65EA88D00B06f36f",
      dexFee: 30,
      metaRouter: "0xca506793A420E901BbCa8066be5661E3C52c84c2",
      metaRouterGateway: "0xd92Ca299F1C2518E78E48C207b64591BA6E9b9a8",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8"
    },
    {
      id: 1101 /* POLYGON_ZK */,
      rpc: "https://rpc.ankr.com/polygon_zkevm",
      spareRpcs: [
        "https://polygon-zkevm.drpc.org",
        "https://zkevm-rpc.com",
        "https://polygon-zkevm-mainnet.public.blastapi.io"
      ],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0xA8CE8aee21bC2A48a5EF670afCc9274C7bbbC035",
          chainId: 1101,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          deprecated: true,
          name: "USD Coin",
          symbol: "USDC.e",
          address: "0x37eAA0eF3549a5Bb7D431be78a3D99BD360d19e5",
          chainId: 1101,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x4f9a0e7fd2bf6067db6994cf12e4495df938e6e9",
          chainId: 1101,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 30,
      metaRouter: "0xb91d3060C90aac7c4c706aef2B37997b3b2a1DcF",
      metaRouterGateway: "0x668961F4923A4FB96b22ad1F18aE215bB2694593",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8"
    },
    {
      id: 59144 /* LINEA_MAINNET */,
      rpc: "https://rpc.linea.build",
      spareRpcs: ["https://1rpc.io/linea", "https://linea.drpc.org", "https://linea.decubate.com"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f",
          chainId: 59144 /* LINEA_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        },
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0x176211869cA2b568f2A7D4EE941E073a821EE1ff",
          chainId: 59144 /* LINEA_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Symbiosis",
          symbol: "SIS",
          address: "0x6EF95B6f3b0F39508e3E04054Be96D5eE39eDE0d",
          chainId: 59144 /* LINEA_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 30,
      metaRouter: "0x9A31bAC4b3B958C835C243800B474818D04393dd",
      metaRouterGateway: "0x83f71AabdDBb9F0E3B6462Cc7635b6fFAD0f2f2e",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8"
    },
    {
      id: 5e3 /* MANTLE_MAINNET */,
      rpc: "https://rpc.mantle.xyz",
      spareRpcs: [
        "https://mantle-rpc.publicnode.com",
        "https://mantle-mainnet.public.blastapi.io",
        "https://rpc.ankr.com/mantle"
      ],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0x09Bc4E0D864854c6aFB6eB9A9cdF58aC190D0dF9",
          chainId: 5e3,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0xdEAddEaDdeadDEadDEADDEAddEADDEAddead1111",
          chainId: 5e3,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0xDd0840118bF9CCCc6d67b2944ddDfbdb995955FD",
      dexFee: 30,
      metaRouter: "0xca506793A420E901BbCa8066be5661E3C52c84c2",
      metaRouterGateway: "0xd92Ca299F1C2518E78E48C207b64591BA6E9b9a8",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8"
    },
    {
      id: 8453 /* BASE_MAINNET */,
      rpc: "https://base-rpc.publicnode.com",
      spareRpcs: ["https://mainnet.base.org", "https://base.llamarpc.com", "https://rpc.ankr.com/base"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x4200000000000000000000000000000000000006",
          chainId: 8453,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        },
        {
          name: "USD Base Coin",
          symbol: "USDbC",
          address: "0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA",
          chainId: 8453,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        }
      ],
      router: "0x327Df1E6de05895d2ab08513aaDD9313Fe505d86",
      dexFee: 0,
      metaRouter: "0x691df9C4561d95a4a726313089c8536dd682b946",
      metaRouterGateway: "0x41Ae964d0F61Bb5F5e253141A462aD6F3b625B92",
      bridge: "0x8097f0B9f06C27AF9579F75762F971D745bb222F",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xEE981B2459331AD268cc63CE6167b446AF4161f8",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x01A3c8E513B758EBB011F7AFaf6C37616c9C24d9"
    },
    {
      id: 728126428 /* TRON_MAINNET */,
      rpc: "https://api.trongrid.io",
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "Tether USDt",
          symbol: "USDT",
          address: "0xa614f803b6fd780986a42c78ec9c7f77e6ded13c",
          chainId: 728126428 /* TRON_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
          }
        }
      ],
      router: "0x6E0617948FE030A7E4970F8389D4AD295F249B7E",
      dexFee: 30,
      metaRouter: "0x0863786bbf4561f4a2a8be5a9ddf152afd8ae25c",
      metaRouterGateway: "0x49e1816a2cf475515e7c80c9f0f0e16ae499198b",
      bridge: "0xc5a6517050c44ba78295f57f4754bb68f8705321",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xd83b5752b42856a08087748de6095af0be52d299",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x354ed0e8616678f2829feb2e2e9a0e0869fa82fb"
    },
    {
      id: 534352 /* SCROLL_MAINNET */,
      rpc: "https://rpc.scroll.io",
      spareRpcs: [
        "https://rpc.ankr.com/scroll",
        "https://scroll.blockpi.network/v1/rpc/public",
        "https://scroll-mainnet.public.blastapi.io"
      ],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x5300000000000000000000000000000000000004",
          chainId: 534352 /* SCROLL_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        },
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0x06eFdBFf2a14a7c8E15944D1F4A48F9F95F663A4",
          chainId: 534352 /* SCROLL_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "Symbiosis",
          symbol: "SIS",
          address: "0x1467b62A6AE5CdcB10A6a8173cfe187DD2C5a136",
          chainId: 534352 /* SCROLL_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
          }
        },
        {
          name: "pufETH",
          symbol: "pufETH",
          address: "0xc4d46E8402F476F269c379677C99F18E22Ea030e",
          chainId: 534352 /* SCROLL_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0x624FFe62eBa13e6057878bCA1D7A9E35651E1D9c",
      metaRouterGateway: "0x49952ff32FcBc3408D447E1E91Da2b44BD2D1AFE",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x5Aa5f7f84eD0E5db0a4a85C3947eA16B53352FD4",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x01A3c8E513B758EBB011F7AFaf6C37616c9C24d9"
    },
    {
      id: 169 /* MANTA_MAINNET */,
      rpc: "https://pacific-rpc.manta.network/http",
      spareRpcs: ["https://1rpc.io/manta", "https://manta-pacific.drpc.org"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x0Dc808adcE2099A9F62AA87D9670745AbA741746",
          chainId: 169 /* MANTA_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        },
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0xb73603C5d87fA094B7314C74ACE2e64D165016fb",
          chainId: 169 /* MANTA_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        },
        {
          name: "pufETH",
          symbol: "pufETH",
          address: "0xA53E005Cecd3D7C89A4AE814617cC14828b6527E",
          chainId: 169 /* MANTA_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0x318C2B9a03C37702742C3d40C72e4056e430135A",
      metaRouterGateway: "0x027cc92c6892de323Ba664F0B3bA8B602d4116B6",
      bridge: "0xda8057acB94905eb6025120cB2c38415Fd81BfEB",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x5Aa5f7f84eD0E5db0a4a85C3947eA16B53352FD4",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x2b7Aa8bDc40B6d3d19d0dE7480c4db8d5B6495e2"
    },
    {
      id: 1088 /* METIS_MAINNET */,
      rpc: "https://andromeda.metis.io/?owner=1088",
      spareRpcs: [
        "https://metis.drpc.org",
        "https://metis-pokt.nodies.app",
        "https://metis-mainnet.public.blastapi.io"
      ],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x420000000000000000000000000000000000000A",
          chainId: 1088 /* METIS_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0xf85FC807D05d3Ab2309364226970aAc57b4e1ea4",
      metaRouterGateway: "0xcd7C056b39DdFB568E451923ABEDb9B6a7Aeb885",
      bridge: "0x01A3c8E513B758EBB011F7AFaf6C37616c9C24d9",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xd8db4fb1fEf63045A443202d506Bcf30ef404160",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x5Aa5f7f84eD0E5db0a4a85C3947eA16B53352FD4"
    },
    {
      id: 5165 /* BAHAMUT_MAINNET */,
      rpc: "https://bahamut-rpc.publicnode.com",
      spareRpcs: ["https://rpc.ankr.com/bahamut", "https://rpc1.bahamut.io", "https://rpc2.bahamut.io"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0x4237e0A5b55233D5B6D6d1D9BF421723954130D8",
          chainId: 5165 /* BAHAMUT_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
          }
        }
      ],
      router: "0xF660558a4757Fb5953d269FF32E228Ae3d5f6c68",
      dexFee: 0,
      metaRouter: "0xf85FC807D05d3Ab2309364226970aAc57b4e1ea4",
      metaRouterGateway: "0xcd7C056b39DdFB568E451923ABEDb9B6a7Aeb885",
      bridge: "0x1ac4C50080871D7a24DD705dE9eFe5FF14bC0Ea2",
      synthesis: "0xB79A4F5828eb55c10D7abF4bFe9a9f5d11aA84e0",
      portal: "0x318C2B9a03C37702742C3d40C72e4056e430135A",
      fabric: "0xA257F3FE4E4032291516DC355eDF90664e9eB932",
      multicallRouter: "0x3E6A3EbbC9D88ACC192221797ad90BF72d391778"
    },
    {
      id: 34443 /* MODE_MAINNET */,
      rpc: "https://mainnet.mode.network",
      spareRpcs: ["https://1rpc.io/mode", "https://mode.drpc.org"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0x4200000000000000000000000000000000000006",
          chainId: 34443 /* MODE_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0x5D61c537393cf21893BE619E36fC94cd73C77DD3",
      dexFee: 30,
      metaRouter: "0xcE8f24A58D85eD5c5A6824f7be1F8d4711A0eb4C",
      metaRouterGateway: "0xAdB2d3b711Bb8d8Ea92ff70292c466140432c278",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8"
    },
    {
      id: 30 /* RSK_MAINNET */,
      rpc: "https://public-node.rsk.co",
      spareRpcs: ["https://go.getblock.io/a4cf9dc5a3e347aaa1bb46315f2b874d", "https://mycrypto.rsk.co"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "Tether USD",
          symbol: "rUSDT",
          address: "0xef213441a85df4d7acbdae0cf78004e1e486bb96",
          chainId: 30 /* RSK_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/825.png"
          }
        },
        {
          name: "Wrapped RBTC",
          symbol: "WRBTC",
          address: "0x542fda317318ebf1d3deaf76e0b632741a7e677d",
          chainId: 30 /* RSK_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/32702.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/32702.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0x7057ab3fb2bee9c18e0cde4240de4ff7f159e365",
      metaRouterGateway: "0xfffdb2a69abcbbf55ecb2f6b348e0bd3d0f9f2e1",
      bridge: "0xda8057acb94905eb6025120cb2c38415fd81bfeb",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x5aa5f7f84ed0e5db0a4a85c3947ea16b53352fd4",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x01a3c8e513b758ebb011f7afaf6c37616c9c24d9"
    },
    {
      id: 81457 /* BLAST_MAINNET */,
      rpc: "https://blast-rpc.publicnode.com",
      spareRpcs: [
        "https://rpc.blast.io",
        "https://rpc.ankr.com/blast",
        "https://blastl2-mainnet.public.blastapi.io"
      ],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "Wrapped ETH",
          symbol: "WETH",
          address: "0x4300000000000000000000000000000000000004",
          chainId: 81457 /* BLAST_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0x7057aB3fB2BeE9c18e0cDe4240DE4ff7f159E365",
      metaRouterGateway: "0xa0079829B9F1Edc5DD0DE3eC104f281745C4bD81",
      bridge: "0xda8057acB94905eb6025120cB2c38415Fd81BfEB",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x5Aa5f7f84eD0E5db0a4a85C3947eA16B53352FD4",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x01A3c8E513B758EBB011F7AFaf6C37616c9C24d9"
    },
    {
      id: 4200 /* MERLIN_MAINNET */,
      rpc: "https://rpc.merlinchain.io",
      spareRpcs: ["https://merlin.blockpi.network/v1/rpc/public"],
      filterBlockOffset: 1e3,
      stables: [
        {
          name: "Wrapped BTC",
          symbol: "WBTC",
          address: "0xF6D226f9Dc15d9bB51182815b320D3fBE324e1bA",
          chainId: 4200 /* MERLIN_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3717.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0xcE8f24A58D85eD5c5A6824f7be1F8d4711A0eb4C",
      metaRouterGateway: "0xAdB2d3b711Bb8d8Ea92ff70292c466140432c278",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8"
    },
    {
      id: 810180 /* ZKLINK_MAINNET */,
      rpc: "https://rpc.zklink.io",
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "Wrapped ETH",
          symbol: "WETH",
          address: "0x8280a4e7D5B3B658ec4580d3Bc30f5e50454F169",
          chainId: 810180 /* ZKLINK_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        },
        {
          name: "pufETH",
          symbol: "pufETH",
          address: "0x1B49eCf1A8323Db4abf48b2F5EFaA33F7DdAB3FC",
          chainId: 810180 /* ZKLINK_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0xAcb35C2D11FEA8849cd9f5Ff6fBC56bB5296641B",
      metaRouterGateway: "0xe4E794C74558057E09e9131705f5F92aAfD8Dd31",
      bridge: "0x2E818E50b913457015E1277B43E469b63AC5D3d7",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x8Dc71561414CDcA6DcA7C1dED1ABd04AF474D189",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x4c398CB4b7D4d31a54D254d8Aed09B9e8353E80E"
    },
    {
      id: 1116 /* CORE_MAINNET */,
      rpc: "https://rpc.coredao.org",
      spareRpcs: ["https://rpc.ankr.com/core", "https://1rpc.io/core"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "Core Wrapped BTC Token",
          symbol: "coreBTC",
          address: "0x8034aB88C3512246Bf7894f57C834DdDBd1De01F",
          chainId: 1116 /* CORE_MAINNET */,
          decimals: 8,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1.png"
          }
        }
      ],
      router: "0x4ddDD324F205e5989bAF8aD0FFCa41f4E5d9841D",
      dexFee: 0,
      metaRouter: "0xcE8f24A58D85eD5c5A6824f7be1F8d4711A0eb4C",
      metaRouterGateway: "0xAdB2d3b711Bb8d8Ea92ff70292c466140432c278",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8"
    },
    {
      id: 167e3 /* TAIKO_MAINNET */,
      rpc: "https://rpc.mainnet.taiko.xyz",
      spareRpcs: ["https://rpc.ankr.com/taiko", "https://taiko.blockpi.network/v1/rpc/public"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "Wrapped Ether",
          symbol: "WETH",
          address: "0xA51894664A773981C6C112C43ce576f315d5b1B6",
          chainId: 167e3 /* TAIKO_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0x7057aB3fB2BeE9c18e0cDe4240DE4ff7f159E365",
      metaRouterGateway: "0xa0079829B9F1Edc5DD0DE3eC104f281745C4bD81",
      bridge: "0xda8057acB94905eb6025120cB2c38415Fd81BfEB",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x5Aa5f7f84eD0E5db0a4a85C3947eA16B53352FD4",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x01A3c8E513B758EBB011F7AFaf6C37616c9C24d9"
    },
    {
      id: 1329 /* SEI_EVM_MAINNET */,
      rpc: "https://evm-rpc.sei-apis.com",
      spareRpcs: [],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0x3894085Ef7Ff0f0aeDf52E2A2704928d1Ec074F1",
          chainId: 1329 /* SEI_EVM_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3408.png"
          }
        },
        {
          name: "USDT",
          symbol: "USDT",
          address: "0xB75D0B03c06A926e488e2659DF1A861F860bD3d1",
          chainId: 1329 /* SEI_EVM_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/825.png"
          }
        }
      ],
      router: "0xa4cF2F53D1195aDDdE9e4D3aCa54f556895712f2",
      dexFee: 30,
      metaRouter: "0xcE8f24A58D85eD5c5A6824f7be1F8d4711A0eb4C",
      metaRouterGateway: "0xAdB2d3b711Bb8d8Ea92ff70292c466140432c278",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8"
    },
    {
      id: 7e3 /* ZETACHAIN_MAINNET */,
      rpc: "https://zetachain-evm.blockpi.network/v1/rpc/public",
      spareRpcs: ["https://zetachain-mainnet-archive.allthatnode.com:8545"],
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "pufETH",
          symbol: "pufETH",
          address: "0x1e4bF3CaBD7707089138dD5a545B077413FA83Fc",
          chainId: 7e3 /* ZETACHAIN_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
          }
        },
        {
          name: "ZetaChain ZRC20 USDC on ETH",
          symbol: "USDC.ETH",
          address: "0x0cbe0dF132a6c6B4a2974Fa1b7Fb953CF0Cc798a",
          chainId: 7e3 /* ZETACHAIN_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3408.png"
          }
        }
      ],
      router: "0x2ca7d64A7EFE2D62A725E2B35Cf7230D6677FfEe",
      dexFee: 0,
      metaRouter: "0x01A3c8E513B758EBB011F7AFaf6C37616c9C24d9",
      metaRouterGateway: "0xcB341279c0A071bfC14e69450Add47c568c4ddAC",
      bridge: "0x5Aa5f7f84eD0E5db0a4a85C3947eA16B53352FD4",
      synthesis: "0x2b7Aa8bDc40B6d3d19d0dE7480c4db8d5B6495e2",
      portal: "0x8a7F930003BedD63A1ebD99C5917FD6aE7E3dedf",
      fabric: "0x1a039cE63AE35a67Bf0E9F6DbFaE969639D59eC8",
      multicallRouter: "0xd8db4fb1fEf63045A443202d506Bcf30ef404160"
    },
    {
      id: 25 /* CRONOS_MAINNET */,
      rpc: "https://evm.cronos.org",
      spareRpcs: ["https://rpc.nebkas.ro", "https://cronos-evm-rpc.publicnode.com"],
      filterBlockOffset: 1e3,
      stables: [
        {
          name: "USD Coin",
          symbol: "USDC",
          address: "0xc21223249ca28397b4b6541dffaecc539bff0c59",
          chainId: 25 /* CRONOS_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3408.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0xcE8f24A58D85eD5c5A6824f7be1F8d4711A0eb4C",
      metaRouterGateway: "0xAdB2d3b711Bb8d8Ea92ff70292c466140432c278",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0xE75C7E85FE6ADd07077467064aD15847E6ba9877",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62"
    },
    {
      id: 252 /* FRAXTAL_MAINNET */,
      rpc: "https://rpc.frax.com",
      spareRpcs: [],
      filterBlockOffset: 1e3,
      stables: [
        {
          name: "Wrapped ETH",
          symbol: "WETH",
          address: "0xA8a59D73388D0c4344a7b0Ba287ddb654227c38a",
          chainId: 252 /* FRAXTAL_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
          }
        },
        {
          name: "Frax",
          symbol: "FRAX",
          address: "0xfc00000000000000000000000000000000000001",
          chainId: 252 /* FRAXTAL_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/6952.png"
          }
        }
      ],
      router: "0x39cd4db6460d8B5961F73E997E86DdbB7Ca4D5F6",
      dexFee: 30,
      metaRouter: "0xcE8f24A58D85eD5c5A6824f7be1F8d4711A0eb4C",
      metaRouterGateway: "0xAdB2d3b711Bb8d8Ea92ff70292c466140432c278",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8"
    },
    {
      id: 1625 /* GRAVITY_MAINNET */,
      rpc: "https://rpc.gravity.xyz",
      spareRpcs: ["https://rpc.ankr.com/gravity"],
      filterBlockOffset: 1e3,
      stables: [
        {
          name: "Bridged USDC (Stargate)",
          symbol: "USDC.e",
          address: "0xFbDa5F676cB37624f28265A144A48B0d6e87d3b6",
          chainId: 1625 /* GRAVITY_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3408.png"
          }
        },
        {
          name: "Gravity",
          symbol: "wG",
          address: "0xBB859E225ac8Fb6BE1C7e38D87b767e95Fef0EbD",
          chainId: 1625 /* GRAVITY_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/32120.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/32120.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0xcE8f24A58D85eD5c5A6824f7be1F8d4711A0eb4C",
      metaRouterGateway: "0xAdB2d3b711Bb8d8Ea92ff70292c466140432c278",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8"
    },
    {
      id: 223 /* BSQUARED_MAINNET */,
      rpc: "https://rpc.bsquared.network",
      spareRpcs: ["https://b2-mainnet.alt.technology"],
      filterBlockOffset: 1e3,
      stables: [
        {
          name: "Wrapped BTC",
          symbol: "WBTC",
          address: "0x4200000000000000000000000000000000000006",
          chainId: 223 /* BSQUARED_MAINNET */,
          decimals: 18,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3717.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0xcE8f24A58D85eD5c5A6824f7be1F8d4711A0eb4C",
      metaRouterGateway: "0xAdB2d3b711Bb8d8Ea92ff70292c466140432c278",
      bridge: "0x5523985926Aa12BA58DC5Ad00DDca99678D7227E",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x292fC50e4eB66C3f6514b9E402dBc25961824D62",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0xb8f275fBf7A959F4BCE59999A2EF122A099e81A8"
    },
    {
      id: 85918 /* TON_MAINNET */,
      rpc: "https://toncenter.com/api/v2/jsonRPC",
      filterBlockOffset: 0,
      stables: [
        {
          name: "TON Coin",
          symbol: "TON",
          address: "0xA4f1b5C2fC9b97d4238B3dE3487ccaE2c36dE07C",
          chainId: 85918 /* TON_MAINNET */,
          decimals: 9,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
          }
        },
        {
          name: "USDt",
          symbol: "USDT",
          address: "0x9328Eb759596C38a25f59028B146Fecdc3621Dfe",
          chainId: 85918 /* TON_MAINNET */,
          decimals: 6,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0x0000000000000000000000000000000000000000",
      metaRouterGateway: "0x0000000000000000000000000000000000000000",
      bridge: "0x0000000000000000000000000000000000000000",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x0000000000000000000000000000000000000000",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x0000000000000000000000000000000000000000",
      tonPortal: "EQDpUHhVl5lJ6Y47DCd0TWdXB_kd-U-N6KyAELePNjfj15HT"
    }
  ]
};

// src/crosschain/config/testnet.ts
var config2 = {
  advisor: {
    url: "https://api.testnet.symbiosis.finance/calculations"
  },
  limits: [],
  transitFeeMap: {
    ETH: "0.0003",
    USD: "0.3",
    SIS: "1",
    TON: "0.1",
    BTC: "0.00001",
    LADYS: "3000000",
    FRAX: "0.3"
  },
  omniPools: [
    // {
    //     chainId: ChainId.BSC_TESTNET,
    //     address: '0xFC385a59b2728cA437057E3cDBA4a2611B75c406', // BTC octopool
    //     oracle: '0xfdF3dBF16a7Dc8078FE4E9D0c1ac391dfb8B19aF',
    //     generalPurpose: true,
    // },
    // {
    //     chainId: ChainId.BSC_TESTNET,
    //     address: '0x3E524E5dbcEc08C3712D7Ac877Ad83cb8dAfCe8D', // BTC mainnet octopool
    //     oracle: '0x7a62416f10cd039cb538953953f94316FE1c32FA',
    //     generalPurpose: true,
    // },
    {
      chainId: 97 /* BSC_TESTNET */,
      address: "0x2826c540065C8eD792d7100ca89628E986f2F42E",
      // TON octopool
      oracle: "0xaF123f922b9cAe0F525c2E5A95314D7E8E229413",
      generalPurpose: true
      // maybe in prod false, eth -\-> ton
    }
  ],
  revertableAddress: {
    [2494104990 /* TRON_TESTNET */]: "0x1b5D6DDF6086Bb06616f58274F894099c31e9DB5",
    default: "0x1b5D6DDF6086Bb06616f58274F894099c31e9DB5"
  },
  chains: [
    {
      // NOTE host chain is better to be first in the config
      id: 97 /* BSC_TESTNET */,
      rpc: "https://rpc.ankr.com/bsc_testnet_chapel",
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "WTON(BSC)",
          symbol: "WTON(BSC)",
          address: "0xe015581A4e36eEbf170a3F4a686fa7606d511b13",
          chainId: 97 /* BSC_TESTNET */,
          decimals: 9,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0xCc9f8896896c6eF44f2504A6A29e6057aDBfF179",
      metaRouterGateway: "0xaa067db6103E4b792bbE09540B5a7757F79d582a",
      bridge: "0xB299eee0Ed46b7a34C01F2a01fc83a0B45aA88AF",
      synthesis: "0x08f5c28ff0622FeF758c2C3c2a5EAEeb63D60D4c",
      portal: "0x0000000000000000000000000000000000000000",
      fabric: "0x9B8D0e0765cDa999910ff31A2204080E1192EfC7",
      multicallRouter: "0x086D8d30822086941729DF294f0e52E42EdC17F9"
    },
    {
      id: 11155111 /* SEPOLIA_TESTNET */,
      rpc: "https://rpc.ankr.com/bsc_testnet_chapel",
      filterBlockOffset: 2e3,
      stables: [
        {
          name: "TONCOIN",
          symbol: "TONCOIN",
          address: "0x331f40cc27aC106e1d5242CE633dc6436626a6F8",
          chainId: 11155111 /* SEPOLIA_TESTNET */,
          decimals: 9,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0x0000000000000000000000000000000000000000",
      metaRouterGateway: "0x0000000000000000000000000000000000000000",
      bridge: "0x0000000000000000000000000000000000000000",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x0000000000000000000000000000000000000000",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x0000000000000000000000000000000000000000"
    },
    {
      id: 85919 /* TON_TESTNET */,
      rpc: "https://testnet.toncenter.com/api/v2/jsonRPC",
      filterBlockOffset: 0,
      stables: [
        {
          name: "TON Coin",
          symbol: "TON",
          address: "0x7eA393298D1077e19ec59F8e3FE8fe642738c08C",
          // derived from EQCgXxcoCXhsAiLyeG5-o5MpjRB34Z7Fn44_6P5kJzjAjKH4
          chainId: 85919 /* TON_TESTNET */,
          isNative: false,
          decimals: 9,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
          }
        },
        {
          name: "USDt",
          symbol: "USDT",
          address: "0x46deec715e419a1f0f5959b5c8450894959d2dbf",
          // derived from EQD73uqQJHKAg140YSlG3uxxXkGaHw9ZWbXIRQiUlZ0tv79a
          chainId: 85919 /* TON_TESTNET */,
          isNative: false,
          decimals: 9,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 0,
      metaRouter: "0x0000000000000000000000000000000000000000",
      metaRouterGateway: "0x0000000000000000000000000000000000000000",
      bridge: "0x0000000000000000000000000000000000000000",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x0000000000000000000000000000000000000000",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x0000000000000000000000000000000000000000",
      tonPortal: "kQChdry7W2UrILq1Wm1SN3WASMR8eWOAHQaDugEgOMVAcbXX"
    },
    // {
    //     id: ChainId.BTC_MUTINY,
    //     rpc: 'https://mutinynet.com/api',
    //     filterBlockOffset: 2000,
    //     stables: [
    //         {
    //             name: 'Bitcoin',
    //             symbol: 'BTC',
    //             address: '0xEa46baF0c59d7A22E14F7ae30cb51086FFDe55C3', // is the btc portal genesis tx
    //             chainId: ChainId.BTC_MUTINY,
    //             decimals: 8,
    //             icons: {
    //                 large: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
    //                 small: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
    //             },
    //         },
    //     ],
    //     router: '0x0000000000000000000000000000000000000000',
    //     dexFee: 0,
    //     metaRouter: '0x0000000000000000000000000000000000000000',
    //     metaRouterGateway: '0x0000000000000000000000000000000000000000',
    //     bridge: '0x0000000000000000000000000000000000000000',
    //     synthesis: '0x0000000000000000000000000000000000000000',
    //     portal: '0x0000000000000000000000000000000000000000',
    //     fabric: '0x0000000000000000000000000000000000000000',
    //     multicallRouter: '0x0000000000000000000000000000000000000000',
    //     symBtc: {
    //         address: '0xEa3f6885Ef517EcaBB2888b0ef9c6873c97f24d4',
    //         chainId: ChainId.SEPOLIA_TESTNET,
    //     },
    //     forwarderUrl: 'https://relayers.testnet.symbiosis.finance/mutinynet/forwarder/api/v1',
    // },
    // {
    //     id: ChainId.BTC_TESTNET4,
    //     rpc: 'https://mempool.space/testnet4/api',
    //     filterBlockOffset: 2000,
    //     stables: [
    //         {
    //             name: 'Bitcoin',
    //             symbol: 'BTC',
    //             address: '0xAdBdcB71a1BD1911C18B583705CB096d3A3cE9a5', // is the btc portal genesis tx
    //             chainId: ChainId.BTC_TESTNET4,
    //             decimals: 8,
    //             icons: {
    //                 large: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
    //                 small: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
    //             },
    //         },
    //     ],
    //     router: '0x0000000000000000000000000000000000000000',
    //     dexFee: 0,
    //     metaRouter: '0x0000000000000000000000000000000000000000',
    //     metaRouterGateway: '0x0000000000000000000000000000000000000000',
    //     bridge: '0x0000000000000000000000000000000000000000',
    //     synthesis: '0x0000000000000000000000000000000000000000',
    //     portal: '0x0000000000000000000000000000000000000000',
    //     fabric: '0x0000000000000000000000000000000000000000',
    //     multicallRouter: '0x0000000000000000000000000000000000000000',
    //     symBtc: {
    //         address: '0x2ff5940024af75e15b810d64ae2c89f632e7f45f',
    //         chainId: ChainId.SEPOLIA_TESTNET,
    //     },
    //     forwarderUrl: 'https://relayers.testnet.symbiosis.finance/forwarder/api/v1',
    // },
    // {
    //     id: ChainId.BTC_MAINNET,
    //     rpc: 'https://mempool.space/api',
    //     filterBlockOffset: 2000,
    //     stables: [
    //         {
    //             name: 'Bitcoin',
    //             symbol: 'BTC',
    //             address: '0x5a01380F0236A9cf36C07F3aeb6faA81bF506BD2', // is the btc portal genesis tx
    //             chainId: ChainId.BTC_MAINNET,
    //             decimals: 8,
    //             icons: {
    //                 large: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
    //                 small: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
    //             },
    //         },
    //     ],
    //     router: '0x0000000000000000000000000000000000000000',
    //     dexFee: 0,
    //     metaRouter: '0x0000000000000000000000000000000000000000',
    //     metaRouterGateway: '0x0000000000000000000000000000000000000000',
    //     bridge: '0x0000000000000000000000000000000000000000',
    //     synthesis: '0x0000000000000000000000000000000000000000',
    //     portal: '0x0000000000000000000000000000000000000000',
    //     fabric: '0x0000000000000000000000000000000000000000',
    //     multicallRouter: '0x0000000000000000000000000000000000000000',
    //     symBtc: {
    //         address: '0x12708f73252953A90840d76F064C7b9fCF2EE0CA',
    //         chainId: ChainId.SEPOLIA_TESTNET,
    //     },
    //     forwarderUrl: 'https://relayers.testnet.symbiosis.finance/mainnet/forwarder/api/v1',
    // },
    // {
    //     id: ChainId.SEPOLIA_TESTNET,
    //     rpc: 'https://rpc.sepolia.org',
    //     spareRpcs: [
    //         'https://sepolia.gateway.tenderly.co',
    //         'https://sepolia.drpc.org',
    //         'https://rpc-sepolia.rockx.com',
    //     ],
    //     filterBlockOffset: 2000,
    //     stables: [
    //         {
    //             name: 'mutSymBtc',
    //             address: '0x41540e95B10383408cfE201974c88E6C3ef9323A',
    //             symbol: 'mutSymBtc',
    //             decimals: 8,
    //             chainId: 11155111,
    //             icons: {
    //                 large: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
    //                 small: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
    //             },
    //         },
    //         {
    //             name: 't4SymBtc',
    //             address: '0x04cd23122a21f6c5F912FC7B9aBC508302899Dfb',
    //             symbol: 't4SymBtc',
    //             decimals: 8,
    //             chainId: 11155111,
    //             icons: {
    //                 large: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
    //                 small: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
    //             },
    //         },
    //         {
    //             name: 'mSymBtc',
    //             address: '0xeD86914A9478a066d82b2bE3E5B99A38BAaE23ce',
    //             symbol: 'mSymBtc',
    //             decimals: 8,
    //             chainId: 11155111,
    //             icons: {
    //                 large: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
    //                 small: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
    //             },
    //         },
    //     ],
    //     router: '0xC532a74256D3Db42D0Bf7a0400fEFDbad7694008',
    //     dexFee: 30,
    //     metaRouter: '0x8b03ad402ab3f1477bdfa64647718e5c537c0029',
    //     metaRouterGateway: '0xc3b59B4a7961EF8FD24C9838731D1f598884F53d',
    //     bridge: '0x7dc13B605508F91Fcd3bf7803C2b96B43941B4E8',
    //     synthesis: '0x3e6235b91c6734821b4037E6459f861E465D4192',
    //     portal: '0xBC4454Ee01EC5B6517333bD716f5135042ca1e38',
    //     fabric: '0xb4ADe33Bba3512c8c0B489cbd03aAd3557EC49Ca',
    //     multicallRouter: '0xF3Cfa393be621097669BcD2bD4923CEC347E1210',
    // },
    {
      id: 43113 /* AVAX_TESTNET */,
      rpc: "https://api.avax-test.network/ext/bc/C/rpc",
      spareRpcs: [
        "https://avalanche-fuji-c-chain-rpc.publicnode.com",
        "https://ava-testnet.public.blastapi.io/ext/bc/C/rpc"
      ],
      filterBlockOffset: 2e3,
      stables: [
        // {
        //     name: 'Wrapped BTC',
        //     address: '0x9374Ea7A11c5B185A6631effF22c015E71c67581',
        //     symbol: 'WBTC',
        //     decimals: 8,
        //     chainId: ChainId.AVAX_TESTNET,
        //     icons: {
        //         large: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
        //         small: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
        //     },
        // },
        // {
        //     name: 'Wrapped BTC',
        //     address: '0xE34EBC0DE48F2947510cFf88a13F1c0B11FD1109',
        //     symbol: 'WBTC(Mainnet)',
        //     decimals: 8,
        //     chainId: ChainId.AVAX_TESTNET,
        //     icons: {
        //         large: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
        //         small: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
        //     },
        // },
        {
          name: "WTON",
          address: "0xCc9f8896896c6eF44f2504A6A29e6057aDBfF179",
          symbol: "WTON(Mainnet)",
          decimals: 9,
          chainId: 43113 /* AVAX_TESTNET */,
          icons: {
            large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
            small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
          }
        }
      ],
      router: "0x0000000000000000000000000000000000000000",
      dexFee: 30,
      // 0.03%
      metaRouter: "0x0EB4Bb54E1551Db887ADdDAbD2562da13fE57D14",
      metaRouterGateway: "0xbA2269b1E4b2eb62FdaA2c7D7bbaC052d4FD05cE",
      bridge: "0xcC0DB081360Eb259bdf6911976c51cAF1B72e845",
      synthesis: "0x0000000000000000000000000000000000000000",
      portal: "0x78Bb4D4872121f162BB3e938F0d10cf34E999648",
      fabric: "0x0000000000000000000000000000000000000000",
      multicallRouter: "0x8C9D3CE1D59d73259018dBC9859F6eBe62Bbf862"
    }
  ]
};

// src/crosschain/config/dev.ts
var config3 = {
  advisor: {
    url: "https://api.dev.symbiosis.finance/calculations"
  },
  limits: [],
  transitFeeMap: {
    ETH: "0.0003",
    USD: "0.3",
    SIS: "1",
    BTC: "0.00001",
    LADYS: "3000000",
    FRAX: "0.3"
  },
  omniPools: [
    {
      chainId: 97,
      address: "0x789001A80a8EdBBEE07876b0dF58c3eAdEE89877",
      oracle: "0x2cD94CB0F4cBC4a51c3e9c4b88d03B982bE24608",
      generalPurpose: true
    }
  ],
  revertableAddress: {
    [2494104990 /* TRON_TESTNET */]: "0x1b5D6DDF6086Bb06616f58274F894099c31e9DB5",
    default: "0x1b5D6DDF6086Bb06616f58274F894099c31e9DB5"
  },
  chains: [
    {
      id: 97,
      rpc: "https://rpc.ankr.com/bsc_testnet_chapel",
      filterBlockOffset: 2e3,
      stables: [],
      router: "0xD99D1c33F9fC3444f8101754aBC46c52416550D1",
      dexFee: 30,
      metaRouter: "0x87BFB71bBd221a57826489DD247EB103a0cc7482",
      metaRouterGateway: "0x27022ad33b09f49BEE2dCC482F4604FD2560A862",
      bridge: "0x9708C5b89F9B166c080B8F5BBcDEC27D5Fa92eE8",
      synthesis: "0xD67940D8414E09F84eBEa85cd021dbc011A94Bc8",
      portal: "0x0000000000000000000000000000000000000000",
      fabric: "0x167C52B035D7cfA2D8199A2Af450B3493C51576C",
      multicallRouter: "0xF77c766DEB09f424228Be0b679E3F8326b9d7741"
    }
  ]
};

// src/crosschain/config/cache/mainnet.json
var mainnet_default = {
  omniPools: [
    {
      chainId: 56288,
      address: "0x6148FD6C649866596C3d8a971fC313E5eCE84882",
      oracle: "0x7775b274f0C3fA919B756b22A4d9674e55927ab8",
      generalPurpose: true,
      id: 0,
      tokens: [
        { index: 0, tokenId: 88 },
        { index: 1, tokenId: 98 },
        { index: 2, tokenId: 105 },
        { index: 3, tokenId: 106 },
        { index: 4, tokenId: 26 },
        { index: 5, tokenId: 111 },
        { index: 10, tokenId: 97 },
        { index: 11, tokenId: 112 },
        { index: 12, tokenId: 119 },
        { index: 13, tokenId: 124 },
        { index: 14, tokenId: 126 },
        { index: 15, tokenId: 128 },
        { index: 16, tokenId: 118 },
        { index: 17, tokenId: 104 },
        { index: 18, tokenId: 134 },
        { index: 19, tokenId: 110 },
        { index: 20, tokenId: 137 },
        { index: 21, tokenId: 132 },
        { index: 22, tokenId: 109 },
        { index: 23, tokenId: 138 },
        { index: 24, tokenId: 140 },
        { index: 25, tokenId: 144 },
        { index: 26, tokenId: 129 },
        { index: 27, tokenId: 149 },
        { index: 28, tokenId: 147 },
        { index: 29, tokenId: 113 },
        { index: 30, tokenId: 157 },
        { index: 31, tokenId: 158 },
        { index: 32, tokenId: 161 },
        { index: 33, tokenId: 160 },
        { index: 34, tokenId: 164 },
        { index: 35, tokenId: 168 }
      ]
    },
    {
      chainId: 56288,
      address: "0xBcc2637DFa64999F75abB53a7265b5B4932e40eB",
      oracle: "0x628613064b1902a1A422825cf11B687C6f17961E",
      generalPurpose: true,
      id: 1,
      tokens: [
        { index: 1, tokenId: 114 },
        { index: 2, tokenId: 130 },
        { index: 3, tokenId: 120 },
        { index: 5, tokenId: 107 },
        { index: 6, tokenId: 99 },
        { index: 7, tokenId: 125 },
        { index: 8, tokenId: 127 },
        { index: 9, tokenId: 90 },
        { index: 10, tokenId: 131 },
        { index: 11, tokenId: 135 },
        { index: 12, tokenId: 136 },
        { index: 13, tokenId: 139 },
        { index: 14, tokenId: 143 },
        { index: 15, tokenId: 146 },
        { index: 16, tokenId: 148 },
        { index: 17, tokenId: 151 },
        { index: 18, tokenId: 153 },
        { index: 19, tokenId: 156 },
        { index: 20, tokenId: 162 }
      ]
    },
    {
      chainId: 56288,
      address: "0xA267C428b16728831Be52b144F78b8F054411f55",
      oracle: "0xECBe427C8F8ea1Ee5258cAf5aB0A9d26b4D91769",
      generalPurpose: true,
      id: 2,
      tokens: [
        { index: 0, tokenId: 91 },
        { index: 1, tokenId: 100 },
        { index: 2, tokenId: 115 },
        { index: 3, tokenId: 150 },
        { index: 4, tokenId: 152 },
        { index: 5, tokenId: 155 },
        { index: 7, tokenId: 117 },
        { index: 8, tokenId: 166 }
      ]
    },
    {
      chainId: 56288,
      address: "0x7b905059Bdd00844280EBf54E00A087006B2D242",
      oracle: "0x82E7034ED28674c185E0d03dF5eBd8cAa5f37Bb5",
      generalPurpose: false,
      id: 3,
      tokens: [
        { index: 0, tokenId: 92 },
        { index: 1, tokenId: 122 }
      ]
    },
    {
      chainId: 56288,
      address: "0xB5D99bE6089720d1aD3DB2a5a16D5765605704df",
      oracle: "0xcd3DCFabA22CE28fA8b8D9e8bf545D642F4f458E",
      generalPurpose: false,
      id: 4,
      tokens: [
        { index: 0, tokenId: 89 },
        { index: 1, tokenId: 121 },
        { index: 2, tokenId: 101 },
        { index: 3, tokenId: 116 },
        { index: 4, tokenId: 133 },
        { index: 5, tokenId: 141 }
      ]
    },
    {
      chainId: 56288,
      address: "0xdc25D04cb14E114426bFc43877e1Fd32C336eA4E",
      oracle: "0x4CD678FF53538E6b084464da0020422738B46038",
      generalPurpose: false,
      chainExceptions: [252],
      id: 5,
      tokens: [
        { index: 0, tokenId: 94 },
        { index: 1, tokenId: 108 },
        { index: 2, tokenId: 123 },
        { index: 3, tokenId: 163 }
      ]
    },
    {
      chainId: 56288,
      address: "0x8D2209E88f68324c6241bCAA7d24538ebe94e2Ee",
      oracle: "0xA7614e3427f52b04EeD23c7371a382640bD6C463",
      generalPurpose: false,
      chainExceptions: [1625],
      id: 6,
      tokens: [
        { index: 0, tokenId: 95 },
        { index: 1, tokenId: 102 },
        { index: 2, tokenId: 165 }
      ]
    },
    {
      chainId: 56288,
      address: "0xDFCaCf059062C5c495436cE534AEeDcD2265Cc23",
      oracle: "0xe717C95007cA64334c9facFFC1975310C3B98EE8",
      generalPurpose: false,
      chainExceptions: [1, 56],
      id: 7,
      tokens: [
        { index: 1, tokenId: 96 },
        { index: 2, tokenId: 103 },
        { index: 4, tokenId: 167 }
      ]
    }
  ],
  tokens: [
    {
      decimals: 8,
      symbol: "BTC",
      name: "Bitcoin",
      chainId: 3652501241,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png"
      },
      deprecated: false,
      address: "0xc102C66D4a1e1865Ee962084626Cf4c27D5BFc74",
      id: 0
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      id: 1
    },
    {
      decimals: 18,
      symbol: "SIS",
      name: "Symbiosis",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      deprecated: false,
      address: "0xd38BB40815d2B0c2d2c866e0c72c5728ffC76dd9",
      id: 2
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      id: 3
    },
    {
      decimals: 6,
      symbol: "USDT",
      name: "Tether USD",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      deprecated: false,
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      id: 4
    },
    {
      decimals: 8,
      symbol: "WBTC",
      name: "Wrapped BTC",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png"
      },
      deprecated: false,
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      id: 5
    },
    {
      decimals: 18,
      symbol: "LADYS",
      name: "Milady Meme Coin",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/25023.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/25023.png"
      },
      deprecated: false,
      address: "0x12970E6868f88f6557B76120662c1B3E50A646bf",
      id: 6
    },
    {
      decimals: 18,
      symbol: "pufETH",
      name: "pufETH",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
      },
      deprecated: false,
      address: "0xD9A442856C234a39a81a089C06451EBAa4306a72",
      id: 7
    },
    {
      decimals: 18,
      symbol: "FRAX",
      name: "Frax",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/6952.png"
      },
      deprecated: false,
      address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
      id: 8
    },
    {
      decimals: 18,
      symbol: "G",
      name: "Gravity",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/32120.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/32120.png"
      },
      deprecated: false,
      address: "0x9C7BEBa8F6eF6643aBd725e45a4E8387eF260649",
      id: 9
    },
    {
      decimals: 9,
      symbol: "WTON",
      name: "Wrapped TON",
      chainId: 1,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
      },
      deprecated: false,
      address: "0x582d872A1B094FC48F5DE31D3B73F2D9bE47def1",
      id: 10
    },
    {
      decimals: 18,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 56,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
      id: 11
    },
    {
      decimals: 18,
      symbol: "BUSD",
      name: "BUSD Token",
      chainId: 56,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png"
      },
      deprecated: true,
      address: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
      id: 12
    },
    {
      decimals: 18,
      symbol: "ETH",
      name: "Ethereum Token",
      chainId: 56,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
      id: 13
    },
    {
      decimals: 18,
      symbol: "BTCB",
      name: "Binance-Peg BTCB Token",
      chainId: 56,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4023.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/4023.png"
      },
      deprecated: false,
      address: "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
      id: 14
    },
    {
      decimals: 18,
      symbol: "SIS",
      name: "Symbiosis",
      chainId: 56,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      deprecated: false,
      address: "0xF98b660AdF2ed7d9d9D9dAACC2fb0CAce4F21835",
      id: 15
    },
    {
      decimals: 18,
      symbol: "G",
      name: "Gravity",
      chainId: 56,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/32120.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/32120.png"
      },
      deprecated: false,
      address: "0x9C7BEBa8F6eF6643aBd725e45a4E8387eF260649",
      id: 16
    },
    {
      decimals: 9,
      symbol: "WTON",
      name: "Wrapped TON",
      chainId: 56,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
      },
      deprecated: false,
      address: "0x76A797A59Ba2C17726896976B7B3747BfD1d220f",
      id: 17
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 43114,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
      id: 18
    },
    {
      decimals: 6,
      symbol: "USDC.e",
      name: "USD Coin",
      chainId: 43114,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: true,
      address: "0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664",
      id: 19
    },
    {
      decimals: 6,
      symbol: "USDC.e",
      name: "USD Coin (PoS) (USDC.e)",
      chainId: 137,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
      id: 20
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 137,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
      id: 21
    },
    {
      decimals: 18,
      symbol: "FRAX",
      name: "Frax",
      chainId: 137,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/6952.png"
      },
      deprecated: false,
      address: "0x45c32fA6DF82ead1e2EF74d17b76547EDdFaFF89",
      id: 22
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "syUSDC",
      chainId: 40,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0xe6E5f3d264117E030C21920356641DbD5B3d660c",
      id: 23
    },
    {
      decimals: 6,
      symbol: "USDt",
      name: "Tether USDt",
      chainId: 2222,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      deprecated: false,
      address: "0x919C1c267BC06a7039e03fcc2eF738525769109c",
      id: 24
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x66a2A913e447d6b4BF33EFbec43aAeF87890FBbc",
      id: 25
    },
    {
      decimals: 18,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x9F98f9F312D23d078061962837042b8918e6aff2",
      id: 26
    },
    {
      decimals: 6,
      symbol: "USDC.e",
      name: "USD Coin",
      chainId: 324,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x3355df6D4c9C3035724Fd0e3914dE96A5a83aaf4",
      id: 27
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 324,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: true,
      address: "0x1d17CBcF0D6D143135aE902365D2E5e2A16538D4",
      id: 28
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 324,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x5AEa5775959fBC2557Cc8789bC1bf90A239D9a91",
      id: 29
    },
    {
      decimals: 8,
      symbol: "WBTC",
      name: "Wrapped BTC",
      chainId: 324,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3717.png"
      },
      deprecated: true,
      address: "0xBBeB516fb02a01611cBBE0453Fe3c580D7281011",
      id: 30
    },
    {
      decimals: 18,
      symbol: "SIS",
      name: "Symbiosis",
      chainId: 324,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      deprecated: false,
      address: "0xdd9f72afED3631a6C85b5369D84875e6c42f1827",
      id: 31
    },
    {
      decimals: 8,
      symbol: "syBTC",
      name: "Symbiosis BTC",
      chainId: 324,
      isNative: false,
      icons: {
        large: "https://assets.coingecko.com/coins/images/50472/standard/NewOption_06.png?1727849200",
        small: "https://assets.coingecko.com/coins/images/50472/standard/NewOption_06.png?1727849200"
      },
      deprecated: false,
      address: "0xED0c95EBe5a3E687cB2224687024FeC6518E683e",
      id: 32
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 42161,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      id: 33
    },
    {
      decimals: 6,
      symbol: "USDC.e",
      name: "USD Coin (Arb1)",
      chainId: 42161,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: true,
      address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
      id: 34
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 42161,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      id: 35
    },
    {
      decimals: 18,
      symbol: "SIS",
      name: "Symbiosis",
      chainId: 42161,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      deprecated: false,
      address: "0x9E758B8a98a42d612b3D38B66a22074DC03D7370",
      id: 36
    },
    {
      decimals: 18,
      symbol: "LADYS",
      name: "Milady Meme Coin",
      chainId: 42161,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/25023.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/25023.png"
      },
      deprecated: false,
      address: "0x3b60FF35D3f7F62d636b067dD0dC0dFdAd670E4E",
      id: 37
    },
    {
      decimals: 18,
      symbol: "FRAX",
      name: "Frax",
      chainId: 42161,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/6952.png"
      },
      deprecated: false,
      address: "0x17FC002b466eEc40DaE837Fc4bE5c67993ddBd6F",
      id: 38
    },
    {
      decimals: 6,
      symbol: "USDC.e",
      name: "USD Coin",
      chainId: 10,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
      id: 39
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 10,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x4200000000000000000000000000000000000006",
      id: 40
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 42170,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x750ba8b76187092B0D1E87E28daaf484d1b5273b",
      id: 41
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 42170,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x722E8BdD2ce80A4422E880164f2079488e115365",
      id: 42
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 1101,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0xA8CE8aee21bC2A48a5EF670afCc9274C7bbbC035",
      id: 43
    },
    {
      decimals: 6,
      symbol: "USDC.e",
      name: "USD Coin",
      chainId: 1101,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: true,
      address: "0x37eAA0eF3549a5Bb7D431be78a3D99BD360d19e5",
      id: 44
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 1101,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x4F9A0e7FD2Bf6067db6994CF12E4495Df938E6e9",
      id: 45
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 59144,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f",
      id: 46
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 59144,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x176211869cA2b568f2A7D4EE941E073a821EE1ff",
      id: 47
    },
    {
      decimals: 18,
      symbol: "SIS",
      name: "Symbiosis",
      chainId: 59144,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      deprecated: false,
      address: "0x6EF95B6f3b0F39508e3E04054Be96D5eE39eDE0d",
      id: 48
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 5e3,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x09Bc4E0D864854c6aFB6eB9A9cdF58aC190D0dF9",
      id: 49
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 5e3,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0xdEAddEaDdeadDEadDEADDEAddEADDEAddead1111",
      id: 50
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 8453,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x4200000000000000000000000000000000000006",
      id: 51
    },
    {
      decimals: 6,
      symbol: "USDbC",
      name: "USD Base Coin",
      chainId: 8453,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA",
      id: 52
    },
    {
      decimals: 6,
      symbol: "USDT",
      name: "Tether USDt",
      chainId: 728126428,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      deprecated: false,
      address: "0xa614f803b6fd780986a42c78ec9c7f77e6ded13c",
      id: 53
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 534352,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x5300000000000000000000000000000000000004",
      id: 54
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 534352,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x06eFdBFf2a14a7c8E15944D1F4A48F9F95F663A4",
      id: 55
    },
    {
      decimals: 18,
      symbol: "SIS",
      name: "Symbiosis",
      chainId: 534352,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      deprecated: false,
      address: "0x1467b62A6AE5CdcB10A6a8173cfe187DD2C5a136",
      id: 56
    },
    {
      decimals: 18,
      symbol: "pufETH",
      name: "pufETH",
      chainId: 534352,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
      },
      deprecated: false,
      address: "0xc4d46E8402F476F269c379677C99F18E22Ea030e",
      id: 57
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 169,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x0Dc808adcE2099A9F62AA87D9670745AbA741746",
      id: 58
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 169,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0xb73603C5d87fA094B7314C74ACE2e64D165016fb",
      id: 59
    },
    {
      decimals: 18,
      symbol: "pufETH",
      name: "pufETH",
      chainId: 169,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
      },
      deprecated: false,
      address: "0xA53E005Cecd3D7C89A4AE814617cC14828b6527E",
      id: 60
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 1088,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x420000000000000000000000000000000000000A",
      id: 61
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 5165,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      deprecated: false,
      address: "0x4237e0A5b55233D5B6D6d1D9BF421723954130D8",
      id: 62
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 34443,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x4200000000000000000000000000000000000006",
      id: 63
    },
    {
      decimals: 18,
      symbol: "rUSDT",
      name: "Tether USD",
      chainId: 30,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/825.png"
      },
      deprecated: false,
      address: "0xef213441A85dF4d7ACbDaE0Cf78004e1E486bB96",
      id: 64
    },
    {
      decimals: 18,
      symbol: "WRBTC",
      name: "Wrapped RBTC",
      chainId: 30,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/32702.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/32702.png"
      },
      deprecated: false,
      address: "0x542fDA317318eBF1d3DEAf76E0b632741A7e677d",
      id: 65
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped ETH",
      chainId: 81457,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x4300000000000000000000000000000000000004",
      id: 66
    },
    {
      decimals: 18,
      symbol: "WBTC",
      name: "Wrapped BTC",
      chainId: 4200,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3717.png"
      },
      deprecated: false,
      address: "0xF6D226f9Dc15d9bB51182815b320D3fBE324e1bA",
      id: 67
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped ETH",
      chainId: 810180,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0x8280a4e7D5B3B658ec4580d3Bc30f5e50454F169",
      id: 68
    },
    {
      decimals: 18,
      symbol: "pufETH",
      name: "pufETH",
      chainId: 810180,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
      },
      deprecated: false,
      address: "0x1B49eCf1A8323Db4abf48b2F5EFaA33F7DdAB3FC",
      id: 69
    },
    {
      decimals: 8,
      symbol: "coreBTC",
      name: "Core Wrapped BTC Token",
      chainId: 1116,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1.png"
      },
      deprecated: false,
      address: "0x8034aB88C3512246Bf7894f57C834DdDBd1De01F",
      id: 70
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 167e3,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0xA51894664A773981C6C112C43ce576f315d5b1B6",
      id: 71
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 1329,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3408.png"
      },
      deprecated: false,
      address: "0x3894085Ef7Ff0f0aeDf52E2A2704928d1Ec074F1",
      id: 72
    },
    {
      decimals: 6,
      symbol: "USDT",
      name: "USDT",
      chainId: 1329,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/825.png"
      },
      deprecated: false,
      address: "0xB75D0B03c06A926e488e2659DF1A861F860bD3d1",
      id: 73
    },
    {
      decimals: 18,
      symbol: "pufETH",
      name: "pufETH",
      chainId: 7e3,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
      },
      deprecated: false,
      address: "0x1e4bF3CaBD7707089138dD5a545B077413FA83Fc",
      id: 74
    },
    {
      decimals: 6,
      symbol: "USDC.ETH",
      name: "ZetaChain ZRC20 USDC on ETH",
      chainId: 7e3,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3408.png"
      },
      deprecated: false,
      address: "0x0cbe0dF132a6c6B4a2974Fa1b7Fb953CF0Cc798a",
      id: 75
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 25,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3408.png"
      },
      deprecated: false,
      address: "0xc21223249CA28397B4B6541dfFaEcC539BfF0c59",
      id: 76
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped ETH",
      chainId: 252,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      deprecated: false,
      address: "0xA8a59D73388D0c4344a7b0Ba287ddb654227c38a",
      id: 77
    },
    {
      decimals: 18,
      symbol: "FRAX",
      name: "Frax",
      chainId: 252,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/6952.png"
      },
      deprecated: false,
      address: "0xFc00000000000000000000000000000000000001",
      id: 78
    },
    {
      decimals: 6,
      symbol: "USDC.e",
      name: "Bridged USDC (Stargate)",
      chainId: 1625,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3408.png"
      },
      deprecated: false,
      address: "0xFbDa5F676cB37624f28265A144A48B0d6e87d3b6",
      id: 79
    },
    {
      decimals: 18,
      symbol: "wG",
      name: "Gravity",
      chainId: 1625,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/32120.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/32120.png"
      },
      deprecated: false,
      address: "0xBB859E225ac8Fb6BE1C7e38D87b767e95Fef0EbD",
      id: 80
    },
    {
      decimals: 18,
      symbol: "WBTC",
      name: "Wrapped BTC",
      chainId: 223,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3717.png"
      },
      deprecated: false,
      address: "0x4200000000000000000000000000000000000006",
      id: 81
    },
    {
      decimals: 9,
      symbol: "TON",
      name: "TON Coin",
      chainId: 85918,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
      },
      deprecated: false,
      address: "0xA4f1b5C2fC9b97d4238B3dE3487ccaE2c36dE07C",
      id: 82
    },
    {
      decimals: 6,
      symbol: "USDT",
      name: "USDt",
      chainId: 85918,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      deprecated: false,
      address: "0x9328Eb759596C38a25f59028B146Fecdc3621Dfe",
      id: 83
    },
    {
      decimals: 18,
      symbol: "SIS",
      name: "Symbiosis",
      chainId: 56,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0xF98b660AdF2ed7d9d9D9dAACC2fb0CAce4F21835",
      id: 84,
      originalId: 2
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "syUSDC",
      chainId: 40,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0xe6E5f3d264117E030C21920356641DbD5B3d660c",
      id: 85,
      originalId: 1
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "syWETH",
      chainId: 40,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x63d71E79AdF0886c989A23b04a0E86F1489b6BC3",
      id: 86,
      originalId: 3
    },
    {
      decimals: 6,
      symbol: "USDT",
      name: "syUSDT",
      chainId: 40,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x7bD3ffe9f0C9CF08FD60e102FEa455A6EA580276",
      id: 87,
      originalId: 4
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin from Ethereum",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x7d6EC42b5d9566931560411a8652Cea00b90d982",
      id: 88,
      originalId: 1
    },
    {
      decimals: 18,
      symbol: "sSIS",
      name: "Synthetic SIS token from Ethereum",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x4E985A18B4Ac70a1C3d986a5f55CB4c5BC8f65AE",
      id: 89,
      originalId: 2
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Ethereum)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x1CE4E75E2Bd6bbbACDE1E10D6813228138337E86",
      id: 90,
      originalId: 3
    },
    {
      decimals: 8,
      symbol: "sWBTC",
      name: "Synthetic WBTC From Ethereum",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0xE6Bb73E4dACD20653Bb8BdC427C9b4766fC159f5",
      id: 91,
      originalId: 5
    },
    {
      decimals: 18,
      symbol: "sLADYS",
      name: "Synthetic Milady Coin (Ethereum)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/25023.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/25023.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x7405b3cf567003317800114511474e52937e1a5e",
      id: 92,
      originalId: 6
    },
    {
      decimals: 18,
      symbol: "spufETH",
      name: "Synthetic pufETH From Ethereum",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x1acF9c15a25752132b14bb4f5e1A47bC88a4CB7E",
      id: 93,
      originalId: 7
    },
    {
      decimals: 18,
      symbol: "sFRAX",
      name: "Synthetic Frax (Ethereum)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/6952.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0xcde7866D581Ca2a4425d5BDE8074413FBbf958F4",
      id: 94,
      originalId: 8
    },
    {
      decimals: 18,
      symbol: "sG",
      name: "Synthetic G (Ethereum)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/32120.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/32120.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0xE5E6576FeAf298f8c253Ef8C010a9d51090AfBb6",
      id: 95,
      originalId: 9
    },
    {
      decimals: 9,
      symbol: "sWTON",
      name: "Synthetic WTON From Ethereum",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x45Bb4E28609f1c6EA05c738F4e7229e5b3bC8657",
      id: 96,
      originalId: 10
    },
    {
      decimals: 18,
      symbol: "sUSDC",
      name: "Synthetic Binance-Peg USD Coin from BSC",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 56,
      deprecated: false,
      address: "0x5e19eFc6AC9C80bfAA755259c9fab2398A8E87eB",
      id: 97,
      originalId: 11
    },
    {
      decimals: 18,
      symbol: "sBUSD",
      name: "Synthetic Binance-Peg BUSD Token from BSC",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png"
      },
      chainFromId: 56,
      deprecated: true,
      address: "0x1a25BEB8E75626ADDb983d46fbDfcE5fdC29Ae58",
      id: 98,
      originalId: 12
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Binance)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 56,
      deprecated: false,
      address: "0x424190072b7Db5352bB91cC70DabD82F547AE003",
      id: 99,
      originalId: 13
    },
    {
      decimals: 18,
      symbol: "sWBTC",
      name: "Synthetic WBTC From BSC",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/4023.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/4023.png"
      },
      chainFromId: 56,
      deprecated: false,
      address: "0x814f76A3f2FF408ad6BCEB5412B60D9fC3B6C0EA",
      id: 100,
      originalId: 14
    },
    {
      decimals: 18,
      symbol: "sSIS",
      name: "Synthetic SIS token from Binance",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      chainFromId: 56,
      deprecated: false,
      address: "0x20259119252a5Ecca065879783ee8964884DC52d",
      id: 101,
      originalId: 15
    },
    {
      decimals: 18,
      symbol: "sG",
      name: "Synthetic G (BNB)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/32120.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/32120.png"
      },
      chainFromId: 56,
      deprecated: false,
      address: "0xe2c3145649EF1988fBa03274bE4C9FAB118CaBd5",
      id: 102,
      originalId: 16
    },
    {
      decimals: 9,
      symbol: "sWTON",
      name: "Synthetic WTON From BNB",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
      },
      chainFromId: 56,
      deprecated: false,
      address: "0x42B7f88dc7DE1679FbAD6A6FF32A5ea36aA2E129",
      id: 103,
      originalId: 17
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Avalanche",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 43114,
      deprecated: false,
      address: "0x04967F713aca02039EA18c2E5805a863b5eC25A0",
      id: 104,
      originalId: 18
    },
    {
      decimals: 6,
      symbol: "sUSDC.e",
      name: "Synthetic USD Coin from Avalanche",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 43114,
      deprecated: true,
      address: "0x6dF9C221F52537DFD63d70721EEAA0C4d4472C18",
      id: 105,
      originalId: 19
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin from Polygon",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 137,
      deprecated: false,
      address: "0x59AA2e5F628659918A4890A2a732E6C8bD334E7A",
      id: 106,
      originalId: 20
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Arbitrum Nova)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 137,
      deprecated: false,
      address: "0x93A973297E492d4E7a2b4aBaB3bFB4f140D1E3Bb",
      id: 107,
      originalId: 21
    },
    {
      decimals: 18,
      symbol: "sFRAX",
      name: "Synthetic Frax (Polygon)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/6952.png"
      },
      chainFromId: 137,
      deprecated: false,
      address: "0x7Fd2eab338fBC3a2d724F92468fE6A9f72f18A12",
      id: 108,
      originalId: 22
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic syUSDC From Telos",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 40,
      deprecated: false,
      address: "0x2c679B79d8F40049d68CaA879Bf643F37E75F704",
      id: 109,
      originalId: 23
    },
    {
      decimals: 6,
      symbol: "sUSDT",
      name: "Synthetic USDT From Kava",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      chainFromId: 2222,
      deprecated: false,
      address: "0xCdc9C3e0fc1909205aC96EC98795aCAa29a6A1E3",
      id: 110,
      originalId: 24
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin from Boba ETH",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 288,
      deprecated: false,
      address: "0x1a3d48492Cd334AD140587091AC382E5695a4934",
      id: 111,
      originalId: 25
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From ZkSync Era Mainnet",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 324,
      deprecated: false,
      address: "0xC6CC7E50A0F20268DB1BAb041ff18b2c7E97a9d3",
      id: 112,
      originalId: 27
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USDC token from zkSync",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 324,
      deprecated: true,
      address: "0x3a2213CaEbcf1727D7b3422B8Ef8Dd5654877f42",
      id: 113,
      originalId: 28
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (zkSync Era)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 324,
      deprecated: false,
      address: "0xE3dB9aD5A3c6387beCe39fAfc26Dbb2b594fb7ff",
      id: 114,
      originalId: 29
    },
    {
      decimals: 8,
      symbol: "sWBTC",
      name: "Synthetic WBTC From zkSync",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3717.png"
      },
      chainFromId: 324,
      deprecated: true,
      address: "0x83a9e719C9b6d0108D64073DC35aCFD40FC9C672",
      id: 115,
      originalId: 30
    },
    {
      decimals: 18,
      symbol: "sSIS",
      name: "Synthetic SIS token from zkSync Era",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      chainFromId: 324,
      deprecated: false,
      address: "0x2E752d64cCc7B1e8F3F8b58F8218C3e0F21A9F3C",
      id: 116,
      originalId: 31
    },
    {
      decimals: 8,
      symbol: "ssyBTC",
      name: "Synthetic syBTC (zkSync)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://assets.coingecko.com/coins/images/50472/standard/NewOption_06.png?1727849200",
        small: "https://assets.coingecko.com/coins/images/50472/standard/NewOption_06.png?1727849200"
      },
      chainFromId: 324,
      deprecated: false,
      address: "0x0a5CF42021F48d2cE026Ca133404b00F99dc82f3",
      id: 117,
      originalId: 32
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Arbitrum One",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 42161,
      deprecated: false,
      address: "0xeeAE2132f2e21f68D862c535D7d9857803FBcF3f",
      id: 118,
      originalId: 33
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Arbitrum One",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 42161,
      deprecated: true,
      address: "0xA8d058ed41B216175400E8B2CC8cD55853596462",
      id: 119,
      originalId: 34
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Arbitrum One)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 42161,
      deprecated: false,
      address: "0x4994b8bb0b58708Cc6A66079d22db35c95650B4b",
      id: 120,
      originalId: 35
    },
    {
      decimals: 18,
      symbol: "sSIS",
      name: "Synthetic SIS token from Arbitrum One",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      chainFromId: 42161,
      deprecated: false,
      address: "0x94F3F6C21e7D2D63d4ea484713B110e64A722fD7",
      id: 121,
      originalId: 36
    },
    {
      decimals: 18,
      symbol: "sLADYS",
      name: "Synthetic Milady Coin (Arbitrum)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/25023.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/25023.png"
      },
      chainFromId: 42161,
      deprecated: false,
      address: "0x355b105634AD4184fd6Cc264C594615F861BE5AA",
      id: 122,
      originalId: 37
    },
    {
      decimals: 18,
      symbol: "sFRAX",
      name: "Synthetic Frax (Arbitrum One)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/6952.png"
      },
      chainFromId: 42161,
      deprecated: false,
      address: "0x5ffc6ac1437C51D94362069E464C646E011c3337",
      id: 123,
      originalId: 38
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Optimism",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 10,
      deprecated: false,
      address: "0xf072f11Bf151038BD8732cd1088b7C98762b839C",
      id: 124,
      originalId: 39
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Optimism)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 10,
      deprecated: false,
      address: "0x983e6839e84004E78FBfE76431D879cf9cF2f084",
      id: 125,
      originalId: 40
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Arbitrum Nova",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 42170,
      deprecated: false,
      address: "0x9d152fcb9692B5b2d31b81a4A5F86Aa1BaB42677",
      id: 126,
      originalId: 41
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Arbitrum Nova)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 42170,
      deprecated: false,
      address: "0xe0B51250bE54fEaF51BDdfAE0828D29BDc7fE87C",
      id: 127,
      originalId: 42
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Polygon zkEVM",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 1101,
      deprecated: false,
      address: "0xa5CA3277041Bf6e8D6eEC2740010B7C6d10E4012",
      id: 128,
      originalId: 43
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USDC From Polygon zkEVM",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 1101,
      deprecated: true,
      address: "0xC28C38B2Af831b222b6933E52637B5145a6774Ad",
      id: 129,
      originalId: 44
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Polygon zkEVM)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 1101,
      deprecated: false,
      address: "0x52B50A6f8564B4895C7EdC9AD3B232bBA0108bA6",
      id: 130,
      originalId: 45
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Linea)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 59144,
      deprecated: false,
      address: "0x6ca6FCbD2fe65F0CB7671f5F0638867fdC991462",
      id: 131,
      originalId: 46
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Linea",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 59144,
      deprecated: false,
      address: "0xD2f5B8525758857aF3553142F59e2b35CbFa0aBE",
      id: 132,
      originalId: 47
    },
    {
      decimals: 18,
      symbol: "sSIS",
      name: "Synthetic SIS token from Linea",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      chainFromId: 59144,
      deprecated: false,
      address: "0x32478a5EE4F9854A26aC4606aa107CfD3E5F8775",
      id: 133,
      originalId: 48
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD Coin From Mantle",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 5e3,
      deprecated: false,
      address: "0x85EC8DA79Bd2e54724ab8aa4a7a209B1f66D6eC0",
      id: 134,
      originalId: 49
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Mantle)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 5e3,
      deprecated: false,
      address: "0xA6e6c78746F873dB8545B7571DD1C5d87cC95763",
      id: 135,
      originalId: 50
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Base)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 8453,
      deprecated: false,
      address: "0x8eFFD39D090C756Db49A8154Db7BD05f59A62193",
      id: 136,
      originalId: 51
    },
    {
      decimals: 6,
      symbol: "sUSDbC",
      name: "Synthetic USDbC From Base",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 8453,
      deprecated: false,
      address: "0xDD1a897f92c14cDA3aB7023b094615A7068d01fA",
      id: 137,
      originalId: 52
    },
    {
      decimals: 6,
      symbol: "sUSDT",
      name: "Synthetic USDT From Tron",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      chainFromId: 728126428,
      deprecated: false,
      address: "0x2dF311E049a839E1011507ccE20Afb6f871a81a1",
      id: 138,
      originalId: 53
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Scroll)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 534352,
      deprecated: false,
      address: "0xC66d177BDa9ef1d9278948FcD86C2C4420ca708C",
      id: 139,
      originalId: 54
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USDC From Scroll",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 534352,
      deprecated: false,
      address: "0x616152a28eAb796789050407DF0f566307bFffDA",
      id: 140,
      originalId: 55
    },
    {
      decimals: 18,
      symbol: "sSIS",
      name: "Synthetic SIS token from Scroll",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      chainFromId: 534352,
      deprecated: false,
      address: "0x1adD5ac0E2b68f020dC8a3bC0BaE1A1bFc873F49",
      id: 141,
      originalId: 56
    },
    {
      decimals: 18,
      symbol: "spufETH",
      name: "Synthetic pufETH From Scroll",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
      },
      chainFromId: 534352,
      deprecated: false,
      address: "0x32699d39c059dc61F2D26B9778830f49c5d200Ca",
      id: 142,
      originalId: 57
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Manta)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 169,
      deprecated: false,
      address: "0x3e54f3F0C9FA63282B92C84a3b710FD2968F177E",
      id: 143,
      originalId: 58
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USDC From Manta",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 169,
      deprecated: false,
      address: "0x60F58f1AbD788eaEFa00838d9a69639F62cC16B8",
      id: 144,
      originalId: 59
    },
    {
      decimals: 18,
      symbol: "spufETH",
      name: "Synthetic pufETH From Manta",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
      },
      chainFromId: 169,
      deprecated: false,
      address: "0xeC4f77C7EfCf5A1Ff26eA8e19d4236A375b3Dfe4",
      id: 145,
      originalId: 60
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Metis)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 1088,
      deprecated: false,
      address: "0x04E7379CdF5b3427E5B3A557B0E98DD92E70584f",
      id: 146,
      originalId: 61
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD\u0421 From Bahamut",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 5165,
      deprecated: false,
      address: "0xf2CF7f859FE187BAa9b2F197Cd6C1698A4BC0905",
      id: 147,
      originalId: 62
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Mode)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 34443,
      deprecated: false,
      address: "0x467fAC56cB149D06A8b268A5Cb8638Fc7B2d8F73",
      id: 148,
      originalId: 63
    },
    {
      decimals: 18,
      symbol: "sUSDT",
      name: "Synthetic rUSDT From RSK",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/825.png"
      },
      chainFromId: 30,
      deprecated: false,
      address: "0xA5De76FEda5bC1c824Ee1FfcCE82c8BbAe1f558F",
      id: 149,
      originalId: 64
    },
    {
      decimals: 18,
      symbol: "sWRBTC",
      name: "Synthetic Wrapped RBTC (Rootstock)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/32702.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/32702.png"
      },
      chainFromId: 30,
      deprecated: false,
      address: "0x4A95D151d5b16B90481F98432Cf3D3B62deef1Fe",
      id: 150,
      originalId: 65
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Blast)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 81457,
      deprecated: false,
      address: "0xB4A492d5d61d4539a70AE3E7BF564250159d1c57",
      id: 151,
      originalId: 66
    },
    {
      decimals: 18,
      symbol: "sWBTC",
      name: "Synthetic Wrapped BTC (Merlin)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3717.png"
      },
      chainFromId: 4200,
      deprecated: false,
      address: "0xc1Aca13EE7Ee4F9211BBC7bb0Da0fCA58405993B",
      id: 152,
      originalId: 67
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped ETH (zkLink)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 810180,
      deprecated: false,
      address: "0x997D45FFC15bC54A52EBDeeFa0E6fc856fC97a55",
      id: 153,
      originalId: 68
    },
    {
      decimals: 18,
      symbol: "spufETH",
      name: "Synthetic pufETH From zkLink",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
      },
      chainFromId: 810180,
      deprecated: false,
      address: "0x42481B8ccE6947178B54D80BFD82B38F6E5b0F61",
      id: 154,
      originalId: 69
    },
    {
      decimals: 8,
      symbol: "sWBTC",
      name: "Synthetic Wrapped BTC (Core)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1.png"
      },
      chainFromId: 1116,
      deprecated: false,
      address: "0x5dC2326bb71725a5bBC18Fb39A2582C5560B67f0",
      id: 155,
      originalId: 70
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Taiko)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 167e3,
      deprecated: false,
      address: "0x3C717a1F4a8e79D93635E812648253A38Bb27557",
      id: 156,
      originalId: 71
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD\u0421 From Sei",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3408.png"
      },
      chainFromId: 1329,
      deprecated: false,
      address: "0xFfECd35dd178D0c55c6E2227516e59314d347921",
      id: 157,
      originalId: 72
    },
    {
      decimals: 6,
      symbol: "sUSDT",
      name: "Synthetic USDT From Sei",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/825.png"
      },
      chainFromId: 1329,
      deprecated: false,
      address: "0x6d13035F5F1ae26a22CBB25A3f7666e0C335E6bC",
      id: 158,
      originalId: 73
    },
    {
      decimals: 18,
      symbol: "spufETH",
      name: "Synthetic pufETH From Zeta",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
      },
      chainFromId: 7e3,
      deprecated: false,
      address: "0x1F39B97acAd7e3C46010c608ea300ceC1FD51EcA",
      id: 159,
      originalId: 74
    },
    {
      decimals: 6,
      symbol: "sUSDC.ETH",
      name: "Synthetic USD\u0421.ETH (Zetachain)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3408.png"
      },
      chainFromId: 7e3,
      deprecated: false,
      address: "0x15FD72412E6bD2768C3C0E2166545A25dC932e0e",
      id: 160,
      originalId: 75
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD\u0421 From Cronos",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3408.png"
      },
      chainFromId: 25,
      deprecated: false,
      address: "0xBF73aF83aE56Ce393737faFcC4778Aa5751d1552",
      id: 161,
      originalId: 76
    },
    {
      decimals: 18,
      symbol: "sWETH",
      name: "Synthetic Wrapped Ether (Fraxtal)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 252,
      deprecated: false,
      address: "0xe51753e4ceee1496aEe26AEFfCa97494C41Fc10E",
      id: 162,
      originalId: 77
    },
    {
      decimals: 18,
      symbol: "sFRAX",
      name: "Synthetic Frax (Fraxtal)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/6952.png"
      },
      chainFromId: 252,
      deprecated: false,
      address: "0x8B6b4b3c037622a81233027c47a733535d0f080B",
      id: 163,
      originalId: 78
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic USD\u0421 From Gravity",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3408.png"
      },
      chainFromId: 1625,
      deprecated: false,
      address: "0xC1FeD2fB83F7CacA0CfC772767Ae33ef6b04899e",
      id: 164,
      originalId: 79
    },
    {
      decimals: 18,
      symbol: "swG",
      name: "Synthetic wG (Gravity)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/32120.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/32120.png"
      },
      chainFromId: 1625,
      deprecated: false,
      address: "0x7cE9911e690d80c421069A683163FA2946E6b400",
      id: 165,
      originalId: 80
    },
    {
      decimals: 18,
      symbol: "sWBTC",
      name: "Synthetic WBTC (bsquared)",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/3717.png"
      },
      chainFromId: 223,
      deprecated: false,
      address: "0x2C11Ba8b608841C9Cf29f60645029421dc120fBe",
      id: 166,
      originalId: 81
    },
    {
      decimals: 9,
      symbol: "sTON",
      name: "Synthetic TON From TON",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
      },
      chainFromId: 85918,
      deprecated: false,
      address: "0x8d17D04A595eCFbBFc8bF8016949161AA034A75B",
      id: 167,
      originalId: 82
    },
    {
      decimals: 6,
      symbol: "sUSDT",
      name: "Synthetic USDT From TON",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      chainFromId: 85918,
      deprecated: false,
      address: "0x651c4CA3f3df776F2db9eD1658e850151b7E1208",
      id: 168,
      originalId: 83
    },
    {
      decimals: 18,
      symbol: "sSIS",
      name: "Synthetic SIS token from Binance",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/15084.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/15084.png"
      },
      chainFromId: 56,
      deprecated: false,
      address: "0x20259119252a5Ecca065879783ee8964884DC52d",
      id: 169,
      originalId: 84
    },
    {
      decimals: 6,
      symbol: "sUSDC",
      name: "Synthetic syUSDC From Telos",
      chainId: 56288,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 40,
      deprecated: false,
      address: "0x2c679B79d8F40049d68CaA879Bf643F37E75F704",
      id: 170,
      originalId: 85
    },
    {
      decimals: 8,
      symbol: "syBTC",
      name: "syBTC",
      chainId: 324,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png"
      },
      chainFromId: 3652501241,
      deprecated: false,
      address: "0xED0c95EBe5a3E687cB2224687024FeC6518E683e",
      id: 171,
      originalId: 0
    },
    {
      decimals: 6,
      symbol: "USDC",
      name: "USD Coin",
      chainId: 5165,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x4237e0A5b55233D5B6D6d1D9BF421723954130D8",
      id: 172,
      originalId: 1
    },
    {
      decimals: 18,
      symbol: "WETH",
      name: "Wrapped Ether",
      chainId: 5165,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/1027.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0xE5b3562A0fa9eC3e718C96FfE349e1280D2Be591",
      id: 173,
      originalId: 3
    },
    {
      decimals: 6,
      symbol: "USDT",
      name: "Tether USD",
      chainId: 5165,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0xDeF886C55a79830C47108eeb9c37e78a49684e41",
      id: 174,
      originalId: 4
    },
    {
      decimals: 18,
      symbol: "pufETH",
      name: "pufETH",
      chainId: 7e3,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/29325.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/128x128/29325.png"
      },
      chainFromId: 1,
      deprecated: false,
      address: "0x1e4bF3CaBD7707089138dD5a545B077413FA83Fc",
      id: 175,
      originalId: 7
    }
  ]
};

// src/crosschain/config/cache/testnet.json
var testnet_default = {
  omniPools: [
    {
      chainId: 97,
      address: "0x2826c540065C8eD792d7100ca89628E986f2F42E",
      oracle: "0xaF123f922b9cAe0F525c2E5A95314D7E8E229413",
      generalPurpose: true,
      id: 0,
      tokens: [
        { index: 0, tokenId: 5 },
        { index: 2, tokenId: 0 }
      ]
    }
  ],
  tokens: [
    {
      decimals: 9,
      symbol: "WTON(BSC)",
      name: "WTON(BSC)",
      chainId: 97,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
      },
      deprecated: false,
      address: "0xe015581A4e36eEbf170a3F4a686fa7606d511b13",
      id: 0
    },
    {
      decimals: 9,
      symbol: "TONCOIN",
      name: "TONCOIN",
      chainId: 11155111,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
      },
      deprecated: false,
      address: "0x331f40cc27aC106e1d5242CE633dc6436626a6F8",
      id: 1
    },
    {
      decimals: 9,
      symbol: "TON",
      name: "TON Coin",
      chainId: 85919,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
      },
      deprecated: false,
      address: "0x7eA393298D1077e19ec59F8e3FE8fe642738c08C",
      id: 2
    },
    {
      decimals: 9,
      symbol: "USDT",
      name: "USDt",
      chainId: 85919,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
      },
      deprecated: false,
      address: "0x46DEEc715E419a1f0F5959b5c8450894959d2DbF",
      id: 3
    },
    {
      decimals: 9,
      symbol: "WTON(Mainnet)",
      name: "WTON",
      chainId: 43113,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
      },
      deprecated: false,
      address: "0xCc9f8896896c6eF44f2504A6A29e6057aDBfF179",
      id: 4
    },
    {
      decimals: 9,
      symbol: "sWTON",
      name: "sWTON",
      chainId: 97,
      isNative: false,
      icons: {
        large: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png",
        small: "https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png"
      },
      chainFromId: 43113,
      deprecated: false,
      address: "0x4950b13CbC3A33164fdd782E75271891D0d9F1D9",
      id: 5,
      originalId: 4
    }
  ]
};

// src/crosschain/config/cache/dev.json
var dev_default = {
  omniPools: [
    {
      chainId: 97,
      address: "0x789001A80a8EdBBEE07876b0dF58c3eAdEE89877",
      oracle: "0x2cD94CB0F4cBC4a51c3e9c4b88d03B982bE24608",
      generalPurpose: true,
      id: 0,
      tokens: []
    }
  ],
  tokens: [],
  thresholds: []
};

// src/crosschain/config/cache/cache.ts
var ConfigCache = class {
  constructor(configName) {
    if (configName === "mainnet") {
      this.data = mainnet_default;
    } else if (configName === "testnet") {
      this.data = testnet_default;
    } else if (configName === "dev") {
      this.data = dev_default;
    } else {
      throw new Error2("Unknown config name");
    }
  }
  tokens() {
    return this.data.tokens.map((attributes) => {
      return new Token(attributes);
    });
  }
  getRepresentation(token, chainId) {
    if (token.isSynthetic) {
      const original = this.getOriginalToken(token);
      if (original?.chainId !== chainId) {
        return;
      }
      return original;
    }
    return this.getSynthTokens(token).find((i) => i.chainId === chainId);
  }
  getOmniPoolByConfig(omniPoolConfig) {
    return this.data.omniPools.find((i) => {
      return i.address.toLowerCase() === omniPoolConfig.address.toLowerCase() && i.chainId === omniPoolConfig.chainId;
    });
  }
  getOmniPoolById(id) {
    return this.data.omniPools.find((i) => i.id === id);
  }
  // It works correctly if the `token` in ONE pool ONLY
  // If there are more than one pool then FIRST pool will be selected
  getOmniPoolByToken(token) {
    let synths;
    if (token.isSynthetic) {
      synths = [token];
    } else {
      synths = this.getSynthTokens(token);
    }
    const ids = synths.map((i) => {
      return this.getTokenInfoByToken(i).id;
    });
    return this.data.omniPools.find((pool) => {
      return pool.tokens.find((i) => {
        return ids.includes(i.tokenId);
      });
    });
  }
  getOmniPoolTokenIndex(omniPoolConfig, token) {
    const omniPool = this.getOmniPoolByConfig(omniPoolConfig);
    if (!omniPool) {
      throw new Error2(`getOmniPoolIndex: cannot find omniPoolByConfig ${omniPoolConfig}`);
    }
    const tokenInfo = this.getTokenInfoByToken(token);
    const found = omniPool.tokens.find((pool) => {
      return pool.tokenId === tokenInfo.id;
    });
    if (found === void 0) {
      throw new Error2(
        `getOmniPoolTokenIndex: There is no token ${tokenInfo.address} in omniPool ${omniPool.address}`,
        3 /* NO_TRANSIT_TOKEN */
      );
    }
    return found.index;
  }
  getOmniPoolTokens(omniPoolConfig) {
    const pool = this.getOmniPoolByConfig(omniPoolConfig);
    if (!pool) {
      throw new Error2("Cannot find omniPool");
    }
    return pool.tokens.map((i) => {
      const tokenInfo = this.getTokenInfoById(i.tokenId);
      return new Token(tokenInfo);
    });
  }
  getTokenInfoById(id) {
    const tokenInfo = this.data.tokens.find((i) => i.id === id);
    if (!tokenInfo) {
      throw new Error2(`Can't get tokenInfo for id ${id}`);
    }
    return tokenInfo;
  }
  // --- PRIVATE ---
  getTokenInfoByToken(token) {
    const found = this.data.tokens.find((i) => {
      return i.address.toLowerCase() === token.address.toLowerCase() && i.chainId === token.chainId && i.chainFromId === token.chainFromId;
    });
    if (!found) {
      throw new Error2(`Can't get tokenInfo by token ${token.address} ${token.chainId}`);
    }
    return found;
  }
  getOriginalToken(token) {
    if (!token.isSynthetic) {
      return;
    }
    const tokenInfo = this.getTokenInfoByToken(token);
    if (tokenInfo.originalId === void 0) {
      return;
    }
    const original = this.getTokenInfoById(tokenInfo.originalId);
    return new Token(original);
  }
  getSynthTokens(token) {
    if (token.isSynthetic) {
      return [];
    }
    const wrapped = wrappedToken(token);
    const tokenInfo = this.getTokenInfoByToken(wrapped);
    return this.data.tokens.filter((i) => {
      return i.originalId === tokenInfo.id;
    }).map((i) => {
      return new Token(i);
    });
  }
};

// src/crosschain/oneInchRequest.ts
var ONE_INCH_API_URL = "https://api-v2.symbiosis.finance/crosschain/v1/inch/";
function makeOneInchRequestFactory(fetch3) {
  return async (url, urlParams) => {
    const requestUrl = new URL(url, ONE_INCH_API_URL);
    if (urlParams) {
      requestUrl.search = urlParams.toString();
    }
    const response = await fetch3(requestUrl.toString());
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text);
    }
    const json = await response.json();
    return json;
  };
}

// src/crosschain/waitForComplete/constants.ts
var POLLING_INTERVAL = 1e3 * 10;
var DEFAULT_EXCEED_DELAY2 = 1e3 * 60 * 20;
var TxNotFound = class extends Error {
  constructor(txId) {
    super(`Transaction ${txId} not found`);
    this.name = "TxNotFound";
  }
};

// src/crosschain/waitForComplete/utils.ts
var fetchData = async (url) => {
  const response = await fetch(url);
  if (!response.ok) {
    const text = await response.text();
    const json = JSON.parse(text);
    throw new Error(json.message ?? text);
  }
  const data = await response.json();
  return data;
};
async function longPolling({
  pollingInterval = POLLING_INTERVAL,
  exceedDelay = DEFAULT_EXCEED_DELAY2,
  pollingFunction,
  successCondition,
  error
}) {
  return new Promise((resolve, reject) => {
    let pastTime = 0;
    let result;
    const func = async () => {
      pastTime += pollingInterval;
      if (pastTime > exceedDelay) {
        clearInterval(interval);
        reject(error ?? new Error(`Long polling exceed time`));
        return;
      }
      try {
        result = await pollingFunction();
      } catch (error2) {
        console.error("Long Polling function error", error2);
      } finally {
        if (result && successCondition(result)) {
          resolve(result);
          clearInterval(interval);
        }
      }
    };
    func();
    const interval = setInterval(func, pollingInterval);
  });
}

// src/crosschain/waitForComplete/tryToFindExtraStepsAndWait.ts
import { BigNumber as BigNumber8 } from "ethers";

// src/crosschain/waitForComplete/waitForTonDepositTxMined.ts
import { Address as Address2 } from "@ton/core";
import { solidityKeccak256 } from "ethers/lib/utils";
import { AddressZero as AddressZero6 } from "@ethersproject/constants";
var BURN_COMPLETED_OPCODE = 1659197634;
function parseBurnCompletedBody(msgBody) {
  const bodySlice = msgBody.beginParse();
  const opcode = bodySlice.loadUint(32);
  if (opcode === BURN_COMPLETED_OPCODE) {
    const burnCompletedData1 = bodySlice.loadRef().beginParse();
    const burnCompletedData2 = bodySlice.loadRef().beginParse();
    const externalId = burnCompletedData1.loadBuffer(32);
    const crossChainId = burnCompletedData1.loadBuffer(32);
    const receiver = burnCompletedData1.loadAddress();
    const amount = burnCompletedData2.loadCoins();
    const fee = burnCompletedData2.loadCoins();
    const tokenAddr = burnCompletedData2.loadAddress();
    return {
      externalId,
      crossChainId,
      receiver,
      amount,
      fee,
      tokenAddr
    };
  } else {
    return null;
  }
}
function _getExternalIdTon({
  internalId,
  receiveSide,
  chainId
}) {
  return solidityKeccak256(["bytes32", "address", "uint256"], [internalId, receiveSide, chainId]);
}
var WaitForTonTxCompleteError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "WaitForTonTxCompleteError";
  }
};
async function waitForTonTxComplete(symbiosis, internalId, chainId) {
  const tonChainConfig = symbiosis.config.chains.find((chain) => chain.id === chainId);
  if (!tonChainConfig) {
    throw new Error("Ton chain config not found");
  }
  const tonPortal = tonChainConfig.tonPortal;
  if (!tonPortal) {
    throw new Error(`Ton portal not found for chain ${chainId}`);
  }
  const externalId = _getExternalIdTon({ internalId, receiveSide: AddressZero6, chainId });
  const client = await symbiosis.getTonClient();
  const tx = await longPolling({
    pollingFunction: async () => {
      const txs = await client.getTransactions(Address2.parse(tonPortal), { limit: 10, archival: true });
      return txs.find((tx2) => {
        return tx2.outMessages.values().find((msg) => {
          if (msg.info.type !== "external-out") {
            return false;
          }
          const burnCompletedEvent = parseBurnCompletedBody(msg.body);
          if (!burnCompletedEvent) {
            return false;
          }
          return burnCompletedEvent.externalId.equals(Buffer.from(externalId.slice(2), "hex"));
        });
      });
    },
    successCondition: (tx2) => {
      return tx2 !== void 0;
    },
    error: new WaitForTonTxCompleteError("Ton transaction not found on TON chain")
  });
  return tx.hash().toString("hex");
}

// src/crosschain/waitForComplete/tryToFindExtraStepsAndWait.ts
import { Address as Address3 } from "@ton/core";
import { parseUnits as parseUnits4 } from "ethers/lib/utils";
async function tryToFindExtraStepsAndWait(symbiosis, chainId, txHash) {
  const provider = symbiosis.getProvider(chainId);
  const receipt = await provider.getTransactionReceipt(txHash);
  if (!receipt) {
    throw new TxNotFound(txHash);
  }
  const isThorChainDeposit = await findThorChainDeposit(receipt);
  if (isThorChainDeposit) {
    const outHash = await waitForThorChainTx(txHash);
    return {
      extraStep: "thorChain",
      outHash
    };
  }
  const burnRequestBtc = await findBurnRequestBtc(receipt);
  if (burnRequestBtc) {
    const { burnSerial, rtoken } = burnRequestBtc;
    const btc = symbiosis.tokens().find((t) => t.address.toLowerCase() === rtoken.toLowerCase());
    if (!btc) {
      throw new Error("BTC token not found");
    }
    const forwarderUrl = symbiosis.getForwarderUrl(btc.chainId);
    const outHash = await waitUnwrapBtcTxComplete(forwarderUrl, burnSerial);
    return {
      extraStep: "burnRequestBtc",
      outHash
    };
  }
  const burnRequestTon = await findBurnRequestTON(receipt);
  if (burnRequestTon) {
    const { internalId, chainId: chainId2 } = burnRequestTon;
    const outHash = await waitForTonTxComplete(symbiosis, internalId, +chainId2);
    return {
      extraStep: "burnRequestTon",
      outHash
    };
  }
  return {
    outHash: txHash
  };
}
async function findThorChainDeposit(receipt) {
  const thorChainDepositTopic0 = "0xef519b7eb82aaf6ac376a6df2d793843ebfd593de5f1a0601d3cc6ab49ebb395";
  const log = receipt.logs.find((log2) => {
    return log2.topics[0] === thorChainDepositTopic0;
  });
  return !!log;
}
async function waitForThorChainTx(txHash) {
  const txHashCleaned = txHash.startsWith("0x") ? txHash.slice(2) : txHash;
  const thorUrl = new URL(`https://thornode.ninerealms.com/thorchain/tx/${txHashCleaned}`);
  return longPolling({
    pollingFunction: async () => {
      const result = await fetchData(thorUrl);
      const { status, out_hashes } = result.observed_tx;
      if (status === "done" && out_hashes && out_hashes.length > 0) {
        return out_hashes.find((outHash) => {
          return outHash !== "0000000000000000000000000000000000000000000000000000000000000000";
        });
      }
      return;
    },
    successCondition: (btcHash) => !!btcHash,
    error: new TxNotFound(txHash),
    exceedDelay: 36e5,
    // 1 hour
    pollingInterval: 6e4
    // 1 minute
  });
}
async function findBurnRequestBtc(receipt) {
  const synthesisInterface = Synthesis__factory.createInterface();
  const topic0 = synthesisInterface.getEventTopic("BurnRequestBTC");
  const log = receipt.logs.find((log2) => {
    return log2.topics[0] === topic0;
  });
  if (!log) {
    return;
  }
  const data = synthesisInterface.parseLog(log);
  const { burnSerial, rtoken } = data.args;
  return { burnSerial, rtoken };
}
async function findBurnRequestTON(receipt) {
  const synthesisInterface = Synthesis__factory.createInterface();
  const burnRequestTonTopic = synthesisInterface.getEventTopic("BurnRequestTON");
  const log = receipt.logs.find((log2) => {
    return log2.topics[0] === burnRequestTonTopic;
  });
  if (!log) {
    return;
  }
  const data = synthesisInterface.parseLog(log);
  const { id, chainID } = data.args;
  return { internalId: id, chainId: chainID.toString() };
}
async function waitUnwrapBtcTxComplete(forwarderUrl, burnSerialBtc) {
  const unwrapInfoUrl = new URL(`${forwarderUrl}/unwrap?serial=${burnSerialBtc.toString()}`);
  const result = await longPolling({
    pollingFunction: async () => {
      return fetchData(unwrapInfoUrl);
    },
    successCondition: (result2) => !!result2.outputIdx,
    error: new TxNotFound(burnSerialBtc.toString()),
    exceedDelay: 36e5,
    // 1 hour
    pollingInterval: 1e4
    // 10 seconds
  });
  return result.tx;
}

// src/crosschain/waitForComplete/getTxTonBridgeInfo.ts
var ORACLE_REQUEST_OPCODE = 2067945553;
var META_SYNTHESIZE_SELECTOR = "c29a91bc";
var SYNTHESIZE_SELECTOR = "a83e754b";
function getTxTonBridgeInfo(tx) {
  let internalId;
  let externalId;
  let externalChainId;
  for (const outMsg of tx.outMessages.values()) {
    if (outMsg?.info.type !== "external-out") {
      continue;
    }
    const parsedOracleRequest = parseOracleRequestBody(outMsg.body);
    internalId = parsedOracleRequest?.internalId;
    externalId = parsedOracleRequest?.externalId;
    externalChainId = parsedOracleRequest?.externalChainId;
    break;
  }
  if (!internalId || !externalId || !externalChainId) {
    throw new Error("Invalid oracle request body");
  }
  return {
    internalId,
    externalId,
    externalChainId,
    requestType: "SynthesizeRequest"
  };
}
function loadHexBytes(slice, bytesCount) {
  return slice.loadBuffer(bytesCount).toString("hex");
}
function parseOracleRequestBody(msgBody) {
  const bodySlice = msgBody.beginParse();
  const opcode = bodySlice.loadUint(32);
  if (opcode !== ORACLE_REQUEST_OPCODE) {
    return;
  }
  const refCalldata = bodySlice.loadRef().beginParse();
  bodySlice.loadInt(8);
  bodySlice.loadBuffer(32);
  bodySlice.loadBuffer(20);
  bodySlice.loadBuffer(20);
  const externalChainId = bodySlice.loadUint(256);
  const ref1 = refCalldata.loadRef().beginParse();
  const ref2 = refCalldata.loadRef().beginParse();
  const functionSelector = loadHexBytes(ref1, 4);
  let internalId, externalId;
  if (functionSelector === META_SYNTHESIZE_SELECTOR) {
    ref1.loadBuffer(64);
    internalId = loadHexBytes(ref1, 32);
    externalId = loadHexBytes(ref2, 32);
  } else if (functionSelector === SYNTHESIZE_SELECTOR) {
    ref1.loadBuffer(32);
    externalId = loadHexBytes(ref1, 32);
    internalId = loadHexBytes(ref1, 32);
  }
  if (!internalId || !externalId) {
    throw new Error("Invalid oracle request body");
  }
  return {
    internalId: "0x" + internalId,
    externalId: "0x" + externalId,
    externalChainId
  };
}

// src/crosschain/waitForComplete/waitForComplete.ts
async function waitForComplete({ symbiosis, chainId, txId, txTon }) {
  const txIdWithPrefix = txId.startsWith("0x") ? txId : `0x${txId}`;
  let aBridgeInfo;
  if (isTonChainId(chainId) && txTon) {
    aBridgeInfo = getTxTonBridgeInfo(txTon);
  } else {
    aBridgeInfo = await getTxBridgeInfo(symbiosis, chainId, txIdWithPrefix);
  }
  if (!aBridgeInfo) {
    const { outHash: outHash2, extraStep } = await tryToFindExtraStepsAndWait(symbiosis, chainId, txId);
    if (!extraStep) {
      throw new Error(`Transaction ${txId} is not a bridge request`);
    }
    return outHash2;
  }
  console.log("aBridgeInfo", aBridgeInfo);
  const bTxId = await waitOtherSideTx(symbiosis, aBridgeInfo);
  console.log("bTxId", bTxId);
  const bBridgeInfo = await getTxBridgeInfo(symbiosis, aBridgeInfo.externalChainId, bTxId);
  console.log("bBridgeInfo", bBridgeInfo);
  if (!bBridgeInfo) {
    const { outHash: outHash2 } = await tryToFindExtraStepsAndWait(symbiosis, aBridgeInfo.externalChainId, bTxId);
    return outHash2;
  }
  const cTxId = await waitOtherSideTx(symbiosis, bBridgeInfo);
  console.log("cTxId", cTxId);
  const { outHash } = await tryToFindExtraStepsAndWait(symbiosis, bBridgeInfo.externalChainId, cTxId);
  return outHash;
}
async function getTxBridgeInfo(symbiosis, chainId, txId) {
  const provider = symbiosis.getProvider(chainId);
  const receipt = await provider.getTransactionReceipt(txId);
  if (!receipt) {
    throw new TxNotFound(txId);
  }
  const portal = symbiosis.portal(chainId);
  const synthesis = symbiosis.synthesis(chainId);
  const revertBurnRequestTopic = portal.interface.getEventTopic("RevertBurnRequest");
  const revertSynthesizeRequestTopic = synthesis.interface.getEventTopic("RevertSynthesizeRequest");
  const metaRevertRequestTopic = portal.interface.getEventTopic("MetaRevertRequest");
  let revertLog = receipt.logs.find((log2) => {
    return !!log2.topics.find((topic) => {
      return topic === revertBurnRequestTopic || topic === revertSynthesizeRequestTopic;
    });
  });
  let isMetaRevertRequest = false;
  if (!revertLog) {
    revertLog = receipt.logs.find((log2) => {
      return !!log2.topics.find((topic) => {
        return topic === metaRevertRequestTopic;
      });
    });
    isMetaRevertRequest = !!revertLog;
  }
  if (revertLog) {
    const address2 = revertLog.address.toLowerCase();
    if (address2 !== portal.address.toLowerCase() && address2 !== synthesis.address.toLowerCase()) {
      throw new Error(`Transaction ${txId} is not a from synthesis or portal contract`);
    }
    const bridge2 = symbiosis.bridge(chainId);
    const oracleRequestTopic = bridge2.interface.getEventTopic("OracleRequest");
    const oracleRequestLog = receipt.logs.find((log2) => log2.topics.includes(oracleRequestTopic));
    if (!oracleRequestLog) {
      throw new Error(`Transaction ${txId} have a OracleRequest call not from bridge contract`);
    }
    const { chainId: oracleRequestChainId } = bridge2.interface.parseLog(oracleRequestLog).args;
    let contract2;
    let requestType2;
    if (revertLog.address.toLowerCase() === portal.address.toLowerCase()) {
      contract2 = portal;
      if (isMetaRevertRequest) {
        requestType2 = "RevertSynthesizeRequest";
      } else {
        requestType2 = "RevertBurnCompleted";
      }
    } else {
      contract2 = synthesis;
      requestType2 = "RevertSynthesizeCompleted";
    }
    const { id: internalId2, to: revertableAddress2 } = contract2.interface.parseLog(revertLog).args;
    const externalChainId2 = oracleRequestChainId.toNumber();
    const externalId2 = getExternalId({
      internalId: internalId2,
      contractAddress: contract2.address,
      revertableAddress: tronAddressToEvm(revertableAddress2),
      chainId
    });
    return { internalId: internalId2, externalId: externalId2, externalChainId: externalChainId2, requestType: requestType2 };
  }
  const synthesizeRequestTopic = portal.interface.getEventTopic("SynthesizeRequest");
  const burnRequestTopic = synthesis.interface.getEventTopic("BurnRequest");
  const log = receipt.logs.find((log2) => {
    return !!log2.topics.find((topic) => topic === synthesizeRequestTopic || topic === burnRequestTopic);
  });
  if (!log) {
    return null;
  }
  if (log.address.toLowerCase() !== portal.address.toLowerCase() && log.address.toLowerCase() !== synthesis.address.toLowerCase()) {
    throw new Error(`Transaction ${txId} is not a from synthesis or portal contract`);
  }
  let contract;
  let requestType;
  if (log.address.toLowerCase() === portal.address.toLowerCase()) {
    contract = portal;
    requestType = "SynthesizeRequest";
  } else {
    contract = synthesis;
    requestType = "BurnRequest";
  }
  const { id: internalId, chainID, revertableAddress } = contract.interface.parseLog(log).args;
  const externalChainId = chainID.toNumber();
  const contractAddress = requestType === "SynthesizeRequest" ? symbiosis.chainConfig(externalChainId).synthesis : symbiosis.chainConfig(externalChainId).portal;
  const externalId = getExternalId({
    internalId,
    contractAddress: tronAddressToEvm(contractAddress),
    revertableAddress: tronAddressToEvm(revertableAddress),
    chainId: externalChainId
  });
  return { internalId, externalId, externalChainId, requestType };
}
async function waitOtherSideTx(symbiosis, bridgeInfo) {
  const { requestType, externalChainId, externalId, internalId } = bridgeInfo;
  let filter;
  switch (requestType) {
    case "SynthesizeRequest": {
      const synthesis = symbiosis.synthesis(externalChainId);
      filter = synthesis.filters.SynthesizeCompleted(externalId);
      break;
    }
    case "BurnRequest": {
      const portal = symbiosis.portal(externalChainId);
      filter = portal.filters.BurnCompleted(externalId);
      break;
    }
    case "RevertSynthesizeRequest": {
      const synthesis = symbiosis.synthesis(externalChainId);
      filter = synthesis.filters.RevertSynthesizeRequest(internalId);
      break;
    }
    case "RevertSynthesizeCompleted": {
      const portal = symbiosis.portal(externalChainId);
      filter = portal.filters.RevertSynthesizeCompleted(externalId);
      break;
    }
    case "RevertBurnCompleted": {
      const synthesis = symbiosis.synthesis(externalChainId);
      filter = synthesis.filters.RevertBurnCompleted(externalId);
      break;
    }
  }
  const log = await getLogWithTimeout({ symbiosis, chainId: externalChainId, filter });
  return log.transactionHash;
}

// src/crosschain/waitForComplete/waitForBtcDepositAccepted.ts
var WaitWrapBtcTxToCompleteError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "WaitWrapBtcTxToCompleteError";
  }
};
async function waitForBtcDepositAccepted(forwarderUrl, btcAddress) {
  const addressInfoUrl = new URL(`${forwarderUrl}/address?address=${btcAddress}`);
  const addressInfo = await longPolling({
    pollingFunction: async () => {
      const addressResponse = await fetchData(addressInfoUrl);
      if (addressResponse.transactions.length === 0) {
        return;
      }
      return addressResponse.transactions[0];
    },
    successCondition: (txInfo) => !!txInfo,
    error: new WaitWrapBtcTxToCompleteError("getting TransactionBtcInfo timeout exceed")
  });
  const { commitTx, revealTx } = addressInfo;
  return { commitTx, revealTx };
}

// src/crosschain/waitForComplete/waitForBtcRevealTxMined.ts
var WaitForRevealBtcTxError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "WaitForRevealBtcTxError";
  }
};
async function waitForBtcRevealTxMined(forwarderUrl, revealTx, confirmations, onConfirmation) {
  const txInfoUrl = new URL(`${forwarderUrl}/tx`);
  txInfoUrl.searchParams.append("txid", revealTx);
  const txResponse = await longPolling({
    pollingFunction: async () => {
      return fetchData(txInfoUrl);
    },
    successCondition: (response) => {
      const currentConfirmations = response?.block?.confirmations || 0;
      onConfirmation(currentConfirmations);
      return currentConfirmations >= confirmations;
    },
    error: new WaitForRevealBtcTxError("getting TxResponse timeout exceed")
  });
  if (!txResponse || !txResponse.txInfo) {
    return;
  }
  return txResponse.txInfo.revealTx;
}

// src/crosschain/waitForComplete/waitForBtcEvmTxIssued.ts
async function waitForBtcEvmTxIssued(symbiosis, revealTx, btcChainId) {
  const symBtcConfig = symbiosis.symBtcConfigFor(btcChainId);
  const symBtc = symbiosis.symBtcFor(btcChainId);
  const synthesis = symbiosis.synthesis(symBtcConfig.chainId);
  const externalId = await symBtc.getBTCExternalID(
    `0x${Buffer.from(revealTx, "hex").reverse().toString("hex")}`,
    0,
    synthesis.address
  );
  const filter = synthesis.filters.BTCSynthesizeCompleted(externalId);
  const log = await getLogWithTimeout({ symbiosis, chainId: symBtcConfig.chainId, filter });
  return log.transactionHash;
}

// src/crosschain/waitForComplete/waitFromTonTxMined.ts
import { Address as Address4 } from "@ton/core";
var waitFromTonTxCompleteError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "WaitForTonTxCompleteError";
  }
};
var TRANSFER_NOTIFICATION_OPCODE = "7362d09c";
async function waitFromTonTxMined(symbiosis, chainId, tonAddress) {
  const tonChainConfig = symbiosis.config.chains.find((chain) => chain.id === chainId);
  if (!tonChainConfig) {
    throw new Error("Ton chain config not found");
  }
  const tonPortal = tonChainConfig.tonPortal;
  if (!tonPortal) {
    throw new Error(`Ton portal not found for chain ${chainId}`);
  }
  const client = await symbiosis.getTonClient();
  const now = Math.floor(Date.now() / 1e3);
  return await longPolling({
    pollingFunction: async () => {
      const txs = await client.getTransactions(Address4.parse(tonPortal), { limit: 20, archival: true });
      const filtered = txs.filter((tx) => {
        if (tx.now < now) {
          return false;
        }
        const bodyInMsg = tx.inMessage?.body;
        if (bodyInMsg) {
          const body = bodyInMsg.beginParse();
          const opcode = body.loadUint(32).toString(16);
          if (opcode === TRANSFER_NOTIFICATION_OPCODE) {
            body.loadUint(64);
            body.loadCoins();
            const senderAddress2 = body.loadAddress();
            if (senderAddress2.equals(Address4.parse(tonAddress))) {
              return true;
            }
          }
        }
        const senderAddress = tx.inMessage?.info.src;
        if (!Address4.isAddress(senderAddress)) {
          return false;
        }
        return Address4.parse(tonAddress).equals(senderAddress);
      });
      return filtered.length > 0 ? filtered[0] : void 0;
    },
    successCondition: (tx) => {
      return tx !== void 0;
    },
    error: new waitFromTonTxCompleteError("Ton transaction not found on TON chain")
  });
}

// src/crosschain/baseSwapping.ts
import { AddressZero as AddressZero7, MaxUint256 as MaxUint2563 } from "@ethersproject/constants";
import { BigNumber as BigNumber9 } from "ethers";
import JSBI15 from "jsbi";

// src/crosschain/transit.ts
import { parseUnits as parseUnits5 } from "@ethersproject/units";
var Transit = class _Transit {
  constructor(symbiosis, amountIn, amountInMin, tokenOut, transitTokenIn, transitTokenOut, slippage, deadline, omniPoolConfig, fee) {
    this.symbiosis = symbiosis;
    this.amountIn = amountIn;
    this.amountInMin = amountInMin;
    this.tokenOut = tokenOut;
    this.transitTokenIn = transitTokenIn;
    this.transitTokenOut = transitTokenOut;
    this.slippage = slippage;
    this.deadline = deadline;
    this.omniPoolConfig = omniPoolConfig;
    this.fee = fee;
    this.direction = _Transit.getDirection(amountIn.token.chainId, tokenOut.chainId, omniPoolConfig.chainId);
    this.route = [];
    this.priceImpact = new Percent("0");
    this.feeToken = this.getFeeToken();
    if (!this.fee && this.feeToken.chainId === 56288 /* BOBA_BNB */) {
      const feeKey = Object.keys(symbiosis.config.transitFeeMap).find(
        (key) => this.feeToken.symbol?.includes(key)
      );
      if (feeKey) {
        const fee2 = symbiosis.config.transitFeeMap[feeKey];
        const feeRaw = parseUnits5(fee2, this.feeToken.decimals);
        this.fee = new TokenAmount(this.feeToken, feeRaw.toString());
      }
    }
  }
  async init() {
    this.trade = await this.buildTrade();
    this.amountOut = this.getTradeAmountOut(this.trade.amountOut);
    this.amountOutMin = this.getTradeAmountOut(this.trade.amountOutMin);
    this.route = this.trade.route;
    this.priceImpact = this.trade.priceImpact;
    return this;
  }
  isV2() {
    return this.direction === "v2";
  }
  /**
   * Amount in stables entering the bridge
   */
  getBridgeAmountIn() {
    if (this.direction === "mint" || this.isV2()) {
      return this.amountIn;
    }
    return this.trade ? this.trade.amountOut : this.amountIn;
  }
  /**
   * Amount in stables coming out of the bridge
   */
  getBridgeAmountOut(amount) {
    const amountOut = new TokenAmount(this.feeToken, amount.raw);
    if (!this.fee) {
      return amountOut;
    }
    if (amountOut.lessThan(this.fee) || amountOut.equalTo(this.fee)) {
      throw new Error2(
        `Amount ${amountOut.toSignificant()} ${amountOut.token.symbol} less than fee ${this.fee.toSignificant()} ${this.fee.token.symbol}`,
        2 /* AMOUNT_LESS_THAN_FEE */
      );
    }
    return amountOut.subtract(this.fee);
  }
  // PROTECTED
  static getDirection(chainIdIn, chainIdOut, omniPoolChainId) {
    const withManagerChain = chainIdIn === omniPoolChainId || chainIdOut === omniPoolChainId;
    if (!withManagerChain) {
      return "v2";
    }
    const chainsPriorityWithMChain = [...CHAINS_PRIORITY, omniPoolChainId];
    const indexIn = chainsPriorityWithMChain.indexOf(chainIdIn);
    const indexOut = chainsPriorityWithMChain.indexOf(chainIdOut);
    if (indexIn === -1) {
      throw new Error2(`Chain ${chainIdIn} not found in chains priority`);
    }
    if (indexOut === -1) {
      throw new Error2(`Chain ${chainIdOut} not found in chains priority`);
    }
    return indexIn > indexOut ? "burn" : "mint";
  }
  getTradeAmountIn(amount) {
    if (this.direction === "burn") {
      return amount;
    }
    return this.getBridgeAmountOut(amount);
  }
  getTradeAmountOut(tradeAmountOut) {
    if (!tradeAmountOut) {
      throw new Error2("There is no trade");
    }
    if (this.direction === "mint" || this.isV2()) {
      return tradeAmountOut;
    }
    const amountOut = new TokenAmount(this.transitTokenOut, tradeAmountOut.raw);
    if (!this.fee) {
      return amountOut;
    }
    if (amountOut.lessThan(this.fee) || amountOut.equalTo(this.fee)) {
      throw new Error2(
        `Amount ${amountOut.toSignificant()} ${amountOut.token.symbol} less than fee ${this.fee.toSignificant()} ${this.fee.token.symbol}`,
        2 /* AMOUNT_LESS_THAN_FEE */
      );
    }
    return amountOut.subtract(this.fee);
  }
  getFeeToken() {
    const transitTokenOutChainId = this.isV2() ? this.omniPoolConfig.chainId : this.tokenOut.chainId;
    if (this.direction === "burn") {
      return this.transitTokenOut;
    }
    const rep = this.symbiosis.getRepresentation(this.transitTokenIn, transitTokenOutChainId);
    if (!rep) {
      throw new Error2(
        `Representation of ${this.transitTokenIn.chainId}:${this.transitTokenIn.symbol} in chain ${transitTokenOutChainId} not found`,
        1 /* NO_REPRESENTATION_FOUND */
      );
    }
    return rep;
  }
  getTradeTokenOut() {
    if (this.direction === "mint") {
      return this.transitTokenOut;
    }
    const transitTokenInChainId = this.isV2() ? this.omniPoolConfig.chainId : this.amountIn.token.chainId;
    const rep = this.symbiosis.getRepresentation(this.transitTokenOut, transitTokenInChainId);
    if (!rep) {
      throw new Error2(
        `Representation of ${this.transitTokenOut.symbol} in chain ${transitTokenInChainId} not found`,
        1 /* NO_REPRESENTATION_FOUND */
      );
    }
    return rep;
  }
  async buildTrade() {
    const tokenAmountIn = this.getTradeAmountIn(this.amountIn);
    const tokenAmountInMin = this.getTradeAmountIn(this.amountInMin);
    const tokenOut = this.getTradeTokenOut();
    const to = this.symbiosis.multicallRouter(this.omniPoolConfig.chainId).address;
    const trade = new OmniTrade(
      tokenAmountIn,
      tokenAmountInMin,
      tokenOut,
      this.slippage,
      this.deadline,
      this.symbiosis,
      to,
      this.omniPoolConfig
    );
    await trade.init();
    return trade;
  }
  calls() {
    if (!this.trade) {
      return void 0;
    }
    const calldatas = [];
    const receiveSides = [];
    const paths = [];
    const offsets = [];
    const preCall = this.trade.buildFeePreCall();
    if (preCall) {
      calldatas.push(preCall.calldata);
      receiveSides.push(preCall.receiveSide);
      paths.push(preCall.path);
      offsets.push(preCall.offset);
    }
    calldatas.push(this.trade.callData);
    receiveSides.push(this.trade.pool.address);
    paths.push(...[this.trade.tokenAmountIn.token.address, this.trade.amountOut.token.address]);
    offsets.push(this.trade.callDataOffset);
    const postCall = this.trade.buildFeePostCall();
    if (postCall) {
      calldatas.push(postCall.calldata);
      receiveSides.push(postCall.receiveSide);
      paths.push(postCall.path);
      offsets.push(postCall.offset);
    }
    return {
      calldatas,
      receiveSides,
      paths,
      offsets
    };
  }
};

// src/crosschain/baseSwapping.ts
var BaseSwapping = class {
  constructor(symbiosis, omniPoolConfig) {
    this.omniPoolConfig = omniPoolConfig;
    this.symbiosis = symbiosis;
    this.dataProvider = new DataProvider(symbiosis);
  }
  async doExactIn({
    tokenAmountIn,
    tokenOut,
    from,
    to,
    slippage,
    deadline,
    oneInchProtocols,
    transitTokenIn,
    transitTokenOut
  }) {
    const start = Date.now();
    let prev = start;
    const timeLog = [];
    const routes = [];
    this.oneInchProtocols = oneInchProtocols;
    this.tokenAmountIn = tokenAmountIn;
    this.tokenOut = tokenOut;
    this.transitTokenIn = transitTokenIn || this.symbiosis.transitToken(this.tokenAmountIn.token.chainId, this.omniPoolConfig);
    this.transitTokenOut = transitTokenOut || this.symbiosis.transitToken(this.tokenOut.chainId, this.omniPoolConfig);
    this.from = tronAddressToEvm(from);
    this.to = tronAddressToEvm(to);
    this.slippage = this.buildDetailedSlippage(slippage);
    this.deadline = deadline;
    this.ttl = deadline - Math.floor(Date.now() / 1e3);
    this.synthesisV2 = this.symbiosis.synthesis(this.omniPoolConfig.chainId);
    if (isTronToken(this.tokenAmountIn.token) || isTronToken(this.tokenOut)) {
      this.revertableAddresses = {
        AB: this.symbiosis.getRevertableAddress(this.tokenAmountIn.token.chainId),
        BC: this.symbiosis.getRevertableAddress(this.tokenOut.chainId)
      };
    } else if (isTonChainId(this.tokenAmountIn.token.chainId) || isTonChainId(this.tokenOut.chainId)) {
      this.revertableAddresses = {
        AB: this.symbiosis.getRevertableAddress(this.tokenAmountIn.token.chainId),
        BC: this.symbiosis.getRevertableAddress(this.tokenOut.chainId)
      };
    } else {
      this.revertableAddresses = { AB: this.from, BC: this.from };
    }
    if (!this.transitTokenIn.equals(tokenAmountIn.token)) {
      this.tradeA = this.buildTradeA();
      await this.tradeA.init();
      timeLog.push(["A", Date.now() - start]);
      prev = Date.now();
      routes.push({
        provider: this.tradeA.tradeType,
        tokens: [this.tradeA.tokenAmountIn.token, this.tradeA.amountOut.token]
      });
    }
    this.transit = this.buildTransit();
    await this.transit.init();
    timeLog.push(["TRANSIT", Date.now() - start, Date.now() - prev]);
    prev = Date.now();
    routes.push({
      provider: "symbiosis",
      tokens: [this.transitTokenIn, this.transitTokenOut]
    });
    await this.doPostTransitAction();
    this.amountInUsd = this.transit.getBridgeAmountIn();
    if (!this.transitTokenOut.equals(tokenOut)) {
      this.tradeC = this.buildTradeC();
      await this.tradeC.init();
      timeLog.push(["C1", Date.now() - start, Date.now() - prev]);
      prev = Date.now();
      routes.push({
        provider: this.tradeC.tradeType,
        tokens: [this.tradeC.tokenAmountIn.token, this.tradeC.amountOut.token]
      });
    }
    this.route = this.getRoute();
    const [feeV1Raw, feeV2Raw] = await Promise.all([
      this.getFee(this.transit.feeToken),
      this.transit.isV2() ? this.getFeeV2() : void 0
    ]);
    timeLog.push(["ADVISOR", Date.now() - start, Date.now() - prev]);
    prev = Date.now();
    const feeV2 = feeV2Raw?.fee;
    this.feeV2 = feeV2;
    let fee = this.transit.fee;
    let save = new TokenAmount(this.transit.feeToken, "0");
    if (!this.transit.fee) {
      fee = feeV1Raw.fee;
      save = feeV1Raw.save;
      this.transit = this.buildTransit(fee);
      await this.transit.init();
    }
    await this.doPostTransitAction();
    if (!this.transitTokenOut.equals(tokenOut)) {
      this.tradeC = this.buildTradeC();
      await this.tradeC.init();
      timeLog.push(["C2", Date.now() - start, Date.now() - prev]);
    }
    const tokenAmountOut = this.tokenAmountOut(feeV2);
    const tokenAmountOutMin = new TokenAmount(
      tokenAmountOut.token,
      JSBI15.divide(JSBI15.multiply(this.transit.amountOutMin.raw, tokenAmountOut.raw), this.transit.amountOut.raw)
    );
    let payload;
    if (isTronChainId(this.tokenAmountIn.token.chainId)) {
      const transactionRequest = this.getTronTransactionRequest(fee, feeV2);
      payload = {
        transactionType: "tron",
        transactionRequest
      };
    } else if (isTonChainId(this.tokenAmountIn.token.chainId)) {
      const transactionRequest = await this.getTonTransactionRequest(fee, feeV2);
      payload = {
        transactionType: "ton",
        transactionRequest
      };
    } else {
      const transactionRequest = this.getEvmTransactionRequest(fee, feeV2);
      payload = {
        transactionType: "evm",
        transactionRequest
      };
    }
    timeLog.push(["F", Date.now() - start]);
    const fees = [
      {
        provider: "symbiosis",
        value: fee,
        description: "Cross-chain fee",
        save
      }
    ];
    if (feeV2Raw) {
      fees.push({
        provider: "symbiosis",
        value: feeV2Raw.fee,
        description: "Cross-chain fee",
        save: feeV2Raw.save
      });
    }
    return {
      ...payload,
      kind: "crosschain-swap",
      tokenAmountOut,
      tokenAmountOutMin,
      priceImpact: this.calculatePriceImpact(),
      approveTo: this.approveTo(),
      routes,
      fees,
      amountInUsd: this.amountInUsd,
      timeLog
    };
  }
  getRevertableAddress(side) {
    return this.revertableAddresses[side];
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  async doPostTransitAction() {
  }
  buildDetailedSlippage(totalSlippage) {
    const hasTradeA = !this.transitTokenIn.equals(this.tokenAmountIn.token);
    const hasTradeC = !this.transitTokenOut.equals(this.tokenOut);
    return splitSlippage(totalSlippage, hasTradeA, hasTradeC);
  }
  approveTo() {
    return this.symbiosis.chainConfig(this.tokenAmountIn.token.chainId).metaRouterGateway;
  }
  async waitForComplete(receipt) {
    if (!this.tokenOut) {
      throw new Error2("Tokens are not set");
    }
    if (this.transit.isV2()) {
      const wfc1 = new LegacyWaitForComplete({
        direction: "mint",
        symbiosis: this.symbiosis,
        revertableAddress: this.getRevertableAddress("AB"),
        chainIdIn: this.tokenAmountIn.token.chainId,
        chainIdOut: this.omniPoolConfig.chainId
      });
      const log = await wfc1.waitForComplete(receipt);
      const provider = this.symbiosis.getProvider(this.omniPoolConfig.chainId);
      const receipt2 = await provider.getTransactionReceipt(log.transactionHash);
      const wfc2 = new LegacyWaitForComplete({
        direction: "burn",
        symbiosis: this.symbiosis,
        revertableAddress: this.getRevertableAddress("BC"),
        chainIdIn: this.omniPoolConfig.chainId,
        chainIdOut: this.tokenOut.chainId
      });
      return wfc2.waitForComplete(receipt2);
    }
    return new LegacyWaitForComplete({
      direction: this.transit.direction,
      chainIdOut: this.tokenOut.chainId,
      symbiosis: this.symbiosis,
      revertableAddress: this.getRevertableAddress("AB"),
      chainIdIn: this.tokenAmountIn.token.chainId
    }).waitForComplete(receipt);
  }
  getEvmTransactionRequest(fee, feeV2) {
    const chainId = this.tokenAmountIn.token.chainId;
    const metaRouter = this.symbiosis.metaRouter(chainId);
    const [relayRecipient, otherSideCalldata] = this.otherSideData(fee, feeV2);
    const amount = this.tradeA ? this.tradeA.tokenAmountIn : this.tokenAmountIn;
    const value = this.tradeA && this.tokenAmountIn.token.isNative ? BigNumber9.from(this.tradeA.tokenAmountIn.raw.toString()) : void 0;
    const data = metaRouter.interface.encodeFunctionData("metaRoute", [
      {
        amount: amount.raw.toString(),
        nativeIn: amount.token.isNative,
        approvedTokens: this.approvedTokens().map(tronAddressToEvm),
        firstDexRouter: tronAddressToEvm(this.firstDexRouter()),
        firstSwapCalldata: this.firstSwapCalldata(),
        secondDexRouter: tronAddressToEvm(this.secondDexRouter()),
        secondSwapCalldata: this.transit.direction === "burn" ? this.secondSwapCalldata() : [],
        relayRecipient,
        otherSideCalldata
      }
    ]);
    return {
      chainId,
      to: metaRouter.address,
      data,
      value
    };
  }
  getTronTransactionRequest(fee, feeV2) {
    const { chainId } = this.tokenAmountIn.token;
    const { metaRouter } = this.symbiosis.chainConfig(chainId);
    const [relayRecipient, otherSideCalldata] = this.otherSideData(fee, feeV2);
    const amount = this.tradeA ? this.tradeA.tokenAmountIn : this.tokenAmountIn;
    const value = this.tradeA && this.tokenAmountIn.token.isNative ? BigNumber9.from(this.tradeA.tokenAmountIn.raw.toString()) : void 0;
    const tronWeb = this.symbiosis.tronWeb(chainId);
    return prepareTronTransaction({
      chainId,
      tronWeb,
      abi: TRON_METAROUTER_ABI,
      contractAddress: metaRouter,
      functionName: "metaRoute",
      params: [
        [
          this.firstSwapCalldata(),
          this.transit.direction === "burn" ? this.secondSwapCalldata() : [],
          this.approvedTokens().map(tronAddressToEvm),
          tronAddressToEvm(this.firstDexRouter()),
          this.secondDexRouter(),
          amount.raw.toString(),
          amount.token.isNative,
          tronAddressToEvm(relayRecipient),
          otherSideCalldata
        ]
      ],
      ownerAddress: this.from,
      value: value?.toString() ?? 0
    });
  }
  async getTonTransactionRequest(_fee, _feeV2) {
    throw new Error2("getTonTransactionRequest not implemented");
  }
  calculatePriceImpact() {
    const zero = new Percent(JSBI15.BigInt(0), BIPS_BASE);
    const pia = this.tradeA?.priceImpact || zero;
    const pib = this.transit.priceImpact || zero;
    const pic = this.tradeC?.priceImpact || zero;
    let pi = pia.add(pib).add(pic);
    const max = new Percent(JSBI15.BigInt(1e4), BIPS_BASE);
    if (pi.greaterThan(max))
      pi = max;
    return new Percent(pi.numerator, pi.denominator);
  }
  tokenAmountOut(feeV2) {
    if (this.tradeC) {
      return this.tradeC.amountOut;
    }
    if (this.transit.isV2()) {
      let amount = this.transit.amountOut.raw;
      if (feeV2) {
        if (JSBI15.lessThan(amount, feeV2.raw) || JSBI15.equal(amount, feeV2.raw)) {
          throw new Error2(
            `Amount ${this.transit.amountOut.toSignificant()} ${feeV2.token.symbol} less than feeV2 ${feeV2.toSignificant()} ${feeV2.token.symbol}`,
            2 /* AMOUNT_LESS_THAN_FEE */
          );
        }
        amount = JSBI15.subtract(amount, feeV2.raw);
      }
      return new TokenAmount(this.tokenOut, amount);
    }
    return this.transit.amountOut;
  }
  buildTradeA() {
    const tokenOut = this.transitTokenIn;
    if (WrapTrade.isSupported(this.tokenAmountIn, tokenOut)) {
      return new WrapTrade(this.tokenAmountIn, tokenOut, this.to);
    }
    const chainId = this.tokenAmountIn.token.chainId;
    const from = this.symbiosis.metaRouter(chainId).address;
    const to = from;
    return new AggregatorTrade({
      tokenAmountIn: this.tokenAmountIn,
      tokenOut,
      from,
      to,
      slippage: this.slippage["A"],
      symbiosis: this.symbiosis,
      dataProvider: this.dataProvider,
      clientId: this.symbiosis.clientId,
      ttl: this.ttl,
      oneInchProtocols: this.oneInchProtocols
    });
  }
  buildTransit(fee) {
    const amountIn = this.tradeA ? this.tradeA.amountOut : this.tokenAmountIn;
    const amountInMin = this.tradeA ? this.tradeA.amountOutMin : amountIn;
    this.symbiosis.validateLimits(amountIn);
    return new Transit(
      this.symbiosis,
      amountIn,
      amountInMin,
      this.tokenOut,
      this.transitTokenIn,
      this.transitTokenOut,
      this.slippage["B"],
      this.deadline,
      this.omniPoolConfig,
      fee
    );
  }
  tradeCTo() {
    return this.to;
  }
  getTradeCAmountIn() {
    let amountIn = this.transit.amountOut;
    if (this.transit.isV2()) {
      let amountRaw = amountIn.raw;
      if (this.feeV2) {
        if (amountIn.lessThan(this.feeV2) || amountIn.equalTo(this.feeV2)) {
          throw new Error2(
            `Amount ${amountIn.toSignificant()} ${amountIn.token.symbol} less than feeV2 ${this.feeV2.toSignificant()} ${this.feeV2.token.symbol}`,
            2 /* AMOUNT_LESS_THAN_FEE */
          );
        }
        amountRaw = JSBI15.subtract(amountRaw, this.feeV2.raw);
      }
      amountIn = new TokenAmount(this.transitTokenOut, amountRaw);
    }
    return amountIn;
  }
  buildTradeC() {
    const amountIn = this.getTradeCAmountIn();
    const chainId = this.tokenOut.chainId;
    if (WrapTrade.isSupported(amountIn, this.tokenOut)) {
      return new WrapTrade(amountIn, this.tokenOut, this.to);
    }
    const from = this.symbiosis.metaRouter(chainId).address;
    return new AggregatorTrade({
      tokenAmountIn: amountIn,
      tokenOut: this.tokenOut,
      from,
      to: this.tradeCTo(),
      slippage: this.slippage["C"],
      symbiosis: this.symbiosis,
      dataProvider: this.dataProvider,
      clientId: this.symbiosis.clientId,
      ttl: this.ttl,
      oneInchProtocols: this.oneInchProtocols
    });
  }
  getRoute() {
    const started = this.tradeA ? [] : [this.tokenAmountIn.token];
    const terminated = this.tradeC ? [] : [this.tokenOut];
    return [
      ...started,
      ...this.tradeA ? this.tradeA.route : [],
      ...this.transit.route,
      ...this.tradeC ? this.tradeC.route : [],
      ...terminated
    ].reduce((acc, token) => {
      const found = acc.find((i) => i.equals(token));
      if (found)
        return acc;
      return [...acc, token];
    }, []);
  }
  metaBurnSyntheticToken(fee) {
    if (!this.tokenAmountIn || !this.tokenOut) {
      throw new Error2("Tokens are not set");
    }
    const synthesis = this.symbiosis.synthesis(this.tokenAmountIn.token.chainId);
    const amount = this.transit.getBridgeAmountIn();
    return [
      synthesis.address,
      synthesis.interface.encodeFunctionData("metaBurnSyntheticToken", [
        {
          stableBridgingFee: fee.raw.toString(),
          amount: amount.raw.toString(),
          syntCaller: tronAddressToEvm(this.from),
          crossChainID: CROSS_CHAIN_ID,
          finalReceiveSide: tronAddressToEvm(this.finalReceiveSide()),
          sToken: tronAddressToEvm(amount.token.address),
          finalCallData: this.finalCalldata(),
          finalOffset: this.finalOffset(),
          chain2address: tronAddressToEvm(this.to),
          receiveSide: tronAddressToEvm(this.symbiosis.portal(this.tokenOut.chainId).address),
          oppositeBridge: tronAddressToEvm(this.symbiosis.bridge(this.tokenOut.chainId).address),
          revertableAddress: this.getRevertableAddress("BC"),
          chainID: this.tokenOut.chainId,
          clientID: this.symbiosis.clientId
        }
      ])
    ];
  }
  metaSynthesize(fee, feeV2) {
    if (!this.tokenAmountIn || !this.tokenOut) {
      throw new Error2("Tokens are not set");
    }
    const chainIdIn = this.tokenAmountIn.token.chainId;
    const chainIdOut = this.transit.isV2() ? this.omniPoolConfig.chainId : this.tokenOut.chainId;
    const tokenAmount = this.transit.getBridgeAmountIn();
    const portal = this.symbiosis.portal(chainIdIn);
    return [
      portal.address,
      portal.interface.encodeFunctionData("metaSynthesize", [
        {
          stableBridgingFee: fee.raw.toString(),
          amount: tokenAmount.raw.toString(),
          rtoken: tronAddressToEvm(tokenAmount.token.address),
          chain2address: this.to,
          receiveSide: tronAddressToEvm(this.symbiosis.synthesis(chainIdOut).address),
          oppositeBridge: tronAddressToEvm(this.symbiosis.bridge(chainIdOut).address),
          syntCaller: tronAddressToEvm(this.from),
          chainID: chainIdOut,
          swapTokens: this.swapTokens().map(tronAddressToEvm),
          secondDexRouter: tronAddressToEvm(this.secondDexRouter()),
          secondSwapCalldata: this.secondSwapCalldata(),
          finalReceiveSide: tronAddressToEvm(this.transit.isV2() ? this.finalReceiveSideV2() : AddressZero7),
          finalCalldata: this.transit.isV2() ? this.finalCalldataV2(feeV2) : [],
          finalOffset: this.transit.isV2() ? this.finalOffsetV2() : 0,
          revertableAddress: this.getRevertableAddress("AB"),
          clientID: this.symbiosis.clientId
        }
      ])
    ];
  }
  otherSideData(fee, feeV2) {
    return this.transit.direction === "burn" ? this.metaBurnSyntheticToken(fee) : this.metaSynthesize(fee, feeV2);
  }
  feeMintCallData() {
    const chainIdIn = this.tokenAmountIn.token.chainId;
    const chainIdOut = this.transit.isV2() ? this.omniPoolConfig.chainId : this.tokenOut.chainId;
    const portalAddress = tronAddressToEvm(this.symbiosis.chainConfig(chainIdIn).portal);
    const synthesisAddress = tronAddressToEvm(this.symbiosis.chainConfig(chainIdOut).synthesis);
    const internalId = getInternalId({
      contractAddress: portalAddress,
      requestCount: MaxUint2563,
      chainId: chainIdIn
    });
    const externalId = getExternalId({
      internalId,
      contractAddress: synthesisAddress,
      revertableAddress: this.getRevertableAddress("AB"),
      chainId: chainIdOut
    });
    const amount = this.transit.getBridgeAmountIn();
    const synthesisInterface = Synthesis__factory.createInterface();
    const callData = synthesisInterface.encodeFunctionData("metaMintSyntheticToken", [
      {
        stableBridgingFee: "0",
        amount: amount.raw.toString(),
        crossChainID: CROSS_CHAIN_ID,
        externalID: externalId,
        tokenReal: tronAddressToEvm(amount.token.address),
        chainID: chainIdIn,
        to: tronAddressToEvm(this.to),
        swapTokens: this.swapTokens().map(tronAddressToEvm),
        secondDexRouter: tronAddressToEvm(this.secondDexRouter()),
        secondSwapCalldata: this.secondSwapCalldata(),
        finalReceiveSide: tronAddressToEvm(this.transit.isV2() ? this.finalReceiveSideV2() : AddressZero7),
        finalCalldata: this.transit.isV2() ? this.finalCalldataV2() : [],
        finalOffset: this.transit.isV2() ? this.finalOffsetV2() : 0
      }
    ]);
    return [synthesisAddress, callData];
  }
  feeBurnCallData() {
    const chainIdIn = this.tokenAmountIn.token.chainId;
    const chainIdOut = this.tokenOut.chainId;
    const synthesisAddress = tronAddressToEvm(this.symbiosis.chainConfig(chainIdIn).synthesis);
    const portalAddress = tronAddressToEvm(this.symbiosis.chainConfig(chainIdOut).portal);
    const internalId = getInternalId({
      contractAddress: synthesisAddress,
      requestCount: MaxUint2563,
      chainId: chainIdIn
    });
    const externalId = getExternalId({
      internalId,
      contractAddress: portalAddress,
      revertableAddress: this.getRevertableAddress("BC"),
      chainId: chainIdOut
    });
    const amount = this.transit.amountOut;
    const portalInterface = Portal__factory.createInterface();
    const calldata = portalInterface.encodeFunctionData("metaUnsynthesize", [
      "0",
      // _stableBridgingFee
      CROSS_CHAIN_ID,
      // crossChainID
      externalId,
      // _externalID,
      tronAddressToEvm(this.to),
      // _to
      amount.raw.toString(),
      // _amount
      tronAddressToEvm(amount.token.address),
      // _rToken
      tronAddressToEvm(this.finalReceiveSide()),
      // _finalReceiveSide
      this.finalCalldata(),
      // _finalCalldata
      this.finalOffset()
      // _finalOffset
    ]);
    return [portalAddress, calldata];
  }
  feeBurnCallDataV2() {
    const chainIdIn = this.omniPoolConfig.chainId;
    const chainIdOut = this.tokenOut.chainId;
    const synthesisAddress = tronAddressToEvm(this.symbiosis.chainConfig(chainIdIn).synthesis);
    const portalAddress = tronAddressToEvm(this.symbiosis.chainConfig(chainIdOut).portal);
    const internalId = getInternalId({
      contractAddress: synthesisAddress,
      requestCount: MaxUint2563,
      chainId: chainIdIn
    });
    const externalId = getExternalId({
      internalId,
      contractAddress: portalAddress,
      revertableAddress: this.getRevertableAddress("BC"),
      chainId: chainIdOut
    });
    const portalInterface = Portal__factory.createInterface();
    const calldata = portalInterface.encodeFunctionData("metaUnsynthesize", [
      "0",
      // _stableBridgingFee
      CROSS_CHAIN_ID,
      // crossChainID
      externalId,
      // _externalID,
      tronAddressToEvm(this.to),
      // _to
      this.transit.amountOut.raw.toString(),
      // _amount
      tronAddressToEvm(this.transitTokenOut.address),
      // _rToken
      tronAddressToEvm(this.finalReceiveSide()),
      // _finalReceiveSide
      this.finalCalldata(),
      // _finalCalldata
      this.finalOffset()
      // _finalOffset
    ]);
    return [portalAddress, calldata];
  }
  async getFee(feeToken) {
    const chainIdFrom = this.tokenAmountIn.token.chainId;
    const chainIdTo = this.transit.isV2() ? this.omniPoolConfig.chainId : this.tokenOut.chainId;
    const [receiveSide, calldata] = this.transit.direction === "burn" ? this.feeBurnCallData() : this.feeMintCallData();
    const { price: fee, save } = await this.symbiosis.getBridgeFee({
      receiveSide,
      calldata,
      chainIdFrom,
      chainIdTo
    });
    return {
      fee: new TokenAmount(feeToken, fee),
      save: new TokenAmount(feeToken, save)
    };
  }
  async getFeeV2() {
    const feeToken = this.transitTokenOut;
    const [receiveSide, calldata] = this.feeBurnCallDataV2();
    const { price: fee, save } = await this.symbiosis.getBridgeFee({
      receiveSide,
      calldata,
      chainIdFrom: this.omniPoolConfig.chainId,
      chainIdTo: this.tokenOut.chainId
    });
    return {
      fee: new TokenAmount(feeToken, fee),
      save: new TokenAmount(feeToken, save)
    };
  }
  approvedTokens() {
    let firstToken = this.tradeA ? this.tradeA.tokenAmountIn.token.address : this.tokenAmountIn.token.address;
    if (!firstToken) {
      firstToken = AddressZero7;
    }
    let tokens;
    if (this.transit.direction === "burn") {
      tokens = [firstToken, ...this.transit.route.map((i) => i.address)];
    } else {
      tokens = [firstToken, this.tradeA ? this.tradeA.amountOut.token.address : this.tokenAmountIn.token.address];
    }
    return tokens;
  }
  firstDexRouter() {
    return this.tradeA?.routerAddress || AddressZero7;
  }
  firstSwapCalldata() {
    return this.tradeA?.callData || [];
  }
  // 1) get multicall router address
  secondDexRouter() {
    const multicallRouter = this.symbiosis.multicallRouter(this.omniPoolConfig.chainId);
    return multicallRouter.address;
  }
  // 2) get second swap calldata, no edits (will be only [swap]). Put in field secondSwapCalldata() in ton request
  secondSwapCalldata() {
    const calls = this.transit.calls();
    if (!calls) {
      return [];
    }
    const { calldatas, receiveSides, paths, offsets } = calls;
    if (this.transit.direction === "mint" && this.tradeC) {
      calldatas.push(this.finalCalldata());
      receiveSides.push(this.finalReceiveSide());
      paths.push(wrappedToken(this.tradeC.amountOut.token).address);
      offsets.push(this.finalOffset());
    }
    const multicallRouter = this.symbiosis.multicallRouter(this.omniPoolConfig.chainId);
    return multicallRouter.interface.encodeFunctionData("multicall", [
      this.transit.amountIn.raw.toString(),
      calldatas,
      // calldata
      receiveSides,
      // receiveSides
      paths,
      // path
      offsets,
      // offset
      this.symbiosis.metaRouter(this.omniPoolConfig.chainId).address
    ]);
  }
  finalReceiveSide() {
    return this.tradeC?.routerAddress || AddressZero7;
  }
  finalReceiveSideV2() {
    return this.synthesisV2.address;
  }
  // C
  finalCalldata() {
    return this.tradeC?.callData || [];
  }
  finalCalldataV2(feeV2) {
    return this.synthesisV2.interface.encodeFunctionData("metaBurnSyntheticToken", [
      {
        stableBridgingFee: feeV2 ? feeV2?.raw.toString() : "0",
        // uint256 stableBridgingFee;
        amount: this.transit.amountOut.raw.toString(),
        // uint256 amount;
        syntCaller: tronAddressToEvm(this.symbiosis.metaRouter(this.omniPoolConfig.chainId).address),
        // address syntCaller;
        crossChainID: CROSS_CHAIN_ID,
        finalReceiveSide: tronAddressToEvm(this.finalReceiveSide()),
        // address finalReceiveSide;
        sToken: tronAddressToEvm(this.transit.amountOut.token.address),
        // address sToken;
        finalCallData: this.finalCalldata(),
        // bytes finalCallData;
        finalOffset: this.finalOffset(),
        // uint256 finalOffset;
        chain2address: tronAddressToEvm(this.to),
        // address chain2address;
        receiveSide: tronAddressToEvm(this.symbiosis.portal(this.tokenOut.chainId).address),
        oppositeBridge: tronAddressToEvm(this.symbiosis.bridge(this.tokenOut.chainId).address),
        revertableAddress: this.getRevertableAddress("BC"),
        chainID: this.tokenOut.chainId,
        clientID: this.symbiosis.clientId
      }
    ]);
  }
  finalOffset() {
    return this.tradeC?.callDataOffset || 0;
  }
  finalOffsetV2() {
    return 100;
  }
  swapTokens() {
    if (this.transit.route.length === 0) {
      return [];
    }
    const tokens = [this.transit.route[0].address, this.transit.route[this.transit.route.length - 1].address];
    if (this.transit.isV2()) {
      return tokens;
    }
    if (this.tradeC) {
      tokens.push(wrappedToken(this.tradeC.amountOut.token).address);
    } else {
      tokens.push(...this.extraSwapTokens());
    }
    return tokens;
  }
  extraSwapTokens() {
    return [];
  }
};

// src/crosschain/swapping.ts
var Swapping = class extends BaseSwapping {
  async exactIn(params) {
    return this.doExactIn(params);
  }
};

// src/crosschain/swappingFromTon.ts
import { AddressZero as AddressZero8 } from "@ethersproject/constants";
var SwappingFromTon = class extends BaseSwapping {
  async getTonTransactionRequest(fee, feeV2) {
    let secondSwapCallData = this.secondSwapCalldata();
    if (secondSwapCallData.length === 0) {
      secondSwapCallData = "";
    }
    return buildMetaSynthesize({
      symbiosis: this.symbiosis,
      fee,
      amountIn: this.transit.getBridgeAmountIn(),
      secondDexRouter: this.secondDexRouter(),
      secondSwapCallData,
      swapTokens: this.swapTokens().map(tronAddressToEvm),
      from: this.from,
      to: this.to,
      revertableAddress: this.getRevertableAddress("AB"),
      chainIdOut: this.omniPoolConfig.chainId,
      validUntil: this.deadline,
      finalReceiveSide: tronAddressToEvm(this.transit.isV2() ? this.finalReceiveSideV2() : AddressZero8),
      finalCallData: this.transit.isV2() ? this.finalCalldataV2(feeV2) : "",
      finalOffset: this.transit.isV2() ? this.finalOffsetV2() : 0
    });
  }
};

// src/crosschain/swappingMiddleware.ts
var SwappingMiddleware = class extends BaseSwapping {
  async exactIn(params) {
    const { middlewareCall, tokenAmountIn } = params;
    if (!middlewareCall) {
      const { symbiosis, omniPoolConfig } = this;
      let swapping = new Swapping(symbiosis, omniPoolConfig);
      if (isTonChainId(tokenAmountIn.token.chainId)) {
        swapping = new SwappingFromTon(symbiosis, omniPoolConfig);
      }
      return swapping.doExactIn(params);
    }
    const { address: address2, data, offset } = middlewareCall;
    this.middlewareAddress = address2;
    this.middlewareData = data;
    this.middlewareOffset = offset;
    return this.doExactIn(params);
  }
  finalReceiveSide() {
    return this.middlewareAddress;
  }
  finalCalldata() {
    return this.middlewareData;
  }
  finalOffset() {
    return this.middlewareOffset;
  }
};

// src/crosschain/symbiosis.ts
import { parseUnits as parseUnits6 } from "@ethersproject/units";

// src/crosschain/swapExactIn/bridge.ts
import { AddressZero as AddressZero9 } from "@ethersproject/constants";
import { MaxUint256 as MaxUint2564 } from "@ethersproject/constants";
import { Address as Address5 } from "@ton/core";
function isBridgeSupported(context) {
  const { tokenAmountIn, tokenOut, symbiosis } = context;
  const wrappedInToken = wrappedToken(tokenAmountIn.token);
  const wrappedOutToken = wrappedToken(tokenOut);
  if (wrappedInToken.chainId === wrappedOutToken.chainId) {
    return false;
  }
  try {
    const representation = symbiosis.getRepresentation(wrappedInToken, wrappedOutToken.chainId);
    return !!representation && representation.equals(wrappedOutToken);
  } catch {
    return false;
  }
}
async function bridge(context) {
  const { tokenAmountIn, tokenOut } = context;
  const direction = getDirection(context);
  const revertableAddress = getRevertableAddress(context);
  const fee = await getFee(context, direction);
  const amountOut = getAmountOut(context, fee);
  const payload = await getTransactionPayload(context, fee, revertableAddress, direction);
  let approveTo = "";
  if (payload.transactionType === "tron") {
    approveTo = payload.transactionRequest.contract_address;
  } else if (payload.transactionType === "evm") {
    approveTo = payload.transactionRequest.to;
  }
  return {
    ...payload,
    kind: "bridge",
    tokenAmountOut: amountOut,
    tokenAmountOutMin: amountOut,
    priceImpact: new Percent("0", "0"),
    approveTo,
    fees: [
      {
        provider: "symbiosis",
        description: "Bridge fee",
        value: fee
      }
    ],
    routes: [
      {
        provider: "symbiosis",
        tokens: [tokenAmountIn.token, tokenOut]
      }
    ]
  };
}
function getDirection(context) {
  const { tokenAmountIn } = context;
  if (tokenAmountIn.token.isSynthetic) {
    return "burn";
  }
  return "mint";
}
function getRevertableAddress(context) {
  const { from, tokenAmountIn, tokenOut, symbiosis } = context;
  const chainIdIn = tokenAmountIn.token.chainId;
  const chainIdOut = tokenOut.chainId;
  let address2 = from;
  if (isTronChainId(chainIdIn) || isTronChainId(chainIdOut)) {
    address2 = symbiosis.getRevertableAddress(chainIdOut);
  } else if (isTonChainId(chainIdIn) || isTonChainId(chainIdOut)) {
    address2 = symbiosis.getRevertableAddress(chainIdOut);
  }
  return address2;
}
async function getFee(context, direction) {
  if (direction === "burn") {
    return getBurnFee(context);
  }
  return getMintFee(context);
}
async function getMintFee(context) {
  const { symbiosis, tokenAmountIn, tokenOut, to } = context;
  const chainIdIn = tokenAmountIn.token.chainId;
  const chainIdOut = tokenOut.chainId;
  const internalId = getInternalId({
    contractAddress: symbiosis.chainConfig(chainIdIn).portal,
    requestCount: MaxUint2564,
    // we must use last possible request count because it is always free
    chainId: chainIdIn
  });
  const synthesisAddress = symbiosis.chainConfig(chainIdOut).synthesis;
  const externalId = getExternalId({
    internalId,
    contractAddress: synthesisAddress,
    revertableAddress: AddressZero9,
    // doesn't matter which address is
    chainId: chainIdOut
  });
  const token = wrappedToken(tokenAmountIn.token);
  const synthesisInterface = Synthesis__factory.createInterface();
  const calldata = synthesisInterface.encodeFunctionData("mintSyntheticToken", [
    "1",
    // stableBridgingFee,
    externalId,
    // externalID,
    CROSS_CHAIN_ID,
    token.address,
    // tokenReal,
    chainIdIn,
    // chainId
    tokenAmountIn.raw.toString(),
    // amount,
    to
  ]);
  const { price: fee } = await symbiosis.getBridgeFee({
    receiveSide: synthesisAddress,
    calldata,
    chainIdFrom: tokenAmountIn.token.chainId,
    chainIdTo: tokenOut.chainId
  });
  return new TokenAmount(tokenOut, fee);
}
async function getBurnFee(context) {
  const { symbiosis, tokenAmountIn, tokenOut, to } = context;
  const chainIdIn = tokenAmountIn.token.chainId;
  const chainIdOut = tokenOut.chainId;
  if (isTonChainId(chainIdOut)) {
    return tonAdvisorMock(tokenOut).fee;
  }
  const internalId = getInternalId({
    contractAddress: symbiosis.chainConfig(chainIdIn).synthesis,
    requestCount: MaxUint2564,
    // we must use last possible request count because it is always free
    chainId: chainIdIn
  });
  const portalAddress = symbiosis.chainConfig(chainIdOut).portal;
  const externalId = getExternalId({
    internalId,
    contractAddress: portalAddress,
    revertableAddress: AddressZero9,
    // doesn't matter which address is
    chainId: chainIdOut
  });
  const portalInterface = Portal__factory.createInterface();
  const calldata = portalInterface.encodeFunctionData("unsynthesize", [
    "1",
    // Bridging fee
    externalId,
    CROSS_CHAIN_ID,
    tokenOut.address,
    // The address of the token to unsynthesize
    tokenAmountIn.raw.toString(),
    // Number of tokens to unsynthesize
    to
    // The address to receive tokens
  ]);
  const { price: fee } = await symbiosis.getBridgeFee({
    receiveSide: portalAddress,
    calldata,
    chainIdFrom: chainIdIn,
    chainIdTo: chainIdOut
  });
  return new TokenAmount(tokenOut, fee);
}
function getAmountOut(context, fee) {
  const { tokenAmountIn, tokenOut } = context;
  const amountOut = new TokenAmount(tokenOut, tokenAmountIn.raw);
  if (amountOut.lessThan(fee)) {
    throw new Error2(
      `Amount ${amountOut.toSignificant()} ${amountOut.token.symbol} less than fee ${fee.toSignificant()} ${fee.token.symbol}`,
      2 /* AMOUNT_LESS_THAN_FEE */
    );
  }
  return amountOut.subtract(fee);
}
async function getTransactionPayload(context, fee, revertableAddress, direction) {
  const { tokenAmountIn } = context;
  const chainIdIn = tokenAmountIn.token.chainId;
  if (isTronChainId(chainIdIn)) {
    const transactionRequest = getTronTransactionRequest(context, fee, revertableAddress, direction);
    return {
      transactionType: "tron",
      transactionRequest
    };
  }
  if (isTonChainId(chainIdIn)) {
    const transactionRequest = await getTonTransactionRequest(context, fee, revertableAddress, direction);
    return {
      transactionType: "ton",
      transactionRequest
    };
  }
  if (isEvmChainId(chainIdIn)) {
    const transactionRequest = getEvmTransactionRequest(context, fee, revertableAddress, direction);
    return {
      transactionType: "evm",
      transactionRequest
    };
  }
  throw new Error2(`Transaction payload can't be built. Unknown chainId type`);
}
function getTronTransactionRequest(context, fee, revertableAddress, direction) {
  const { symbiosis, tokenAmountIn, tokenOut, to, from } = context;
  const chainIdIn = tokenAmountIn.token.chainId;
  const chainIdOut = tokenOut.chainId;
  if (direction === "burn") {
    throw new Error2("Burn is not supported on Tron");
  }
  return prepareTronTransaction({
    chainId: chainIdIn,
    abi: TRON_PORTAL_ABI,
    ownerAddress: from,
    contractAddress: symbiosis.chainConfig(chainIdIn).portal,
    functionName: "synthesize",
    params: [
      fee.raw.toString(),
      tokenAmountIn.token.address,
      tokenAmountIn.raw.toString(),
      to,
      symbiosis.chainConfig(chainIdOut).synthesis,
      symbiosis.chainConfig(chainIdOut).bridge,
      revertableAddress,
      chainIdOut.toString(),
      symbiosis.clientId
    ],
    tronWeb: symbiosis.tronWeb(chainIdIn)
  });
}
async function getTonTransactionRequest(context, fee, revertableAddress, direction) {
  if (direction === "burn") {
    throw new Error2("Burn is not supported on Tron");
  }
  const { symbiosis, tokenAmountIn, tokenOut, to, from, deadline } = context;
  return buildSynthesize({
    symbiosis,
    fee,
    amountIn: tokenAmountIn,
    chainIdOut: tokenOut.chainId,
    from,
    to,
    revertableAddress,
    validUntil: deadline
  });
}
function getEvmTransactionRequest(context, fee, revertableAddress, direction) {
  const { symbiosis, tokenAmountIn, tokenOut, to } = context;
  const chainIdIn = tokenAmountIn.token.chainId;
  const chainIdOut = tokenOut.chainId;
  if (direction === "burn") {
    const synthesis = symbiosis.synthesis(chainIdIn);
    if (isTonChainId(chainIdOut)) {
      const { workChain, hash } = Address5.parse(to);
      const tonAddress = {
        workchain: workChain,
        address_hash: `0x${hash.toString("hex")}`
      };
      const data2 = synthesis.interface.encodeFunctionData("burnSyntheticTokenTON", [
        fee.raw.toString(),
        tokenAmountIn.token.address,
        tokenAmountIn.raw.toString(),
        CROSS_CHAIN_ID,
        tonAddress,
        AddressZero9,
        // any arbitrary data, this addresses passed from relayer
        AddressZero9,
        // any arbitrary data, this addresses passed from relayer
        revertableAddress,
        chainIdOut,
        symbiosis.clientId
      ]);
      return {
        chainId: chainIdIn,
        to: synthesis.address,
        data: data2
      };
    }
    const data = synthesis.interface.encodeFunctionData("burnSyntheticToken", [
      fee.raw.toString(),
      tokenAmountIn.token.address,
      tokenAmountIn.raw.toString(),
      to,
      symbiosis.chainConfig(chainIdOut).portal,
      symbiosis.chainConfig(chainIdOut).bridge,
      revertableAddress,
      chainIdOut,
      symbiosis.clientId
    ]);
    return {
      chainId: chainIdIn,
      to: synthesis.address,
      data
    };
  }
  const portal = symbiosis.portal(chainIdIn);
  return {
    chainId: chainIdIn,
    to: portal.address,
    data: portal.interface.encodeFunctionData("synthesize", [
      fee.raw.toString(),
      tokenAmountIn.token.address,
      tokenAmountIn.raw.toString(),
      to,
      symbiosis.chainConfig(chainIdOut).synthesis,
      symbiosis.chainConfig(chainIdOut).bridge,
      revertableAddress,
      chainIdOut,
      symbiosis.clientId
    ])
  };
}

// src/crosschain/swapExactIn/utils.ts
async function theBestOutput(promises) {
  if (promises.length === 0) {
    throw new Error2(`No route`, 3 /* NO_TRANSIT_TOKEN */);
  }
  const results = await Promise.allSettled(promises);
  let result;
  const errors = [];
  for (const item of results) {
    if (item.status !== "fulfilled") {
      errors.push(item.reason);
      continue;
    }
    const { value } = item;
    if (result && result.tokenAmountOut.greaterThan(value.tokenAmountOut)) {
      continue;
    }
    result = value;
  }
  if (!result) {
    throw AggregateError(errors, "Build route error");
  }
  return result;
}

// src/crosschain/swapExactIn/crosschainSwap/bestTokenSwapping.ts
async function bestTokenSwapping(params, poolConfig) {
  const { symbiosis, tokenAmountIn, tokenOut } = params;
  const combinations = symbiosis.getTransitCombinations(tokenAmountIn.token.chainId, tokenOut.chainId, poolConfig);
  const promises = combinations.map(({ transitTokenIn, transitTokenOut }) => {
    const action = symbiosis.newSwapping(poolConfig);
    return action.exactIn({ ...params, transitTokenIn, transitTokenOut });
  });
  return theBestOutput(promises);
}

// src/crosschain/swapExactIn/crosschainSwap/bestPoolSwapping.ts
async function bestPoolSwapping(params) {
  const { symbiosis, tokenAmountIn, tokenOut } = params;
  const optimalRoute = getOptimalRoute(symbiosis, tokenAmountIn.token, tokenOut);
  if (optimalRoute) {
    const result = await symbiosis.newSwapping(optimalRoute.pool).exactIn({
      ...params,
      transitTokenIn: optimalRoute.transitTokenIn,
      transitTokenOut: optimalRoute.transitTokenOut
    });
    const threshold = new Percent("-1", "100");
    if (result.priceImpact.greaterThan(threshold)) {
      return result;
    }
  }
  const { omniPools } = symbiosis.config;
  const promises = omniPools.filter((poolConfig) => poolConfig.generalPurpose || poolConfig.chainExceptions?.includes(tokenOut.chainId)).map((poolConfig) => bestTokenSwapping(params, poolConfig));
  return theBestOutput(promises);
}
function getOptimalRoute(symbiosis, tokenIn, tokenOut) {
  const { omniPools } = symbiosis.config;
  let optimal;
  for (let i = 0; i < omniPools.length; i++) {
    const pool = omniPools[i];
    const transitTokenIn = symbiosis.transitTokens(tokenIn.chainId, pool).find((transitToken) => {
      return transitToken.equals(wrappedToken(tokenIn));
    });
    const transitTokenOut = symbiosis.transitTokens(tokenOut.chainId, pool).find((transitToken) => {
      return transitToken.equals(wrappedToken(tokenOut));
    });
    if (transitTokenIn && transitTokenOut) {
      optimal = {
        transitTokenIn,
        transitTokenOut,
        pool
      };
      break;
    }
  }
  if (optimal) {
    return optimal;
  }
  for (let i = 0; i < omniPools.length; i++) {
    try {
      const pool = omniPools[i];
      const transitTokenIn = symbiosis.transitToken(tokenIn.chainId, pool);
      const transitTokenOut = symbiosis.transitTokens(tokenOut.chainId, pool).find((transitToken) => {
        return transitToken.equals(wrappedToken(tokenOut));
      });
      if (transitTokenOut) {
        optimal = {
          transitTokenIn,
          transitTokenOut,
          pool
        };
        break;
      }
    } catch {
    }
  }
  return optimal;
}

// src/crosschain/swapExactIn/crosschainSwap/crosschainSwap.ts
async function crosschainSwap(params) {
  return bestPoolSwapping(params);
}

// src/crosschain/swapExactIn/feeCollectorSwap.ts
import { AddressZero as AddressZero10 } from "@ethersproject/constants";
import { BigNumber as BigNumber11, utils as utils39 } from "ethers";

// src/crosschain/swapExactIn/preparePayload.ts
import TronWeb3 from "tronweb";
function preparePayload({
  chainId,
  from,
  to,
  callData,
  value = "0",
  functionSelector
}) {
  if (isTronChainId(chainId)) {
    if (!functionSelector) {
      throw new Error("This method is not supported for tron chain");
    }
    const rawParameter = callData.replace(/^(0x)/, "").slice(8);
    return {
      transactionType: "tron",
      transactionRequest: {
        function_selector: functionSelector,
        call_value: value,
        chain_id: chainId,
        contract_address: TronWeb3.address.fromHex(to),
        owner_address: TronWeb3.address.fromHex(from),
        raw_parameter: rawParameter,
        fee_limit: 15e7
        // Default fee limit - 150 TRX
      }
    };
  }
  return {
    transactionType: "evm",
    transactionRequest: {
      chainId,
      from,
      to,
      value,
      data: callData
    }
  };
}

// src/crosschain/swapExactIn/aggregatorsSwap.ts
async function aggregatorsSwap({
  symbiosis,
  deadline,
  to,
  from,
  slippage,
  tokenAmountIn,
  tokenOut,
  oneInchProtocols
}) {
  const dataProvider = new DataProvider(symbiosis);
  const ttl = deadline - Math.floor(Date.now() / 1e3);
  const aggregatorTrade = new AggregatorTrade({
    symbiosis,
    to,
    from,
    clientId: symbiosis.clientId,
    dataProvider,
    slippage,
    tokenAmountIn,
    tokenOut,
    ttl,
    oneInchProtocols
  });
  await aggregatorTrade.init();
  const { amountOut, amountOutMin, callData, priceImpact, route, routerAddress, tradeType, functionSelector } = aggregatorTrade;
  const value = tokenAmountIn.token.isNative ? tokenAmountIn.raw.toString() : "0";
  const payload = preparePayload({
    functionSelector,
    chainId: tokenAmountIn.token.chainId,
    from,
    to: routerAddress,
    value,
    callData
  });
  return {
    ...payload,
    kind: "onchain-swap",
    approveTo: routerAddress,
    tokenAmountOut: amountOut,
    tokenAmountOutMin: amountOutMin,
    priceImpact,
    fees: [],
    routes: [
      {
        provider: tradeType,
        tokens: route
      }
    ]
  };
}

// src/crosschain/swapExactIn/okxSwap.ts
var import_crypto_js = __toESM(require_crypto_js());
import BigNumber10 from "bignumber.js";
var OKX_CHAINS = /* @__PURE__ */ new Set([
  1 /* ETH_MAINNET */,
  324 /* ZKSYNC_MAINNET */,
  10 /* OPTIMISM_MAINNET */,
  137 /* MATIC_MAINNET */,
  56 /* BSC_MAINNET */,
  43114 /* AVAX_MAINNET */,
  42161 /* ARBITRUM_MAINNET */,
  59144 /* LINEA_MAINNET */,
  8453 /* BASE_MAINNET */
]);
function isOKXSwapSupported(params) {
  const inChainId = params.tokenAmountIn.token.chainId;
  const outChainId = params.tokenOut.chainId;
  return inChainId === outChainId && OKX_CHAINS.has(inChainId) && OneInchTrade.isAvailable(inChainId);
}
function okxSecurityHeaders(url) {
  const secretKey = "5E7583807F073388BC0E127817D08A4D";
  const timestamp = (/* @__PURE__ */ new Date()).toISOString();
  const passphrase = "*N0b0C@1tq&6";
  const hash = import_crypto_js.default.HmacSHA256(`${timestamp}GET${url.pathname}${url.search}`, secretKey);
  const sign = import_crypto_js.default.enc.Base64.stringify(hash);
  return {
    "OK-ACCESS-KEY": "a90cfe67-4bb8-4d65-9115-d4ab0cb8f83c",
    "OK-ACCESS-SIGN": sign,
    "OK-ACCESS-TIMESTAMP": timestamp,
    "OK-ACCESS-PASSPHRASE": passphrase
  };
}
function getTokenAddress(token) {
  if (token.isNative) {
    return NATIVE_TOKEN_ADDRESS;
  }
  return token.address;
}
async function okxSwap({
  symbiosis,
  tokenAmountIn,
  tokenOut,
  from,
  to,
  slippage
}) {
  if (from.toLowerCase() !== to.toLowerCase()) {
    throw new Error("Sender and receiver must be the same");
  }
  const fromTokenAddress = getTokenAddress(tokenAmountIn.token);
  const toTokenAddress = getTokenAddress(tokenOut);
  const convertedSlippage = new BigNumber10(slippage).div(1e4).toString();
  const url = new URL("https://www.okx.com/api/v5/dex/aggregator/swap");
  url.searchParams.set("chainId", tokenAmountIn.token.chainId.toString());
  url.searchParams.set("fromTokenAddress", fromTokenAddress);
  url.searchParams.set("toTokenAddress", toTokenAddress);
  url.searchParams.set("amount", tokenAmountIn.raw.toString());
  url.searchParams.set("userWalletAddress", from);
  url.searchParams.set("slippage", convertedSlippage);
  const response = await fetch(url.toString(), {
    headers: {
      "content-type": "application/json",
      ...okxSecurityHeaders(url)
    }
  });
  const { data } = await response.json();
  if (!data?.length) {
    throw new Error("No data in response");
  }
  const { routerResult, tx } = data[0];
  const amountOut = new TokenAmount(tokenOut, routerResult.toTokenAmount);
  const oracle = symbiosis.oneInchOracle(tokenAmountIn.token.chainId);
  const dataProvider = new DataProvider(symbiosis);
  const priceImpactPromise = getTradePriceImpact({
    dataProvider,
    oracle,
    tokenAmountIn,
    tokenAmountOut: amountOut
  });
  const approveUrl = new URL("https://www.okx.com/api/v5/dex/aggregator/approve-transaction");
  approveUrl.searchParams.set("chainId", tokenAmountIn.token.chainId.toString());
  approveUrl.searchParams.set("tokenContractAddress", fromTokenAddress);
  approveUrl.searchParams.set("approveAmount", tokenAmountIn.raw.toString());
  const approveResponsePromise = fetch(approveUrl.toString(), {
    headers: { "content-type": "application/json", ...okxSecurityHeaders(approveUrl) }
  });
  const [priceImpact, approveResponse] = await Promise.all([priceImpactPromise, approveResponsePromise]);
  const { data: approveData } = await approveResponse.json();
  const approveTo = approveData?.[0]?.dexContractAddress;
  return {
    kind: "onchain-swap",
    tokenAmountOut: amountOut,
    tokenAmountOutMin: amountOut,
    approveTo,
    priceImpact,
    transactionType: "evm",
    transactionRequest: {
      to: tx.to,
      data: tx.data,
      value: tokenAmountIn.token.isNative ? tokenAmountIn.raw.toString() : void 0
    },
    fees: [],
    routes: [
      {
        provider: "okx",
        tokens: [tokenAmountIn.token, tokenOut]
      }
    ]
  };
}

// src/crosschain/trade/magpieTrade.ts
import JSBI16 from "jsbi";
var MAGPIE_NETWORKS = {
  [56 /* BSC_MAINNET */]: {
    slug: "bsc"
  },
  [1 /* ETH_MAINNET */]: {
    slug: "ethereum"
  },
  [137 /* MATIC_MAINNET */]: {
    slug: "polygon"
  },
  [43114 /* AVAX_MAINNET */]: {
    slug: "avalanche"
  },
  [42161 /* ARBITRUM_MAINNET */]: {
    slug: "arbitrum"
  },
  [10 /* OPTIMISM_MAINNET */]: {
    slug: "optimism"
  },
  [1101 /* POLYGON_ZK */]: {
    slug: "polygonzk"
  },
  [8453 /* BASE_MAINNET */]: {
    slug: "base"
  },
  [324 /* ZKSYNC_MAINNET */]: {
    slug: "zksync"
  },
  [81457 /* BLAST_MAINNET */]: {
    slug: "blast"
  },
  [169 /* MANTA_MAINNET */]: {
    slug: "manta"
  },
  [534352 /* SCROLL_MAINNET */]: {
    slug: "scroll"
  },
  [167e3 /* TAIKO_MAINNET */]: {
    slug: "taiko"
  },
  [1088 /* METIS_MAINNET */]: {
    slug: "metis"
  }
};
var BASE_URL2 = "https://api.magpiefi.xyz";
var MAGPIE_NATIVE = "0x0000000000000000000000000000000000000000";
var MagpieTrade = class {
  constructor({ symbiosis, tokenAmountIn, tokenOut, from, to, slippage }) {
    this.tradeType = "magpie";
    this.symbiosis = symbiosis;
    this.tokenAmountIn = tokenAmountIn;
    this.tokenOut = tokenOut;
    this.to = to;
    this.from = from;
    this.slippage = slippage;
    this.callDataOffset = 0;
  }
  static isAvailable(chainId) {
    return Object.keys(MAGPIE_NETWORKS).includes(chainId.toString());
  }
  async init() {
    this.chain = MAGPIE_NETWORKS[this.tokenAmountIn.token.chainId];
    if (!this.chain) {
      throw new Error("Unsupported chain");
    }
    let fromTokenAddress = this.tokenAmountIn.token.address;
    if (this.tokenAmountIn.token.isNative) {
      fromTokenAddress = MAGPIE_NATIVE;
    }
    let toTokenAddress = this.tokenOut.address;
    if (this.tokenOut.isNative) {
      toTokenAddress = MAGPIE_NATIVE;
    }
    const quote = await this.getQuote(fromTokenAddress, toTokenAddress);
    const tx = await this.getTransaction(quote.id, this.to, this.from);
    this.routerAddress = tx.to;
    this.callData = tx.data;
    this.amountOut = new TokenAmount(this.tokenOut, quote.amountOut);
    const amountOutMinRaw = getMinAmount(this.slippage, quote.amountOut);
    this.amountOutMin = new TokenAmount(this.tokenOut, amountOutMinRaw);
    this.route = [this.tokenAmountIn.token, this.tokenOut];
    try {
      this.priceImpact = await this.getPriceImpact(this.tokenAmountIn, this.amountOut);
    } catch (e) {
      this.priceImpact = new Percent("0", "100");
    }
    return this;
  }
  async getQuote(fromTokenAddress, toTokenAddress) {
    const url = new URL(`${BASE_URL2}/aggregator/quote`);
    url.searchParams.set("network", this.chain.slug);
    url.searchParams.set("fromTokenAddress", fromTokenAddress);
    url.searchParams.set("toTokenAddress", toTokenAddress);
    url.searchParams.set("sellAmount", this.tokenAmountIn.raw.toString());
    url.searchParams.set("slippage", (this.slippage / 1e4).toString());
    const quoteResponse = await this.symbiosis.fetch(url.toString());
    if (!quoteResponse.ok) {
      const text = await quoteResponse.text();
      throw new Error(`Cannot build Magpie quote for chain ${this.tokenAmountIn.token.chainId}: ${text}`);
    }
    return quoteResponse.json();
  }
  async getTransaction(quoteId, toAddress, fromAddress) {
    const url = new URL(`${BASE_URL2}/aggregator/transaction`);
    url.searchParams.set("quoteId", quoteId);
    url.searchParams.set("toAddress", toAddress);
    url.searchParams.set("fromAddress", fromAddress);
    url.searchParams.set("estimateGas", "false");
    const response = await this.symbiosis.fetch(url.toString());
    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Cannot build Magpie trade for chain ${this.tokenAmountIn.token.chainId}: ${text}`);
    }
    return response.json();
  }
  async getPriceImpact(tokenAmountIn, tokenAmountOut) {
    const [tokenInPrice, tokenOutPrice] = await Promise.all([
      this.symbiosis.dataProvider.getTokenPrice(tokenAmountIn.token),
      this.symbiosis.dataProvider.getTokenPrice(tokenAmountOut.token)
    ]);
    const tokenAmountInUsd = getTokenAmountUsd(this.tokenAmountIn, tokenInPrice);
    const tokenAmountOutUsd = getTokenAmountUsd(this.amountOut, tokenOutPrice);
    const impactNumber = -(1 - tokenAmountOutUsd / tokenAmountInUsd);
    return new Percent(parseInt(`${impactNumber * JSBI16.toNumber(BIPS_BASE)}`).toString(), BIPS_BASE);
  }
};

// src/crosschain/swapExactIn/magpieSwap.ts
async function magpieSwap({
  symbiosis,
  tokenAmountIn,
  tokenOut,
  from,
  to,
  slippage
}) {
  const trade = new MagpieTrade({
    symbiosis,
    tokenAmountIn,
    tokenOut,
    from,
    to,
    slippage
  });
  await trade.init();
  return {
    kind: "onchain-swap",
    tokenAmountOut: trade.amountOut,
    tokenAmountOutMin: trade.amountOutMin,
    approveTo: trade.routerAddress,
    priceImpact: trade.priceImpact,
    transactionType: "evm",
    transactionRequest: {
      to: trade.routerAddress,
      data: trade.callData,
      value: tokenAmountIn.token.isNative ? tokenAmountIn.raw.toString() : void 0
    },
    fees: [],
    routes: [
      {
        provider: "magpie",
        tokens: [tokenAmountIn.token, tokenOut]
      }
    ]
  };
}

// src/crosschain/swapExactIn/onchainSwap.ts
async function onchainSwap(params) {
  const promises = [aggregatorsSwap(params)];
  if (isOKXSwapSupported(params)) {
    promises.push(okxSwap(params));
  }
  if (MagpieTrade.isAvailable(params.tokenAmountIn.token.chainId)) {
    promises.push(magpieSwap(params));
  }
  return theBestOutput(promises);
}

// src/crosschain/swapExactIn/feeCollectorSwap.ts
var ZERO_FEE_COLLECTOR_ADDRESSES = {
  [324 /* ZKSYNC_MAINNET */]: "0x35e3dc1f3383bD348EC651EdD73fE1d7a7dA5AAa"
};
var FEE_COLLECTOR_ADDRESSES = {
  [1 /* ETH_MAINNET */]: "0xff9b21c3bfa4bce9b20b55fed56d102ced48b0f6",
  [56 /* BSC_MAINNET */]: "0x0425841529882628880fBD228AC90606e0c2e09A",
  [43114 /* AVAX_MAINNET */]: "0xA257F3FE4E4032291516DC355eDF90664e9eB932",
  [137 /* MATIC_MAINNET */]: "0x9d74807B8fA79d49bb95CF988Af3c25Fb1437B4f",
  [5e3 /* MANTLE_MAINNET */]: "0x7B4E28E7273aA8CB64C56fF191ebF43b64f409F9",
  [59144 /* LINEA_MAINNET */]: "0x0f91052dc5B4baE53d0FeA5DAe561A117268f5d2",
  [1101 /* POLYGON_ZK */]: "0xB79A4F5828eb55c10D7abF4bFe9a9f5d11aA84e0",
  [8453 /* BASE_MAINNET */]: "0xF951789c6A356BfbC3033648AA10b5Dd3e9d88C0",
  [42161 /* ARBITRUM_MAINNET */]: "0x4FDA0599b78a49d289577a8DF2046459abC04d82",
  [42170 /* ARBITRUM_NOVA */]: "0x7B4E28E7273aA8CB64C56fF191ebF43b64f409F9",
  [10 /* OPTIMISM_MAINNET */]: "0x7775b274f0C3fA919B756b22A4d9674e55927ab8",
  [40 /* TELOS_MAINNET */]: "0xf02bBC9de6e443eFDf3FC41851529C2c3B9E5e0C",
  [324 /* ZKSYNC_MAINNET */]: "0x56C343E7cE75e53e58Ed2f3743C6f137c13D2013",
  [288 /* BOBA_MAINNET */]: "0xB79A4F5828eb55c10D7abF4bFe9a9f5d11aA84e0",
  [2222 /* KAVA_MAINNET */]: "0xca506793A420E901BbCa8066be5661E3C52c84c2",
  [56288 /* BOBA_BNB */]: "0x7e0B73141c8a1AC26B8693e9F34cf42BE17Fea2C",
  [728126428 /* TRON_MAINNET */]: "0x5112ac3d77551b9f670eb34ef75984246164e38d",
  [534352 /* SCROLL_MAINNET */]: "0xf02bBC9de6e443eFDf3FC41851529C2c3B9E5e0C",
  [169 /* MANTA_MAINNET */]: "0xf85FC807D05d3Ab2309364226970aAc57b4e1ea4",
  [1088 /* METIS_MAINNET */]: "0x81aB74A9f9d7457fF47dfD102e78A340cF72EC39",
  [5165 /* BAHAMUT_MAINNET */]: "0x70A16EB2B39A5573A8138b18582111bBA480fb8F",
  [34443 /* MODE_MAINNET */]: "0xd8db4fb1fEf63045A443202d506Bcf30ef404160",
  [30 /* RSK_MAINNET */]: "0x2b7aa8bdc40b6d3d19d0de7480c4db8d5b6495e2",
  [81457 /* BLAST_MAINNET */]: "0xf1C374D065719Ce1Fdc63E2c5C13146813c0A83b",
  [4200 /* MERLIN_MAINNET */]: "0x1a039cE63AE35a67Bf0E9F6DbFaE969639D59eC8",
  [810180 /* ZKLINK_MAINNET */]: "0x9C64162e1614E10f833aFc2a0BdF173324f36Dd5",
  [1116 /* CORE_MAINNET */]: "0x2b7Aa8bDc40B6d3d19d0dE7480c4db8d5B6495e2",
  [167e3 /* TAIKO_MAINNET */]: "0x2b7Aa8bDc40B6d3d19d0dE7480c4db8d5B6495e2",
  [1329 /* SEI_EVM_MAINNET */]: "0x2b7Aa8bDc40B6d3d19d0dE7480c4db8d5B6495e2",
  [7e3 /* ZETACHAIN_MAINNET */]: "0x6148FD6C649866596C3d8a971fC313E5eCE84882",
  [25 /* CRONOS_MAINNET */]: "0x1a039cE63AE35a67Bf0E9F6DbFaE969639D59eC8",
  [252 /* FRAXTAL_MAINNET */]: "0x2b7Aa8bDc40B6d3d19d0dE7480c4db8d5B6495e2",
  [1625 /* GRAVITY_MAINNET */]: "0x6AEb9b27590387b8Fd0560C52f6B968C59C10Fab",
  [223 /* BSQUARED_MAINNET */]: "0x2b7Aa8bDc40B6d3d19d0dE7480c4db8d5B6495e2"
};
function isFeeCollectorSwapSupported(params) {
  const inChainId = params.tokenAmountIn.token.chainId;
  const outChainId = params.tokenOut.chainId;
  return inChainId === outChainId && FEE_COLLECTOR_ADDRESSES[inChainId] !== void 0;
}
async function feeCollectorSwap(params) {
  const { symbiosis } = params;
  const inChainId = params.tokenAmountIn.token.chainId;
  const feeCollectorAddress = FEE_COLLECTOR_ADDRESSES[inChainId];
  if (!feeCollectorAddress) {
    throw new Error2(`Fee collector not found for chain ${inChainId}`);
  }
  const provider = symbiosis.getProvider(inChainId);
  const contract = FeeCollector__factory.connect(feeCollectorAddress, provider);
  const [fee, approveAddress] = await Promise.all([contract.callStatic.fee(), contract.callStatic.onchainGateway()]);
  const feeToken = GAS_TOKEN[inChainId];
  const feeTokenAmount = new TokenAmount(feeToken, fee.toString());
  let inTokenAmount = params.tokenAmountIn;
  if (inTokenAmount.token.equals(feeToken)) {
    if (inTokenAmount.lessThan(feeTokenAmount) || inTokenAmount.equalTo(feeTokenAmount)) {
      throw new Error2(
        `Amount is too low. Min amount: ${feeTokenAmount.toSignificant()}`,
        2 /* AMOUNT_LESS_THAN_FEE */
      );
    }
    inTokenAmount = inTokenAmount.subtract(feeTokenAmount);
  }
  const result = await onchainSwap({ ...params, tokenAmountIn: inTokenAmount, from: feeCollectorAddress });
  let value = "";
  let callData = "";
  let routerAddress = "";
  if (result.transactionType === "tron") {
    value = result.transactionRequest.call_value.toString();
    const method = utils39.id(result.transactionRequest.function_selector).slice(0, 10);
    callData = method + result.transactionRequest.raw_parameter;
    routerAddress = tronAddressToEvm(result.transactionRequest.contract_address);
  } else if (result.transactionType === "evm") {
    value = result.transactionRequest.value?.toString();
    callData = result.transactionRequest.data;
    routerAddress = result.transactionRequest.to;
  }
  if (inTokenAmount.token.isNative) {
    value = BigNumber11.from(value).add(fee).toString();
  } else {
    value = fee.toString();
  }
  callData = contract.interface.encodeFunctionData("onswap", [
    inTokenAmount.token.isNative ? AddressZero10 : inTokenAmount.token.address,
    inTokenAmount.raw.toString(),
    routerAddress,
    inTokenAmount.token.isNative ? AddressZero10 : result.approveTo,
    callData
  ]);
  const functionSelector = getFunctionSelector(contract.interface.getFunction("onswap"));
  const payload = preparePayload({
    functionSelector,
    chainId: inChainId,
    from: params.from,
    to: feeCollectorAddress,
    value,
    callData
  });
  return {
    ...result,
    ...payload,
    approveTo: approveAddress,
    fees: [
      {
        provider: "symbiosis",
        value: feeTokenAmount,
        description: "Symbiosis on-chain fee"
      },
      ...result.fees
    ]
  };
}

// src/crosschain/swapExactIn/unwrap.ts
import { AddressZero as AddressZero11 } from "@ethersproject/constants/lib/addresses";
function isUnwrapSupported(params) {
  const { tokenAmountIn, tokenOut, from, to } = params;
  if (from.toLowerCase() !== to.toLowerCase()) {
    return false;
  }
  const chainIdIn = tokenAmountIn.token.chainId;
  const chainIdOut = tokenOut.chainId;
  const weth = WETH[chainIdIn];
  return chainIdIn === chainIdOut && tokenOut.isNative && weth && weth.equals(tokenAmountIn.token);
}
async function unwrap(params) {
  const { tokenAmountIn, tokenOut, from } = params;
  const wethInterface = Weth__factory.createInterface();
  const amountOut = new TokenAmount(tokenOut, tokenAmountIn.raw);
  const callData = wethInterface.encodeFunctionData("withdraw", [tokenAmountIn.raw.toString()]);
  const functionSelector = getFunctionSelector(wethInterface.getFunction("withdraw"));
  const payload = preparePayload({
    functionSelector,
    chainId: tokenAmountIn.token.chainId,
    from,
    to: tokenAmountIn.token.address,
    callData
  });
  let approveTo = AddressZero11;
  if (payload.transactionType === "tron") {
    approveTo = payload.transactionRequest.contract_address;
  } else if (payload.transactionType === "evm") {
    approveTo = payload.transactionRequest.to;
  }
  return {
    ...payload,
    kind: "unwrap",
    tokenAmountOut: amountOut,
    tokenAmountOutMin: amountOut,
    priceImpact: new Percent("0", "0"),
    approveTo,
    fees: [],
    routes: [
      {
        provider: "wrap",
        tokens: [params.tokenAmountIn.token, params.tokenOut]
      }
    ]
  };
}

// src/crosschain/swapExactIn/wrap.ts
import { AddressZero as AddressZero12 } from "@ethersproject/constants/lib/addresses";
function isWrapSupported(params) {
  const { tokenAmountIn, tokenOut, from, to } = params;
  if (from.toLowerCase() !== to.toLowerCase()) {
    return false;
  }
  const chainIdIn = tokenAmountIn.token.chainId;
  const chainIdOut = tokenOut.chainId;
  const weth = WETH[chainIdIn];
  return chainIdIn === chainIdOut && tokenAmountIn.token.isNative && weth && weth.equals(tokenOut);
}
async function wrap(params) {
  const { tokenAmountIn } = params;
  const { chainId } = tokenAmountIn.token;
  const weth = WETH[chainId];
  if (!weth) {
    throw new Error(`Wrap token not found for chain ${chainId}`);
  }
  const wethInterface = Weth__factory.createInterface();
  const amountOut = new TokenAmount(weth, tokenAmountIn.raw);
  const callData = wethInterface.encodeFunctionData("deposit");
  const functionSelector = getFunctionSelector(wethInterface.getFunction("deposit"));
  const payload = preparePayload({
    functionSelector,
    chainId,
    from: params.from,
    to: weth.address,
    value: tokenAmountIn.raw.toString(),
    callData
  });
  let approveTo = AddressZero12;
  if (payload.transactionType === "tron") {
    approveTo = payload.transactionRequest.contract_address;
  } else if (payload.transactionType === "evm") {
    approveTo = payload.transactionRequest.to;
  }
  return {
    ...payload,
    kind: "wrap",
    tokenAmountOut: amountOut,
    tokenAmountOutMin: amountOut,
    priceImpact: new Percent("0", "0"),
    approveTo,
    fees: [],
    routes: [
      {
        provider: "wrap",
        tokens: [tokenAmountIn.token, weth]
      }
    ]
  };
}

// src/crosschain/swappingToTon.ts
import { Address as Address6 } from "@ton/core";
import { AddressZero as AddressZero13 } from "@ethersproject/constants";
var SwappingToTon = class extends BaseSwapping {
  async exactIn(params) {
    this.userAddress = params.to;
    return this.doExactIn({
      ...params,
      to: params.from
    });
  }
  // TODO: remove when advisor is ready
  async getFeeV2() {
    return tonAdvisorMock(this.transitTokenOut);
  }
  metaBurnSyntheticToken(fee) {
    if (!this.tokenAmountIn || !this.tokenOut) {
      throw new Error("Tokens are not set");
    }
    const synthesis = this.symbiosis.synthesis(this.tokenAmountIn.token.chainId);
    const amount = this.transit.getBridgeAmountIn();
    const { workChain, hash } = Address6.parse(this.userAddress);
    const tonAddress = {
      workchain: workChain,
      address_hash: `0x${hash.toString("hex")}`
    };
    return [
      synthesis.address,
      synthesis.interface.encodeFunctionData("burnSyntheticTokenTON", [
        fee.raw.toString(),
        amount.token.address,
        amount.raw.toString(),
        CROSS_CHAIN_ID,
        tonAddress,
        AddressZero13,
        // any arbtitary data, this addresses passed from relayer
        AddressZero13,
        // any arbtitary data, this addresses passed from relayer
        this.from,
        this.tokenOut.chainId,
        this.symbiosis.clientId
      ])
    ];
  }
  finalOffsetV2() {
    return 100;
  }
  finalCalldataV2(feeV2) {
    const { workChain, hash } = Address6.parse(this.userAddress);
    const tonAddress = {
      workchain: workChain,
      address_hash: `0x${hash.toString("hex")}`
    };
    return this.synthesisV2.interface.encodeFunctionData("burnSyntheticTokenTON", [
      feeV2 ? feeV2?.raw.toString() : "0",
      // uint256 stableBridgingFee;
      this.transit.amountOut.token.address,
      this.transit.amountOut.raw.toString(),
      CROSS_CHAIN_ID,
      tonAddress,
      AddressZero13,
      AddressZero13,
      this.from,
      this.tokenOut.chainId,
      this.symbiosis.clientId
    ]);
  }
};

// src/crosschain/swapExactIn/toTonSwap.ts
function symbiosisBridgeToTon(context) {
  const { symbiosis, tokenAmountIn, tokenOut } = context;
  const promises = [];
  symbiosis.config.omniPools.forEach((poolConfig) => {
    const combinations = symbiosis.getTransitCombinations(tokenAmountIn.token.chainId, tokenOut.chainId, poolConfig);
    const poolPromises = combinations.map(({ transitTokenIn, transitTokenOut }) => {
      const swappingToTon = new SwappingToTon(symbiosis, poolConfig);
      return swappingToTon.exactIn({ ...context, transitTokenIn, transitTokenOut });
    });
    promises.push(...poolPromises);
  });
  return promises;
}
async function toTonSwap(context) {
  const promises = [];
  promises.push(...symbiosisBridgeToTon(context));
  return theBestOutput(promises);
}

// src/crosschain/zappingThor.ts
import fetch2 from "isomorphic-unfetch";
import { BigNumber as BigNumber12 } from "ethers";
import { AddressType, getAddressInfo, validate } from "bitcoin-address-validation";
var BTC = GAS_TOKEN[3652501241 /* BTC_MAINNET */];
var thorApiUrl = "https://thornode.ninerealms.com";
function toThorToken(token) {
  const chain = toThorChain(token.chainId);
  return `${chain}.${token.symbol}-${token.address.toUpperCase()}`;
}
function toThorChain(chainId) {
  let chain;
  if (chainId === 43114 /* AVAX_MAINNET */) {
    chain = "AVAX";
  } else if (chainId === 1 /* ETH_MAINNET */) {
    chain = "ETH";
  } else if (chainId === 56 /* BSC_MAINNET */) {
    chain = "BSC";
  } else {
    throw new Error2("toThorChain: unknown chain");
  }
  return chain;
}
function toThorAmount(tokenAmount) {
  const tokenDecimals = BigNumber12.from(10).pow(tokenAmount.token.decimals);
  const thorDecimals = BigNumber12.from(10).pow(8);
  return BigNumber12.from(tokenAmount.raw.toString()).mul(thorDecimals).div(tokenDecimals);
}
var MIN_AMOUNT_IN = 100;
var ZappingThor = class _ZappingThor extends BaseSwapping {
  constructor() {
    super(...arguments);
    this.thorTokenOut = "BTC.BTC";
  }
  async doPostTransitAction() {
    const amountIn = parseFloat(this.transit.amountIn.toSignificant());
    if (amountIn < MIN_AMOUNT_IN) {
      throw new Error2(
        `The min swap amount towards Bitcoin is $${MIN_AMOUNT_IN}`,
        4 /* MIN_THORCHAIN_AMOUNT_IN */
      );
    }
    const amount = this.getTradeCAmountIn();
    this.thorQuote = await this.getThorQuote(amount);
  }
  async exactIn({
    tokenAmountIn,
    thorTokenIn,
    from,
    to,
    slippage,
    deadline
  }) {
    const isAddressValid = validate(to);
    if (!isAddressValid) {
      throw new Error2("Bitcoin address is not valid");
    }
    const addressInfo = getAddressInfo(to);
    if (addressInfo.type === AddressType.p2tr) {
      throw new Error2(`ThorChain doesn't support taproot addresses`, 9 /* THORCHAIN_NOT_SUPPORTED_ADDRESS */);
    }
    this.bitcoinAddress = to;
    this.thorTokenIn = thorTokenIn;
    await _ZappingThor.getThorPools(thorTokenIn);
    this.multicallRouter = this.symbiosis.multicallRouter(thorTokenIn.chainId);
    this.thorVault = await _ZappingThor.getThorVault(thorTokenIn);
    const result = await this.doExactIn({
      tokenAmountIn,
      tokenOut: thorTokenIn,
      from,
      to: from,
      slippage,
      deadline
    });
    return {
      ...result,
      tokenAmountOut: this.thorQuote.amountOut,
      tokenAmountOutMin: this.thorQuote.amountOutMin,
      routes: [
        ...result.routes,
        {
          provider: "thorchain-bridge",
          tokens: [thorTokenIn, BTC]
        }
      ],
      fees: [
        ...result.fees,
        {
          provider: "thorchain-bridge",
          description: "THORChain fee",
          value: new TokenAmount(BTC, this.thorQuote.fees.total)
        }
      ]
    };
  }
  static async getThorPools(token) {
    const url = new URL("/thorchain/pools", thorApiUrl);
    const response = await fetch2(url.toString(), {
      headers: {
        "x-client-id": "symbiosis"
      }
    });
    const json = await response.json();
    const found = json.find((i) => {
      return i.asset === toThorToken(token);
    });
    if (!found) {
      throw new Error2("Thor pool not found");
    }
    if (found.status !== "Available") {
      throw new Error2("Thor pool is not available");
    }
    return found;
  }
  static async getThorVault(token) {
    const url = new URL("/thorchain/inbound_addresses", thorApiUrl);
    const response = await fetch2(url.toString(), {
      headers: {
        "x-client-id": "symbiosis"
      }
    });
    const json = await response.json();
    if (json.error) {
      throw new Error2(json.error);
    }
    const found = json.find((i) => {
      return i.chain === toThorChain(token.chainId);
    });
    if (!found) {
      throw new Error2("Thor vault not found");
    }
    return found.address;
  }
  async getThorQuote(amount) {
    const url = new URL("/thorchain/quote/swap", thorApiUrl);
    url.searchParams.set("from_asset", toThorToken(this.thorTokenIn));
    url.searchParams.set("to_asset", this.thorTokenOut);
    url.searchParams.set("refund_address", this.from);
    url.searchParams.set("amount", toThorAmount(amount).toString());
    url.searchParams.set("destination", this.bitcoinAddress);
    url.searchParams.set("streaming_interval", "1");
    url.searchParams.set("streaming_quantity", "0");
    url.searchParams.set("affiliate", "sy");
    url.searchParams.set("affiliate_bps", "20");
    const response = await fetch2(url.toString(), {
      headers: {
        "x-client-id": "symbiosis"
      }
    });
    const json = await response.json();
    if (json.error) {
      throw new Error2(json.error);
    }
    const { memo, expected_amount_out: expectedAmountOut, router, expiry, fees } = json;
    const defaultSlippage = 300;
    const expectedAmountOutWithSlippage = getMinAmount(defaultSlippage, expectedAmountOut);
    const patchedMemo = memo.replace("0/1/0", `${expectedAmountOutWithSlippage.toString()}/1/0`);
    return {
      memo: patchedMemo,
      amountOut: new TokenAmount(BTC, expectedAmountOut),
      amountOutMin: new TokenAmount(BTC, expectedAmountOutWithSlippage),
      router,
      expiry,
      fees
    };
  }
  tradeCTo() {
    return this.multicallRouter.address;
  }
  finalReceiveSide() {
    return this.multicallRouter.address;
  }
  finalCalldata() {
    return this.buildMulticall();
  }
  finalOffset() {
    return 36;
  }
  buildMulticall() {
    const callDatas = [];
    const receiveSides = [];
    const path = [];
    const offsets = [];
    const amount = this.getTradeCAmountIn();
    if (this.tradeC) {
      callDatas.push(this.tradeC.callData);
      receiveSides.push(this.tradeC.routerAddress);
      path.push(this.tradeC.tokenAmountIn.token.address);
      offsets.push(this.tradeC.callDataOffset);
    }
    const expiry = Math.floor(Date.now() / 1e3) + 60 * 60;
    const burnCalldata = ThorRouter__factory.createInterface().encodeFunctionData("depositWithExpiry", [
      this.thorVault,
      this.thorTokenIn.address,
      "0",
      // will be patched
      this.thorQuote.memo,
      expiry
    ]);
    callDatas.push(burnCalldata);
    receiveSides.push(this.thorQuote.router);
    path.push(this.thorTokenIn.address);
    offsets.push(100);
    return this.multicallRouter.interface.encodeFunctionData("multicall", [
      amount.raw.toString(),
      callDatas,
      receiveSides,
      path,
      offsets,
      this.from
    ]);
  }
};

// src/crosschain/swapExactIn/thorChainSwap.ts
var ETH_USDC = new Token({
  address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
  chainId: 1 /* ETH_MAINNET */,
  decimals: 6,
  name: "USDC",
  symbol: "USDC",
  icons: {
    large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
    small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
  }
});
var AVAX_USDC = new Token({
  address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
  chainId: 43114 /* AVAX_MAINNET */,
  decimals: 6,
  name: "USDC",
  symbol: "USDC",
  icons: {
    large: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png",
    small: "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
  }
});
var THOR_TOKENS = [ETH_USDC, AVAX_USDC];
async function thorChainSwap(context) {
  const { tokenAmountIn, from, to, symbiosis, slippage, deadline } = context;
  const poolConfig = symbiosis.config.omniPools[0];
  const promises = THOR_TOKENS.map((thorToken) => {
    const zappingThor = new ZappingThor(symbiosis, poolConfig);
    return zappingThor.exactIn({
      tokenAmountIn,
      thorTokenIn: thorToken,
      from,
      to,
      slippage,
      deadline
    });
  });
  return theBestOutput(promises);
}

// src/crosschain/swapExactIn/toBtc/unwrapBtc.ts
import { initEccLib as initEccLib2 } from "bitcoinjs-lib";
import ecc2 from "@bitcoinerlab/secp256k1";

// src/crosschain/zappingBtc.ts
import { networks, address, initEccLib } from "bitcoinjs-lib";
import ecc from "@bitcoinerlab/secp256k1";
initEccLib(ecc);
var BTC_NETWORKS = {
  [3652501241 /* BTC_MAINNET */]: networks.bitcoin,
  [2782866891 /* BTC_MUTINY */]: networks.testnet,
  [675223068 /* BTC_TESTNET4 */]: networks.testnet
};
function getPkScript(addr, btcChain) {
  return address.toOutputScript(addr, btcChain);
}
var ZappingBtc = class extends BaseSwapping {
  async doPostTransitAction() {
  }
  async exactIn({
    tokenAmountIn,
    syBtc,
    from,
    to,
    slippage,
    deadline,
    transitTokenIn,
    transitTokenOut
  }) {
    if (!syBtc.chainFromId) {
      throw new Error("sBtc is not synthetic");
    }
    const network = BTC_NETWORKS[syBtc.chainFromId];
    if (!network) {
      throw new Error("Unknown BTC network");
    }
    const btc = GAS_TOKEN[syBtc.chainFromId];
    this.bitcoinAddress = getPkScript(to, network);
    this.sBtc = syBtc;
    this.multicallRouter = this.symbiosis.multicallRouter(syBtc.chainId);
    this.synthesis = this.symbiosis.synthesis(syBtc.chainId);
    this.minBtcFee = await getToBtcFee(syBtc, this.synthesis, this.symbiosis.dataProvider);
    const result = await this.doExactIn({
      tokenAmountIn,
      tokenOut: syBtc,
      from,
      to: from,
      slippage,
      deadline,
      transitTokenIn,
      transitTokenOut
    });
    const tokenAmountOut = new TokenAmount(btc, result.tokenAmountOut.subtract(this.minBtcFee).raw);
    const tokenAmountOutMin = new TokenAmount(btc, result.tokenAmountOutMin.subtract(this.minBtcFee).raw);
    return {
      ...result,
      tokenAmountOut,
      tokenAmountOutMin,
      fees: [
        ...result.fees,
        {
          provider: "symbiosis",
          description: "BTC fee",
          value: this.minBtcFee
        }
      ],
      routes: [
        ...result.routes,
        {
          provider: "symbiosis",
          tokens: [syBtc, btc]
        }
      ]
    };
  }
  tradeCTo() {
    return this.multicallRouter.address;
  }
  finalReceiveSide() {
    return this.multicallRouter.address;
  }
  finalCalldata() {
    return this.buildMulticall();
  }
  finalOffset() {
    return 36;
  }
  buildMulticall() {
    const callDatas = [];
    const receiveSides = [];
    const path = [];
    const offsets = [];
    const amount = this.getTradeCAmountIn();
    if (this.tradeC) {
      callDatas.push(this.tradeC.callData);
      receiveSides.push(this.tradeC.routerAddress);
      path.push(this.tradeC.tokenAmountIn.token.address);
      offsets.push(this.tradeC.callDataOffset);
    }
    const burnCalldata = this.synthesis.interface.encodeFunctionData("burnSyntheticTokenBTC", [
      this.minBtcFee.raw.toString(),
      // _stableBridgingFee must be >= minBtcFee
      "0",
      // _amount will be patched
      this.bitcoinAddress,
      // _to
      this.sBtc.address,
      // _stoken
      this.symbiosis.clientId
      // _clientID
    ]);
    callDatas.push(burnCalldata);
    receiveSides.push(this.synthesis.address);
    path.push(this.sBtc.address);
    offsets.push(68);
    return this.multicallRouter.interface.encodeFunctionData("multicall", [
      amount.raw.toString(),
      callDatas,
      receiveSides,
      path,
      offsets,
      this.from
    ]);
  }
};

// src/crosschain/swapExactIn/toBtc/unwrapBtc.ts
initEccLib2(ecc2);
async function unwrapBtc({ symbiosis, tokenAmountIn, to }) {
  let syBtc = tokenAmountIn.token;
  if (!syBtc.chainFromId) {
    const found = symbiosis.tokens().find((token) => {
      return token.equals(syBtc) && token.isSynthetic;
    });
    if (found) {
      syBtc = found;
    }
  }
  if (!syBtc.chainFromId) {
    throw new Error("syBtc is not synthetic");
  }
  const network = BTC_NETWORKS[syBtc.chainFromId];
  if (!network) {
    throw new Error("Unknown BTC network");
  }
  const btc = GAS_TOKEN[syBtc.chainFromId];
  const bitcoinAddress = getPkScript(to, network);
  const synthesis = symbiosis.synthesis(syBtc.chainId);
  const minBtcFee = await getToBtcFee(syBtc, synthesis, symbiosis.dataProvider);
  const data = synthesis.interface.encodeFunctionData("burnSyntheticTokenBTC", [
    minBtcFee.raw.toString(),
    // _stableBridgingFee must be >= minBtcFee
    tokenAmountIn.raw.toString(),
    bitcoinAddress,
    // _to
    syBtc.address,
    // _stoken
    symbiosis.clientId
    // _clientID
  ]);
  const tokenAmountOut = new TokenAmount(btc, tokenAmountIn.subtract(minBtcFee).raw);
  const payload = {
    transactionType: "evm",
    transactionRequest: {
      chainId: syBtc.chainId,
      to: synthesis.address,
      data
    }
  };
  return {
    ...payload,
    tokenAmountOut,
    tokenAmountOutMin: tokenAmountOut,
    priceImpact: new Percent("0", "0"),
    amountInUsd: tokenAmountIn,
    approveTo: synthesis.address,
    routes: [
      {
        provider: "symbiosis",
        tokens: [syBtc, btc]
      }
    ],
    fees: [
      {
        provider: "symbiosis",
        value: minBtcFee,
        description: "Unwrap BTC fee"
      }
    ],
    kind: "crosschain-swap"
  };
}

// src/crosschain/swapExactIn/toBtc/zappingBtcOnChain.ts
import { BigNumber as BigNumber13, utils as utils40 } from "ethers";
import { AddressZero as AddressZero14 } from "@ethersproject/constants/lib/addresses";
async function zappingBtcOnChain(params) {
  const { symbiosis, tokenOut, to, from } = params;
  const network = BTC_NETWORKS[tokenOut.chainId];
  if (!network) {
    throw new Error2(`Unknown BTC network ${tokenOut.chainId}`);
  }
  const bitcoinAddress = getPkScript(to, network);
  const chainId = params.tokenAmountIn.token.chainId;
  const syBTC = symbiosis.getRepresentation(params.tokenOut, chainId);
  if (!syBTC) {
    throw new Error2(`No syBTC found on chain ${chainId}`);
  }
  if (!syBTC.chainFromId) {
    throw new Error2("syBTC is not synthetic");
  }
  const feeCollectorAddress = ZERO_FEE_COLLECTOR_ADDRESSES[chainId];
  if (!feeCollectorAddress) {
    throw new Error2(`Fee collector not found for chain ${chainId}`);
  }
  const multicallRouterAddress = MULTICALL_ROUTER_V2[chainId];
  if (!multicallRouterAddress) {
    throw new Error2(`MulticallRouterV2 not found for chain ${chainId}`);
  }
  const provider = symbiosis.getProvider(chainId);
  const multicallRouter = MulticallRouterV2__factory.connect(multicallRouterAddress, provider);
  const feeCollector = FeeCollector__factory.connect(feeCollectorAddress, provider);
  const [fee, approveAddress] = await symbiosis.dataProvider.get(
    ["feeCollector.fee", "feeCollector.onchainGateway"],
    () => {
      return Promise.all([feeCollector.callStatic.fee(), feeCollector.callStatic.onchainGateway()]);
    },
    60 * 60
    // 1 hour
  );
  let inTokenAmount = params.tokenAmountIn;
  if (inTokenAmount.token.isNative) {
    const feeTokenAmount = new TokenAmount(inTokenAmount.token, fee.toString());
    if (inTokenAmount.lessThan(feeTokenAmount) || inTokenAmount.equalTo(feeTokenAmount)) {
      throw new Error2(
        `Amount is too low. Min amount: ${feeTokenAmount.toSignificant()}`,
        2 /* AMOUNT_LESS_THAN_FEE */
      );
    }
    inTokenAmount = inTokenAmount.subtract(feeTokenAmount);
  }
  const swapCall = await getSwapCall({
    ...params,
    tokenOut: syBTC,
    from: multicallRouterAddress,
    to: multicallRouterAddress
  });
  let value = fee.toString();
  if (swapCall.amountIn.token.isNative) {
    value = BigNumber13.from(swapCall.value).add(fee).toString();
  }
  const burnCall = await getBurnCall({
    symbiosis,
    amountIn: new TokenAmount(syBTC, swapCall.amountOut.raw),
    tokenOut,
    bitcoinAddress
  });
  const multicallCalldata = multicallRouter.interface.encodeFunctionData("multicall", [
    inTokenAmount.raw.toString(),
    [swapCall.data, burnCall.data],
    [swapCall.to, burnCall.to],
    [
      swapCall.amountIn.token.isNative ? AddressZero14 : swapCall.amountIn.token.address,
      burnCall.amountIn.token.address
    ],
    [swapCall.offset, burnCall.offset],
    [swapCall.amountIn.token.isNative, burnCall.amountIn.token.isNative],
    from
  ]);
  const data = feeCollector.interface.encodeFunctionData("onswap", [
    inTokenAmount.token.isNative ? AddressZero14 : inTokenAmount.token.address,
    inTokenAmount.raw.toString(),
    multicallRouter.address,
    multicallRouter.address,
    // inTokenAmount.token.isNative ? AddressZero : result.approveTo,
    multicallCalldata
  ]);
  const tokenAmountOut = burnCall.amountOut;
  return {
    tokenAmountOut,
    tokenAmountOutMin: tokenAmountOut,
    priceImpact: swapCall.priceImpact,
    amountInUsd: swapCall.amountInUsd,
    approveTo: approveAddress,
    routes: [...swapCall.routes, ...burnCall.routes],
    fees: [...swapCall.fees, ...burnCall.fees],
    kind: "crosschain-swap",
    transactionType: "evm",
    transactionRequest: {
      chainId,
      to: feeCollectorAddress,
      data,
      value
    }
  };
}
async function getSwapCall(params) {
  const result = await onchainSwap(params);
  let value;
  let data;
  let routerAddress;
  if (result.transactionType === "tron") {
    value = result.transactionRequest.call_value.toString();
    const method = utils40.id(result.transactionRequest.function_selector).slice(0, 10);
    data = method + result.transactionRequest.raw_parameter;
    routerAddress = tronAddressToEvm(result.transactionRequest.contract_address);
  } else if (result.transactionType === "evm") {
    value = result.transactionRequest.value?.toString();
    data = result.transactionRequest.data;
    routerAddress = result.transactionRequest.to;
  } else {
    value = "";
    data = "";
    routerAddress = "";
  }
  return {
    ...result,
    priceImpact: result.priceImpact || new Percent("0", "0"),
    amountInUsd: result.amountInUsd || params.tokenAmountIn,
    // Call type params
    amountIn: params.tokenAmountIn,
    amountOut: result.tokenAmountOut,
    to: routerAddress,
    data,
    value,
    offset: 0
  };
}
async function getBurnCall({
  symbiosis,
  amountIn,
  tokenOut,
  bitcoinAddress
}) {
  const synthesis = symbiosis.synthesis(amountIn.token.chainId);
  const fee = await getToBtcFee(amountIn.token, synthesis, symbiosis.dataProvider);
  const data = synthesis.interface.encodeFunctionData("burnSyntheticTokenBTC", [
    fee.raw.toString(),
    // _stableBridgingFee must be >= minBtcFee
    "0",
    // _amount will be patched
    bitcoinAddress,
    // _to
    amountIn.token.address,
    // _stoken
    symbiosis.clientId
    // _clientID
  ]);
  return {
    amountIn,
    amountOut: new TokenAmount(tokenOut, amountIn.subtract(fee).raw),
    to: synthesis.address,
    data,
    value: "0",
    offset: 68,
    fees: [
      {
        provider: "symbiosis",
        description: "Burn fee",
        value: fee
      }
    ],
    routes: [
      {
        provider: "symbiosis",
        tokens: [amountIn.token, tokenOut]
      }
    ]
  };
}

// src/crosschain/swapExactIn/toBtc/burnSyntheticBtc.ts
async function burnSyntheticBtc(context) {
  const { tokenAmountIn, tokenOut, symbiosis, to } = context;
  const promises = [];
  symbiosis.config.chains.forEach((chain) => {
    const syBtc = symbiosis.getRepresentation(tokenOut, chain.id);
    if (!syBtc) {
      return;
    }
    if (tokenAmountIn.token.equals(syBtc)) {
      promises.push(unwrapBtc(context));
      return;
    }
    if (tokenAmountIn.token.chainId === syBtc.chainId) {
      promises.push(zappingBtcOnChain(context));
      return;
    }
    symbiosis.config.omniPools.filter((poolConfig) => poolConfig.generalPurpose).forEach((poolConfig) => {
      const combinations = symbiosis.getTransitCombinations(
        tokenAmountIn.token.chainId,
        syBtc.chainId,
        poolConfig
      );
      combinations.forEach(({ transitTokenIn, transitTokenOut }) => {
        const zappingBtc = new ZappingBtc(symbiosis, poolConfig);
        const { from, slippage, deadline } = context;
        const promise = zappingBtc.exactIn({
          tokenAmountIn,
          syBtc,
          from,
          to,
          slippage,
          deadline,
          transitTokenIn,
          transitTokenOut
        });
        promises.push(promise);
      });
    });
  });
  return theBestOutput(promises);
}

// src/crosschain/swapExactIn/toBtcSwap.ts
function isThorChainAvailable(chainId) {
  return chainId === 3652501241 /* BTC_MAINNET */;
}
function isNativeAvailable(chainId) {
  return isBtcChainId(chainId);
}
function isToBtcSwapSupported(context) {
  const { tokenOut } = context;
  return isThorChainAvailable(tokenOut.chainId) || isNativeAvailable(tokenOut.chainId);
}
async function toBtcSwap(context) {
  const { tokenOut } = context;
  const promises = [];
  if (isNativeAvailable(tokenOut.chainId)) {
    promises.push(burnSyntheticBtc(context));
  }
  if (isThorChainAvailable(tokenOut.chainId)) {
    promises.push(thorChainSwap(context));
  }
  return theBestOutput(promises);
}

// src/crosschain/swapExactIn/fromBtcSwap.ts
import { AddressZero as AddressZero15 } from "@ethersproject/constants/lib/addresses";
import { isAddress } from "ethers/lib/utils";
import { BigNumber as BigNumber14 } from "ethers";
function isFromBtcSwapSupported(context) {
  const { tokenAmountIn, symbiosis } = context;
  if (!isBtcChainId(tokenAmountIn.token.chainId)) {
    return false;
  }
  symbiosis.validateLimits(tokenAmountIn);
  return true;
}
async function fromBtcSwap(context) {
  const { tokenAmountIn, tokenOut, symbiosis, to } = context;
  const btcChainId = tokenAmountIn.token.chainId;
  const symBtcConfig = symbiosis.symBtcConfigFor(btcChainId);
  const sBtcChainId = symBtcConfig.chainId;
  if (!sBtcChainId) {
    throw new Error2(`Synthetic BTC chainId wasn't found`);
  }
  const sBtc = symbiosis.getRepresentation(tokenAmountIn.token, sBtcChainId);
  if (!sBtc) {
    throw new Error2(`Synthetic BTC wasn't found`);
  }
  if (!isAddress(to)) {
    throw new Error2(`Destination address wasn't provided`);
  }
  const forwarderUrl = symbiosis.getForwarderUrl(btcChainId);
  let sBtcAmount = new TokenAmount(sBtc, tokenAmountIn.raw);
  const btcPortalFeeRaw = await getBtcPortalFee(forwarderUrl, symbiosis.dataProvider);
  const btcPortalFee = new TokenAmount(sBtc, btcPortalFeeRaw);
  sBtcAmount = sBtcAmount.subtract(btcPortalFee);
  const mintFeeRaw = "1000";
  const mintFee = new TokenAmount(sBtc, mintFeeRaw.toString());
  if (sBtcAmount.lessThan(mintFee)) {
    throw new Error2(
      `Amount ${sBtcAmount.toSignificant()} ${sBtcAmount.token.symbol} less than fee ${mintFee.toSignificant()} ${mintFee.token.symbol}`,
      2 /* AMOUNT_LESS_THAN_FEE */
    );
  }
  sBtcAmount = sBtcAmount.subtract(mintFee);
  let tokenAmountOut;
  let tokenAmountOutMin;
  let btcForwarderFee;
  let btcForwarderFeeMax;
  let tail;
  let tailFees = [];
  let priceImpact = new Percent("0", "0");
  let amountInUsd;
  let routes = [];
  if (tokenOut.equals(sBtc)) {
    tail = "";
    btcForwarderFee = new TokenAmount(
      sBtc,
      await estimateWrap({
        forwarderUrl,
        portalFee: btcPortalFeeRaw,
        stableBridgingFee: mintFeeRaw,
        tail,
        to
      })
    );
    if (btcForwarderFee.greaterThan(sBtcAmount)) {
      throw new Error2(
        `Amount ${sBtcAmount.toSignificant()} less than btcForwarderFee ${btcForwarderFee.toSignificant()}`,
        2 /* AMOUNT_LESS_THAN_FEE */
      );
    }
    tokenAmountOut = sBtcAmount.subtract(btcForwarderFee);
    btcForwarderFeeMax = new TokenAmount(
      btcForwarderFee.token,
      BigNumber14.from(btcForwarderFee.raw.toString()).mul(120).div(100).toString()
      // +20% of fee
    );
    tokenAmountOutMin = sBtcAmount.subtract(btcForwarderFeeMax);
  } else {
    const sameChain = tokenOut.chainId === sBtc.chainId;
    const buildTailFunc = sameChain ? buildOnchainTail : buildTail;
    const { tail: initialTail } = await buildTailFunc(context, sBtcAmount);
    btcForwarderFee = new TokenAmount(
      sBtc,
      await estimateWrap({
        forwarderUrl,
        portalFee: btcPortalFeeRaw,
        stableBridgingFee: mintFeeRaw,
        tail: initialTail,
        to
      })
    );
    btcForwarderFeeMax = new TokenAmount(
      btcForwarderFee.token,
      BigNumber14.from(btcForwarderFee.raw.toString()).mul(120).div(100).toString()
      // +20% of fee
    );
    if (btcForwarderFee.greaterThan(sBtcAmount)) {
      throw new Error2(
        `Amount ${sBtcAmount.toSignificant()} less than btcForwarderFee ${btcForwarderFee.toSignificant()}`,
        2 /* AMOUNT_LESS_THAN_FEE */
      );
    }
    const tailResult = await buildTailFunc(context, sBtcAmount.subtract(btcForwarderFee));
    tail = tailResult.tail;
    tailFees = tailResult.fees;
    tokenAmountOut = tailResult.tokenAmountOut;
    tokenAmountOutMin = tailResult.tokenAmountOutMin;
    priceImpact = tailResult.priceImpact;
    amountInUsd = tailResult.amountInUsd;
    routes = tailResult.routes;
  }
  const { validUntil, revealAddress } = await wrap2({
    forwarderUrl,
    portalFee: btcPortalFeeRaw,
    stableBridgingFee: mintFeeRaw,
    tail,
    to,
    feeLimit: btcForwarderFeeMax.raw.toString()
  });
  return {
    kind: "from-btc-swap",
    transactionType: "btc",
    transactionRequest: {
      depositAddress: revealAddress,
      validUntil,
      tokenAmountOut
    },
    tokenAmountOut,
    tokenAmountOutMin,
    priceImpact,
    approveTo: AddressZero15,
    amountInUsd,
    routes: [
      {
        provider: "symbiosis",
        tokens: [tokenAmountIn.token, sBtc]
      },
      ...routes
    ],
    fees: [
      {
        provider: "symbiosis",
        description: "BTC Forwarder fee",
        value: new TokenAmount(tokenAmountIn.token, btcForwarderFee.raw)
      },
      {
        provider: "symbiosis",
        description: "BTC Portal fee",
        value: new TokenAmount(tokenAmountIn.token, btcPortalFee.raw)
      },
      {
        provider: "symbiosis",
        description: "Mint fee",
        value: mintFee
      },
      ...tailFees
    ]
  };
}
async function buildOnchainTail(context, sBtcAmount) {
  const { to, tokenOut, deadline, symbiosis } = context;
  const ttl = deadline - Math.floor(Date.now() / 1e3);
  const aggregatorTrade = new AggregatorTrade({
    ...context,
    from: to,
    // there is not from address, set user's address
    clientId: symbiosis.clientId,
    dataProvider: symbiosis.dataProvider,
    tokenAmountIn: sBtcAmount,
    ttl
  });
  await aggregatorTrade.init();
  const symBtcContract = symbiosis.symBtcFor(sBtcAmount.token.chainFromId);
  const tail = await symBtcContract.callStatic.packBTCTransactionTail({
    receiveSide: aggregatorTrade.routerAddress,
    receiveSideCalldata: aggregatorTrade.callData,
    receiveSideOffset: aggregatorTrade.callDataOffset
  });
  const { amountOut, amountOutMin, callData, priceImpact, routerAddress } = aggregatorTrade;
  const payload = {
    transactionType: "evm",
    transactionRequest: {
      chainId: sBtcAmount.token.chainId,
      from: to,
      // there is not from address, set user's address
      to,
      value: "0",
      data: callData
    }
  };
  return {
    ...payload,
    kind: "onchain-swap",
    tokenAmountOut: amountOut,
    tokenAmountOutMin: amountOutMin,
    priceImpact,
    amountInUsd: sBtcAmount,
    approveTo: routerAddress,
    routes: [
      {
        provider: aggregatorTrade.tradeType,
        tokens: [sBtcAmount.token, tokenOut]
      }
    ],
    fees: [],
    tail
  };
}
async function buildTail(context, sBtcAmount) {
  const { to, symbiosis } = context;
  const poolConfig = symbiosis.config.omniPools[2];
  const swapExactInResult = await bestTokenSwapping(
    {
      ...context,
      tokenAmountIn: sBtcAmount,
      from: to
      // to be able to revert a tx
    },
    poolConfig
  );
  const data = swapExactInResult.transactionRequest.data;
  const result = MetaRouter__factory.createInterface().decodeFunctionData("metaRoute", data);
  const tx = result._metarouteTransaction;
  const symBtcContract = symbiosis.symBtcFor(sBtcAmount.token.chainFromId);
  const tail = await symBtcContract.callStatic.packBTCTransactionTail({
    receiveSide: tx.relayRecipient,
    receiveSideCalldata: tx.otherSideCalldata,
    receiveSideOffset: 100
    // metaSynthesize struct
  });
  return {
    ...swapExactInResult,
    tail
  };
}
async function estimateWrap({
  forwarderUrl,
  portalFee,
  stableBridgingFee,
  tail,
  to
}) {
  const estimateWrapApiUrl = new URL(`${forwarderUrl}/estimate-wrap`);
  const myHeaders = new Headers({
    accept: "application/json",
    "Content-Type": "application/json"
  });
  const raw = JSON.stringify({
    info: {
      portalFee: Number(portalFee),
      op: 0,
      // 0 - wrap operation
      stableBridgingFee: Number(stableBridgingFee),
      tail: encodeTail(tail),
      to
    }
  });
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw
  };
  const response = await fetch(`${estimateWrapApiUrl}`, requestOptions);
  if (!response.ok) {
    const text = await response.text();
    const json = JSON.parse(text);
    throw new Error2(json.message ?? text);
  }
  const { revealTxFee } = await response.json();
  return revealTxFee;
}
async function wrap2({
  forwarderUrl,
  portalFee,
  stableBridgingFee,
  tail,
  to,
  feeLimit
}) {
  const raw = JSON.stringify({
    info: {
      portalFee: Number(portalFee),
      op: 0,
      // 0 - is wrap operation
      stableBridgingFee: Number(stableBridgingFee),
      tail: encodeTail(tail),
      to
    },
    feeLimit: Number(feeLimit)
  });
  const wrapApiUrl = new URL(`${forwarderUrl}/wrap`);
  const myHeaders = new Headers({
    accept: "application/json",
    "Content-Type": "application/json"
  });
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw
  };
  const response = await fetch(`${wrapApiUrl}`, requestOptions);
  if (!response.ok) {
    const text = await response.text();
    const json = JSON.parse(text);
    throw new Error2(json.message ?? text);
  }
  const data = await response.json();
  const { revealAddress, validUntil, legacyAddress } = data;
  return {
    revealAddress,
    validUntil,
    legacyAddress
  };
}
function encodeTail(tail) {
  return Buffer.from(tail.slice(2), "hex").toString("base64");
}
async function getBtcPortalFee(forwarderUrl, dataProvider) {
  let fee = await dataProvider.get(
    ["getMinBtcFee"],
    async () => {
      const portalApiUrl = new URL(`${forwarderUrl}/portal?kind=2`);
      const response = await fetch(portalApiUrl);
      if (!response.ok) {
        const text = await response.text();
        const json = JSON.parse(text);
        throw new Error2(json.message ?? text);
      }
      const {
        state: { minBtcFee }
      } = await response.json();
      return Number(minBtcFee);
    },
    600
    // 10 minutes
  );
  try {
    const fastestFee = await dataProvider.get(["getFastestFee"], getFastestFee, 60);
    const recommendedFee = fastestFee * 200;
    if (recommendedFee > fee) {
      fee = recommendedFee;
    }
  } catch {
  }
  return fee.toString();
}

// src/crosschain/swapExactIn/swapExactIn.ts
async function swapExactIn(params) {
  const { tokenAmountIn, tokenOut } = params;
  if (isTronChainId(tokenAmountIn.token.chainId)) {
    params.from = tronAddressToEvm(params.from);
  }
  if (isTronChainId(tokenOut.chainId)) {
    params.to = tronAddressToEvm(params.to);
  }
  if (tokenAmountIn.token.equals(tokenOut)) {
    throw new Error("Cannot swap same tokens");
  }
  if (isWrapSupported(params)) {
    return wrap(params);
  }
  if (isUnwrapSupported(params)) {
    return unwrap(params);
  }
  if (isFeeCollectorSwapSupported(params)) {
    return feeCollectorSwap(params);
  }
  if (tokenAmountIn.token.chainId === tokenOut.chainId) {
    return onchainSwap(params);
  }
  if (isFromBtcSwapSupported(params)) {
    return fromBtcSwap(params);
  }
  if (isToBtcSwapSupported(params)) {
    return toBtcSwap(params);
  }
  if (isBridgeSupported(params)) {
    return bridge(params);
  }
  if (isTonChainId(tokenOut.chainId)) {
    return toTonSwap(params);
  }
  return crosschainSwap(params);
}

// src/crosschain/symbiosis.ts
import { getHttpEndpoint } from "@orbs-network/ton-access";
import { TonClient } from "@ton/ton";
var defaultFetch = (url, init) => {
  return isomorphicFetch(url, init);
};
var Symbiosis = class {
  setSignature(signature) {
    this.signature = signature;
  }
  async getDiscountTiers() {
    const response = await this.fetch(`${this.config.advisor.url}/v1/swap/discount/tiers`);
    if (!response.ok) {
      const text = await response.text();
      const json = JSON.parse(text);
      throw new Error2(json.message ?? text);
    }
    return await response.json();
  }
  async getDiscountChains() {
    const response = await this.fetch(`${this.config.advisor.url}/v1/swap/discount/chains`);
    if (!response.ok) {
      const text = await response.text();
      const json = JSON.parse(text);
      throw new Error2(json.message ?? text);
    }
    return await response.json();
  }
  async getDiscount(signature) {
    const response = await this.fetch(`${this.config.advisor.url}/v1/swap/discount`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        signature
      })
    });
    if (!response.ok) {
      const text = await response.text();
      const json2 = JSON.parse(text);
      throw new Error2(json2.message ?? text);
    }
    const json = await response.json();
    return json["percent"];
  }
  constructor(configName, clientId, overrideConfig) {
    this.configName = configName;
    if (configName === "mainnet") {
      this.config = config;
    } else if (configName === "testnet") {
      this.config = config2;
    } else if (configName === "dev") {
      this.config = config3;
    } else {
      throw new Error2("Unknown config name");
    }
    this.dataProvider = new DataProvider(this);
    if (overrideConfig?.chains) {
      const { chains: chains2 } = overrideConfig;
      this.config.chains = this.config.chains.map((chainConfig) => {
        const found = chains2.find((i) => i.id === chainConfig.id);
        if (found) {
          chainConfig.rpc = found.rpc;
        }
        return chainConfig;
      });
    }
    if (overrideConfig?.limits) {
      this.config.limits = overrideConfig.limits;
    }
    if (overrideConfig?.advisor) {
      this.config.advisor = overrideConfig.advisor;
    }
    if (overrideConfig?.transitFeeMap) {
      this.config.transitFeeMap = overrideConfig.transitFeeMap;
    }
    this.fetch = overrideConfig?.fetch ?? defaultFetch;
    this.makeOneInchRequest = overrideConfig?.makeOneInchRequest ?? makeOneInchRequestFactory(this.fetch);
    this.configCache = new ConfigCache(configName);
    this.clientId = utils41.formatBytes32String(clientId);
    this.providers = new Map(
      this.config.chains.map((chain) => {
        const rpc = isTronChainId(chain.id) ? `${chain.rpc}/jsonrpc` : chain.rpc;
        return [chain.id, new StaticJsonRpcProvider(rpc, chain.id)];
      })
    );
  }
  async getTonClient() {
    return this.dataProvider.get(
      ["tonClient"],
      async () => {
        const network = this.configName === "mainnet" ? "mainnet" : "testnet";
        const endpoint = await getHttpEndpoint({ network });
        return new TonClient({ endpoint });
      },
      60
      // 1 minute
    );
  }
  chains() {
    const ids = this.config.chains.map((i) => i.id);
    return chains.filter((chain) => ids.includes(chain.id));
  }
  swapExactIn(params) {
    return swapExactIn({ symbiosis: this, ...params });
  }
  newSwapping(omniPoolConfig) {
    return new SwappingMiddleware(this, omniPoolConfig);
  }
  newRevertPending(request) {
    return new RevertPending(this, request);
  }
  newZapping(omniPoolConfig) {
    return new Zapping(this, omniPoolConfig);
  }
  getProvider(chainId, rpc) {
    if (rpc) {
      const url = isTronChainId(chainId) ? `${rpc}/jsonrpc` : rpc;
      return new StaticJsonRpcProvider(url, chainId);
    }
    const provider = this.providers.get(chainId);
    if (!provider) {
      throw new Error2(`No provider for given chainId: ${chainId}`);
    }
    return provider;
  }
  tonBridge(chainId, address2, signer) {
    const signerOrProvider = signer || this.getProvider(chainId);
    return TonBridge__factory.connect(address2, signerOrProvider);
  }
  portal(chainId, signer) {
    const address2 = this.chainConfig(chainId).portal;
    const signerOrProvider = signer || this.getProvider(chainId);
    return Portal__factory.connect(address2, signerOrProvider);
  }
  synthesis(chainId, signer) {
    const address2 = this.chainConfig(chainId).synthesis;
    const signerOrProvider = signer || this.getProvider(chainId);
    return Synthesis__factory.connect(address2, signerOrProvider);
  }
  bridge(chainId, signer) {
    const address2 = this.chainConfig(chainId).bridge;
    const signerOrProvider = signer || this.getProvider(chainId);
    return Bridge__factory.connect(address2, signerOrProvider);
  }
  fabric(chainId, signer) {
    const address2 = this.chainConfig(chainId).fabric;
    const signerOrProvider = signer || this.getProvider(chainId);
    return Fabric__factory.connect(address2, signerOrProvider);
  }
  symBtcConfigFor(btcChainId) {
    if (!isBtcChainId(btcChainId)) {
      throw new Error2(`This chain ${btcChainId} is not BTC chain`);
    }
    const symBtcConfig = this.chainConfig(btcChainId).symBtc;
    if (!symBtcConfig) {
      throw new Error2(`This chain ${btcChainId} doesn't have symBtc contract`);
    }
    return symBtcConfig;
  }
  symBtcFor(btcChainId, signer) {
    const symBtcConfig = this.symBtcConfigFor(btcChainId);
    const signerOrProvider = signer || this.getProvider(symBtcConfig.chainId);
    return SymBtc__factory.connect(symBtcConfig.address, signerOrProvider);
  }
  uniLikeRouter(chainId, signer) {
    const address2 = this.chainConfig(chainId).router;
    const signerOrProvider = signer || this.getProvider(chainId);
    return UniLikeRouter__factory.connect(address2, signerOrProvider);
  }
  avaxRouter(chainId, signer) {
    const address2 = this.chainConfig(chainId).router;
    const signerOrProvider = signer || this.getProvider(chainId);
    return AvaxRouter__factory.connect(address2, signerOrProvider);
  }
  adaRouter(chainId, signer) {
    const address2 = this.chainConfig(chainId).router;
    const signerOrProvider = signer || this.getProvider(chainId);
    return AdaRouter__factory.connect(address2, signerOrProvider);
  }
  kavaRouter(chainId, signer) {
    const address2 = this.chainConfig(chainId).router;
    const signerOrProvider = signer || this.getProvider(chainId);
    return KavaRouter__factory.connect(address2, signerOrProvider);
  }
  kimRouter(chainId, signer) {
    const address2 = this.chainConfig(chainId).router;
    const signerOrProvider = signer || this.getProvider(chainId);
    return KimRouter__factory.connect(address2, signerOrProvider);
  }
  multicallRouter(chainId, signer) {
    const address2 = this.chainConfig(chainId).multicallRouter;
    const signerOrProvider = signer || this.getProvider(chainId);
    return MulticallRouter__factory.connect(address2, signerOrProvider);
  }
  metaRouter(chainId, signer) {
    const address2 = this.chainConfig(chainId).metaRouter;
    const signerOrProvider = signer || this.getProvider(chainId);
    return MetaRouter__factory.connect(address2, signerOrProvider);
  }
  omniPool(config4, signer) {
    const { address: address2, chainId } = config4;
    const signerOrProvider = signer || this.getProvider(chainId);
    return OmniPool__factory.connect(address2, signerOrProvider);
  }
  omniPoolOracle(config4, signer) {
    const { oracle, chainId } = config4;
    const signerOrProvider = signer || this.getProvider(chainId);
    return OmniPoolOracle__factory.connect(oracle, signerOrProvider);
  }
  oneInchOracle(chainId, signer) {
    const address2 = ONE_INCH_ORACLE_MAP[chainId];
    if (!address2) {
      throw new Error2(`Could not find oneInch off-chain oracle on chain ${chainId}`);
    }
    const signerOrProvider = signer || this.getProvider(chainId);
    return OneInchOracle__factory.connect(address2, signerOrProvider);
  }
  getRepresentation(token, chainId) {
    return this.configCache.getRepresentation(token, chainId);
  }
  getOmniPoolTokenIndex(omniPoolConfig, token) {
    return this.configCache.getOmniPoolTokenIndex(omniPoolConfig, token);
  }
  async getBridgeFee({
    calldata,
    receiveSide,
    chainIdFrom,
    chainIdTo
  }) {
    const params = {
      chain_id_from: chainIdFrom,
      chain_id_to: chainIdTo,
      receive_side: receiveSide,
      call_data: calldata,
      client_id: utils41.parseBytes32String(this.clientId),
      signature: this.signature
    };
    const response = await this.fetch(`${this.config.advisor.url}/v1/swap/price`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(params)
    });
    if (!response.ok) {
      const text = await response.text();
      const json = JSON.parse(text);
      throw new Error2(json.message ?? text, 5 /* ADVISOR_ERROR */);
    }
    const { price, save } = await response.json();
    return {
      price: JSBI17.BigInt(price),
      save: JSBI17.BigInt(save)
    };
  }
  filterBlockOffset(chainId) {
    return this.chainConfig(chainId).filterBlockOffset;
  }
  async getFromBlockWithOffset(chainId) {
    const provider = this.getProvider(chainId);
    const blockNumber = await provider.getBlockNumber();
    const offset = this.filterBlockOffset(chainId);
    return Math.max(0, blockNumber - offset);
  }
  dexFee(chainId) {
    return this.chainConfig(chainId).dexFee;
  }
  chainConfig(chainId) {
    const config4 = this.config.chains.find((item) => {
      return item.id === chainId;
    });
    if (!config4)
      throw new Error2(`Could not config by given chainId: ${chainId}`);
    return config4;
  }
  // === stables ===
  tokens() {
    return this.configCache.tokens();
  }
  findToken(address2, chainId, chainFromId) {
    return this.tokens().find((token) => {
      const condition = token.address.toLowerCase() === address2.toLowerCase() && token.chainId === chainId;
      if (chainFromId === void 0)
        return condition;
      return condition && token.chainFromId === chainFromId;
    });
  }
  transitTokens(chainId, omniPoolConfig) {
    const pool = this.configCache.getOmniPoolByConfig(omniPoolConfig);
    if (!pool) {
      throw new Error2(`Cannot find omniPool ${pool}`);
    }
    const tokens = this.configCache.tokens().filter((token) => {
      return token.chainId === chainId && !token.deprecated && !token.isSynthetic;
    });
    if (chainId === pool.chainId) {
      return tokens;
    }
    return tokens.filter((token) => {
      const tokenPool = this.getOmniPoolByToken(token);
      return pool.id === tokenPool?.id;
    });
  }
  transitToken(chainId, omniPoolConfig) {
    const pool = this.configCache.getOmniPoolByConfig(omniPoolConfig);
    if (!pool) {
      throw new Error2(`Cannot find omniPool ${pool}`);
    }
    const tokens = this.configCache.tokens().filter((token) => {
      return token.chainId === chainId && !token.deprecated && !token.isSynthetic;
    });
    if (tokens.length === 0) {
      throw new Error2(`Cannot find token for chain ${chainId}`);
    }
    if (chainId === pool.chainId) {
      return tokens[0];
    }
    const transitToken = tokens.find((token) => {
      return this.getOmniPoolByToken(token)?.id === pool.id;
    });
    if (!transitToken) {
      throw new Error2(
        `Cannot find transitToken for chain ${chainId}. Pool: ${pool.id}`,
        3 /* NO_TRANSIT_TOKEN */
      );
    }
    return transitToken;
  }
  getTransitCombinations(chainIdIn, chainIdOut, poolConfig) {
    const transitTokensIn = this.transitTokens(chainIdIn, poolConfig);
    const transitTokensOut = this.transitTokens(chainIdOut, poolConfig);
    const combinations = [];
    transitTokensIn.forEach((transitTokenIn) => {
      transitTokensOut.forEach((transitTokenOut) => {
        if (transitTokenIn.equals(transitTokenOut)) {
          return;
        }
        combinations.push({ transitTokenIn, transitTokenOut });
      });
    });
    return combinations;
  }
  getOmniPoolByConfig(config4) {
    return this.configCache.getOmniPoolByConfig(config4);
  }
  getOmniPoolByToken(token) {
    return this.configCache.getOmniPoolByToken(token);
  }
  getOmniPoolTokens(omniPoolConfig) {
    return this.configCache.getOmniPoolTokens(omniPoolConfig);
  }
  getTokenInfoById(tokenId) {
    return this.configCache.getTokenInfoById(tokenId);
  }
  tronWeb(chainId) {
    if (!isTronChainId(chainId)) {
      throw new Error2(`Chain ${chainId} is not Tron chain`);
    }
    const config4 = this.chainConfig(chainId);
    if (!config4) {
      throw new Error2(`Could not find Tron config for chain ${chainId}`);
    }
    return new TronWeb4({ fullHost: config4.rpc, eventNode: config4.rpc, solidityNode: config4.rpc });
  }
  async waitForComplete({
    chainId,
    txId,
    txTon
  }) {
    return waitForComplete({ symbiosis: this, chainId, txId, txTon });
  }
  getForwarderUrl(btcChainId) {
    if (!isBtcChainId(btcChainId)) {
      throw new Error2(`This chain ${btcChainId} is not BTC chain`);
    }
    const forwarderUrl = this.chainConfig(btcChainId).forwarderUrl;
    if (!forwarderUrl) {
      throw new Error2(`This chain ${btcChainId} doesn't have forwardsUrl`);
    }
    return forwarderUrl;
  }
  async waitForBtcDepositAccepted(btcChainId, depositAddress) {
    const forwarderUrl = this.getForwarderUrl(btcChainId);
    return waitForBtcDepositAccepted(forwarderUrl, depositAddress);
  }
  async waitForBtcRevealTxMined(btcChainId, revealTx, onConfirmation, confirmations = 2) {
    const forwarderUrl = this.getForwarderUrl(btcChainId);
    return waitForBtcRevealTxMined(forwarderUrl, revealTx, confirmations, onConfirmation);
  }
  async waitForBtcEvmTxIssued(btcChainId, revealTx) {
    return waitForBtcEvmTxIssued(this, revealTx, btcChainId);
  }
  async waitFromTonTxMined(chainId, tonAddress) {
    return waitFromTonTxMined(this, chainId, tonAddress);
  }
  async findTransitTokenSent(chainId, transactionHash) {
    const metarouter = this.metaRouter(chainId);
    const providerTo = this.getProvider(chainId);
    const receipt = await providerTo.getTransactionReceipt(transactionHash);
    if (!receipt) {
      return void 0;
    }
    const eventId = utils41.id("TransitTokenSent(address,uint256,address)");
    const log = receipt.logs.find((log2) => {
      return log2.topics[0] === eventId;
    });
    if (!log) {
      return void 0;
    }
    const parsedLog = metarouter.interface.parseLog(log);
    const token = this.tokens().find((token2) => {
      return token2.chainId === chainId && token2.address.toLowerCase() === parsedLog.args.token.toLowerCase();
    });
    if (!token) {
      return void 0;
    }
    return new TokenAmount(token, parsedLog.args.amount.toString());
  }
  async tronWaitForMined(chainId, txId) {
    let info;
    const tronWeb = this.tronWeb(chainId);
    const TRIES = 10;
    for (let i = 0; i < TRIES; i++) {
      const response = await getTransactionInfoById(tronWeb, txId);
      if (response) {
        info = response;
        break;
      }
      await delay(1e3);
    }
    if (!info) {
      throw new Error2("Transaction not found");
    }
    return info;
  }
  getRevertableAddress(chainId) {
    const address2 = this.config.revertableAddress[chainId];
    if (address2) {
      return address2;
    }
    return this.config.revertableAddress.default;
  }
  validateLimits(amount) {
    const { token } = amount;
    const limit = this.config.limits.find((limit2) => {
      return limit2.address.toLowerCase() === token.address.toLowerCase() && limit2.chainId === token.chainId;
    });
    if (!limit) {
      return;
    }
    const maxAmountRaw = parseUnits6(limit.max, token.decimals).toString();
    if (maxAmountRaw !== "0") {
      const maxLimitTokenAmount = new TokenAmount(token, maxAmountRaw);
      if (amount.greaterThan(maxLimitTokenAmount)) {
        throw new Error2(
          `Swap amount is too high. Max: ${maxLimitTokenAmount.toSignificant()} ${maxLimitTokenAmount.token.symbol}`,
          6 /* AMOUNT_TOO_HIGH */
        );
      }
    }
    const minAmountRaw = parseUnits6(limit.min, token.decimals).toString();
    if (minAmountRaw !== "0") {
      const minLimitTokenAmount = new TokenAmount(token, minAmountRaw);
      if (amount.lessThan(minLimitTokenAmount)) {
        throw new Error2(
          `Swap amount is too low. Min: ${minLimitTokenAmount.toSignificant()} ${minLimitTokenAmount.token.symbol}`,
          7 /* AMOUNT_TOO_LOW */
        );
      }
    }
  }
};

// src/crosschain/getRepresentation.ts
import { AddressZero as AddressZero16 } from "@ethersproject/constants";
async function getRepresentation(symbiosis, token, chainId) {
  const fabricChainId = token.isSynthetic ? token.chainId : chainId;
  const fabric = symbiosis.fabric(fabricChainId);
  if (fabric.address === AddressZero16) {
    return void 0;
  }
  const wrapped = wrappedToken(token);
  let tokenAddress;
  if (isTronToken(wrapped)) {
    tokenAddress = tronAddressToEvm(wrapped.address);
  } else {
    tokenAddress = wrapped.address;
  }
  try {
    let representation;
    if (token.isSynthetic) {
      representation = await fabric.getRealRepresentation(tokenAddress);
    } else {
      representation = await fabric.getSyntRepresentation(tokenAddress, wrapped.chainId);
    }
    if (representation === AddressZero16) {
      return void 0;
    }
    return symbiosis.findToken(representation, chainId);
  } catch (e) {
    console.error(`Error while getting representation of ${token.address} in chain ${chainId}`, e);
    return void 0;
  }
}
export {
  BASES_TO_CHECK_TRADES_AGAINST,
  BIPS_BASE,
  BaseSwapping,
  Bridge,
  CHAINS_PRIORITY,
  COINGECKO_GAS_TOKEN_IDS,
  COINGECKO_PLATFORMS,
  CROSS_CHAIN_ID,
  CUSTOM_BASES,
  Chain,
  ChainId,
  DEFAULT_EXCEED_DELAY,
  DEX_TOKENS_TO_CHECK_TRADES_AGAINST,
  DataProvider,
  Error2 as Error,
  ErrorCode,
  EventIds,
  FACTORY_ADDRESS,
  FEE_COLLECTOR_ADDRESSES,
  Field,
  Fraction,
  GAS_TOKEN,
  GetLogTimeoutExceededError,
  INIT_CODE_HASH,
  InsufficientInputAmountError,
  InsufficientReservesError,
  IzumiTrade,
  JSBI18 as JSBI,
  LegacyWaitForComplete,
  MINIMUM_LIQUIDITY,
  MIN_META_SYNTH_JETTONS,
  MIN_META_SYNTH_TONS,
  MIN_SYNTH_JETTONS,
  MIN_SYNTH_TONS,
  MULTICALL_ADDRESSES,
  MULTICALL_ROUTER_V2,
  NATIVE_TON_BRIDGE_OPTIONS,
  NOTIFICATION_PAYMENT,
  NoMulticallAddressError,
  ONE_BIPS,
  ONE_INCH_CHAINS,
  ONE_INCH_ORACLE_MAP,
  OmniLiquidity,
  Opcodes,
  Pair,
  PendingRequestState,
  Percent,
  Price,
  RevertPending,
  RevertRequest,
  Rounding,
  Route,
  Router,
  Symbiosis,
  THOR_TOKENS,
  TON_TOKEN_DECIMALS,
  TRON_PORTAL_ABI,
  TRON_TRC20_ABI,
  Token,
  TokenAmount,
  Trade,
  TradeType,
  TransactionStuckError,
  WETH,
  WETH_ONLY,
  ZERO,
  Zapping,
  ZappingThor,
  basisPointsToPercent,
  buildMetaSynthesize,
  buildSynthesize,
  calculateGasMargin,
  calculatePriceImpact,
  callDataToCell,
  canOneInch,
  chains,
  computeSlippageAdjustedAmounts,
  computeTradePriceBreakdown,
  findSourceChainData,
  getAllPairCombinations,
  getChainById,
  getExternalId,
  getInternalId,
  getLogWithTimeout,
  getMinAmount,
  getMulticall,
  getRepresentation,
  getTokenAmountUsd,
  getTokenPriceUsd,
  getTonTokenAddress,
  getTradePriceImpact,
  inputOutputComparator,
  isBtcChainId,
  isEvmChainId,
  isSynthesizeV2,
  isTonChainId,
  isTronChain,
  isTronChainId,
  isTronToken,
  isUsdt,
  isWTon,
  prepareTransactionRequest,
  prepareTronTransaction,
  splitSlippage,
  tokenEquals,
  tonAdvisorMock,
  tradeComparator,
  tronAddressToEvm,
  waitForBtcDepositAccepted,
  waitForBtcEvmTxIssued,
  waitForBtcRevealTxMined,
  waitForComplete,
  waitFromTonTxMined,
  wrappedAmount,
  wrappedToken
};
/*! Bundled license information:

crypto-js/ripemd160.js:
  (** @preserve
  	(c) 2012 by Cédric Mesnil. All rights reserved.
  
  	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
  
  	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
  	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
  
  	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  	*)

crypto-js/mode-ctr-gladman.js:
  (** @preserve
   * Counter block mode compatible with  Dr Brian Gladman fileenc.c
   * derived from CryptoJS.mode.CTR
   * Jan Hruby jhruby.web@gmail.com
   *)
*/
//# sourceMappingURL=index.esm.js.map